require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0df128e4d9c37ba41e7beec18fa5414e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0df128e4d9c37ba41e7beec18fa5414e'] = async function fn_0df128e4d9c37ba41e7beec18fa5414e(lead_id) {
var LeadHolder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LeadHolder = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/findLeadFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(lead_id)));

return ((getObjectProperty(((getObjectProperty(LeadHolder, 'contacts'))[0]), 'id')).replace((new RegExp('cont', '')), 'teach'))
}

})
define('./functions/0e8c594b4c753e562b1581b671ad6261/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0e8c594b4c753e562b1581b671ad6261'] = async function fn_0e8c594b4c753e562b1581b671ad6261(userName, pageData, usedIn) {
var dash, error, userName, _unused, tutorDateMidnight, MondayThisWeek, MondayLastWeek, todayNumber, mondayTimestamp, subject, subjects, tutorDateNow, DSToffSet, testTimezone, tutorDateMidnightUTC;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (userName === null) || (typeof userName === 'undefined') ? ['email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    tutorDateNow = (new Date());
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((((new Date()).valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((((new Date()).valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(tutorDateMidnight).getDay()) == 0 ? 7 : (new Date(tutorDateMidnight).getDay());
    console.log('TODAY NUMBER');
    console.log(todayNumber);
    MondayLastWeek = ((tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber)) - 86400000 * 7;
    MondayThisWeek = (tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber);
    console.log(MondayLastWeek);
    console.log('MondayThisWeek');
    console.log(MondayThisWeek);
    console.log(tutorDateMidnight);
    if (todayNumber < 3) {
      mondayTimestamp = ((tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber) + 0) - 86400000 * 7;
    } else {
      mondayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (0 - todayNumber) + 0;
    }
    console.log('MondayTimestamp');
    console.log(mondayTimestamp);

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function fillCalendarListRaw2 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    subjects = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/calendar/find')).setEncoding('utf8').send(({ [`where`]: (typeof userName === 'undefined') ? ['(start_time >= ',mondayTimestamp,' and start_time <= ',(tutorDateNow.valueOf()),' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and slots_slug not like \'%Microschool%\'',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',(tutorDateNow.valueOf()),' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',(tutorDateNow.valueOf()),' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join('') : ['(start_time >= ',mondayTimestamp,' and start_time <= ',(tutorDateNow.valueOf()),' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and slots_slug not like \'%Microschool%\'',' and weekly_slots[calendar].student_name not LIKE \'%[OFFBOARDED]%\' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',(tutorDateNow.valueOf()),' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and (slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\')) or (start_time >= ',mondayTimestamp,' and start_time <= ',(tutorDateNow.valueOf()),' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\')',''].join(''),[`property`]: ['weekly_slots[calendar].startDate', 'weekly_slots[calendar].status', 'weekly_slots[calendar].lastHmwrk', 'weekly_slots[calendar].rubric', 'weekly_slots[calendar].contact_id', 'weekly_slots[calendar].parent_name', 'weekly_slots[calendar].student_name', 'weekly_slots[calendar].subject', 'weekly_slots[calendar].grade', 'weekly_slots[calendar].timezone as parentTimezone', 'Users[calendar].timezone as tutorTimezone', 'Users[calendar].objectId as tutorObjectId', 'objectId as calendarObjectId', 'Users[calendar].tutorType', 'weekly_slots[calendar].tutor_lifetime_slots', '*'],[`sortBy`]: 'start_time ASC',[`pageSize`]: 100 })));

  } catch (error) {
    console.log(error);
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function fillCalendarListRaw2 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from the calendar DB / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    dash = [];
    for (var subject_index in subjects) {
      subject = subjects[subject_index];
      addItemToList(dash, ({ [`startDate`]: (getObjectProperty(subject, 'startDate')),[`parentIANA`]: undefined,[`tutorIANA`]: undefined,[`rubric`]: (getObjectProperty(subject, 'rubric')),[`contact_id`]: (getObjectProperty(subject, 'contact_id')),[`parent_name`]: (getObjectProperty(subject, 'parent_name')),[`student_name`]: (getObjectProperty(subject, 'student_name')),[`subject`]: (getObjectProperty(subject, 'subject')),[`grade`]: (getObjectProperty(subject, 'grade')),[`slots_slug`]: (getObjectProperty(subject, 'slots_slug')),[`parentTimezone`]: (getObjectProperty(subject, 'parentTimezone')),[`tutorTimezone`]: (getObjectProperty(subject, 'tutorTimezone')),[`tutor_name`]: (getObjectProperty(subject, 'tutor')),[`scheduling`]: (getObjectProperty(subject, 'scheduling')),[`homework_sent`]: (getObjectProperty(subject, 'homework_sent')),[`calendarObjectId`]: (getObjectProperty(subject, 'calendarObjectId')),[`tutorObjectId`]: (getObjectProperty(subject, 'tutorObjectId')),[`start_time`]: (getObjectProperty(subject, 'start_time')),[`lastHmwrk`]: ((new Date((getObjectProperty(subject, 'lastHmwrk')))).valueOf()),[`tutorSign`]: undefined,[`tutorOffset`]: undefined,[`parentSign`]: undefined,[`parentOffset`]: undefined,[`toBePaid`]: (getObjectProperty(subject, 'toBePaid')),[`reportRowClick`]: false,[`messageRowClick`]: false,[`localeStartTime`]: 'tutor',[`event_title`]: (getObjectProperty(subject, 'event_title')),[`tutor_lifetime_slots`]: (getObjectProperty(subject, 'tutor_lifetime_slots')),[`tutorType`]: (getObjectProperty(subject, 'tutorType')) }));
    }
    pageData['startWeek'] = mondayTimestamp;
    pageData['calendarListRaw'] = dash;
    pageData['todayNumber'] = todayNumber;
    pageData['MondayLastWeek'] = MondayLastWeek;
    pageData['MondayThisWeek'] = MondayThisWeek;
    pageData['tutorDateMidnight'] = tutorDateMidnight;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function fillCalendarListRaw2 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while setting the data to the dash / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }

return dash
}

})
define('./functions/184994440a04f7b16266320a3805a58f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f'] = async function fn_184994440a04f7b16266320a3805a58f(methodName, logMessage, error) {
var errorObject, logger_name, slack;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  logger_name = methodName;
  Backendless.Logging.getLogger(logger_name).info(logMessage);
  slack = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/frontendCatchWithError`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'channelID': 'C02178TDDA7','channelMessage': (['Error encountered during the process.','\n','Method: ',logger_name,'\n','Message: ',logMessage,'\n','Error: ',(JSON.stringify((getObjectProperty(error, 'message'))))].join('')),'chatbotName': 'Backendless Error','bot_icon': ':x:' }));
  errorObject = (await Backendless.Data.of('errors').save( ({ [`message`]: (JSON.stringify((getObjectProperty(error, 'message')))),[`code`]: (JSON.stringify((getObjectProperty(error, 'code')))),[`channel`]: 'WARN',[`checked`]: false,[`time`]: (new Date()),[`method`]: methodName,[`data`]: error }) ));

return errorObject
}

})
define('./functions/1bfd91c36a66a7b48bb5b7bbe3ba5d75/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1bfd91c36a66a7b48bb5b7bbe3ba5d75'] = async function fn_1bfd91c36a66a7b48bb5b7bbe3ba5d75(sheetId, cellRange, ColumnsRows) {
var accessTokenString, DriveTokenObject, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  DriveTokenObject = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0];
  if (((new Date()).valueOf()) > (getObjectProperty(DriveTokenObject, 'expiring'))) {
    console.log('new Google Drive API auth code needed');
    accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty(DriveTokenObject, 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
    await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty(DriveTokenObject, 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
    accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
  } else {
    accessTokenString = (getObjectProperty(DriveTokenObject, 'access_token'));
  }

return (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://sheets.googleapis.com/v4/spreadsheets/',sheetId,'/values/',cellRange].join('')))).query(({ [`majorDimension`]: ColumnsRows })).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send())
}

})
define('./functions/1f22b9b531d33432a3832ab3b6a61ecc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1f22b9b531d33432a3832ab3b6a61ecc'] = async function fn_1f22b9b531d33432a3832ab3b6a61ecc(Rawlist, PageData) {
var studentContainer, item, tutorTimezone, FilterTimezone, Timezones, parentTimezone;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Timezones = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/timezones')).query(({ [`groupBy`]: 'long_name',[`pageSize`]: 100 })).setEncoding('utf8').send());
  studentContainer = (await asyncListFilter(Rawlist, async (item) => {
     if ((getObjectProperty(item, 'parentTimezone')) != null) {
      parentTimezone = (await asyncListFilter(Timezones, async (FilterTimezone) => {


       return ((getObjectProperty(FilterTimezone, 'long_name')) == (getObjectProperty(item, 'parentTimezone')));
      }))[0];
      item['parentIANA'] = (getObjectProperty(parentTimezone, 'iana'));
      item['parentSign'] = (getObjectProperty(parentTimezone, 'sign'));
      item['parentOffset'] = (getObjectProperty(parentTimezone, 'offSet'));
    }
    if ((getObjectProperty(item, 'tutorTimezone')) != null) {
      tutorTimezone = (await asyncListFilter(Timezones, async (FilterTimezone) => {


       return ((getObjectProperty(FilterTimezone, 'long_name')) == (getObjectProperty(item, 'tutorTimezone')));
      }))[0];
      item['tutorIANA'] = (getObjectProperty(tutorTimezone, 'iana'));
      item['tutorSign'] = (getObjectProperty(tutorTimezone, 'sign'));
      item['tutorOffset'] = (getObjectProperty(tutorTimezone, 'offSet'));
    }
    item['messageRowClick'] = false;


   return (((getObjectProperty(item, 'slots_slug')) == 'Manual time' || (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf())) && ((getObjectProperty(item, 'scheduling')) == 'scheduled' || (getObjectProperty(item, 'scheduling')) == 'being_rescheduled'));
  }));
  console.log('Student Container');
  console.log(studentContainer);

return studentContainer
}

})
define('./functions/2cd130a2816951bedf8c3a643d842fde/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2cd130a2816951bedf8c3a643d842fde'] = function fn_2cd130a2816951bedf8c3a643d842fde(subject) {
var subject;


  subject = subject;
  if (subject == 'MS_Middle'.toUpperCase()) {
    subject = 'Microschool Middle';
  } else if (subject == 'MS_Elementary'.toUpperCase()) {
    subject = 'Microschool Elementary';
  } else if (subject == 'MS_Lower_Elem'.toUpperCase()) {
    subject = 'Microschool Lower Elementary';
  } else if (subject == 'MS_Upper_Elem'.toUpperCase()) {
    subject = 'Microschool Upper Elementary';
  } else if (subject == 'MS_High'.toUpperCase()) {
    subject = 'Microschool High';
  } else if (subject == 'MS_Elementary_Light'.toUpperCase()) {
    subject = 'Microschool Elementary';
  } else if (subject == 'MS_High_Light'.toUpperCase()) {
    subject = 'Microschool High';
  } else if (subject == 'MS_Lower_Elem_Light'.toUpperCase()) {
    subject = 'Microschool Lower Elementary';
  } else if (subject == 'MS_Middle_Light'.toUpperCase()) {
    subject = 'Microschool Middle';
  } else if (subject == 'MS_Upper_Elem_Light'.toUpperCase()) {
    subject = 'Microschool Upper Elementary';
  } else if (subject == 'MS_ESE_Elementary'.toUpperCase()) {
    subject = 'Microschool Elementary (ESE)';
  } else if (subject == 'MS_ESE_Middle-High'.toUpperCase() || subject == 'MS_ESE_Middle_High'.toUpperCase()) {
    subject = 'Microschool Middle-High (ESE)';
  } else if (subject == 'MS_Summerschool_ESE_Elementary'.toUpperCase()) {
    subject = 'Summerschool Elementary (ESE)';
  } else if (subject == 'MS_Summerschool_ESE_Middle-High'.toUpperCase() || subject == 'MS_Summerschool_ESE_Middle_High'.toUpperCase()) {
    subject = 'Summerschool Middle-High (ESE)';
  } else if (subject == 'MS_SummerSchool_Middle'.toUpperCase()) {
    subject = 'Summerschool Middle';
  } else if (subject == 'MS_SummerSchool_Upper_Elem'.toUpperCase()) {
    subject = 'Summerschool Upper Elementary';
  } else if (subject == 'MS_SummerSchool_High'.toUpperCase()) {
    subject = 'Summerschool High';
  } else if (subject == 'MS_Summerschool_Lower_Elem'.toUpperCase()) {
    subject = 'Summerschool Lower Elementary';
  } else if (subject == 'MS_Homeschool-Support_Middle-High'.toUpperCase()) {
    subject = 'Microschool Homeschool-Support Middle High';
  } else if (subject == 'MS_Junior_High'.toUpperCase()) {
    subject = 'Microschool Junior High';
  } else if (subject == 'MS_Senior_High'.toUpperCase()) {
    subject = 'Microschool Senior High';
  } else if (subject == 'MS_Lower_High'.toUpperCase()) {
    subject = 'Microschool Lower High';
  } else if (subject == 'MS_Upper_High'.toUpperCase()) {
    subject = 'Microschool Upper High';
  } else if (subject == 'MS_SummerSchool_Lower_High'.toUpperCase()) {
    subject = 'Summerschool Lower High';
  } else if (subject == 'MS_SummerSchool_Upper_High'.toUpperCase()) {
    subject = 'Summerschool Upper High';
  } else if (subject == 'MS_SummerSchool_Lower_Elem'.toUpperCase()) {
    subject = 'Summerschool Lower Elementary';
  } else if (subject == 'MS_SummerSchool_Upper_Elem'.toUpperCase()) {
    subject = 'Summerschool Upper Elementary';
  } else if (subject == 'MS_Kindergarten'.toUpperCase()) {
    subject = 'Microschool Kindergarten';
  } else {
    subject = subject;
  }

return subject
}

})
define('./functions/34fd633c8d03816ddc83f64bf2eb921c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_34fd633c8d03816ddc83f64bf2eb921c'] = async function fn_34fd633c8d03816ddc83f64bf2eb921c(calendarList, pageData) {
var hoursList, submittedHours, payableHoursFiltered, payableHours, pendingHours, item, uniqueSlots, pendingHoursFinal, payableHoursFinal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  pendingHours = [];
  payableHours = [];
  uniqueSlots = [];
  payableHoursFinal = [];
  pendingHoursFinal = [];
  submittedHours = [];
  hoursList = (await asyncListFilter(calendarList, async (item) => {
     item['reportRowClick'] = false;
    item['messageRowClick'] = false;
    if ((getObjectProperty(item, 'start_time')) <= ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled') {
      if ((getObjectProperty(item, 'lastHmwrk')) > (getObjectProperty(item, 'start_time')) - 86400000 && (getObjectProperty(item, 'homework_sent')) == true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || ((getObjectProperty(item, 'student_name')) == null ? null : ((getObjectProperty(item, 'student_name')).indexOf('[OFFBOARDED]') !== -1)) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) && (getObjectProperty(item, 'toBePaid')) != true || (getObjectProperty(item, 'toBePaid')) != true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time')) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(payableHours, item);
      } else if (!((getObjectProperty(item, 'lastHmwrk')) > (getObjectProperty(item, 'start_time')) - 86400000) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) != true && !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(pendingHours, item);
      } else if ((getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time')))) || (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == true && ((getObjectProperty(item, 'slots_slug')) == 'Mock Session' || (getObjectProperty(item, 'slots_slug')) == 'Manual time')) {
        addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
        addItemToList(submittedHours, item);
      }
    }


   return ((getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()) && (getObjectProperty(item, 'start_time')) > ((new Date((new Date()).getTime() - ((86400 * 21) * 1000))).valueOf()) && (getObjectProperty(item, 'scheduling')) == 'scheduled' && (getObjectProperty(item, 'toBePaid')) == false && (getObjectProperty(item, 'scheduling')) == 'scheduled' && !((getObjectProperty(item, 'parent_name')) === null));
  }));
  pageData['hoursList'] = hoursList;
  pageData['payableHours2'] = payableHours;
  if ((getObjectProperty(pageData, 'todayNumber')) < 3) {
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayLastWeek')) && (getObjectProperty(item, 'start_time')) < (getObjectProperty(pageData, 'MondayThisWeek')));
    }));
  } else {
    payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


     return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'MondayThisWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
    }));
  }
  payableHoursFiltered = (await asyncListFilter(payableHours, async (item) => {


   return ((getObjectProperty(item, 'start_time')) > (getObjectProperty(pageData, 'startWeek')) && (getObjectProperty(item, 'start_time')) < ((new Date()).valueOf()));
  }));
  pageData['payableHoursFiltered'] = payableHoursFiltered;
  pageData['pendingHours'] = (pendingHours.length);
  pageData['payableHours'] = (payableHoursFiltered.length);
  pageData['submittedHours'] = (submittedHours.length);

return hoursList
}

})
define('./functions/52beecb51cd79e6487216b2ea64c0022/code.js', () => { 

BackendlessUI.Functions.Custom['fn_52beecb51cd79e6487216b2ea64c0022'] = async function fn_52beecb51cd79e6487216b2ea64c0022(calendarList, pageData) {
var MessagingList, studentsToday, lateTime, item, uniqueSlots;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  studentsToday = [];
  uniqueSlots = [];
  MessagingList = (await asyncListFilter(calendarList, async (item) => {
     item['reportRowClick'] = false;
    lateTime = (getObjectProperty(item, 'start_time')) + 1000 * 60 * 20;
    if (lateTime > ((new Date()).valueOf())) {
      if (!((getObjectProperty(item, 'startDate')) === null)) {
        if (((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) <= (getObjectProperty(item, 'start_time')) && ((new Date((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).getTime() + (86340 * 1000))).valueOf()) >= (getObjectProperty(item, 'start_time')) && !(uniqueSlots.includes((getObjectProperty(item, 'start_time'))))) {
          addItemToList(uniqueSlots, (getObjectProperty(item, 'start_time')));
          addItemToList(studentsToday, item);
        }
      }
    }


   return (lateTime > ((new Date()).valueOf()));
  }));
  pageData['studentsToday'] = (studentsToday.length);
  pageData['MessageLimit'] = 1000;

return MessagingList
}

})
define('./functions/7632b4b571bab0a71894762cdd9e7dd9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7632b4b571bab0a71894762cdd9e7dd9'] = function fn_7632b4b571bab0a71894762cdd9e7dd9(name) {
var array;


  array = name.split(', ');

return ([array.slice(-1)[0],' ',array[0]].join(''))
}

})
define('./functions/a76b1a4ea7f5d5dedb2d3b1195c168d7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a76b1a4ea7f5d5dedb2d3b1195c168d7'] = async function fn_a76b1a4ea7f5d5dedb2d3b1195c168d7(userName, pageData, usedIn) {
var dash, error, userName, _unused, subject, subjects, UniqueCalendarObjects, sundayTimestamp, tutorDateNow, DSToffSet, todayNumber, tutorDateMidnight, testTimezone, tutorDateMidnightUTC;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    userName = (typeof userName === 'undefined') ? (getObjectProperty(pageData, 'userName')) : userName;
    testTimezone = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/Users')).query(({ [`where`]: (typeof userName === 'undefined') ? ['email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join('') : ['name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''),[`property`]: ['timezones.offSet', 'timezones.sign'],[`pageSize`]: 10 })).setEncoding('utf8').send())[0];
    tutorDateNow = (new Date());
    if ((getObjectProperty(testTimezone, 'sign')) == '-') {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((((new Date()).valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    } else {
      tutorDateMidnightUTC = (new Date(((JSON.stringify((new Date((((new Date()).valueOf()) + (getObjectProperty(testTimezone, 'offSet')) * 3600000))))).slice(1, 11))));
      tutorDateMidnight = (new Date(((tutorDateMidnightUTC.valueOf()) - (getObjectProperty(testTimezone, 'offSet')) * 3600000)));
    }
    todayNumber = (new Date(tutorDateMidnight).getDay()) == 0 ? 7 : (new Date(tutorDateMidnight).getDay());
    console.log(todayNumber);
    if (todayNumber < 3) {
      sundayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0 + 86400000 * 7;
    } else {
      sundayTimestamp = (tutorDateMidnight.valueOf()) + 86400000 * (1 - todayNumber) + 0 + 86400000 * 14;
    }

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function fillCalendarListRaw3 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data for query / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    subjects = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/calendar/find')).setEncoding('utf8').send(({ [`where`]: (typeof userName === 'undefined') ? ['(start_time >= ',(tutorDateNow.valueOf()) - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and slots_slug not like \'%Microschool%\'',' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',(tutorDateNow.valueOf()) - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\'',' and scheduling != \'is_paused\') or (start_time >= ',(tutorDateNow.valueOf()) - 1800000,' and start_time <= ',sundayTimestamp,' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].email = \'',((getObjectProperty(pageData, 'userEmail')).replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join('') : ['(start_time >= ',(tutorDateNow.valueOf()) - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_paused\'',' and scheduling != \'is_substituted\'',' and slots_slug not like \'%Microschool%\'',' and (weekly_slots[calendar].status = \'churn\' or weekly_slots[calendar].status = \'enrolled\' or weekly_slots[calendar].status = \'deleted\' or weekly_slots[calendar].status = \'long pause\')) or (start_time >= ',(tutorDateNow.valueOf()) - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and scheduling != \'is_rescheduled\'',' and scheduling != \'is_pushed\'',' and scheduling != \'is_substituted\' and weekly_slots[calendar].objectId is null and slots_slug not like \'%Microschool%\' and slots_slug not like \'Mock%\'',' and scheduling != \'is_paused\') or (start_time >= ',(tutorDateNow.valueOf()) - 1800000,' and start_time <= ',sundayTimestamp,' and tutor = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\' and slots_slug like \'Mock%\' and Users[calendar].name = \'',(userName.replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join(''),[`property`]: ['weekly_slots[calendar].startDate', 'weekly_slots[calendar].status', 'weekly_slots[calendar].lastHmwrk', 'weekly_slots[calendar].rubric', 'weekly_slots[calendar].contact_id', 'weekly_slots[calendar].parent_name', 'weekly_slots[calendar].student_name', 'weekly_slots[calendar].subject', 'weekly_slots[calendar].grade', 'weekly_slots[calendar].timezone as parentTimezone', 'Users[calendar].timezone as tutorTimezone', 'Users[calendar].objectId as tutorObjectId', 'objectId as calendarObjectId', '*'],[`sortBy`]: 'start_time ASC',[`pageSize`]: 100 })));

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function fillCalendarListRaw3 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while getting data from calendar / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }
  try {
    dash = [];
    UniqueCalendarObjects = [];
    for (var subject_index in subjects) {
      subject = subjects[subject_index];
      if ((getObjectProperty(subject, 'status')) == 'enrolled') {
        addItemToList(dash, ({ [`startDate`]: (getObjectProperty(subject, 'startDate')),[`parentIANA`]: undefined,[`tutorIANA`]: undefined,[`rubric`]: (getObjectProperty(subject, 'rubric')),[`contact_id`]: (getObjectProperty(subject, 'contact_id')),[`parent_name`]: (getObjectProperty(subject, 'parent_name')),[`student_name`]: (getObjectProperty(subject, 'student_name')),[`subject`]: (getObjectProperty(subject, 'subject')),[`grade`]: (getObjectProperty(subject, 'grade')),[`slots_slug`]: (getObjectProperty(subject, 'slots_slug')),[`parentTimezone`]: (getObjectProperty(subject, 'parentTimezone')),[`tutorTimezone`]: (getObjectProperty(subject, 'tutorTimezone')),[`tutor_name`]: (getObjectProperty(subject, 'tutor')),[`scheduling`]: (getObjectProperty(subject, 'scheduling')),[`homework_sent`]: (getObjectProperty(subject, 'homework_sent')),[`calendarObjectId`]: (getObjectProperty(subject, 'calendarObjectId')),[`tutorObjectId`]: (getObjectProperty(subject, 'tutorObjectId')),[`start_time`]: (getObjectProperty(subject, 'start_time')),[`lastHmwrk`]: ((new Date((getObjectProperty(subject, 'lastHmwrk')))).valueOf()),[`tutorSign`]: undefined,[`tutorOffset`]: undefined,[`parentSign`]: undefined,[`parentOffset`]: undefined,[`toBePaid`]: (getObjectProperty(subject, 'toBePaid')),[`reportRowClick`]: false,[`messageRowClick`]: false,[`localeStartTime`]: 'tutor',[`event_title`]: (getObjectProperty(subject, 'event_title')) }));
      }
    }
    pageData['calendarListRaw3'] = dash;

  } catch (error) {
    _unused = (await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']((String('Custom Function fillCalendarListRaw3 / ') + String((typeof usedIn === 'string') ? usedIn : null)), (['Error occurred while setting data to the dashboard / ',userName,' / ',(getObjectProperty(pageData, 'userEmail'))].join('')), error));

  }

return dash
}

})
define('./functions/b9494f93ccada28c2fb195861aec0033/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b9494f93ccada28c2fb195861aec0033'] = async function fn_b9494f93ccada28c2fb195861aec0033(sheetId, sheetName) {
var update, error, accessTokenString, DriveTokenObject, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    DriveTokenObject = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0];
    if (((new Date((new Date()).getTime() + (1800 * 1000))).valueOf()) >= (getObjectProperty(DriveTokenObject, 'expiring'))) {
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty(DriveTokenObject, 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty(DriveTokenObject, 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty(DriveTokenObject, 'access_token'));
    }
    update = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://sheets.googleapis.com/v4/spreadsheets/',sheetId,':batchUpdate','',''].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`requests`]: [({ [`updateCells`]: ({ [`range`]: ({ [`sheetId`]: sheetName }),[`fields`]: 'userEnteredValue' }) })] })));

  } catch (error) {
    console.log(error);

  }

return update
}

})
define('./functions/cad53b2c8115106fd3afcda20303acdc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cad53b2c8115106fd3afcda20303acdc'] = function fn_cad53b2c8115106fd3afcda20303acdc(method, message) {
  Backendless.Logging.getLogger(method).info(message);

return 
}

})
define('./functions/e1368ab112384907e31f5a48678e6ca4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e1368ab112384907e31f5a48678e6ca4'] = function fn_e1368ab112384907e31f5a48678e6ca4(LoggerName, LogMessage, LogChannel, LoggingStatus) {
  if (LoggingStatus) {
    if (LogChannel.indexOf('INFO') !== -1) {
      Backendless.Logging.getLogger(LoggerName).info(LogMessage);
    } else if (LogChannel.indexOf('WARN') !== -1) {
      Backendless.Logging.getLogger(LoggerName).warn(LogMessage);
    }
  } else {
    return null;
  }

return 
}

})
define('./functions/e8a8947b491478e74417805bd7b43fa8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e8a8947b491478e74417805bd7b43fa8'] = async function fn_e8a8947b491478e74417805bd7b43fa8(sheetId, cellLocation, cellValue) {
var error, accessTokenString, update, DriveTokenObject, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    DriveTokenObject = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0];
    if (((new Date((new Date()).getTime() + (1800 * 1000))).valueOf()) >= (getObjectProperty(DriveTokenObject, 'expiring'))) {
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty(DriveTokenObject, 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty(DriveTokenObject, 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty(DriveTokenObject, 'access_token'));
    }
    update = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://sheets.googleapis.com/v4/spreadsheets/',sheetId,'/values/',cellLocation,''].join('')))).query(({ [`valueInputOption`]: 'USER_ENTERED' })).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`range`]: cellLocation,[`majorDimension`]: 'ROWS',[`values`]: cellValue })));

  } catch (error) {
    console.log(error);

  }

return 
}

})
define('./pages/1on1_Class/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, pageCount, InitialClasses, lead_id, LoginData, UserObject, item, urlParam, _value, _label, CurrentURL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', true);
    CurrentURL = ((function () { return window.location.href })());
    urlParam = (await Promise.all((CurrentURL.split('?').slice(-1)[0].split('&')).map(async item => {  _label = item.split('=')[0];
      _value = item.split('=').slice(-1)[0];
    ; return ({ [`label`]: _label,[`value`]: _value });})));
    lead_id = (getObjectProperty((await asyncListFind(urlParam, async (item) => {


     return ((getObjectProperty(item, 'label')) == 'lead_id');
    })), 'value'));
    ___arguments.context.pageData['lead_id'] = lead_id;
    console.log(lead_id);
    UserObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',lead_id,'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
    LoginData = (await Backendless.UserService.login( (getObjectProperty(UserObject, 'email')), (getObjectProperty(UserObject, 'MS_teacher_password')), false  ));
    ___arguments.context.pageData['UserData'] = LoginData;

  } catch (error) {
    console.log(error);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);

  }
  try {
    console.log((getObjectProperty(___arguments.context.pageData, 'lead_id')) == 'lead_UJ4WydwHrW4YEIOcf4gc5GBcxXiAZxkA9Xqjvh1EPK8' && (await Backendless.UserService.isValidLogin()));
    console.log(getObjectProperty(___arguments.context.pageData, 'UserData'));
    if (lead_id == 'lead_UJ4WydwHrW4YEIOcf4gc5GBcxXiAZxkA9Xqjvh1EPK8' && (await Backendless.UserService.isValidLogin())) {
      ___arguments.context.pageData['searchValue'] = '';
      ___arguments.context.pageData['Offset'] = 0;
      console.log('Offset');
      console.log(getObjectProperty(___arguments.context.pageData, 'Offset'));
      ___arguments.context.pageData['query'] = 'slot_slug like \'%MICROSCHOOL%\' and slot_slug like \'%MAX1-%\' and status = \'enrolled\' and startDate is not null';
      InitialClasses = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'query'))).setSortBy('tutor ASC').setPageSize(10).setOffset((getObjectProperty(___arguments.context.pageData, 'Offset')))));
      console.log(InitialClasses);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', false);
      ___arguments.context.pageData['Classes'] = InitialClasses;
      pageCount = (await Backendless.Data.of('weekly_slots').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'query'))))) / 10;
      ___arguments.context.pageData['PageCount'] = (Math.round(pageCount));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/1on1_Class/components/8e578ba976dcd23d67879fbc50a82124/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'slot_slug')).split('-')[3]) + String(' EST'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1on1_Class/components/cf95fadc20f3035d816bf958c1fba8fa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, InitialClasses, item, pageCount, query;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', true);
    ___arguments.context.pageData['Offset'] = 0;
    console.log('Offset');
    console.log(getObjectProperty(___arguments.context.pageData, 'Offset'));
    query = (getObjectProperty(___arguments.context.pageData, 'query'));
    query = String(query) + String([' and tutor like \'%',___arguments.value,'%\''].join(''));
    ___arguments.context.pageData['query'] = query;
    InitialClasses = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'query'))).setSortBy('tutor ASC').setPageSize(10).setOffset((getObjectProperty(___arguments.context.pageData, 'Offset')))));
    console.log(InitialClasses);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', false);
    ___arguments.context.pageData['Classes'] = InitialClasses;
    pageCount = (await Backendless.Data.of('weekly_slots').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'query'))))) / 10;
    ___arguments.context.pageData['PageCount'] = (Math.round(pageCount));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/1on1_Class/components/e6ae8f01e2ef9174873d71a127ae9045/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
      return [({ [`label`]: 'All Classes',[`value`]: 'All' }), ({ [`label`]: 'Kindergarten',[`value`]: 'MS_KINDERGARTEN' }), ({ [`label`]: 'Lower Elementary',[`value`]: 'MS_LOWER_ELEM' }), ({ [`label`]: 'Upper Elementary',[`value`]: 'MS_UPPER_ELEM' }), ({ [`label`]: 'Middle School',[`value`]: 'MS_MIDDLE' }), ({ [`label`]: 'Lower High School',[`value`]: 'MS_LOWER_HIGHSCHOOL' }), ({ [`label`]: 'Upper High School',[`value`]: 'MS_UPPER_HIGHSCHOOL' }), ({ [`label`]: 'ESE',[`value`]: 'ESE' })]

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, pageCount, InitialClasses;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log(___arguments.value);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', true);
    ___arguments.context.pageData['searchValue'] = '';
    ___arguments.context.pageData['Offset'] = 0;
    console.log('Offset');
    console.log(getObjectProperty(___arguments.context.pageData, 'Offset'));
    ___arguments.context.pageData['query'] = (___arguments.value == 'All' ? 'slot_slug like \'%MICROSCHOOL%\' and slot_slug like \'%MAX1-%\' and status = \'enrolled\' and startDate is not null' : ['slot_slug like \'%MICROSCHOOL%\' and slot_slug like \'%MAX1-%\' and status = \'enrolled\' and startDate is not null and slot_slug like \'%',___arguments.value,'%\''].join(''));
    InitialClasses = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'query'))).setSortBy('tutor ASC').setPageSize(10).setOffset((getObjectProperty(___arguments.context.pageData, 'Offset')))));
    console.log(InitialClasses);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', false);
    ___arguments.context.pageData['Classes'] = InitialClasses;
    pageCount = (await Backendless.Data.of('weekly_slots').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'query'))))) / 10;
    ___arguments.context.pageData['PageCount'] = (Math.round(pageCount));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/1on1_Class/components/c79912028293a28e7488021dbf240e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/?page=SIS&from=ParentOTPLogin&lead_id=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'lead_id')),'&student_name=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'student_name'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1on1_Class/components/a345bc8c5ee974a3c03d5969acd63722/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(['https://hi.btgs.co/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'tutor')).split(' ')[0].toLowerCase(),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'tutor')).split(' ').slice(-1)[0].toLowerCase()].join(''));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://hi.btgs.co/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'tutor')).split(' ')[0].toLowerCase(),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'tutor')).split(' ').slice(-1)[0].toLowerCase()].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1on1_Class/components/196e3a6d3e29fbdfa479c2d64a7b8697/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.pageData, 'Classes')) === null) && (typeof (getObjectProperty(___arguments.context.pageData, 'Classes')) === 'undefined') && !(getObjectProperty(___arguments.context.pageData, 'Classes')).length))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/1on1_Class/components/04aa887a36c88f92cd953878365b6faf/bundle.js', [], () => ({
  /* content */
  /* handler:onPageChange */
  async ['onPageChange'](___arguments) {
    var InitialClasses;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Offset'] = ((___arguments['currentPage'] - 1) * 10);
  console.log('Offset');
  console.log(getObjectProperty(___arguments.context.pageData, 'Offset'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', true);
  InitialClasses = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'query'))).setSortBy('tutor ASC').setPageSize(10).setOffset((getObjectProperty(___arguments.context.pageData, 'Offset')))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', false);
  console.log(InitialClasses);
  ___arguments.context.pageData['Classes'] = InitialClasses;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a344eaf1122e3a292b9295651bfc6936')));

  },
  /* handler:onPageChange */
  /* content */
}))

define('./pages/1on1_Class/components/cd5afbf9b4a5738804fd7902269ce2de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'Classes')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'Classes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/1on1_Class/components/d3af3a68e8bd26a7c81d834617fda796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('portal.brilliantgrades.com', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5a8b9b8e9f847485a03400888c80b17', (await Backendless.Data.of('subjects').find(Backendless.DataQueryBuilder.create().setWhereClause('tutor = \'Shlok Verma\'').setPageSize(10))));

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item, TeacherList, tutorData, LoginData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', false);
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromDashboard')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromDashboard'))) {
    await Backendless.UserService.logout();
    try {
      ___arguments.context.pageData['name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',((getObjectProperty(___arguments.context.pageData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'BACKENDLESS\''].join(''))).setProperties('email,MS_teacher_password,name,access_level,userType, tutorType,lead_id').setPageSize(10)))[0];
      LoginData = (await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'MS_teacher_password')), true  ));
      ___arguments.context.pageData['teacherInfo'] = tutorData;

    } catch (error) {
      console.log(error);
      Backendless.Logging.getLogger('Assistant_Principal_Page').debug((String('Problem with AP Login | Error:') + String(error)));

    }
  }
  console.log(await Backendless.UserService.getCurrentUser(false));
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), true, undefined);
  } else {
    try {
      TeacherList = [];
      TeacherList = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['house_leader=\'',((getObjectProperty(___arguments.context.pageData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and opp_status=\'enrolled\' and name !=\'',(getObjectProperty(___arguments.context.pageData, 'name')),'\''].join(''))).setProperties('name').setSortBy('name').setPageSize(100).setDistinct(true)));
      ___arguments.context.pageData['TeacherList'] = (await Promise.all(TeacherList.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });})));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);

    } catch (error) {
      console.log(error);
      Backendless.Logging.getLogger('Assistant Teacher').debug((['Assistant Teacher Error | Error in Page Enter AP:',(decodeURIComponent((getObjectProperty(___arguments.context.pageData, 'name')))),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    await Backendless.UserService.logout();
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/d17c61b1f2f49205db7b77f54acf08e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var TeacherObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TeacherObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'teacher')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(TeacherObject, 'video')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/a6bc742ebaaaf7da14c2abd3a9fb3091/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2, teacherData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  name2 = 'Dashboard';
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'name')) === 'undefined')) {
    name2 = ['Hi ',(getObjectProperty(___arguments.context.pageData, 'name')).split(' ')[0],', welcome back!'].join('');
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/563cb02864d70a74580cbaacaa2db2e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam, UserData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    UserData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedTeacherObject')), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'BACKENDLESS\''].join(''))).setProperties('name, email').setPageSize(10)))[0];
    urlParam = ({ [`fromAP`]: true,[`email`]: (getObjectProperty(UserData, 'email')),[`ap_name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Teacher' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('googleRedirectClever_refactored').debug((['Login Error: Teacher:\n',(await Backendless.UserService.getCurrentUser(false)),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/cb37a57d2f9b8af8069b693b5202bff8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, UserData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userType': 'teacher','loginFrom': 'teacher','userObject': ({ [`access_level`]: 'School Administrator' }) })), false, ({ [`fromSA`]: true,[`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')) }));
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/a9b170ef3c7c7818ef082f1fa684f645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Student Metrics' })), true, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('School_Administrator_Page').error((String('Problem encounter with accessing the Student Metric') + String(JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/8f0561a4fd095b3a8356b463baca706d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, teacherData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    teacherData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
    console.log(teacherData);
    ___arguments.context.pageData['teacherName'] = (getObjectProperty(teacherData, 'name'));
    ___arguments.context.pageData['email'] = (getObjectProperty(teacherData, 'email'));
    ___arguments.context.pageData['contact'] = (getObjectProperty(teacherData, 'phone'));
    ___arguments.context.pageData['selectedTeacherObject'] = teacherData;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff64453889bc48c39e52838ae79cfd28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/ded91ee10b95f8c411fd7d5f2683d131/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam, TeacherData, UserData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    UserData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'BACKENDLESS\''].join(''))).setProperties('name, email').setPageSize(10)))[0];
    urlParam = ({ [`fromAP`]: true,[`email`]: (getObjectProperty(UserData, 'email')),[`ap_name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Teacher' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('googleRedirectClever_refactored').debug((['Login Error: Teacher:\n',(await Backendless.UserService.getCurrentUser(false)),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/3d79c0fd3e446d2ec56d85d43aafb331/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Admin/index.html?page=EmployeeHandbook', true, ({ [`email`]: (getObjectProperty(___arguments.context.pageData, 'email')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/c8584a038ebe10fc8c5323722b94f198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    
  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assistant_Principal_Page/components/55e2a4edcf47a64c894493232b7ca37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var userDB;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  userDB = (getObjectProperty(___arguments.context.pageData, 'teacherInfo'));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=StudentInfo_Summary&lead_id=',(getObjectProperty(userDB, 'lead_id')),'&userType=Assistant_Principal'].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_Student_Credentials/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, ClassSlug, item, _oldClassSlug, weeklySlot, classList, offset, _unused;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', false);
  try {
    if (!(await Backendless.UserService.isValidLogin())) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);
    } else {
      classList = [];
      offset = 0;
      var repeat_end = Math.ceil((await Backendless.Data.of('ms_classes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['(teacher = \'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\' or students.assistant_teacher=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\')and students_dir is not null'].join(''))))) / 100);
      for (var count = 0; count < repeat_end; count++) {
        _unused = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause((['(teacher = \'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\' or students.assistant_teacher=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\')and students_dir is not null and (students is not null or students =\'enrolled\')'].join(''))).setRelated('students').setSortBy('Class ASC').setPageSize(100).setOffset(offset).setDistinct(true)));
        addItemToList(classList, _unused);
        offset = (typeof offset == 'number' ? offset : 0) + 100;
      }
      ___arguments.context.pageData['pageTitle'] = ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).split(' ')[0]);
      ___arguments.context.pageData['ClassList'] = (await Promise.all(classList.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Class')),[`label`]: ClassSlug });})));
      ___arguments.context.pageData['StudentList'] = [];
      ___arguments.context.pageData['ClassTitle'] = '';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_Student_Credentials').error((String('Error in Page Enter | Error:') + String(error)));

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/BMS_Student_Credentials/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    await Backendless.UserService.logout();
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_Student_Credential').error((String('Error in logout | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_Student_Credentials/components/51a4d73e0b3583b2a86af884ce7ff74b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'pageTitle')) === 'undefined') ? 'BMS Student Credentials' : String(getObjectProperty(___arguments.context.pageData, 'pageTitle')) + String('\'s Student Credentials'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_Student_Credentials/components/af330adce8522d3fa3ccf5ded28f2673/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    urlParam = ({  });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['fromAP'] = true;
      urlParam['fromDashboard'] = true;
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['fromDashboard'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Teacher' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_Student_Credentials').error((String('Error in Navigating back to Dashboard | Error:') + String(getObjectProperty(error, 'ap_name'))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_Student_Credentials/components/0244df799848a903bf91203dc87d3295/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, studentList, _oldClassSlug, weeklySlot, studentWeeklySlotList, class2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  class2 = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause((['Class=\'',___arguments.value,'\''].join(''))).setPageSize(10)))[0];
  console.log(class2);
  studentList = (await Backendless.Data.of('ms_classes').loadRelations((getObjectProperty(class2, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('students_dir').setPageSize(30).setOffset(0).setSortBy('student_name ASC')));
  console.log(studentList);
  if (___arguments.value.indexOf('1ON1') !== -1) {
    studentWeeklySlotList = (await Backendless.Data.of('ms_classes').loadRelations((getObjectProperty(class2, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('students').setPageSize(30).setOffset(0).setSortBy('student_name ASC')));
    weeklySlot = studentWeeklySlotList[0];
    _oldClassSlug = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendCreateMSSlotSlugFor1on1`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'SlotObject': (getObjectProperty(weeklySlot, 'slots_sort')),'Tutor': (getObjectProperty(weeklySlot, 'tutor')),'Grade': (getObjectProperty(weeklySlot, 'grade')),'Subject': (getObjectProperty(weeklySlot, 'subject')),'Group': (getObjectProperty(weeklySlot, 'group')),'Year': ((getObjectProperty(weeklySlot, 'slot_slug')).split('-')[6]),'Timezone': (getObjectProperty(weeklySlot, 'timezone')),'lead_id': (getObjectProperty(weeklySlot, 'lead_id')),'contact_id': (getObjectProperty(weeklySlot, 'contact_id')),'CurrentClassSlug': ___arguments.value })), 'SlotSlugWithRandomChar'));
  } else {
    _oldClassSlug = ___arguments.value;
  }
  ___arguments.context.pageData['ClassTitle'] = _oldClassSlug;
  ___arguments.context.pageData['StudentList'] = (await Promise.all(studentList.map(async item => {; return ({ [`name`]: (getObjectProperty(item, 'student_name')),[`studentMSEmail`]: ((getObjectProperty(item, 'studentMSEmail')) === null) ? 'Not Found' : (getObjectProperty(item, 'studentMSEmail')),[`studentMSPassword`]: ((getObjectProperty(item, 'studentMSPassword')) === null) ? 'Not Found' : (getObjectProperty(item, 'studentMSPassword')) });})));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff64453889bc48c39e52838ae79cfd28', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/BMS_Student_Credentials/components/bd06ddc12ba64db401857a1a392fec42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    urlParam = ({ [`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')),[`fromAP`]: true,[`fromDashboard`]: true });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_sso').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/BMS_Student_Credentials/components/cf29bee73b19414cd5e99da6428a82a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_Student_Credentials').debug((String('Problem with Back To Admin button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, ms_clubs, item, adviserDB, rawClub, MS_Directory_Placer, Classes, MSClasses, MicroschoolClass, TimeFormatted, Time, DateString, timezoneEST, StartTime, TempClasses, j, templist, WeeklySlot, ObjectList, student, offset, _unused, studentList, TeacherDB, tutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('525c6ed8455fa941a1e26853657a7cf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', false);
    MS_Directory_Placer = ({  });
    ___arguments.context.pageData['TimeTable'] = [];
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
      MS_Directory_Placer = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name=\'',((getObjectProperty(___arguments.context.pageData, 'student_name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
    } else {
      if (!(await Backendless.UserService.isValidLogin()) && (typeof (getObjectProperty(___arguments.context.pageData, 'studentMSEmail')) === 'undefined')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), undefined);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
        if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentMSEmail')) === 'undefined') || ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1)) {
          MS_Directory_Placer = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['studentMSEmail=\'',((!(typeof (getObjectProperty(___arguments.context.pageData, 'studentMSEmail')) === 'undefined') ? (getObjectProperty(___arguments.context.pageData, 'studentMSEmail')) : (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))).replace((new RegExp('\'', 'g')), '\'\'')),'\' and student_name != null'].join(''))).setPageSize(10)))[0];
        } else {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d646a580876f77ba79d1aae19091e4b', true);
          TeacherDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['(MS_teacher_email = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\' or email = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\') and accountType = \'BACKENDLESS\' and userType = \'Teacher\''].join(''))).setPageSize(100)))[0];
          ___arguments.context.pageData['isTeacher'] = (TeacherDB !== null && !Array.isArray(TeacherDB) && (typeof TeacherDB === 'object'));
          ___arguments.context.pageData['pageTitle'] = ((getObjectProperty(TeacherDB, 'name')).split(' ')[0]);
          ObjectList = [];
          studentList = [];
          offset = 0;
          var repeat_end = Math.ceil((await Backendless.Data.of('ms_classes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'isTeacher')) ? ['teacher = \'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\' or students.assistant_teacher=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\''].join('') : 'teacher not like \'TestNicolasTutor Live\' and teacher not like \'JomarTutor live\' and students.lead_id not like \'lead_LxXPvI8zzYVdVWGBqWgtZzHqF40H956TFOd0Rn9cWNr\' and Class not like \'%MS_BREAK%\'')))) / 100);
          for (var count = 0; count < repeat_end; count++) {
            _unused = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'isTeacher')) ? ['teacher = \'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\' or students.assistant_teacher=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\''].join('') : 'teacher not like \'TestNicolasTutor Live\' and teacher not like \'JomarTutor live\' and students.lead_id not like \'lead_LxXPvI8zzYVdVWGBqWgtZzHqF40H956TFOd0Rn9cWNr\' and Class not like \'%MS_BREAK%\'')).setRelated('students').setPageSize(100).setOffset(offset).setDistinct(true)));
            addItemToList(ObjectList, _unused);
            offset = (typeof offset == 'number' ? offset : 0) + 100;
          }
          ___arguments.context.pageData['ClassList'] = (await asyncListFilter(ObjectList, async (item) => {


           return (!((getObjectProperty(item, 'Class')) === null) && !((getObjectProperty(item, 'Class')).indexOf('MS_BREAK') !== -1) && !!(await asyncListFilter((getObjectProperty(item, 'students')), async (student) => {


           return ((getObjectProperty(student, 'status')).indexOf('enrolled') !== -1);
          })).length && !((getObjectProperty(item, 'Class')).indexOf('SUMMERSCHOOL') !== -1));
          }));
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
        }
      }
    }
    if ((MS_Directory_Placer !== null && !Array.isArray(MS_Directory_Placer) && (typeof MS_Directory_Placer === 'object')) && !(typeof MS_Directory_Placer === 'undefined') && (typeof (getObjectProperty(___arguments.context.pageData, 'fromTutorSSO')) === 'undefined')) {
      ___arguments.context.pageData['pageTitle'] = (getObjectProperty(MS_Directory_Placer, 'student_name'));
      console.log((getObjectProperty(MS_Directory_Placer, 'lead_id')) == 'lead_KzboCdSv3PWQWj4stPbbVXR37Z3w4m04XQ2zkF7883u' ? ['lead_id = \'',(getObjectProperty(MS_Directory_Placer, 'lead_id')),'\' and status = \'enrolled\' and student_name = \'',(getObjectProperty(MS_Directory_Placer, 'student_name')),'\' and startDate is not null'].join('') : ['lead_id = \'',(getObjectProperty(MS_Directory_Placer, 'lead_id')),'\' and status = \'enrolled\' and subject != \'CoTeaching\' and student_name = \'',(getObjectProperty(MS_Directory_Placer, 'student_name')),'\' and startDate is not null'].join(''));
      Classes = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((false ? ['lead_id = \'',(getObjectProperty(MS_Directory_Placer, 'lead_id')),'\' and status = \'enrolled\' and student_name = \'',(getObjectProperty(MS_Directory_Placer, 'student_name')),'\' and startDate is not null'].join('') : ((getObjectProperty(MS_Directory_Placer, 'lead_id')) == 'lead_KzboCdSv3PWQWj4stPbbVXR37Z3w4m04XQ2zkF7883u' ? ['lead_id = \'',(getObjectProperty(MS_Directory_Placer, 'lead_id')),'\' and status = \'enrolled\' and student_name = \'',(getObjectProperty(MS_Directory_Placer, 'student_name')),'\' and startDate is not null'].join('') : ['lead_id = \'',(getObjectProperty(MS_Directory_Placer, 'lead_id')),'\' and status = \'enrolled\' and subject != \'CoTeaching\' and student_name = \'',(getObjectProperty(MS_Directory_Placer, 'student_name')),'\' and startDate is not null'].join('')))).setProperties('calendar.start_time,Users[slots].zoomRaw,Users[slots].zoom,ms_classes[students].starting_time,ms_classes[students].grades,ms_classes[students].Class,ms_classes[students].teacher,ms_classes[students].zoomURL,timezones.offsetHour,timezones.region,timezones.short_name,slot_slug,tutor,*').setPageSize(100)));
      console.log(Classes);
      MSClasses = (await asyncListFilter(Classes, async (item) => {


       return (!((getObjectProperty(item, 'slot_slug')) === null) && ((getObjectProperty(item, 'slot_slug')).indexOf('MICROSCHOOL') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('SUMMERSCHOOL') !== -1) && (!((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('MS_CLUB') !== -1) || ((getObjectProperty(item, 'slot_slug')).indexOf('COTEACHING') !== -1)));
      }));
      console.log(MSClasses);
      Classes = (await asyncListFilter(Classes, async (item) => {


       return (!((getObjectProperty(item, 'slot_slug')) === null) && ((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1));
      }));
      console.log(Classes);
      templist = [];
      TempClasses = [];
      for (var j_index in MSClasses) {
        j = MSClasses[j_index];
        if (!(templist.includes((getObjectProperty(j, 'objectId'))))) {
          console.log(getObjectProperty(j, 'Class'));
          addItemToList(templist, (getObjectProperty(j, 'objectId')));
          addItemToList(TempClasses, j);
        }
      }
      MSClasses = TempClasses;
      templist = [];
      TempClasses = [];
      for (var j_index2 in Classes) {
        j = Classes[j_index2];
        if (!(templist.includes((getObjectProperty(j, 'objectId'))))) {
          addItemToList(templist, (getObjectProperty(j, 'objectId')));
          addItemToList(TempClasses, j);
        }
      }
      Classes = TempClasses;
      for (var MicroschoolClass_index in MSClasses) {
        MicroschoolClass = MSClasses[MicroschoolClass_index];
        if ((getObjectProperty(MicroschoolClass, 'timezone')).indexOf('Eastern') !== -1) {
          MicroschoolClass['MSSchedule'] = (!(typeof (getObjectProperty(MicroschoolClass, 'starting_time')) === 'undefined') ? (getObjectProperty(MicroschoolClass, 'starting_time')) : (getObjectProperty(MicroschoolClass, 'start_time')));
        } else {
          timezoneEST = (await Backendless.Data.of('timezones').find(Backendless.DataQueryBuilder.create().setWhereClause((['long_name = \'','US/Eastern','\''].join(''))).setPageSize(10)))[0];
          StartTime = (new Date((String('01/01/1970 ') + String((!(typeof (getObjectProperty(MicroschoolClass, 'starting_time')) === 'undefined') ? (getObjectProperty(MicroschoolClass, 'starting_time')) : (getObjectProperty(MicroschoolClass, 'start_time'))).split(' ')[3]))));
          DateString = ((new Date((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIConvertGMTDateExpressionsDSTByDate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'start_time': (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIConvertGMTDateExpressionsDSTByDate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'start_time': StartTime,'timezoneOffset': (getObjectProperty(timezoneEST, 'schedule_timezone')),'region': (getObjectProperty(timezoneEST, 'region')) })),'timezoneOffset': (getObjectProperty(MicroschoolClass, 'offsetHour')),'region': (getObjectProperty(MicroschoolClass, 'region')) })))).toString());
          Time = DateString.split(' ')[4];
          console.log(Time);
          TimeFormatted = Time.slice(0, 5);
          TimeFormatted = (TimeFormatted.startsWith('0')) ? TimeFormatted.slice(1, TimeFormatted.length) : TimeFormatted;
          MicroschoolClass['MSSchedule'] = ([((getObjectProperty(MicroschoolClass, 'slot_slug')).indexOf('ESE') !== -1) ? 'MON - THU ' : 'MON - FRI ',TimeFormatted,' ',(getObjectProperty(MicroschoolClass, 'short_name'))].join(''));
        }
        MicroschoolClass['MSGrade'] = (getObjectProperty(MicroschoolClass, 'grade'));
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('525c6ed8455fa941a1e26853657a7cf4', true);
      if (!MSClasses.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d22b63435998e7e1435c6faf7c2b5269', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb8ff0ad13b1cc710a4b8f857972eb5c', true);
      } else {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d22b63435998e7e1435c6faf7c2b5269', MSClasses);
        console.log(MSClasses);
      }
      if (!Classes.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78beb1e44b55501e613f6e556023080a', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6db39175752dbf89714711f0fc25c0a', true);
      } else {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('78beb1e44b55501e613f6e556023080a', Classes);
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_time_table').debug((['Error on page enter.\nError:n',error,'\n',(getObjectProperty(error, 'message'))].join('')));

  }
  try {
    if (MS_Directory_Placer !== null && !Array.isArray(MS_Directory_Placer) && (typeof MS_Directory_Placer === 'object')) {
      rawClub = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause((['Class like \'%CLUB%\' and students_dir.lead_id=\'',(getObjectProperty(MS_Directory_Placer, 'lead_id')),'\''].join(''))).setPageSize(30)));
      if (!!rawClub.length) {
        ms_clubs = (await Promise.all(rawClub.map(async item => {  adviserDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and name=\'',(getObjectProperty(item, 'teacher')),'\''].join(''))).setPageSize(10)))[0];
        ; return ({ [`teacher`]: (getObjectProperty(item, 'teacher')),[`clubSlot`]: (getObjectProperty(item, 'Class')),[`zoomId`]: (getObjectProperty(adviserDB, 'zoomRaw')),[`zoomURL`]: (getObjectProperty(item, 'zoomURL')) });})));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a59e6cb7e7acd379b5b0ac5c0233638', true);
        await new Promise(r => setTimeout(r, 400 || 0));
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d695e650c617f68ee0440383c01e989', ms_clubs);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7a3fe856bb986bc1ecd1bf8bc6928c2', true);
      }
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/BMS_time_table/components/73ee1db7d8c180bee29636bf831e024e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var TimeTableData, first, item, Students, Classes, Found;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e78c67e71fce91df479de1760ab2fcc1'), 'searchInput'))) == 0) {
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['TimeTable'] = [];
    ___arguments.context.getComponentDataStoreByUid('e78c67e71fce91df479de1760ab2fcc1')['ClassValue'] = '';
    ___arguments.context.getComponentDataStoreByUid('e78c67e71fce91df479de1760ab2fcc1')['StudentValue'] = '';
    ___arguments.context.pageData['infoTitle'] = '';
  } else {
    Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


     return (([(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join('').toUpperCase()).indexOf(((___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')).toUpperCase())) !== -1);
    }));
    if (!Classes.length) {
      return null;
    }
    Found = (await Promise.all(Classes.map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join(''),[`value`]: (getObjectProperty(item, 'Class')) });})));
    ___arguments.context.getComponentDataStoreByUid('e78c67e71fce91df479de1760ab2fcc1')['ClassOptions'] = Found;
    ___arguments.context.pageData['TimeTable'] = Classes;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/BMS_time_table/components/d7c7ad3a9bcc895d2fd6d7e58d636b4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'Class')).split('-')[2].split('_')[0]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'Class')).split('-')[2].split('_')[0]).indexOf('REMEDIAL') !== -1) || (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'Class')).split('-')[2]).indexOf('STUDENT_COUNCIL') !== -1) ? (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'Class')).split('-')[2]).replace((new RegExp('_', 'g')), ' ')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'Class')).split('-')[2].split('_')[0]))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/a4d5ae9456ca4c16dd7809ce64c8ae5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18bc10aea44e22af2f09503c4a2a7c38'), 'teacherZoom'));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((false ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('18bc10aea44e22af2f09503c4a2a7c38'), 'teacherZoom')) : ['https://hi.btgs.co/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18bc10aea44e22af2f09503c4a2a7c38'), 'teacher')).split(' ')[0].toLowerCase(),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18bc10aea44e22af2f09503c4a2a7c38'), 'teacher')).split(' ').slice(-1)[0].toLowerCase()].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('18bc10aea44e22af2f09503c4a2a7c38'), 'teacherZoom')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/0244df799848a903bf91203dc87d3295/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var TimeTableData, first, item, Students, Classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


   return ((getObjectProperty(item, 'Class')).startsWith(___arguments.value));
  }));
  Students = (await Backendless.Data.of('ms_classes').loadRelations((getObjectProperty((Classes[0]), 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('students').setPageSize(25).setOffset(0)));
  ___arguments.context.getComponentDataStoreByUid('e78c67e71fce91df479de1760ab2fcc1')['StudentOptions'] = (await Promise.all(Students.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'student_name')),[`value`]: (getObjectProperty(item, 'student_name')) });})));
  ___arguments.context.pageData['TimeTable'] = Classes;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/BMS_time_table/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_time_table').debug((['BMS_time_table logout Error:\n',error,'\n',(getObjectProperty(error, ''))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/67a351960bf4677d03a9c59980e18a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((true ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'teacherZoom')) : ['https://hi.btgs.co/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'tutor')).split(' ')[0].toLowerCase(),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'tutor')).split(' ').slice(-1)[0].toLowerCase()].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'teacherZoom')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/dd141a5dafda4595aa794a8cf933921a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var StudentInfo, MSClass, num, item, Students, Classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


   return ((getObjectProperty(item, 'Class')).startsWith((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e78c67e71fce91df479de1760ab2fcc1'), 'ClassValue'))));
  }));
  Students = (await asyncListFilter((getObjectProperty((Classes[0]), 'students')), async (item) => {


   return ((getObjectProperty(item, 'student_name')).startsWith(___arguments.value));
  }));
  ___arguments.context.pageData['infoTitle'] = (String(getObjectProperty((Students[0]), 'student_name')) + String('\'s Classes'));
  StudentInfo = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause((['students.student_name = \'',(getObjectProperty((Students[0]), 'student_name')),'\' and students.parent_name = \'',(getObjectProperty((Students[0]), 'parent_name')),'\' and students.lead_id = \'',(getObjectProperty((Students[0]), 'lead_id')),'\''].join(''))).setPageSize(100)));
  MSClass = (await asyncListFilter(StudentInfo, async (item) => {


   return ((getObjectProperty(item, 'Class')).indexOf('MICROSCHOOL') !== -1);
  }))[0];
  removeItemInList(StudentInfo, MSClass, '');
  StudentInfo = (await asyncListSort(StudentInfo, 1, async (item) => {
     num = String(((getObjectProperty(item, 'Class')).indexOf('MON') !== -1) ? 1 : (((getObjectProperty(item, 'Class')).indexOf('TUE') !== -1) ? 2 : (((getObjectProperty(item, 'Class')).indexOf('WED') !== -1) ? 3 : (((getObjectProperty(item, 'Class')).indexOf('THU') !== -1) ? 4 : (((getObjectProperty(item, 'Class')).indexOf('FRI') !== -1) ? 5 : 6))))) + String((getObjectProperty(item, 'starting_time')).split(' ')[1].slice(0, ((getObjectProperty(item, 'starting_time')).split(' ')[1].indexOf(':') + 1) - 1));


   return num;
  }));
  StudentInfo[0] = MSClass;
  if (!(typeof StudentInfo === 'undefined')) {
    ___arguments.context.pageData['TimeTable'] = StudentInfo;
    console.log(StudentInfo);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/BMS_time_table/components/3cf9821da0f97c280e0f232cd7b4205d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1500 || 0));

  return (!!(getObjectProperty(___arguments.context.pageData, 'TimeTable')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/ff64453889bc48c39e52838ae79cfd28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1500 || 0));

  return (!(getObjectProperty(___arguments.context.pageData, 'TimeTable')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/51a4d73e0b3583b2a86af884ce7ff74b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'pageTitle')) === 'undefined') ? 'BMS Timetable' : String(getObjectProperty(___arguments.context.pageData, 'pageTitle')) + String('\'s Timetable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/a78e56e47435d58a328d557234ebe7a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'Class')).split('-')[2].split('_')[0]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'Class')).split('-')[2].split('_')[0]) : (await BackendlessUI.Functions.Custom['fn_2cd130a2816951bedf8c3a643d842fde'](((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'Class')).split('-')[2]))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/49d74029aad92b9437d68cc1ef480b99/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.dataModel, 'Class')).indexOf('ELECTIVE') !== -1) || ((getObjectProperty(___arguments.context.dataModel, 'Class')).indexOf('HOMESCHOOL') !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['background'] = '#d2c7f1';
  } else if (((getObjectProperty(___arguments.context.dataModel, 'Class')).indexOf('MICROSCHOOL') !== -1) && !((getObjectProperty(___arguments.context.dataModel, 'Class')).indexOf('HOMESCHOOL') !== -1)) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['background'] = '#FACFBF';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/e78c67e71fce91df479de1760ab2fcc1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  if (typeof (getObjectProperty(___arguments.context.pageData, 'ClassList')) === 'undefined') {
    return null;
  }
  ___arguments.context.dataModel['ClassOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'ClassList')).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join(''),[`value`]: (getObjectProperty(item, 'Class')) });})));
  if (getObjectProperty(___arguments.context.pageData, 'isTeacher')) {
    ___arguments.context.dataModel['searchInput'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name'));
    ___arguments.context.dataModel['searchDisabled'] = true;
  }
  ___arguments.context.dataModel['ClassLabel'] = 'Choose a classroom';
  ___arguments.context.dataModel['StudentLabel'] = 'Choose a student';
  ___arguments.context.pageData['TimeTable'] = (getObjectProperty(___arguments.context.pageData, 'ClassList'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/BMS_time_table/components/0d9cd3f2a6b90254f289a75328c18169/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var TeacherObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TeacherObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'teacher')).replace((new RegExp('\'', 'igu')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(TeacherObject, 'zoomRaw')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/037f9dc6ba71587fec6341ac39e51623/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var startingTime, TimeFormatted, Day, Time, DateString, timezoneEST, StartTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'timezone')).indexOf('Eastern') !== -1) {
    startingTime = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'starting_time'));
  } else {
    timezoneEST = (await Backendless.Data.of('timezones').find(Backendless.DataQueryBuilder.create().setWhereClause((['long_name = \'','US/Eastern','\''].join(''))).setPageSize(10)))[0];
    StartTime = (new Date((String('01/01/1970 ') + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'starting_time')).split(' ')[1]))));
    DateString = ((new Date((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIConvertGMTDateExpressionsDSTByDate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'start_time': (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIConvertGMTDateExpressionsDSTByDate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'start_time': StartTime,'timezoneOffset': (getObjectProperty(timezoneEST, 'schedule_timezone')),'region': (getObjectProperty(timezoneEST, 'region')) })),'timezoneOffset': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'offsetHour')),'region': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'region')) })))).toString());
    Day = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'starting_time')).split(' ')[0].toUpperCase();
    Time = DateString.split(' ')[4];
    TimeFormatted = Time.slice(0, 5);
    TimeFormatted = (TimeFormatted.startsWith('0')) ? TimeFormatted.slice(1, TimeFormatted.length) : TimeFormatted;
    startingTime = [Day,' ',TimeFormatted,' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'short_name'))].join('');
  }

  return startingTime

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/af330adce8522d3fa3ccf5ded28f2673/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam, url;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    url = '';
    urlParam = ({  });
    if ((getObjectProperty(___arguments.context.pageData, 'SSO')) || (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
      url = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Student' }) }));
      urlParam = (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) ? ({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`student_name`]: (getObjectProperty(___arguments.context.pageData, 'student_name')),[`fromParentOTP`]: true }) : null;
    } else {
      url = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Teacher' }) }));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
        urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
        urlParam['fromAP'] = true;
        urlParam['fromDashboard'] = true;
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
        urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
        urlParam['fromSA'] = true;
        urlParam['fromDashboard'] = true;
      }
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(url, false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_time_table').error((['Error in Navigating back to Dashboard | Error:\n',error,'\nLead ID: ',(getObjectProperty(___arguments.context.pageData, 'lead_id'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/49eb0f1911a23b773cfb7656bc1dfe8b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Class, _oldClassSlug, weeklySlot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Class = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('18bc10aea44e22af2f09503c4a2a7c38'), 'Class'));

  return (await BackendlessUI.Functions.Custom['fn_2cd130a2816951bedf8c3a643d842fde']((Class.split('-')[2])))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/d17c61b1f2f49205db7b77f54acf08e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var TeacherObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TeacherObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'teacher')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(TeacherObject, 'video')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/26abf05c0f8128038d0822930ba73f0d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c9a046595388081646b1bb33a1d64c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/902e2c8402c54a9bbfa730c105ddee2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb557b9f672e67873ea61395a0f2ca59', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/ad73f92e84232b0973547ab7d10a6547/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb557b9f672e67873ea61395a0f2ca59'), 'teacherPresentation')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/e569559928c2b6b7a925a39883185baa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb557b9f672e67873ea61395a0f2ca59', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/a7c9a046595388081646b1bb33a1d64c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var TeacherObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TeacherObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(___arguments.context.dataModel, 'teacher')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
  ___arguments.context.dataModel['teacherZoomid'] = (getObjectProperty(TeacherObject, 'zoomid'));
  ___arguments.context.dataModel['teacherEmail'] = (getObjectProperty(TeacherObject, 'MS_teacher_email'));
  ___arguments.context.dataModel['teacherPresentation'] = (getObjectProperty(TeacherObject, 'video'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/BMS_time_table/components/536bdb24b9bfc0a17376d6ddf9a3953c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7c9a046595388081646b1bb33a1d64c'), 'teacherPresentation')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/2f6d076d714c6a2988e8535337a314e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c9a046595388081646b1bb33a1d64c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/18bc10aea44e22af2f09503c4a2a7c38/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var TeacherObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TeacherObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',((getObjectProperty(___arguments.context.dataModel, 'teacher')).replace((new RegExp('\'', 'igu')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
  ___arguments.context.dataModel['teacherZoomid'] = (getObjectProperty(TeacherObject, 'zoomid'));
  ___arguments.context.dataModel['teacherZoom'] = (getObjectProperty(TeacherObject, 'zoomRaw'));
  ___arguments.context.dataModel['teacherEmail'] = (getObjectProperty(TeacherObject, 'MS_teacher_email'));
  ___arguments.context.dataModel['teacherPresentation'] = (getObjectProperty(TeacherObject, 'video'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/BMS_time_table/components/fe474094e3579d3c963d2809d7293f02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('18bc10aea44e22af2f09503c4a2a7c38'), 'teacherZoom')) === null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/4bcec1f3b9b5e3f3dbf454e155e3303c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb557b9f672e67873ea61395a0f2ca59'), 'teacherZoomid')) === null) ? 'Meeting ID will be available shortly' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb557b9f672e67873ea61395a0f2ca59'), 'teacherZoomid')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/700830cbb7e12b28bc2858e799f759fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7c9a046595388081646b1bb33a1d64c'), 'teacherZoomid')) === null) ? 'Meeting ID will be available shortly' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7c9a046595388081646b1bb33a1d64c'), 'teacherZoomid')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/efbc875a0505a4299c5968b6f82beb7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fc3b2fd390f4780b5d9f4e0d59454ef2'), 'teacherZoom')) === null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/fc3b2fd390f4780b5d9f4e0d59454ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var TeacherObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TeacherObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(___arguments.context.dataModel, 'teacher')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
  ___arguments.context.dataModel['teacherZoomid'] = (getObjectProperty(TeacherObject, 'zoomid'));
  ___arguments.context.dataModel['teacherZoom'] = (getObjectProperty(TeacherObject, 'zoomRaw'));
  ___arguments.context.dataModel['teacherEmail'] = (getObjectProperty(TeacherObject, 'MS_teacher_email'));
  ___arguments.context.dataModel['teacherPresentation'] = (getObjectProperty(TeacherObject, 'video'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/BMS_time_table/components/c0e8eece0c6e8f16c0d8bfd5d372f6bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    urlParam = ({  });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['fromAP'] = true;
      urlParam['fromDashboard'] = true;
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['fromDashboard'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_Time_table').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/dbaf80025c0ac7a43dabdbc26aff03a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_time_table').debug((String('Problem with Back Admin button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/4f6424a7ad45cf8b24b7d227334b473b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Parent' }) })), false, ({ [`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('BMS_time_table').debug((String('Problem encountered in clicking Back to Student List | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BMS_time_table/components/276ab8f54195901c27b5d2838f9ad433/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'pageTitle')) + String('\'s Club'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/c9ff86930f021906058a8e7a07be0e48/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var ClubSlot, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}


  ClubSlot = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea8cbfc5ab1ed7a5514081c70e5db96'), 'clubSlot')).split('-')[2];

  return (String(textToTitleCase(ClubSlot.split('_')[0])) + String((ClubSlot.indexOf('_A1') !== -1) ? ' Lower Elementary' : ((ClubSlot.indexOf('_B1') !== -1) ? ' Upper Elementary' : ((ClubSlot.indexOf('_C1') !== -1) ? ' Lower High' : ((ClubSlot.indexOf('_D1') !== -1) ? ' Upper High' : '')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/4c5a31623f148d94388d434293dbed93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var schedule, list, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  schedule = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea8cbfc5ab1ed7a5514081c70e5db96'), 'clubSlot')).split('-')[3];

  return ([schedule.slice(0, 3),' ',schedule.slice(3, schedule.length),' EST'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/BMS_time_table/components/87bd4e15f662e4f36ba170b397ddf6d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fea8cbfc5ab1ed7a5514081c70e5db96'), 'zoomId')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/GMeet_Recordings/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var recordingData, ObjectList, loadingData, _unused, offset, LeadHolder, nameOfTutor, leadDB, leadData, userType;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'tutorEmail'));
  console.log(await Backendless.UserService.getCurrentUser(false));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', false);
  if (((function () { return window.location.href })()).indexOf('user_type=Admin') !== -1) {
    userType = 'SystemGet';
  }
  leadData = (await Backendless.UserService.getCurrentUser(false));
  if (!(leadData !== null && !Array.isArray(leadData) && (typeof leadData === 'object')) && !(typeof (getObjectProperty(___arguments.context.pageData, 'tutorEmail')) === 'undefined')) {
    leadData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty(___arguments.context.pageData, 'tutorEmail')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
  }
  leadDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType = \'BACKENDLESS\' AND ','name = \'',!(typeof userType === 'undefined') ? userType : ((getObjectProperty(leadData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(1)))[0];
  ___arguments.context.pageData['dateDesc'] = true;
  LeadHolder = leadDB;
  ___arguments.context.pageData['Recordings'] = [];
  ___arguments.context.pageData['oldRecordings'] = [];
  ___arguments.context.pageData['searchedData'] = [];
  ___arguments.context.pageData['searchInput'] = '';
  ___arguments.context.pageData['searchByDate'] = '';
  ___arguments.context.pageData['leadData'] = leadDB;
  ___arguments.context.pageData['increment'] = 0;
  ___arguments.context.pageData['pageNum'] = 1;
  ___arguments.context.pageData['GMeetRec'] = false;
  if ((await Backendless.UserService.isValidLogin()) && (getObjectProperty(LeadHolder, 'userType')) != 'Teacher' && (getObjectProperty(LeadHolder, 'userType')) != 'Admin') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    ObjectList = [];
    loadingData = true;
    offset = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
    if ((getObjectProperty(LeadHolder, 'userType')) == 'Teacher' && (getObjectProperty(LeadHolder, 'name')) != 'Jordan Knoetgen') {
      nameOfTutor = String((getObjectProperty(LeadHolder, 'name')).split(' ')[0]) + String('\'s Google Meet Recordings');
      ___arguments.context.pageData['tutorName'] = nameOfTutor;
      recordingData = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event=\'meeting.end\')',' and  tutor = \'',((getObjectProperty(LeadHolder, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created<=\'',((new Date()).valueOf()),'\''].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1f6c38ad287b682ab7849c144e72da3', true);
    } else if ((getObjectProperty(LeadHolder, 'userType')) != 'Teacher' || (getObjectProperty(LeadHolder, 'name')) == 'Jordan Knoetgen') {
      recordingData = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['event = \'recording.completed\'',' AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\''].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73ee1db7d8c180bee29636bf831e024e', true);
    }
    ___arguments.context.pageData['Recordings'] = (recordingData.slice(0, 10));
    ___arguments.context.pageData['oldRecordings'] = recordingData;
    if (!(getObjectProperty(___arguments.context.pageData, 'Recordings')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d52ca7be59d3d3d87624f4dd247fd53f', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/GMeet_Recordings/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/GMeet_Recordings/components/73ee1db7d8c180bee29636bf831e024e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var newRecordings, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['searchInput'] = ___arguments.value;
  newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')','and  tutor LIKE \'%',___arguments.value,'%\' AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
  if (___arguments.value == '') {
    newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['event = \'recording.completed\'','AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'searchByDate')) != '') {
    newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['event = \'recording.completed\'','and  tutor LIKE \'%',___arguments.value,'%\' AND created>=\'',((getObjectProperty(___arguments.context.pageData, 'searchByDate')).valueOf()),'\' AND created<=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
  }
  ___arguments.context.pageData['Recordings'] = (newRecordings.slice(0, 10));
  ___arguments.context.pageData['searchedData'] = newRecordings;
  ___arguments.context.pageData['pageNum'] = 1;
  ___arguments.context.pageData['increment'] = 0;
  if (!!(getObjectProperty(___arguments.context.pageData, 'Recordings')).length) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/GMeet_Recordings/components/73374bd9d22792588107eec390513e09/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var newRecordings, ObjectList, loadingData, _unused, offset, LeadHolder, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value != '' && ___arguments.value != null) {
    ___arguments.context.pageData['searchByDate'] = ___arguments.value;
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'userType')) == 'Teacher') {
      newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')','and  tutor = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'name')),'\' AND created>=\'',(___arguments.value.valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'userType')) != 'Teacher') {
      newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')','AND created>=\'',(___arguments.value.valueOf()),'\' AND created<=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
      if ((getObjectProperty(___arguments.context.pageData, 'searchInput')) != '') {
        newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')','AND created>=\'',(___arguments.value.valueOf()),'\' AND created<=\'',((new Date()).valueOf()),'\' AND tutor LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'searchInput')),'%\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
      }
    }
  } else if (___arguments.value == '' || ___arguments.value == null) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'userType')) == 'Teacher') {
      newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')','and  tutor = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'name')),'\' AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created<=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'userType')) != 'Teacher') {
      newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')','AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
    }
  }
  ___arguments.context.pageData['Recordings'] = (newRecordings.slice(0, 10));
  ___arguments.context.pageData['searchedData'] = newRecordings;
  ___arguments.context.pageData['pageNum'] = 1;
  ___arguments.context.pageData['increment'] = 0;
  if (!newRecordings.length) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/GMeet_Recordings/components/0d9cd3f2a6b90254f289a75328c18169/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'recording')) === null)) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'recording')), true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'recording')) === null) ? 'Not Recorded' : 'Recording')

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'recording')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings/components/a78e56e47435d58a328d557234ebe7a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'created')))))).toDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings/components/4eb8f764de1962c4e277234aefd3e30f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var LeadHolder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LeadHolder = (getObjectProperty(___arguments.context.pageData, 'leadData'));

  return ((getObjectProperty(LeadHolder, 'userType')) != 'Teacher')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings/components/0cf76e3118e822275112a7c7a9f4f835/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recordingData, ObjectList, loadingData, _unused, offset, LeadHolder, nameOfTutor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LeadHolder = (getObjectProperty(___arguments.context.pageData, 'leadData'));
  ___arguments.context.pageData['searchInput'] = '';
  ___arguments.context.pageData['dateDesc'] = true;
  ___arguments.context.pageData['searchedData'] = '';
  ___arguments.context.pageData['searchByDate'] = '';
  ___arguments.context.pageData['pageNum'] = 1;
  ___arguments.context.pageData['increment'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
  console.log(getObjectProperty(LeadHolder, 'userType'));
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Main_Page', undefined);
  } else {
    ObjectList = [];
    loadingData = true;
    offset = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
    if ((getObjectProperty(LeadHolder, 'userType')) == 'Teacher') {
      nameOfTutor = String((getObjectProperty(LeadHolder, 'name')).split(' ')[0]) + String('\'s Google Meet Recordings');
      ___arguments.context.pageData['tutorName'] = nameOfTutor;
      ObjectList = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')','and  tutor = \'',(getObjectProperty(LeadHolder, 'name')),'\' AND created  >=\'',((new Date((new Date()).getTime() - (2629746 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\''].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(10)));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1f6c38ad287b682ab7849c144e72da3', true);
    } else if ((getObjectProperty(LeadHolder, 'userType')) != 'Teacher') {
      ObjectList = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')','AND created  >=\'',((new Date((new Date()).getTime() - (2629746 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\''].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(10)));
      console.log('OBJECT LIST:');
      console.log(ObjectList);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73ee1db7d8c180bee29636bf831e024e', true);
    }
    ___arguments.context.pageData['Recordings'] = (ObjectList.slice(0, 10));
    ___arguments.context.pageData['oldRecordings'] = ObjectList;
    console.log((getObjectProperty(___arguments.context.pageData, 'Recordings')).length);
    if (!(getObjectProperty(___arguments.context.pageData, 'Recordings')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d52ca7be59d3d3d87624f4dd247fd53f', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/GMeet_Recordings/components/47279f41b1645fadd89bee1665bcb50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var rminutes, rhours, minutes, hour, time;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  time = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'duration'));
  hour = time / 60;
  rhours = Math.floor(hour);
  minutes = hour - rhours;
  rminutes = Math.round(minutes * 60);

  return ([rhours != 0 ? String(rhours) + String('hrs ') : '',rminutes,'mins'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings/components/259300e1402e3a65c562ba3ae98b8259/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var tend, tstart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tstart = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'start_time'));
  tend = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'end_time'));

  return ([((new Date(tstart)).toLocaleTimeString()),' - ',((new Date(tend)).toLocaleTimeString())].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings/components/d52ca7be59d3d3d87624f4dd247fd53f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var increment, offset, LeadHolder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  increment = (getObjectProperty(___arguments.context.pageData, 'pageNum')) - 1;
  LeadHolder = (getObjectProperty(___arguments.context.pageData, 'leadData'));
  if (increment != 0) {
    if (increment == 1) {
      offset = 1;
      ___arguments.context.pageData['Recordings'] = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')',(getObjectProperty(LeadHolder, 'userType')) != 'Teacher' ? ((getObjectProperty(___arguments.context.pageData, 'searchInput')) != '' ? ['AND  tutor LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'searchInput')),'%\''].join('') : '') : ['AND  tutor=\'',(getObjectProperty(LeadHolder, 'name')),'\''].join(''),(getObjectProperty(___arguments.context.pageData, 'searchByDate')) != '' ? ['AND created>=\'',((getObjectProperty(___arguments.context.pageData, 'searchByDate')).valueOf()),'\' AND created<=\'',((new Date()).valueOf()),'\''].join('') : ['AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\''].join('')].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(10).setOffset(offset)));
    } else {
      offset = (increment - 1) * 10 + ((getObjectProperty(___arguments.context.pageData, 'pageNum')) - increment);
      ___arguments.context.pageData['Recordings'] = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')',(getObjectProperty(LeadHolder, 'userType')) != 'Teacher' ? ((getObjectProperty(___arguments.context.pageData, 'searchInput')) != '' ? ['AND  tutor LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'searchInput')),'%\''].join('') : '') : ['AND  tutor=\'',(getObjectProperty(LeadHolder, 'name')),'\''].join(''),(getObjectProperty(___arguments.context.pageData, 'searchByDate')) != '' ? ['AND created>=\'',((getObjectProperty(___arguments.context.pageData, 'searchByDate')).valueOf()),'\' AND created<=\'',((new Date()).valueOf()),'\''].join('') : ['AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\''].join('')].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(10).setOffset(offset)));
    }
    ___arguments.context.pageData['pageNum'] = increment;
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'pageNum')) > 1)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings/components/322e42ee926b11e17b09009e602101d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var increment, offset, LeadHolder, recordingsData, recordingList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  increment = (getObjectProperty(___arguments.context.pageData, 'pageNum')) + 1;
  LeadHolder = (getObjectProperty(___arguments.context.pageData, 'leadData'));
  offset = (getObjectProperty(___arguments.context.pageData, 'pageNum')) * 10 + (increment - (getObjectProperty(___arguments.context.pageData, 'pageNum')));
  recordingList = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')',(getObjectProperty(LeadHolder, 'userType')) != 'Teacher' ? ((getObjectProperty(___arguments.context.pageData, 'searchInput')) != '' ? ['AND  tutor LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'searchInput')),'%\''].join('') : '') : ['AND  tutor=\'',(getObjectProperty(LeadHolder, 'name')),'\''].join(''),(getObjectProperty(___arguments.context.pageData, 'searchByDate')) != '' ? ['AND created>=\'',((getObjectProperty(___arguments.context.pageData, 'searchByDate')).valueOf()),'\'AND created<=\'',((new Date()).valueOf()),'\''].join('') : ['AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\'AND created<=\'',((new Date()).valueOf()),'\''].join(''),(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(10).setOffset(offset)));
  if (recordingList > 10) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('322e42ee926b11e17b09009e602101d9', false);
  } else {
    recordingsData = recordingList.slice(0, 10);
    if (!!recordingsData.length) {
      ___arguments.context.pageData['Recordings'] = recordingsData;
      ___arguments.context.pageData['pageNum'] = increment;
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/GMeet_Recordings/components/ca433d92b6b2e1dd1dcea1aea2e10323/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var increment, offset, recordingsData, recordingList, LeadHolder, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  LeadHolder = (getObjectProperty(___arguments.context.pageData, 'leadData'));
  ___arguments.context.pageData['dateDesc'] = ((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? false : true);
  increment = (getObjectProperty(___arguments.context.pageData, 'pageNum'));
  offset = (getObjectProperty(___arguments.context.pageData, 'pageNum')) * 10 + (increment - (getObjectProperty(___arguments.context.pageData, 'pageNum')));
  recordingList = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(event = \'recording.completed\' or event = \'meeting.end\')',(getObjectProperty(LeadHolder, 'userType')) != 'Teacher' ? ((getObjectProperty(___arguments.context.pageData, 'searchInput')) != '' ? ['AND  tutor LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'searchInput')),'%\''].join('') : '') : ['AND  tutor=\'',(getObjectProperty(LeadHolder, 'name')),'\''].join(''),(getObjectProperty(___arguments.context.pageData, 'searchByDate')) != '' ? ['AND created>=\'',((getObjectProperty(___arguments.context.pageData, 'searchByDate')).valueOf()),'\'AND created<=\'',((new Date()).valueOf()),'\''].join('') : ['AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\'AND created<=\'',((new Date()).valueOf()),'\''].join('')].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(10).setOffset(offset)));
  if (recordingList > 10) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('322e42ee926b11e17b09009e602101d9', false);
  } else {
    recordingsData = recordingList.slice(0, 10);
    if (!!recordingsData.length) {
      ___arguments.context.pageData['Recordings'] = recordingsData;
      ___arguments.context.pageData['pageNum'] = increment;
    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'Date Descending' : 'Date Ascending')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings/components/bac4f1bef2ed979a809ae2c37de71f34/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_sso', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/GMeet_Recordings/components/52d445827c9b6299e826bc69b491d9a6/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'GMeetRec'))

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, newRecordings, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['GMeetRec'] = ((getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? false : true);
    ___arguments.context.pageData['dateDesc'] = false;
    newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['event = \'recording.completed\'','AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
    if (!!(getObjectProperty(___arguments.context.pageData, 'searchInput')).length) {
      newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['event = \'recording.completed\'','and  tutor LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'searchInput')),'%\' AND created>=\'',((new Date((new Date()).getTime() - (7890000 * 1000))).valueOf()),'\' AND created <=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'searchByDate')) != '') {
      newRecordings = (await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['event = \'recording.completed\'','and  tutor LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'searchInput')),'%\' AND created>=\'',((getObjectProperty(___arguments.context.pageData, 'searchByDate')).valueOf()),'\' AND created<=\'',((new Date()).valueOf()),'\'',(getObjectProperty(___arguments.context.pageData, 'GMeetRec')) ? ' and recording like \'%drive.google%\'' : null].join(''))).setSortBy(((getObjectProperty(___arguments.context.pageData, 'dateDesc')) ? 'created DESC' : 'created ASC')).setPageSize(100)));
    }
    ___arguments.context.pageData['Recordings'] = (newRecordings.slice(0, 10));
    ___arguments.context.pageData['searchedData'] = newRecordings;
    ___arguments.context.pageData['pageNum'] = 1;
    ___arguments.context.pageData['increment'] = 0;
    if (!!(getObjectProperty(___arguments.context.pageData, 'Recordings')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/GMeet_Recordings/components/d9130234d97cecef12f8cafd94db0fa7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'recording')) === null) ? (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'recording')).indexOf('drive.google') !== -1) ? 'Google Meet Recording' : 'Zoom Recording') : 'Not Recorded')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings/components/801bb74cf961088e6d98de456e842e8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'recording')) === null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings_V2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, ModRecordings, j, ms_class, tutorDB, DateMax, DateMin, recordings, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ce3be919212e6936fc457c8394551d3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65a483071303872acb6f30b80dd29ded', true);
    DateMin = ((new Date(([(new Date((new Date((new Date()).getTime() - ((1 * 86400) * 1000)))).getFullYear()),'-',(new Date((new Date((new Date()).getTime() - ((1 * 86400) * 1000)))).getMonth() + 1),'-',(new Date((new Date((new Date()).getTime() - ((1 * 86400) * 1000)))).getDate()),' 00:00'].join('')))).valueOf());
    DateMax = ((new Date(([(new Date((new Date())).getFullYear()),'-',(new Date((new Date())).getMonth() + 1),'-',(new Date((new Date())).getDate()),' 23:59'].join('')))).valueOf());
    console.log(DateMin);
    recordings = (await asyncListSort((await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(tutor not like \'%Test%\' or tutor not like \'%JomarTutor%\') and start_time >= ',DateMin,' and end_time <= ',DateMax].join(''))).setSortBy('start_time').setPageSize(15))), -1, async (item) => {


     return (getObjectProperty(item, 'start_time'));
    }));
    ModRecordings = [];
    ___arguments.context.pageData['SearchTutor'] = '';
    ___arguments.context.pageData['DateRange'] = (new Date());
    for (var j_index in recordings) {
      j = recordings[j_index];
      console.log(['accountType=\'BACKENDLESS\' and name=\'',(getObjectProperty(j, 'tutor')),'\''].join(''));
      tutorDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and name=\'',((getObjectProperty(j, 'tutor')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
      j['Description'] = (false ? textToTitleCase(((getObjectProperty(ms_class, 'Description')).split('-')[2]).replace((new RegExp('_', 'igu')), ' ')) : (getObjectProperty(j, 'topic')));
      j['zoom_code'] = (getObjectProperty(tutorDB, 'zoomRaw'));
      j['start_date'] = (getObjectProperty(j, 'start_time'));
      j['end_date'] = (getObjectProperty(j, 'end_time'));
      addItemToList(ModRecordings, j);
    }
    if (!!ModRecordings.length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65a483071303872acb6f30b80dd29ded', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ce3be919212e6936fc457c8394551d3', true);
      await new Promise(r => setTimeout(r, 300 || 0));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2890cf79e5d4920449ab8f2b8b8629', ModRecordings);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65a483071303872acb6f30b80dd29ded', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c77a46d230307dad5f87fa149a143ec', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/GMeet_Recordings_V2/components/6a0ff6aa765d34aee12f6cc1b5874ba5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'recording')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/GMeet_Recordings_V2/components/fd3fd8db232d85c29e18fa945046221d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'tutor')),'\'s ',(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'Description')).replace((new RegExp('Ms ', 'igu')), '')).replace((new RegExp('Ese', 'igu')), 'ESE'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings_V2/components/333e23b12d1cbc8cde65f7c20d9aea4d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'zoom_code')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/GMeet_Recordings_V2/components/474452d936e6b9541cbeaf8b36f1f9dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}



  return (false ? subsequenceFromStartLast([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'start_date')))).toDateString()),' ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'start_date')))).toLocaleTimeString())].join(''), 4) : subsequenceFromStartLast([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'start_time')))).toDateString()),' ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'start_time')))).toLocaleTimeString())].join(''), 4))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings_V2/components/b22e03c241c4c25288fed80b1a4124ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}



  return (false ? subsequenceFromStartLast([((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'end_date')).toDateString()),' ',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'end_date')).toLocaleTimeString())].join(''), 4) : subsequenceFromStartLast([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'end_time')))).toDateString()),' ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6e8120a642b8d1e10ef5bd492ab3fdf7'), 'end_time')))).toLocaleTimeString())].join(''), 4))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/GMeet_Recordings_V2/components/ab93397400bfdf3b687ed2c9ea838e56/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, ModRecordings, j, ms_class, tutorDB, DateMax, DateMin, recordings, item;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c77a46d230307dad5f87fa149a143ec', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65a483071303872acb6f30b80dd29ded', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ce3be919212e6936fc457c8394551d3', false);
    await new Promise(r => setTimeout(r, 400 || 0));
    if (getValueLength(___arguments.value) > 3) {
      ___arguments.context.pageData['SearchTutor'] = ___arguments.value;
      ___arguments.context.pageData['DateRange'] = (new Date((new Date()).getTime() - ((2 * 86400) * 1000)));
      DateMin = ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getFullYear()),'-',(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getMonth() + 1),'-',(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getDate()),' 00:00'].join('')))).valueOf());
      DateMax = ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getFullYear()),'-',(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getMonth() + 1),'-',(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getDate()),' 23:59'].join('')))).valueOf());
      console.log(DateMin);
      console.log(['(tutor not like \'%Test%\' or tutor not like \'%JomarTutor%\')',' and tutor like \'%',___arguments.value,'%\' and event=\'recording.completed\''].join(''));
      recordings = (await asyncListSort((await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(tutor not like \'%Test%\' or tutor not like \'%JomarTutor%\')',' and tutor like \'%',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'%\' and event=\'recording.completed\''].join(''))).setPageSize(15))), -1, async (item) => {


       return (getObjectProperty(item, 'start_time'));
      }));
      ModRecordings = [];
      for (var j_index in recordings) {
        j = recordings[j_index];
        console.log(['scheduling=\'scheduled\' and Description not like \'%MS_BREAK%\' and tutor=\'',(getObjectProperty(j, 'tutor')),'\' and start_date >= ',DateMin,' and start_date <= ',DateMax].join(''));
        tutorDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and name=\'',((getObjectProperty(j, 'tutor')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)))[0];
        j['Description'] = (false ? textToTitleCase(((getObjectProperty(ms_class, 'Description')).split('-')[2]).replace((new RegExp('_', 'igu')), ' ')) : (getObjectProperty(j, 'topic')));
        j['zoom_code'] = (getObjectProperty(tutorDB, 'zoomRaw'));
        j['start_date'] = (getObjectProperty(j, 'start_time'));
        j['end_date'] = (getObjectProperty(j, 'end_time'));
        addItemToList(ModRecordings, j);
      }
      if (!ModRecordings.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c77a46d230307dad5f87fa149a143ec', true);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ce3be919212e6936fc457c8394551d3', true);
        await new Promise(r => setTimeout(r, 400 || 0));
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2890cf79e5d4920449ab8f2b8b8629', ModRecordings);
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65a483071303872acb6f30b80dd29ded', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/GMeet_Recordings_V2/components/a80293032ed785157533d694345fa906/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DateRange'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var DateMax, DateMin, error, item, j, ModRecordings, ms_class, recordings;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['DateRange'] = ___arguments.value;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c77a46d230307dad5f87fa149a143ec', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65a483071303872acb6f30b80dd29ded', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ce3be919212e6936fc457c8394551d3', false);
    await new Promise(r => setTimeout(r, 800 || 0));
    DateMin = ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getFullYear()),'-',(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getMonth() + 1),'-',(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getDate()),' 00:00'].join('')))).valueOf());
    DateMax = ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getFullYear()),'-',(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getMonth() + 1),'-',(new Date((getObjectProperty(___arguments.context.pageData, 'DateRange'))).getDate()),' 23:59'].join('')))).valueOf());
    console.log(DateMin);
    recordings = (await asyncListSort((await Backendless.Data.of('zoom_meetings').find(Backendless.DataQueryBuilder.create().setWhereClause((['(tutor not like \'%Test%\' or tutor not like \'%JomarTutor%\') and start_time >= ',DateMin,' and end_time <= ',DateMax,!!(getObjectProperty(___arguments.context.pageData, 'SearchTutor')).length ? [' and tutor like \'%',(getObjectProperty(___arguments.context.pageData, 'SearchTutor')),'%\''].join('') : '','',''].join(''))).setPageSize(50))), -1, async (item) => {


     return (getObjectProperty(item, 'start_time'));
    }));
    ModRecordings = [];
    for (var j_index in recordings) {
      j = recordings[j_index];
      console.log(['Description != null and scheduling=\'scheduled\' and Description not like \'%MS_BREAK%\' and Description like \'%MAX%\' and tutor=\'',(getObjectProperty(j, 'tutor')),'\' and start_date >= ',DateMin,' and start_date <= ',DateMax].join(''));
      ms_class = (await Backendless.Data.of('ms_calendar').find(Backendless.DataQueryBuilder.create().setWhereClause((['Description != null and scheduling=\'scheduled\' and Description not like \'%MS_BREAK%\' and Description like \'%MAX%\' and tutor=\'',((getObjectProperty(j, 'tutor')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and start_date >= ',DateMin,' and start_date <= ',DateMax].join(''))).setProperties('tutor_relations.google_meet as MeetID, tutor_relations.zoomRaw as ZoomID,*').setPageSize(10)))[0];
      if (!(ms_class !== null && !Array.isArray(ms_class) && (typeof ms_class === 'object')) || (typeof (getObjectProperty(ms_class, 'Description')) === 'undefined')) {
        console.log('No MS Class');
        continue;
      }
      console.log(ms_class);
      j['ms_class'] = ms_class;
      j['Description'] = (textToTitleCase(((getObjectProperty(ms_class, 'Description')).split('-')[2]).replace((new RegExp('_', 'igu')), ' ')));
      j['meet_code'] = (getObjectProperty(ms_class, 'MeetID'));
      j['zoom_code'] = (getObjectProperty(ms_class, 'ZoomID'));
      j['start_date'] = (getObjectProperty(ms_class, 'start_date'));
      j['end_date'] = (new Date((new Date((getObjectProperty(ms_class, 'start_date')))).getTime() + (((getObjectProperty(ms_class, 'duration')) * 3600) * 1000)));
      console.log(textToTitleCase(((getObjectProperty(ms_class, 'Description')).split('-')[2]).replace((new RegExp('_', 'igu')), ' ')));
      addItemToList(ModRecordings, j);
    }
    if (!ModRecordings.length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c77a46d230307dad5f87fa149a143ec', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ce3be919212e6936fc457c8394551d3', true);
      await new Promise(r => setTimeout(r, 400 || 0));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2890cf79e5d4920449ab8f2b8b8629', ModRecordings);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65a483071303872acb6f30b80dd29ded', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Grade_Switcher/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item, ObjectList, loadingData, _unused, offset, leadDB, availableTutors, isHouseLeader, leadData, j, houseLeaders, houseLeaderCloseData, tutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    leadData = (await Backendless.UserService.getCurrentUser(false));
    if ((getObjectProperty(leadData, 'name')) == 'TestNicolasTutor Live') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3353ccb2441884133de39966a1e98276', true);
    }
    leadDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(leadData, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadData, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadData, 'name')) == 'Jordan Knoetgen' || (getObjectProperty(leadData, 'access_level')) == 'Assistant Principal' || (getObjectProperty(leadData, 'access_level')) == 'School Administrator' ? ['name = \'',((getObjectProperty(leadData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join('') : ['userType=\'Teacher\' AND ','name = \'',((getObjectProperty(leadData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND accountType=\'BACKENDLESS\''].join(''))).setPageSize(1)))[0];
    availableTutors = [];
    availableTutors = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(leadDB, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadData, 'name')) == 'Jordan Knoetgen' || (getObjectProperty(leadData, 'name')) == 'School Administrator' || (getObjectProperty(leadDB, 'access_level')) == 'Assistant Principal' ? 'usertype=\'teacher\' and tutortype=\'Microschool\' and opp_status=\'enrolled\' and accountType=\'BACKENDLESS\'' : ['usertype=\'teacher\' and tutortype=\'Microschool\' and opp_status=\'enrolled\' and accountType=\'BACKENDLESS\' AND house_leader= \'',((getObjectProperty(leadDB, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(100)));
    houseLeaderCloseData = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UiCloseGetLeadCustomFields`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    isHouseLeader = false;
    houseLeaders = [];
    var j_list = (getObjectProperty(houseLeaderCloseData, 'data'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ('cf_ouQZnNx05W2c3xaPwMJqDqUO3FbC6MI5aB9oIxH8qsO' == (getObjectProperty(j, 'id'))) {
        addItemToList(houseLeaders, (getObjectProperty(j, 'choices')));
      }
    }
    for (var j_index2 in houseLeaders) {
      j = houseLeaders[j_index2];
      if (!(typeof j === 'undefined') && (j == (getObjectProperty(leadDB, 'name')) || (getObjectProperty(leadDB, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadData, 'name')) == 'School Administrator' || (getObjectProperty(leadDB, 'access_level')) == 'Assistant Principal')) {
        isHouseLeader = true;
      }
    }
    if (isHouseLeader) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c5321c5b61abbd3a89540f2b56750ed', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c5321c5b61abbd3a89540f2b56750ed', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
    }
    ___arguments.context.pageData['chosenApprovalStatus'] = '';
    ___arguments.context.pageData['suggestGradeApproval'] = '';
    ___arguments.context.pageData['slotSlug'] = '';
    ___arguments.context.pageData['slotSlugApproval'] = '';
    ___arguments.context.pageData['approvalStatusOption'] = '';
    ___arguments.context.pageData['suggestStudent'] = [];
    ___arguments.context.pageData['modalVisible'] = false;
    ___arguments.context.pageData['approvalChanged'] = false;
    ___arguments.context.pageData['leadData'] = leadDB;
    ___arguments.context.pageData['pendingApprovals'] = false;
    ___arguments.context.pageData['availableTutors'] = availableTutors;
    ___arguments.context.pageData['nameOfTutor'] = (String((getObjectProperty(leadDB, 'email')) != 'am@brilliantmicroschool.org' ? String((getObjectProperty(leadDB, 'name')).split(' ')[0]) + String('\' Class') : 'School Administration'));
    ObjectList = [];
    loadingData = true;
    offset = 0;
    while (loadingData) {
      console.log((getObjectProperty(leadDB, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'name')) == 'Jordan Knoetgen' || (getObjectProperty(leadDB, 'name')) == 'School Administrator' || (getObjectProperty(leadDB, 'access_level')) == 'Assistant Principal' ? 'status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%23_24%\') AND (slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\' AND slot_slug NOT LIKE \'%TestNicolasTutor Live%\' AND slot_slug NOT LIKE \'%JomarTutor Live%\' AND slot_slug NOT LIKE \'%DUMMYTEACHER1%\')' : ('TestNicolasTutor Live' == (getObjectProperty(leadDB, 'name')) ? ['tutor = \'',((getObjectProperty(leadDB, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\') AND (slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\')'].join('') : ['tutor = \'',((getObjectProperty(leadDB, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\')  AND (slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\' AND slot_slug NOT LIKE \'%TestNicolasTutor Live%\' AND slot_slug NOT LIKE \'%JomarTutor Live%\' AND slot_slug NOT LIKE \'%DUMMYTEACHER1%\')'].join('')));
      _unused = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(leadDB, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'name')) == 'Jordan Knoetgen' || (getObjectProperty(leadDB, 'name')) == 'School Administrator' || (getObjectProperty(leadDB, 'access_level')) == 'Assistant Principal' ? (false ? 'status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%24_25%\') AND (slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\' AND slot_slug NOT LIKE \'%TestNicolasTutor Live%\' AND slot_slug NOT LIKE \'%JomarTutor Live%\' AND slot_slug NOT LIKE \'%DUMMYTEACHER1%\')' : ['status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%24_25%\') AND (slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\' AND slot_slug NOT LIKE \'%TestNicolasTutor Live%\' AND slot_slug NOT LIKE \'%JomarTutor Live%\' AND slot_slug NOT LIKE \'%DUMMYTEACHER1%\')',' and tutor=\'',(getObjectProperty(leadDB, 'name')),'\''].join('')) : ('TestNicolasTutor Live' == (getObjectProperty(leadDB, 'name')) ? ['tutor = \'',((getObjectProperty(leadDB, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\') AND (slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\')'].join('') : ['tutor = \'',((getObjectProperty(leadDB, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\')  AND (slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\' AND slot_slug NOT LIKE \'%TestNicolasTutor Live%\' AND slot_slug NOT LIKE \'%JomarTutor Live%\' AND slot_slug NOT LIKE \'%DUMMYTEACHER1%\')'].join('')))).setSortBy('slot_slug ASC').setGroupBy('slot_slug').setPageSize(100).setOffset(offset).setDistinct(true)));
      ObjectList = (ObjectList.concat(_unused));
      offset = offset + 100;
      if (_unused.length < 100) {
        loadingData = false;
      }
    }
    ___arguments.context.pageData['classOptions'] = (await Promise.all(ObjectList.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'slot_slug')),[`value`]: (getObjectProperty(item, 'slot_slug')) });})));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Grade_Switcher/components/416e128daaca55916fc471e2e5f8e404/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('0505fd3a2fb27b9c6b4c0cd77af26d19');
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('661423c123180be96a5ad664323b7648', ___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'));
  ___arguments.context.pageData['approvalData'] = ___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'isSuggest')) == true || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'isUpdateSuggest')) == true ? 'Edit' : 'View')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/b679c5a219f3cdd12fc7578dffc9089e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['modalVisible'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0505fd3a2fb27b9c6b4c0cd77af26d19');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/5afea65534978435fd7589ea5a6ca059/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var studentList, error, j, gradeSuggestionList, leadDB, suggestedGradeList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
  suggestedGradeList = [];
  studentList = [];
  leadDB = (getObjectProperty(___arguments.context.pageData, 'leadData'));
  ___arguments.context.pageData['slotSlug'] = (___arguments.value.replace((new RegExp('\'', 'g')), '\'\''));
  try {
    studentList = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(leadDB, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'name')) == 'Jordan Knoetgen' ? ['status=\'enrolled\' AND slot_slug=\'',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\''].join('') : ['tutor = \'',((getObjectProperty(leadDB, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND slot_slug=\'',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\''].join(''))).setPageSize(100)));

  } catch (error) {
    console.log(error);

  }
  try {
    for (var j_index in studentList) {
      j = studentList[j_index];
      gradeSuggestionList = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.objectId=\'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['previous_grade', 'status_updated_by', 'status_updated_date', 'created', 'suggested_grade', 'suggested_by', 'status', 'objectId']).setRelated('class').setPageSize(1)));
      if (!!gradeSuggestionList.length) {
        j['grade_suggestion'] = gradeSuggestionList;
        j['suggested_status'] = (getObjectProperty(gradeSuggestionList, 'status'));
        if ((getObjectProperty((gradeSuggestionList[0]), 'status')) == 'For Approval') {
          j['isSuggest'] = false;
          j['isUpdateSuggest'] = true;
        } else {
          j['isSuggest'] = false;
          j['isUpdateSuggest'] = false;
        }
      } else {
        j['grade_suggestion'] = [({ [`previous_grade`]: '-',[`status`]: '-',[`status_updated_by`]: '-',[`status_updated_date`]: '',[`created`]: '',[`suggested_grade`]: '-',[`suggested_by`]: '-' })];
        j['suggested_status'] = 'NA';
        j['isSuggest'] = true;
        j['isUpdateSuggest'] = false;
      }
    }

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['studentList'] = studentList;
  if (!!studentList.length) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Grade_Switcher/components/e8e104596aabc13424c752016c427b6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, studentList, j, gradeSuggestionList, lead, returnSaved;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648')['displayError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')) == '') {
    ___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648')['displayError'] = true;
    ___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648')['errorText'] = 'Please choose a Suggested Grade!';
  } else {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('36c31e619e2ac4dbc0b3a0ad63df8e84');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/47279f41b1645fadd89bee1665bcb50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var suggestedStatus, gradeSuggestionData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'grade_suggestion'))[0]), 'status'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/49d74029aad92b9437d68cc1ef480b99/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var gradeSuggestionData, studentsBlockStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  gradeSuggestionData = (getObjectProperty(___arguments.context.dataModel, 'grade_suggestion'))[0];
  if ((getObjectProperty(gradeSuggestionData, 'status')) == 'NA') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['background'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['border'] = 'solid 1px #D9D9D9';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['border-radius'] = '10px 10px 10px 10px';
  } else if ((getObjectProperty(gradeSuggestionData, 'status')) == 'For Approval') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['background'] = '#FFE8A4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['border'] = 'solid 1px #FFC107';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['border-radius'] = '10px 10px 10px 10px';
  } else if ((getObjectProperty(gradeSuggestionData, 'status')) == 'Approved') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['background'] = '#BEE3BE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['border'] = 'solid 1px #53A653';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['border-radius'] = '10px 10px 10px 10px';
  } else if ((getObjectProperty(gradeSuggestionData, 'status')) == 'Disapproved') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['background'] = '#F5C4C9';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['border'] = 'solid 1px #DC3545';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49d74029aad92b9437d68cc1ef480b99'))['border-radius'] = '10px 10px 10px 10px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/8f91601b7c4f21322f3f5187e0b22002/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['suggestGradeApproval'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Grade_Switcher/components/f3fd802fc27be3aeeb5902d500b2c832/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Grade for Next School Year <strong style=\'color: red;\'>*</strong>'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/259300e1402e3a65c562ba3ae98b8259/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'grade_suggestion'))[0]), 'suggested_grade'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/b798e914890b6bef25951f1d54032dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, studentList, j, gradeSuggestionList, studentData, lead, gradeSuggestData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648')['displayError'] = false;
  lead = (getObjectProperty(___arguments.context.pageData, 'leadData'));
  gradeSuggestData = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0];
  studentData = (getObjectProperty(gradeSuggestData, 'class'))[0];
  if ((getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')) == 'NA' || false || (getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')) == '') {
    ___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648')['displayError'] = true;
    ___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648')['errorText'] = 'Please update suggested grade!';
  } else {
    ___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648')['displayError'] = false;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('5486760160369e49afe9acc30c4725e8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/6d797115e2ad34f58f047e0f972c26f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var teacherClass, item, teacherData, leadData, houseLeader, teacherClassOption;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('searchTutor');

  ;(function() {
    const callback = async () => {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a4ab0275a887d288ca19f2a685dc5f8', true);
    teacherClassOption = [];
    ___arguments.context.pageData['SearchValueTutor'] = ___arguments.value;
    if (getObjectProperty(___arguments.context.pageData, 'pendingApprovals')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', true);
      if (___arguments.value != '') {
        ___arguments.context.pageData['gradeSuggestionsList'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'gradeSuggestionPendings')), async (item) => {


         return ((getObjectProperty(((getObjectProperty(item, 'class'))[0]), 'tutor')).indexOf(___arguments.value) !== -1);
        }));
      } else {
        ___arguments.context.pageData['gradeSuggestionsList'] = (getObjectProperty(___arguments.context.pageData, 'gradeSuggestionPendings'));
      }
      if (!(getObjectProperty(___arguments.context.pageData, 'gradeSuggestionsList')).length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', false);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', true);
      }
    } else {
      if (___arguments.value != '') {
        leadData = (getObjectProperty(___arguments.context.pageData, 'leadData'));
        console.log(['name LIKE \'%',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'%\' AND userType=\'Teacher\' AND accountType=\'BACKENDLESS\'',(getObjectProperty(leadData, 'email')) == 'am@brilliantmicroschool.org' || ((getObjectProperty(leadData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')) == 'Jordan Knoetgen' || (getObjectProperty(leadData, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadData, 'access_level')) == 'Assistant Principal' || (getObjectProperty(leadData, 'access_level')) == 'School Administrator' ? '' : ['AND house_leader=\'',((getObjectProperty(leadData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join('')].join(''));
        teacherData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name LIKE \'%',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'%\' AND userType=\'Teacher\' AND accountType=\'BACKENDLESS\'',(getObjectProperty(leadData, 'email')) == 'am@brilliantmicroschool.org' || ((getObjectProperty(leadData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')) == 'Jordan Knoetgen' || (getObjectProperty(leadData, 'email')) == 'edtech@brilliantmicroschool.org' || false || (getObjectProperty(leadData, 'access_level')) == 'School Administrator' ? '' : ['AND house_leader=\'',((getObjectProperty(leadData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join('')].join(''))).setPageSize(10)))[0];
        console.log(teacherData);
        if (!(typeof teacherData === 'undefined')) {
          houseLeader = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseFindLeadObjectByObjectID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(teacherData, 'lead_id')) }))));
        } else {
          ___arguments.context.pageData['teacherClassOptions'] = [];
        }
        if (!(typeof houseLeader === 'undefined')) {
          if (!(typeof (getObjectProperty((getObjectProperty(houseLeader, 'custom')), 'House Leader')) === 'undefined')) {
            if ((getObjectProperty((getObjectProperty(houseLeader, 'custom')), 'House Leader')) == (getObjectProperty(leadData, 'name')) || (getObjectProperty(leadData, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadData, 'name')) == 'Jordan Knoetgen' || (getObjectProperty(leadData, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadData, 'access_level')) == 'Assistant Principal' || (getObjectProperty(leadData, 'access_level')) == 'School Administrator') {
              console.log(['tutor=\'',((getObjectProperty(teacherData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\' AND  slot_slug NOT LIKE \'%MS_Summerschool%\''].join(''));
              teacherClass = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['tutor=\'',((getObjectProperty(teacherData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\' AND  slot_slug NOT LIKE \'%MS_Summerschool%\''].join(''))).setSortBy('slot_slug ASC').setGroupBy('slot_slug').setPageSize(100).setDistinct(true)));
              ___arguments.context.pageData['teacherClassOptions'] = (await Promise.all(teacherClass.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'slot_slug')),[`value`]: (getObjectProperty(item, 'slot_slug')) });})));
              await new Promise(r => setTimeout(r, 200 || 0));
            } else {
              ___arguments.context.pageData['teacherClassOptions'] = [];
              return null;
            }
          } else {
            if ((getObjectProperty(leadData, 'name')) == 'Jordan Knoetgen' || (getObjectProperty(leadData, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadData, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadData, 'access_level')) == 'Assistant Principal' || (getObjectProperty(leadData, 'access_level')) == 'School Administrator') {
              teacherClass = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['tutor=\'',((getObjectProperty(teacherData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\' AND  slot_slug NOT LIKE \'%MS_Summerschool%\''].join(''))).setSortBy('slot_slug ASC').setGroupBy('slot_slug').setPageSize(100).setDistinct(true)));
              ___arguments.context.pageData['teacherClassOptions'] = (await Promise.all(teacherClass.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'slot_slug')),[`value`]: (getObjectProperty(item, 'slot_slug')) });})));
              await new Promise(r => setTimeout(r, 200 || 0));
            } else {
              ___arguments.context.pageData['teacherClassOptions'] = [];
              return null;
            }
          }
        } else {
          ___arguments.context.pageData['teacherClassOptions'] = [];
          return null;
        }
      } else {
        ___arguments.context.pageData['teacherClassOptions'] = [];
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a4ab0275a887d288ca19f2a685dc5f8', false);

    };

    const timerId = 'searchTutor';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Grade_Switcher/components/fae36f9b13cf7855811786365a62feb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, gradeApprovalList;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', true);
  try {
    ___arguments.context.pageData['slotSlugApproval'] = ___arguments.value;
    console.log(['class.slot_slug=\'',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''));
    gradeApprovalList = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.slot_slug=\'',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setRelated('class').setSortBy('class.student_name ASC').setPageSize(100)));
    ___arguments.context.pageData['gradeSuggestionsList'] = gradeApprovalList;
    if (!gradeApprovalList.length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Grade_Switcher/components/bc3e740314c969540003223e1df2b0a9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var studentsBlockStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'status')) == 'NA') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['background'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border'] = 'solid 1px #D9D9D9';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border-radius'] = '10px 10px 10px 10px';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'status')) == 'For Approval') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['background'] = '#FFE8A4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border'] = 'solid 1px #FFC107';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border-radius'] = '10px 10px 10px 10px';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'status')) == 'Approved') {
    if ((getObjectProperty(___arguments.context.dataModel, 'suggested_grade')) == 'NA') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['background'] = '#FFFFFF';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border'] = 'solid 1px #D9D9D9';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border-radius'] = '10px 10px 10px 10px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['background'] = '#BEE3BE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border'] = 'solid 1px #53A653';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border-radius'] = '10px 10px 10px 10px';
    }
  } else if ((getObjectProperty(___arguments.context.dataModel, 'status')) == 'Disapproved') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['background'] = '#F5C4C9';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border'] = 'solid 1px #DC3545';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bc3e740314c969540003223e1df2b0a9'))['border-radius'] = '10px 10px 10px 10px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/2702e03a8f72e7d45d634cf86c9b90f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9e53fff10a05d7ad98a214aa84328515');
  ___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9')['inputStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9'), 'status'));
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('1d85beeb83899b151169dc8efc8312d8', ___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/94585154793f10e568f6509a03de3ad4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9e53fff10a05d7ad98a214aa84328515');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/291dc839473b070529bb213c28a359e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var gradeApprovalList, error, gradeSuggestion, subject, dbContact, j, CloseNote, group, closeContact, subjectList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  gradeApprovalList = [];
  subjectList = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87cdf868e6088cbb6b7bc90b40780f16', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
  if (!((getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')) == '')) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('abb782e3a4c916a7a0478f9a1435d79d');
  } else {
    ___arguments.context.pageData['chosenApprovalStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('abb782e3a4c916a7a0478f9a1435d79d');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/f3e81b7e2cd10f4cbf994a226f3c3397/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['chosenApprovalStatus'] = ___arguments.value;
  ___arguments.context.pageData['approvalChanged'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Grade_Switcher/components/7c570fdf0fa667f2d8ee4934adc57f5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved' || (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Disapproved' ? true : false;
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/a08ef678440e1ebce5c4ab9c20aa07ab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    if ((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'For Approval') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a08ef678440e1ebce5c4ab9c20aa07ab'))['color'] = '#FFC107';
    } else if ((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Disapproved') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a08ef678440e1ebce5c4ab9c20aa07ab'))['color'] = '#DC3545';
    } else if ((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a08ef678440e1ebce5c4ab9c20aa07ab'))['color'] = '#53A653';
    }
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/eea95f9cac2cba5b21f530c2d48a1af3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved' || (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Disapproved' ? true : false;
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/07c4ec28c2e1492a0c97b71d22c463da/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = ((new Date((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status_updated_date')))).toDateString());
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved' || (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Disapproved' ? true : false;
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/02278d620c18bdb571d739367a9e8c3f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'slot_slug')) === 'undefined')) {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'slot_slug')).split('-')[3];
  }

  return content2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/ecfe0036db612fffa391d41ee87a7915/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Status <strong style=\'color: red;\'>*</strong>'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/a61f930a3fe958a17545a3dd3d1feb9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Approved' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Disapproved') {
      content2 = true;
    } else {
      content2 = false;
    }
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/616d20825b2aec3e537e8685e60573a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Approved' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Disapproved') {
      content2 = true;
    } else {
      content2 = false;
    }
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/ce2cb7d572ca19cf7cb2b78837ad260e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) === 'undefined') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Approved' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Disapproved'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Approved' ? ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status_updated_date')))).toDateString()) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/1e141557deca8245f1c7611e0ecdb103/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Approved' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Disapproved') {
      content2 = true;
    } else {
      content2 = false;
    }
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/fc5abad39afba53e9cf5ab722f687598/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved' || (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Disapproved' ? true : false;
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/bef97c4877862f1b1b3756815f2d7313/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;


  content2 = true;

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/e5fa80080d5aae3e307bf5417f37696c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Pending Approval');
  console.log(___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9'), 'status')) == 'Approved') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9'), 'previous_grade'));
  } else {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9'), 'class'))[0]), 'grade'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/7d7520a121867e8e68366d16e08d5efd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9'), 'status')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc3e740314c969540003223e1df2b0a9'), 'status')) == 'Approved') {
      content2 = 'Previous Grade';
    } else {
      content2 = 'Current Grade';
    }
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/b5146f3d98b9b1bc2bea7eeb5cebb987/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Approved') {
      content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'previous_grade'));
    } else {
      content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'class'))[0]), 'grade'));
    }
  }

  return content2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/ccbcefc51fe381475c363b7b9ab15b13/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved' ? 'Previous Grade' : 'Current Grade';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/83814062839c9d9c196691541d065d4a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    if ((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved') {
      content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'previous_grade'));
    } else {
      content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade'));
    }
  }

  return content2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/a78e56e47435d58a328d557234ebe7a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'grade_suggestion'))[0]), 'status')) == 'Approved' ? (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'grade_suggestion'))[0]), 'previous_grade')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'grade'));

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/166c1778aa94f6f41cbfd9d5b6045903/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'grade_suggestion'))[0]), 'status')) == 'Approved' ? 'Previous Grade' : 'Current Grade';

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/7e29be3813cbe5532c55ecba38c5378f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) === 'undefined')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'status')) == 'Approved') {
      content2 = 'Previous Grade';
    } else {
      content2 = 'Current Grade';
    }
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/e06bfcc3107f30f50822380e3c3f7534/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var content2, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'class')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d85beeb83899b151169dc8efc8312d8'), 'class'))[0]), 'slot_slug')).split('-')[3];
  }

  return content2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/abb782e3a4c916a7a0478f9a1435d79d/bundle.js', [], () => ({
  /* content */
  /* handler:titleLogic */
  ['titleLogic'](___arguments) {
    var title;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')) == 'Approved' ? 'Confirmation for Approval' : 'Confirmation for Disapproval')

  },
  /* handler:titleLogic */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')) == 'Approved' ? ['<strong>Are you sure you want to continue?</strong><br><br>','If you wish to continue, the following data will be changed: <br>','   - Grade to (Chosen Grade)<br>   - Subject to (Grade band of chosen grade)<br><br><strong>If New Grade band, this info will also be updated:</strong><br>   - Tutor (Student will be remove from the tutor class)<br>'].join('') : String('<strong>Are you sure you want to continue?</strong><br><br>') + String('This will not update the student\'s grade.'))

  },
  /* handler:contentLogic */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var gradeApprovalList, error, gradeSuggestion, j, _unused, newTermList, closeContact, gradeSuggestionObject, DueDateGraduating, dbContact, newTerm, tutor, group, subject, slot, contact, CheckOffBTask, item, CloseNote, DueDate, NewTaskInClose, subjectList, contactList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('abb782e3a4c916a7a0478f9a1435d79d');
  if (await Backendless.Cache.contains('isRunningSubmit')) {
    if (await Backendless.Cache.get('isRunningSubmit')) {
      return null;
    }
  } else {
    await Backendless.Cache.put('isRunningSubmit', true, 30);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0d635015bdb01e2e4474966900ead26', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('291dc839473b070529bb213c28a359e1', false);
  ___arguments.context.pageData['chosenGradeApproval'] = (getObjectProperty(___arguments.context.dataModel, 'suggested_grade'));
  newTermList = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()).split('_');
  newTerm = [(Number((newTermList[0]))) + 1,'_',(Number((newTermList.slice(-1)[0]))) + 1].join('');
  if ((getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')) == 'Approved') {
    try {
      gradeSuggestionObject = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.student_name=\'',((getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'student_name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND class.status=\'enrolled\' AND class.lead_id=\'',(getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'lead_id')),'\' AND (suggested_by=\'Jordan Knoetgen\' OR (suggested_by=\'',((getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'tutor')).replace((new RegExp('\'', 'g')), '\'\'')),'\' OR class.tutor=\'',((getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'tutor')).replace((new RegExp('\'', 'g')), '\'\'')),'\'))'].join(''))).setRelated('class').setPageSize(100)));
      subjectList = [];
      subjectList = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['student_name=\'',((getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'student_name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND lead_id=\'',(getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'lead_id')),'\' AND grade =\'',(getObjectProperty(___arguments.context.dataModel, 'suggested_grade')),'\' AND (slot_slug LIKE \'%MS_%\' AND slot_slug LIKE \'%',newTerm,'%\')'].join(''))).setPageSize(100)));
      contactList = (getObjectProperty(((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseGetObjectListByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`entityName`]: 'lead',[`entityId`]: (getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'lead_id')),[`queryParam`]: undefined,[`outputField`]: 'contacts',[`outputCount`]: 1 }))))[0]), 'contacts'));
      contact = (await asyncListFilter(contactList, async (item) => {


       return ((getObjectProperty(item, 'id')) == (getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'contact_id')));
      }))[0];

    } catch (error) {
      console.log(error);
      console.log(getObjectProperty(error, 'message'));

    }
    if (!gradeSuggestionObject.length) {
      await Backendless.Data.of('grade_suggestions').save( ({ [`status`]: 'NA',[`status_updated_date`]: (new Date()),[`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')) }) );
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0d635015bdb01e2e4474966900ead26', false);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('0b38fdd8c1987348536879285ed89841');
      return null;
    }
    if (!!subjectList.length) {
      for (var j_index in subjectList) {
        j = subjectList[j_index];
        if ((getObjectProperty(j, 'slot_slug')).indexOf('MS_ESE_') !== -1) {
          if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Kindergarten') !== -1) || (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Grade 1' || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 2') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 3') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 4') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 5') !== -1)) {
            subject = 'MS_ESE_Elementary';
            group = (getObjectProperty(j, 'group'));
          } else if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 6') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 7') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 8') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 9') !== -1) || (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Grade 10' || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 11') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 12') !== -1)) {
            subject = 'MS_ESE_Middle-High';
            group = (getObjectProperty(j, 'group'));
          }
        } else {
          if ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Kindergarten') !== -1) {
            subject = 'MS_Kindergarten';
            group = (getObjectProperty(j, 'group'));
            tutor = '#Tutor TBC';
            slot = '#Slot TBC';
          }
          if ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Grade 1' || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 2') !== -1)) {
            subject = 'MS_Lower_Elem';
            group = (getObjectProperty(j, 'group'));
          }
          if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 3') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 4') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 5') !== -1)) {
            subject = 'MS_Upper_Elem';
            group = (getObjectProperty(j, 'group'));
          }
          if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 6') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 7') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 8') !== -1)) {
            subject = 'MS_Middle';
            group = 'MAX10';
          }
          if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 9') !== -1) || (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Grade 10') {
            subject = 'MS_Lower_High';
            group = 'MAX20';
          }
          if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 11') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 12') !== -1)) {
            subject = 'MS_Upper_High';
            group = 'MAX20';
          }
          if ((getObjectProperty(j, 'slot_slug')).indexOf('MAX1-') !== -1) {
            group = 'MAX1';
          }
        }
        try {
          if (subject != (getObjectProperty(j, 'subject')) && (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) != 'NA') {
            tutor = '#Tutor TBC';
            slot = '#Slot TBC';
            DueDate = (new Date((String('07/01/20') + String((Number(((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()).split('_')[0]))) + 1))));
            NewTaskInClose = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(j, 'lead_id')),'text': (['[FIND_CLASS] Student to be enrolled in a class [',newTerm,']'].join('')),'date': DueDate,'is_complete': false,'assigned_to': 'user_ucqgdQ2LgSJz2ilFeyPMDxljRrVeEDhGnuD38JgV3PG' }));
          } else {
            tutor = (getObjectProperty(j, 'tutor'));
            slot = (getObjectProperty(contact, 'custom.ccf_JQfEM4g49NVpBMOpetyBenCRXZJMTW9P5s3fANgOYlE'));
          }
          gradeSuggestion = (await Backendless.Data.of('grade_suggestions').save( ({ [`previous_grade`]: (getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'grade')),[`status`]: (getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')),[`status_updated_by`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'name')),[`status_updated_date`]: (new Date()),[`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')),[`suggested_grade`]: (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) }) ));
          await Backendless.Data.of('weekly_slots').save( ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`group`]: group,[`subject`]: subject,[`grade`]: (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')),[`tutor`]: (tutor.replace((new RegExp('\'', 'g')), '\'\'')),[`slots_sort`]: slot }) );
          if ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'NA') {
            _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UiDeleteCloseContactByContactID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(j, 'contact_id')))));
          } else {
          }
          CloseNote = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(j, 'lead_id')),[`note`]: [(getObjectProperty(j, 'student_name')),'\'s grade has been updated.','\nFrom: \n',(getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'grade')),' - ',(getObjectProperty(j, 'subject')),'\n\nTo:  \n',(getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')),' - ',subject,'\n\nSuggested by: \n',(getObjectProperty(gradeSuggestion, 'suggested_by')),'\n\nApproved by: \n',(getObjectProperty(gradeSuggestion, 'status_updated_by')),'\n\nApproved Date: \n',((new Date()).toDateString())].join('') }))));

        } catch (error) {
          Backendless.Logging.getLogger('Grade_Switcher').warn((getObjectProperty(error, 'message')));
          console.log(error);

        }
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0d635015bdb01e2e4474966900ead26', false);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('12287647e7ca293f20f792b22b27580c');
    } else {
      subject = '';
      group = 'NA';
      dbContact = (getObjectProperty((gradeSuggestionObject[0]), 'class'))[0];
      if ((getObjectProperty(dbContact, 'slot_slug')).indexOf('MS_ESE_') !== -1) {
        if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Kindergarten') !== -1) || (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Grade 1' || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 2') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 3') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 4') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 5') !== -1)) {
          subject = 'MS_ESE_Elementary';
          group = (getObjectProperty(dbContact, 'group'));
        } else if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 6') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 7') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 8') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 9') !== -1) || (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Grade 10' || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 11') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 12') !== -1)) {
          subject = 'MS_ESE_Middle-High';
          group = (getObjectProperty(dbContact, 'group'));
        }
      } else {
        if ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Kindergarten') !== -1) {
          subject = 'MS_Kindergarten';
          group = (getObjectProperty(dbContact, 'group'));
        }
        if ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Grade 1' || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 2') !== -1)) {
          subject = 'MS_Lower_Elem';
          group = (getObjectProperty(dbContact, 'group'));
        }
        if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 3') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 4') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 5') !== -1)) {
          subject = 'MS_Upper_Elem';
          group = (getObjectProperty(dbContact, 'group'));
        }
        if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 6') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 7') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 8') !== -1)) {
          subject = 'MS_Middle';
          group = 'MAX10';
        }
        if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 9') !== -1) || (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Grade 10') {
          subject = 'MS_Lower_High';
          group = 'MAX20';
        }
        if (((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 11') !== -1) || ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')).indexOf('Grade 12') !== -1)) {
          subject = 'MS_Upper_High';
          group = 'MAX20';
        }
        if ((getObjectProperty(dbContact, 'slot_slug')).indexOf('MAX1-') !== -1) {
          group = 'MAX1';
        }
      }
      try {
        if (subject != (getObjectProperty(dbContact, 'subject')) && (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) != 'NA' && (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) != 'Graduating') {
          tutor = '#Tutor TBC';
          slot = '#Slot TBC';
          DueDate = (new Date((String('07/01/20') + String((Number(((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()).split('_')[0]))) + 1))));
          NewTaskInClose = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(dbContact, 'lead_id')),'text': (['[FIND_CLASS] Student to be enrolled in a class [',newTerm,'] '].join('')),'date': DueDate,'is_complete': false,'assigned_to': 'user_ucqgdQ2LgSJz2ilFeyPMDxljRrVeEDhGnuD38JgV3PG' }));
        } else {
          tutor = (getObjectProperty(dbContact, 'tutor'));
          slot = (getObjectProperty(contact, 'custom.ccf_JQfEM4g49NVpBMOpetyBenCRXZJMTW9P5s3fANgOYlE'));
        }
        gradeSuggestion = (await Backendless.Data.of('grade_suggestions').save( ({ [`previous_grade`]: (getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'grade')),[`status`]: (getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')),[`status_updated_by`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'name')),[`status_updated_date`]: (new Date()),[`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')),[`suggested_grade`]: (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) }) ));
        CloseNote = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'lead_id')),[`note`]: [(getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'student_name')),'\'s grade has been updated.','\nFrom: \n',(getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'grade')),' - ',(getObjectProperty(dbContact, 'subject')),'\n\nTo:  \n',(getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')),' - ',subject,'\n\nSuggested by: \n',(getObjectProperty(gradeSuggestion, 'suggested_by')),'\n\nApproved by: \n',(getObjectProperty(gradeSuggestion, 'status_updated_by')),'\n\nApproved Date: \n',((new Date()).toDateString())].join('') }))));
        if ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) != 'NA' && (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) != 'Graduating') {
          console.log('check offb task');
          CheckOffBTask = (await asyncListFilter((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseGetTaskByLeadID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'lead_id')) })))), async (item) => {


           return (!(getObjectProperty(item, 'is_complete')) && ((getObjectProperty(item, 'text')).indexOf('Fill Offboarding Form & Wait for Claudia\'s approval (DO NOT CLICK \'DONE\' BEFORE APPROVAL') !== -1));
          }));
          if (!CheckOffBTask.length) {
            console.log('no offb task');
            closeContact = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/CloseContactCreateByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`start_date`]: (new Date((getObjectProperty(contact, 'custom.cf_y7WVyIhhK2rbfMiV1L5rHfSI4pP7SJ2mLxGZpzSn0Nm')))),[`contact_name`]: (getObjectProperty(dbContact, 'student_name')),[`phone`]: (getObjectProperty(dbContact, 'phone')),[`email`]: (getObjectProperty(dbContact, 'email')),[`slot`]: slot,[`subject`]: subject,[`group`]: group,[`tutor`]: tutor,[`grade`]: (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')),[`lead_id`]: (getObjectProperty(dbContact, 'lead_id')),[`year`]: newTerm,[`first_day`]: (new Date('2025-08-19')) }))));
          } else {
            console.log('offb task found');
          }
        } else {
          closeContact = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/CloseContactCreateByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`start_date`]: (new Date((getObjectProperty(contact, 'custom.cf_y7WVyIhhK2rbfMiV1L5rHfSI4pP7SJ2mLxGZpzSn0Nm')))),[`contact_name`]: (getObjectProperty(dbContact, 'student_name')),[`phone`]: (getObjectProperty(dbContact, 'phone')),[`email`]: (getObjectProperty(dbContact, 'email')),[`slot`]: slot,[`subject`]: subject,[`group`]: group,[`tutor`]: tutor,[`grade`]: (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')),[`lead_id`]: (getObjectProperty(dbContact, 'lead_id')),[`year`]: newTerm,[`first_day`]: (new Date('2025-08-19')) }))));
        }
        if ((getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) == 'Graduating') {
          DueDateGraduating = (new Date((String('07/01/20') + String((Number(((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()).split('_')[0]))) + 1))));
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(dbContact, 'lead_id')),'text': (['[Graduation] Student will graduate, no need to find a new class [',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'] '].join('')),'date': DueDateGraduating,'is_complete': false,'assigned_to': 'user_ucqgdQ2LgSJz2ilFeyPMDxljRrVeEDhGnuD38JgV3PG' });
        }

      } catch (error) {
        Backendless.Logging.getLogger('Grade_Switcher').warn((getObjectProperty(error, 'message')));
        console.log(error);

      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0d635015bdb01e2e4474966900ead26', false);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('abb782e3a4c916a7a0478f9a1435d79d');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('12287647e7ca293f20f792b22b27580c');
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')) == 'Disapproved') {
    try {
      await Backendless.Data.of('grade_suggestions').save( ({ [`status`]: (getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')),[`status_updated_by`]: ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),[`status_updated_date`]: (new Date()),[`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')) }) );

    } catch (error) {
      console.log(error);

    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')) == 'For Approval') {
    try {
      gradeSuggestionObject = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.student_name=\'',((getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'student_name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND class.status=\'enrolled\' AND class.lead_id=\'',(getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'lead_id')),'\' AND (suggested_by=\'Jordan Knoetgen\' OR suggested_by=\'',((getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'tutor')).replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join(''))).setRelated('class').setPageSize(100)));
      closeContact = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseGetObjectListByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`entityName`]: 'lead',[`entityId`]: (getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'lead_id')),[`queryParam`]: undefined,[`outputField`]: 'contacts',[`outputCount`]: 1 }))))[0];
      console.log(getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval'));
      console.log([(Number((newTermList[0]))) + 1,'_',(Number((newTermList.slice(-1)[0]))) + 1].join(''));
      console.log(getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'student_name'));
      console.log(getObjectProperty(closeContact, 'contacts'));
      var j_list = (getObjectProperty(closeContact, 'contacts'));
      for (var j_index2 in j_list) {
        j = j_list[j_index2];
        if ((getObjectProperty(j, 'custom.ccf_HhFzm0bLKAhy9OXFzCD8ojjFcJbUqFF3VhNmIxQg91N')) == (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) && (getObjectProperty(j, 'custom.cf_KfOnhfrLSuve8OmXEoGBh8ozUxBnKmldfqSFKbwCSHx')) == [(Number((newTermList[0]))) + 1,'_',(Number((newTermList.slice(-1)[0]))) + 1].join('') && (getObjectProperty(j, 'display_name')) == (getObjectProperty(((getObjectProperty(___arguments.context.dataModel, 'class'))[0]), 'student_name'))) {
          console.log('Contact found!');
          console.log(getObjectProperty(j, 'id'));
          _unused = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UiDeleteCloseContactByContactID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(j, 'id')))));
        }
      }

    } catch (error) {
      console.log(error);
      console.log(getObjectProperty(error, 'message'));

    }
    gradeSuggestion = (await Backendless.Data.of('grade_suggestions').save( ({ [`status`]: (getObjectProperty(___arguments.context.pageData, 'chosenApprovalStatus')),[`status_updated_by`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'leadData')), 'name')),[`status_updated_date`]: (new Date()),[`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')),[`suggested_grade`]: (getObjectProperty(___arguments.context.pageData, 'chosenGradeApproval')) }) ));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('12287647e7ca293f20f792b22b27580c');
  }
  try {
    gradeApprovalList = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.slot_slug=\'',((getObjectProperty(___arguments.context.pageData, 'slotSlugApproval')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setRelated('class').setSortBy('class.student_name ASC').setPageSize(100)));

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['gradeSuggestionsList'] = gradeApprovalList;
  ___arguments.context.pageData['chosenApprovalStatus'] = '';
  if (!gradeApprovalList.length) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('291dc839473b070529bb213c28a359e1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('291dc839473b070529bb213c28a359e1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', true);
  }
  await Backendless.Cache.remove('isRunningSubmit');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/Grade_Switcher/components/5486760160369e49afe9acc30c4725e8/bundle.js', [], () => ({
  /* content */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
      return (['<strong>Are you sure you want to continue?</strong><br><br>','If the grade suggestion will be approved by House Leader, the following data will be changed: <br>','   - Grade to (Chosen Grade)<br>   - Subject to (Grade band of chosen grade)<br><br><strong>If New Grade band, this info will also be updated:</strong><br>   - Tutor (Student will be remove from your class)<br>'].join(''))

  },
  /* handler:contentLogic */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, studentList, j, gradeSuggestionList, studentData, lead, gradeSuggestData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lead = (getObjectProperty(___arguments.context.pageData, 'leadData'));
  gradeSuggestData = (getObjectProperty(___arguments.context.dataModel, 'grade_suggestion'))[0];
  studentData = (getObjectProperty(gradeSuggestData, 'class'))[0];
  if ((getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')) == '') {
    console.log(gradeSuggestData);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')) == 'NA' || false || (getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')) == '') {
    ___arguments.context.dataModel['displayError'] = true;
    ___arguments.context.dataModel['errorText'] = 'Please update suggested grade!';
  } else {
    ___arguments.context.dataModel['displayError'] = false;
    try {
      await Backendless.Data.of('grade_suggestions').save( ({ [`previous_grade`]: (getObjectProperty(studentData, 'grade')),[`status`]: 'For Approval',[`suggested_by`]: (getObjectProperty(lead, 'name')),[`suggested_date`]: (new Date()),[`suggested_grade`]: (getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')),[`class`]: (getObjectProperty(studentData, 'objectId')),[`objectId`]: (getObjectProperty(gradeSuggestData, 'objectId')) }) );
      studentList = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['tutor = \'',((getObjectProperty(lead, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND slot_slug=\'',(getObjectProperty(studentData, 'slot_slug')),'\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\''].join(''))).setPageSize(100)));
      for (var j_index in studentList) {
        j = studentList[j_index];
        gradeSuggestionList = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.objectId=\'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['previous_grade', 'status_updated_by', 'status_updated_date', 'created', 'suggested_grade', 'suggested_by', 'status']).setRelated('class').setPageSize(1)));
        if (!!gradeSuggestionList.length) {
          j['grade_suggestion'] = gradeSuggestionList;
          j['suggested_status'] = (getObjectProperty(gradeSuggestionList, 'status'));
          if ((getObjectProperty((gradeSuggestionList[0]), 'status')) == 'For Approval') {
            j['isSuggest'] = false;
            j['isUpdateSuggest'] = true;
          } else {
            j['isSuggest'] = false;
            j['isUpdateSuggest'] = false;
          }
        } else {
          j['grade_suggestion'] = [({ [`previous_grade`]: '-',[`status`]: '-',[`status_updated_by`]: '-',[`status_updated_date`]: '',[`created`]: '',[`suggested_grade`]: '-',[`suggested_by`]: '-' })];
          j['suggested_status'] = 'NA';
          j['isSuggest'] = true;
          j['isUpdateSuggest'] = false;
        }
      }
      ___arguments.context.pageData['suggestGradeApproval'] = '';
      ___arguments.context.pageData['studentList'] = studentList;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5486760160369e49afe9acc30c4725e8');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0505fd3a2fb27b9c6b4c0cd77af26d19');
      await new Promise(r => setTimeout(r, 3000 || 0));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4fa4cb4bda830a0ddee860ce92c54f05');

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/Grade_Switcher/components/36c31e619e2ac4dbc0b3a0ad63df8e84/bundle.js', [], () => ({
  /* content */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
      return (['<strong>Are you sure you want to continue?</strong><br><br>','If the grade suggestion will be approved by House Leader, the following data will be changed: <br>','   - Grade to (Chosen Grade)<br>   - Subject to (Grade band of chosen grade)<br><br><strong>If New Grade band, this info will also be updated:</strong><br>   - Tutor (Student will be remove from your class)<br>'].join(''))

  },
  /* handler:contentLogic */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, studentList, j, gradeSuggestionList, lead, returnSaved, suggestChecker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('36c31e619e2ac4dbc0b3a0ad63df8e84');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7918bfeb1db934b92948a5da7091dca', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec9a725825a86b883b9599389173b2f5', false);
  lead = (getObjectProperty(___arguments.context.pageData, 'leadData'));
  if (await Backendless.Cache.contains('suggestGrade')) {
    if (await Backendless.Cache.get('suggestGrade')) {
      return null;
    }
  } else {
    await Backendless.Cache.put('suggestGrade', true, 50);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')) != '') {
    suggestChecker = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.objectId=\'',(getObjectProperty(___arguments.context.dataModel, 'objectId')),'\' and suggested_by=\'',((getObjectProperty(lead, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(10)));
    if (!suggestChecker.length) {
      try {
        returnSaved = (await Backendless.Data.of('grade_suggestions').save( ({ [`previous_grade`]: (getObjectProperty(___arguments.context.dataModel, 'grade')),[`status`]: 'For Approval',[`suggested_by`]: (getObjectProperty(lead, 'name')),[`suggested_date`]: (new Date()),[`suggested_grade`]: (getObjectProperty(___arguments.context.pageData, 'suggestGradeApproval')),[`class`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')) }) ));
        await Backendless.Data.of('grade_suggestions').setRelation(({ [`objectId`]: (getObjectProperty(returnSaved, 'objectId')) }), 'class', [(getObjectProperty(___arguments.context.dataModel, 'objectId'))]);
        studentList = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['tutor = \'',((getObjectProperty(lead, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND slot_slug=\'',(getObjectProperty(___arguments.context.pageData, 'slotSlug')),'\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\''].join(''))).setPageSize(100)));
        for (var j_index in studentList) {
          j = studentList[j_index];
          gradeSuggestionList = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.objectId=\'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['status_updated_by', 'status_updated_date', 'created', 'suggested_grade', 'suggested_by', 'status']).setRelated('class').setPageSize(10)));
          if (!!gradeSuggestionList.length) {
            j['grade_suggestion'] = gradeSuggestionList;
            j['suggested_status'] = (getObjectProperty(gradeSuggestionList, 'status'));
            if ((getObjectProperty((gradeSuggestionList[0]), 'status')) == 'For Approval') {
              j['isSuggest'] = false;
              j['isUpdateSuggest'] = true;
            } else {
              j['isSuggest'] = false;
              j['isUpdateSuggest'] = false;
            }
          } else {
            j['grade_suggestion'] = [({ [`status`]: '-',[`status_updated_by`]: '-',[`status_updated_date`]: '',[`created`]: '',[`suggested_grade`]: '-',[`suggested_by`]: '-' })];
            j['suggested_status'] = 'NA';
            j['isSuggest'] = true;
            j['isUpdateSuggest'] = false;
          }
        }
        ___arguments.context.pageData['suggestGradeApproval'] = '';
        ___arguments.context.pageData['studentList'] = studentList;
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7918bfeb1db934b92948a5da7091dca', false);
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0505fd3a2fb27b9c6b4c0cd77af26d19');
        await new Promise(r => setTimeout(r, 3000 || 0));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4fa4cb4bda830a0ddee860ce92c54f05');
        if (!!studentList.length) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
        } else {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', true);
        }

      } catch (error) {
        console.log(error);

      }
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7918bfeb1db934b92948a5da7091dca', false);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4fa4cb4bda830a0ddee860ce92c54f05');
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7918bfeb1db934b92948a5da7091dca', false);
    ___arguments.context.pageData['displayError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9339d0e1aa3d51e65eb96a8a68515b6', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec9a725825a86b883b9599389173b2f5', true);
  await Backendless.Cache.remove('suggestGrade');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/Grade_Switcher/components/58d5274d3417d5aafdda29bc617396e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved' || (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'For Approval' || (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Disapproved' ? true : false;
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/6108f29e2373e154fe77e92271a9ea7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved' || (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Disapproved' ? true : false;
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/00bd02e11049f3564ffaad431c4bf713/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = false;
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion')) === 'undefined')) {
    content2 = (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Approved' || (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('661423c123180be96a5ad664323b7648'), 'grade_suggestion'))[0]), 'status')) == 'Disapproved' ? true : false;
  }

  return content2

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/2713067ddd9f2e95b8665ef2781472b3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['chosenGradeApproval'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Grade_Switcher/components/f6538b8f79973c2ee30a38d9fa0d6748/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var gradeSuggestionPending, item, error, _unused, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  gradeSuggestionPending = [];
  if (___arguments.value) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', true);
    ___arguments.context.pageData['pendingApprovals'] = true;
    console.log(getObjectProperty(___arguments.context.pageData, 'SearchValueTutor'));
    var j_list = (getObjectProperty(___arguments.context.pageData, 'availableTutors'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      try {
        _unused = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((false ? ['status=\'For Approval\' AND (suggested_by=\'',((getObjectProperty(___arguments.context.pageData, 'SearchValueTutor')).replace((new RegExp('\'', 'g')), '\'\'')),'\' OR class.tutor =\'',((getObjectProperty(___arguments.context.pageData, 'SearchValueTutor')).replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join('') : ['status=\'For Approval\' AND (suggested_by=\'',((getObjectProperty(j, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' OR class.tutor =\'',((getObjectProperty(j, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\')'].join(''))).setRelated('class').setSortBy('class.tutor').setPageSize(100).setDistinct(true)));
        if (!!_unused.length || !(typeof _unused === 'undefined')) {
          addItemToList(gradeSuggestionPending, _unused);
        }

      } catch (error) {
        console.log(error);
        console.log(getObjectProperty(error, 'message'));

      }
    }
    ___arguments.context.pageData['gradeSuggestionPendings'] = gradeSuggestionPending;
    ___arguments.context.pageData['gradeSuggestionsList'] = gradeSuggestionPending;
  } else {
    ___arguments.context.pageData['pendingApprovals'] = false;
    gradeSuggestionPending = [];
  }
  if (!gradeSuggestionPending.length) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('787e22ee025bff420a45e89530d2ec7e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('414f4ca652c5546b6dc51f1a3e3f0cd5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e239df7a01f19f1cff995ecd09f784a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b911657f5e88afec21364b74209b2c53', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Grade_Switcher/components/0276cf51abddd1fd839c9b65c3815192/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var display;


  display = true;

  return display

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/c724e5a30c92045f5033bc6193460d79/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var leadData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  leadData = (getObjectProperty(___arguments.context.pageData, 'leadData'));

  return (!(typeof leadData === 'undefined') && ((getObjectProperty(leadData, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadData, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadData, 'name')) == 'Jordan Knoetgen' || (getObjectProperty(leadData, 'access_level')) == 'Assistant Principal' || (getObjectProperty(leadData, 'access_level')) == 'School Administrator') ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/8098d4ac583b0266e0916f41ce83f1fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _unused, duplicateClass, error, j, loadingData, ObjectList, offset, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8098d4ac583b0266e0916f41ce83f1fc', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dbcbb1928e68fc64a1380ea8fdcc4ad8', true);
      ObjectList = [];
      result = [];
      loadingData = true;
      offset = 0;
      duplicateClass = [];
      while (loadingData) {
        _unused = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\') AND (slot_slug NOT LIKE \'%MAX1-%\' and slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\' AND slot_slug NOT LIKE \'%TestNicolasTutor Live%\' AND slot_slug NOT LIKE \'%JomarTutor Live%\' AND slot_slug NOT LIKE \'%DUMMYTEACHER1%\')'].join(''))).setSortBy('slot_slug ASC').setPageSize(100).setOffset(offset).setDistinct(true)));
        ObjectList = (ObjectList.concat(_unused));
        offset = offset + 100;
        if (_unused.length < 100) {
          loadingData = false;
        }
      }
      for (var j_index in ObjectList) {
        j = ObjectList[j_index];
        _unused = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.contact_id = \'',(getObjectProperty(j, 'contact_id')),'\' and class.slot_slug=\'',((getObjectProperty(j, 'slot_slug')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setRelated('class').setPageSize(10)));
        if (!_unused.length) {
          if (!(duplicateClass.includes((getObjectProperty(j, 'slot_slug'))))) {
            addItemToList(duplicateClass, (getObjectProperty(j, 'slot_slug')));
            addItemToList(result, ({ [`tutor`]: (getObjectProperty(j, 'tutor')),[`slot_slug`]: (getObjectProperty(j, 'slot_slug')) }));
          }
        }
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('f13e94e1dee718af3946af7192acd60b');
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('1c7726aeeee96af3a9c6c2167e888eac', result);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5698d477306d0d44e23692aa35c462b', result);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8098d4ac583b0266e0916f41ce83f1fc', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dbcbb1928e68fc64a1380ea8fdcc4ad8', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/08a80a0e1b3607a881a770961cf7fa9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_sso', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/6d58fac8a5e966ce5dc81de198a861b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var leadData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  leadData = (getObjectProperty(___arguments.context.pageData, 'leadData'));

  return (!(typeof leadData === 'undefined') && (getObjectProperty(leadData, 'access_level')) == 'Teacher')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/4388bb6b8e388ebaa176331efbded16c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, result, j, duplicateClass, _unused, ObjectList, query, loadingData, offset, leadData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4388bb6b8e388ebaa176331efbded16c', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3d4c4c82f0bd6ba48cef69a78e86ed3', true);
      ObjectList = [];
      result = [];
      loadingData = true;
      _unused = [0];
      offset = 0;
      leadData = (getObjectProperty(___arguments.context.pageData, 'leadData'));
      query = ['status=\'enrolled\' AND (slot_slug LIKE \'%MICROSCHOOL%\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\') AND (slot_slug NOT LIKE \'%MAX1-%\' and slot_slug NOT LIKE \'%MS_SUMMERSCHOOL%\' AND slot_slug NOT LIKE \'%#Slot TBC%\' AND slot_slug NOT LIKE \'%TestNicolasTutor Live%\' AND slot_slug NOT LIKE \'%JomarTutor Live%\' AND slot_slug NOT LIKE \'%DUMMYTEACHER1%\') and tutor =\'',((getObjectProperty(leadData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join('');
      duplicateClass = [];
      while (!!_unused.length) {
        _unused = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause(query).setSortBy('slot_slug ASC').setPageSize(100).setOffset(offset)));
        if (!!_unused.length) {
          addItemToList(ObjectList, _unused);
        }
        offset = (typeof offset == 'number' ? offset : 0) + 100;
      }
      console.log(query);
      console.log(ObjectList);
      for (var j_index in ObjectList) {
        j = ObjectList[j_index];
        _unused = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.contact_id = \'',(getObjectProperty(j, 'contact_id')),'\' and class.slot_slug=\'',((getObjectProperty(j, 'slot_slug')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setRelated('class').setPageSize(10)));
        console.log(_unused);
        console.log(!_unused.length);
        console.log(typeof _unused === 'undefined');
        if (!_unused.length || (typeof _unused === 'undefined')) {
          console.log(getObjectProperty(j, 'slot_slug'));
          if (!(duplicateClass.includes((getObjectProperty(j, 'slot_slug'))))) {
            addItemToList(duplicateClass, (getObjectProperty(j, 'slot_slug')));
            addItemToList(result, ({ [`tutor`]: (getObjectProperty(j, 'tutor')),[`slot_slug`]: (getObjectProperty(j, 'slot_slug')) }));
          }
        }
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('f13e94e1dee718af3946af7192acd60b');
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('1c7726aeeee96af3a9c6c2167e888eac', result);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5698d477306d0d44e23692aa35c462b', result);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4388bb6b8e388ebaa176331efbded16c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3d4c4c82f0bd6ba48cef69a78e86ed3', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Grade_Switcher/components/1309ddb4b9c8b2f61db9273f5452a10c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (!___arguments.context.getComponentDataStoreByUid('1c7726aeeee96af3a9c6c2167e888eac').length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/a5698d477306d0d44e23692aa35c462b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (!!___arguments.context.getComponentDataStoreByUid('1c7726aeeee96af3a9c6c2167e888eac').length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Grade_Switcher/components/7f698cb8851deb0de1a95ecc49b8f549/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var leadData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  leadData = (getObjectProperty(___arguments.context.pageData, 'leadData'));

  return (!(typeof leadData === 'undefined') && (getObjectProperty(leadData, 'access_level')) == 'Teacher')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var studentList, error, j, gradeSuggestionList, slotSlug, leadDB, suggestedGradeList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  slotSlug = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bf416ee9fc83a8a38106f1536019d4b2'), 'slot_slug'));
  console.log(slotSlug);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('5afea65534978435fd7589ea5a6ca059', slotSlug);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('f13e94e1dee718af3946af7192acd60b');
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
    suggestedGradeList = [];
    studentList = [];
    leadDB = (getObjectProperty(___arguments.context.pageData, 'leadData'));
    ___arguments.context.pageData['slotSlug'] = (slotSlug.replace((new RegExp('\'', 'g')), '\'\''));

  } catch (error) {
    console.log(error);

  }
  try {
    studentList = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(leadDB, 'email')) == 'am@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'email')) == 'edtech@brilliantmicroschool.org' || (getObjectProperty(leadDB, 'name')) == 'Jordan Knoetgen' ? ['status=\'enrolled\' AND slot_slug=\'',(slotSlug.replace((new RegExp('\'', 'g')), '\'\'')),'\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\''].join('') : ['tutor = \'',((getObjectProperty(leadDB, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' AND status=\'enrolled\' AND slot_slug=\'',(slotSlug.replace((new RegExp('\'', 'g')), '\'\'')),'\' AND slot_slug LIKE \'%',(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICurrentTerm`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()),'%\''].join(''))).setPageSize(100)));

  } catch (error) {
    console.log(error);

  }
  try {
    for (var j_index in studentList) {
      j = studentList[j_index];
      gradeSuggestionList = (await Backendless.Data.of('grade_suggestions').find(Backendless.DataQueryBuilder.create().setWhereClause((['class.objectId=\'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setProperties(['previous_grade', 'status_updated_by', 'status_updated_date', 'created', 'suggested_grade', 'suggested_by', 'status', 'objectId']).setRelated('class').setPageSize(1)));
      if (!!gradeSuggestionList.length) {
        j['grade_suggestion'] = gradeSuggestionList;
        j['suggested_status'] = (getObjectProperty(gradeSuggestionList, 'status'));
        if ((getObjectProperty((gradeSuggestionList[0]), 'status')) == 'For Approval') {
          j['isSuggest'] = false;
          j['isUpdateSuggest'] = true;
        } else {
          j['isSuggest'] = false;
          j['isUpdateSuggest'] = false;
        }
      } else {
        j['grade_suggestion'] = [({ [`previous_grade`]: '-',[`status`]: '-',[`status_updated_by`]: '-',[`status_updated_date`]: '',[`created`]: '',[`suggested_grade`]: '-',[`suggested_by`]: '-' })];
        j['suggested_status'] = 'NA';
        j['isSuggest'] = true;
        j['isUpdateSuggest'] = false;
      }
    }

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['studentList'] = studentList;
  if (!!studentList.length) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dee9acb56b76c55e3b83d0ccc924ede3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/61d448da23eaeea50aecdbc54fdc5c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var CheckEmail, CreateEmail, AddAdmin, OpportunityStatus, Admin, AdminStartDate, AdminObjectId, UserStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'sendEmail')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'sendEmail')).length) {
    (function (message) { alert(message) })('You need to enter an email to proceed.');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'sendEmail')).startsWith(' ')) {
    (function (message) { alert(message) })('Check email if it\'s correct.');
    return null;
  }
  CheckEmail = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),'\' and userType = \'Teacher\''].join(''))).setPageSize(10)))[0];
  if ((typeof CheckEmail === 'undefined') || (CheckEmail === null)) {
    (function (message) { alert(message) })('Please enter an email that is registered on Brilliant Grades.');
    return null;
  } else {
    await Backendless.Request.post(`${Backendless.appPath}/services/BG_01_ADMIN/BackendlessLoginAuthRestBlock`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ 'action': 'update','method': 'tutor_dash main page','databaseName': 'Users','requestType': 'serverSide','createObject': ({ 'password': (getObjectProperty(CheckEmail, 'zoomid')),'objectId': (getObjectProperty(CheckEmail, 'objectId')) }) })));
    CreateEmail = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': ((new Date()).valueOf()),'lead_id': (getObjectProperty(CheckEmail, 'lead_id')),'sender_name': 'Brilliant Grades','sender_email': 'notifications@brilliantgrades.com','to': (getObjectProperty(___arguments.context.pageData, 'sendEmail')),'body_html': (['Your account has been reset, please try entering with email = ',(getObjectProperty(___arguments.context.pageData, 'sendEmail')),' and zoomid = ',(getObjectProperty(CheckEmail, 'zoomid')),'. <br><br>','Thank you!'].join('')),'subject': 'Forgot Password' }));
    (function (message) { alert(message) })('Successfully send email!');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc99353c6efa6e72a386bf3ba68587c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, StudentDIRObject, LoginData, password, email, Parameter, ParameterList, UTMValue, UTMName, AnsweredQuestion, Parameters, URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);
    URL2 = ((function () { return window.location.href })());
    if (URL2.indexOf('#') !== -1) {
      Parameters = URL2.slice(((URL2.indexOf('#') + 1 + 1) - 1), URL2.length);
      ParameterList = (await Promise.all((Parameters.split('&')).map(async AnsweredQuestion => {  UTMName = AnsweredQuestion.slice(0, (AnsweredQuestion.indexOf('=') + 1) - 1);
        UTMValue = AnsweredQuestion.slice(((AnsweredQuestion.indexOf('=') + 1 + 1) - 1), AnsweredQuestion.length);
      ; return ({ [`utmName`]: UTMName,[`utmValue`]: UTMValue });})));
      for (var Parameter_index in ParameterList) {
        Parameter = ParameterList[Parameter_index];
        ___arguments.context.pageData[(getObjectProperty(Parameter, 'utmName'))] = (getObjectProperty(Parameter, 'utmValue'));
      }
    }
    if (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) {
      if (getObjectProperty(___arguments.context.pageData, 'tutorMenuDashboard')) {
        email = (getObjectProperty(___arguments.context.pageData, 'tutorEmail'));
        password = (getObjectProperty(___arguments.context.pageData, 'zoomid'));
        LoginData = (await Backendless.UserService.login( email, (String(password)), true  ));
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_sso', undefined);
      } else {
        LoginData = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'adminEmail')), (String(getObjectProperty(___arguments.context.pageData, 'phonenumber'))), false  ));
        console.log(LoginData);
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('SIS', ({ [`LoginData`]: LoginData,[`fromAdminPanel`]: true }));
      }
    }
    if (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string') {
      ___arguments.context.pageData['loginAs'] = 'PS';
    }
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string') {
      StudentDIRObject = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['sendEmail'] = (getObjectProperty(StudentDIRObject, 'email'));
    }

  } catch (error) {
    console.log(error);

  }
  try {
    console.log(___arguments.context.pageData);
    ___arguments.context.pageData['sendEmailLabel'] = 'Send a One-Time-Password to my email';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Main_Page/components/c452784297afc3ca082dbd58a2eecd79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  if ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'teacher') {
    await socialLogin('googleplus', ({ [`email`]: 'email',[`name`]: 'name' }), null, null, 'tutor_sso', null);
  } else {
    await socialLogin('googleplus', ({ [`email`]: 'email',[`name`]: 'name' }), null, null, 'SIS', null);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/373a80c5245e672221fe8a8fd78e8067/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decrement, date, CreateEmail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'sendEmail')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'sendEmail')).length) {
    (function (message) { alert(message) })('You need to enter an email to proceed.');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'sendEmail')).indexOf(' ') !== -1) {
    (function (message) { alert(message) })('Check email if it\'s correct.');
    return null;
  }
  ___arguments.context.pageData['otp'] = (mathRandomInt(1, 999999));
  await Backendless.Cache.put((String('parentOTP-') + String(getObjectProperty(___arguments.context.pageData, 'lead_id'))), (getObjectProperty(___arguments.context.pageData, 'otp')), 7200);
  date = (new Date((new Date()).getTime() + (600 * 1000)));
  CreateEmail = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'outbox','lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'sender_name': 'Brilliant Grades','sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(___arguments.context.pageData, 'sendEmail')),'body_html': (['Your OTP is ',(getObjectProperty(___arguments.context.pageData, 'otp')),'<br><br>Please enter your OTP in the corresponding text box to access the Student Information Form.','<br>Please note that the OTP will expire in 2 hours<br><br>','Thank you!'].join('')),'subject': 'OTP for Student Information Form' }));
  ___arguments.context.pageData['sendEmailDisabled'] = true;
  ___arguments.context.pageData['sendEmailTextDisabled'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('373a80c5245e672221fe8a8fd78e8067'))['background'] = '#d3d3d3';
  decrement = 30;
  for (var count = 0; count < 30; count++) {
    decrement = decrement - 1;
    ___arguments.context.pageData['sendEmailLabel'] = (['Resend OTP in ',decrement,decrement > 1 && decrement == 0 ? ' seconds' : ' second'].join(''));
    await new Promise(r => setTimeout(r, 1000 || 0));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('373a80c5245e672221fe8a8fd78e8067'))['background'] = '#32325D';
  ___arguments.context.pageData['sendEmailLabel'] = 'Send OTP';
  ___arguments.context.pageData['sendEmailDisabled'] = false;
  ___arguments.context.pageData['sendEmailTextDisabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/819801a91fb9c97ed64e2e854c86ff37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var OTPfromCache;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  OTPfromCache = (await Backendless.Cache.get((String('parentOTP-') + String(getObjectProperty(___arguments.context.pageData, 'lead_id')))));
  console.log(OTPfromCache);
  if (!(typeof OTPfromCache === 'number' && !isNaN(OTPfromCache))) {
    (function (message) { alert(message) })('One time pin expired. Please send a new one and try again');
    return null;
  }
  if (OTPfromCache == (getObjectProperty(___arguments.context.pageData, 'OneTimePin'))) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/?page=SIS&from=ParentOTPLogin&lead_id=',(getObjectProperty(___arguments.context.pageData, 'lead_id')),''].join('')), false, undefined);
  } else {
    (function (message) { alert(message) })('Invalid one time pin. Please check and try again');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/e878644a01da6cdc1a1fe8c3f71b5f6a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string') || (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/065a22e90528cecc5b7f4bbfa755dcae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string') && (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/605d81c2f7e4c4b27af8544eac4cdf82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _unused, checkUser, error, LoginData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'email')).length) {
      ___arguments.context.pageData['status'] = 'Please enter your email address';
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'phoneNumber')).length) {
      ___arguments.context.pageData['status'] = 'Please enter your phone number';
    }
    LoginData = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'email')), (getObjectProperty(___arguments.context.pageData, 'phoneNumber')), true  ));
    if ((getObjectProperty(LoginData, 'userType')) == 'Teacher') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_sso', ___arguments.context.pageData);
    } else {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/index.html?page=SIS', false, ({ [`fromTutorSSO`]: true,[`fromAdminPanel`]: true,[`tutorEmail`]: (getObjectProperty(LoginData, 'email')),[`phoneNumber`]: (getObjectProperty(___arguments.context.pageData, 'phoneNumber')) }));
    }

  } catch (error) {
    checkUser = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty(___arguments.context.pageData, 'email')),'\''].join(''))).setPageSize(1)));
    if (!checkUser.length) {
      ___arguments.context.pageData['status'] = 'Please use the email registered with Brilliant Grades';
    } else {
      if ((getObjectProperty((checkUser[0]), 'userStatus')) == 'ENABLED') {
        ___arguments.context.pageData['status'] = 'Please use the phone number registered with Brilliant Grades';
      } else {
        ___arguments.context.pageData['status'] = 'Please contact Brilliant Grades regarding your account';
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a12d78fa3fface8e46d419d9a0de6554', true);
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/668814050db6f454cfd2480960c390a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc99353c6efa6e72a386bf3ba68587c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/82cab10ae09d5e537bc8b1dccea832a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null) && ((getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'teacher' || (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'student'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/30456e88e23de205184a0ba3ea71ccd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'PS';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/714f3231a8173c960e4c2818be28a98a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'teacher';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/5261e619e3df555b028515fc3d683ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = 'student';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/f5ba947804386f0edebdf656cfe63923/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null) && (getObjectProperty(___arguments.context.pageData, 'loginAs')) == 'PS')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Main_Page/components/41115e9a4d6d0e49303b33f8810a5428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/d2fbfb49e6cda32a3a3c2539a09e7a19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['loginAs'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Main_Page/components/98f2983d039dac84d344ef1cb896fab2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'loginAs')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'loginAs')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/MobyMax_CSV/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    
  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/MobyMax_CSV/components/54bc945de15c3388567b9519088b5001/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('ce7e3fea9ef2b1588e3eb024149b5131');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobyMax_CSV/components/caf7b0d14c54205482d80ee93b053433/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('ce7e3fea9ef2b1588e3eb024149b5131');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobyMax_CSV/components/57cf4046825c3c84275d2f1ef5bba4db/bundle.js', [], () => ({
  /* content */
  /* handler:tabsLogic */
  ['tabsLogic'](___arguments) {
      return [({ [`id`]: 'tab1',[`label`]: 'Math' }), ({ [`id`]: 'tab2',[`label`]: 'Reading' }), ({ [`id`]: 'tab3',[`label`]: 'Language' })]

  },
  /* handler:tabsLogic */
  /* content */
}))

define('./pages/MobyMax_CSV/components/10c53b2646e3aab7e39f27617316bfeb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentTabId() })('57cf4046825c3c84275d2f1ef5bba4db')) == 'tab1')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/MobyMax_CSV/components/6747fdba046d50583c3d81c8ecedab0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentTabId() })('57cf4046825c3c84275d2f1ef5bba4db')) == 'tab2')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/MobyMax_CSV/components/0481fa83bd2ee25cee5a425aa0bc7eac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentTabId() })('57cf4046825c3c84275d2f1ef5bba4db')) == 'tab3')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/MobyMax_CSV/components/4df330872125e459b073692f9b8e8e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, SheetID, sheetDataForLanguage, combineArray, item, sheetDataForReading, sheetDataForMath, list, data2, data, k, j, tempData, fileData;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function readFileContent(encoding, result) {
    if (!encoding) {
      if (typeof Buffer !== 'undefined') {
        return result instanceof Buffer
          ? result.toJSON().data
          : Buffer.from(JSON.stringify(result)).toJSON().data
      }

      return result
    }

    if (result && typeof result === 'object') {
      return JSON.stringify(result)
    }

    return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4df330872125e459b073692f9b8e8e1e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97cf768bebe809ffa94a17532c5e579d', true);
  try {
    await Backendless.Files.remove(encodePath('MobyMaxCSV/MobyMax.csv'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).uploadFiles() })('18592cfecf0878a4516609721b96fa67');

  } catch (error) {
    console.log(error);

  }
  try {
    await new Promise(r => setTimeout(r, 200 || 0));
    fileData = (await Backendless.Request.get((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(encodePath('https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/MobyMaxCSV/MobyMax.csv'))).setEncoding('utf8').then(result => readFileContent('utf8', result)));
    list = [];
    data2 = [];
    tempData = (fileData.replace((new RegExp(', ', 'g')), '% ')).split('\n');
    for (var j_index in tempData) {
      j = tempData[j_index];
      data = (j.replace((new RegExp('\\r', 'g')), '')).split(',');
      data2 = [(await Promise.all(data.map(async item => {; return ((item.replace((new RegExp('"', 'g')), '')).replace((new RegExp('% ', 'g')), ', '));})))];
      addItemToList(list, data2);
    }
    await BackendlessUI.Functions.Custom['fn_e8a8947b491478e74417805bd7b43fa8']('1gSvmUgNMaaeJrJxbwQfsPMbtqdS0R-Jzk1JKesFxUIU', '\'Sheet1\'!A1', list);

  } catch (error) {
    console.log(error);

  }
  try {
    SheetID = '1gSvmUgNMaaeJrJxbwQfsPMbtqdS0R-Jzk1JKesFxUIU';
    sheetDataForMath = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_1bfd91c36a66a7b48bb5b7bbe3ba5d75'](SheetID, '\'Sheet1\'!A156:J4000', 'ROWS')), 'values'));
    sheetDataForReading = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_1bfd91c36a66a7b48bb5b7bbe3ba5d75'](SheetID, '\'Sheet1\'!L156:U4000', 'ROWS')), 'values'));
    sheetDataForLanguage = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_1bfd91c36a66a7b48bb5b7bbe3ba5d75'](SheetID, '\'Sheet1\'!W156:AF4000', 'ROWS')), 'values'));
    combineArray = [];
    combineArray = (combineArray.concat((await Promise.all(sheetDataForMath.map(async item => {; return ({ [`tutor`]: (await BackendlessUI.Functions.Custom['fn_7632b4b571bab0a71894762cdd9e7dd9']((item[0]))),[`student_name`]: (await BackendlessUI.Functions.Custom['fn_7632b4b571bab0a71894762cdd9e7dd9']((item[1]))),[`ending_grade_level`]: item[2],[`beginning_grade_level`]: item[3],[`increase`]: item[4],[`standards_passed`]: item[5],[`learning_velocity`]: item[6],[`total_hours`]: item[7],[`month`]: item[8],[`subject`]: 'Math' });})))));
    combineArray = (combineArray.concat((await Promise.all(sheetDataForReading.map(async item => {; return ({ [`tutor`]: (await BackendlessUI.Functions.Custom['fn_7632b4b571bab0a71894762cdd9e7dd9']((item[0]))),[`student_name`]: (await BackendlessUI.Functions.Custom['fn_7632b4b571bab0a71894762cdd9e7dd9']((item[1]))),[`ending_grade_level`]: item[2],[`beginning_grade_level`]: item[3],[`increase`]: item[4],[`standards_passed`]: item[5],[`learning_velocity`]: item[6],[`total_hours`]: item[7],[`month`]: item[8],[`subject`]: 'Reading' });})))));
    combineArray = (combineArray.concat((await Promise.all(sheetDataForLanguage.map(async item => {; return ({ [`tutor`]: (await BackendlessUI.Functions.Custom['fn_7632b4b571bab0a71894762cdd9e7dd9']((item[0]))),[`student_name`]: (await BackendlessUI.Functions.Custom['fn_7632b4b571bab0a71894762cdd9e7dd9']((item[1]))),[`ending_grade_level`]: item[2],[`beginning_grade_level`]: item[3],[`increase`]: item[4],[`standards_passed`]: item[5],[`learning_velocity`]: item[6],[`total_hours`]: item[7],[`month`]: item[8],[`subject`]: 'Language' });})))));
    await Backendless.Data.of('MobyMax').bulkCreate( combineArray );
    console.log(combineArray);

  } catch (error) {
    console.log(error);

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4df330872125e459b073692f9b8e8e1e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97cf768bebe809ffa94a17532c5e579d', false);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('ce7e3fea9ef2b1588e3eb024149b5131');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobyMax_CSV/components/18592cfecf0878a4516609721b96fa67/bundle.js', [], () => ({
  /* content */
  /* handler:fileNameLogic */
  ['fileNameLogic'](___arguments) {
      return 'MobyMax'

  },
  /* handler:fileNameLogic */
  /* content */
}))

define('./pages/ParentOTPLogin/components/61d448da23eaeea50aecdbc54fdc5c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decrement, CreateEmail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'sendEmail')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'sendEmail')).length) {
    (function (message) { alert(message) })('You need to enter an email to proceed.');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'sendEmail')).indexOf(' ') !== -1) {
    (function (message) { alert(message) })('Check email if it\'s correct.');
    return null;
  }
  CreateEmail = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'outbox','lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'sender_name': 'Brilliant Grades','sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(___arguments.context.pageData, 'sendEmail')),'body_html': (['Your OTP is ',(getObjectProperty(___arguments.context.pageData, 'otp')),'<br><br>Please enter your OTP in the corresponding text box to access the Student Information Form.','<br><br>','Thank you!',''].join('')),'subject': 'OTP for Student Information Form' }));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('139707d6bff997e9ea8e766190aea938', true);
  ___arguments.context.pageData['sendEmailDisabled'] = true;
  ___arguments.context.pageData['sendEmailTextDisabled'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('61d448da23eaeea50aecdbc54fdc5c0f'))['background'] = '#d3d3d3';
  decrement = 30;
  for (var count = 0; count < 30; count++) {
    decrement = decrement - 1;
    ___arguments.context.pageData['sendEmailLabel'] = (['Resend OTP in ',decrement,decrement > 1 && decrement == 0 ? ' seconds' : ' second'].join(''));
    await new Promise(r => setTimeout(r, 1000 || 0));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('61d448da23eaeea50aecdbc54fdc5c0f'))['background'] = '#32325D';
  ___arguments.context.pageData['sendEmailLabel'] = 'Send OTP';
  ___arguments.context.pageData['sendEmailDisabled'] = false;
  ___arguments.context.pageData['sendEmailTextDisabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ParentOTPLogin/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, StudentDIRObject, Parameter, ParameterList, UTMValue, UTMName, AnsweredQuestion, Parameters, URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    URL2 = ((function () { return window.location.href })());
    if (URL2.indexOf('#') !== -1) {
      Parameters = URL2.slice(((URL2.indexOf('#') + 1 + 1) - 1), URL2.length);
      ParameterList = (await Promise.all((Parameters.split('&')).map(async AnsweredQuestion => {  UTMName = AnsweredQuestion.slice(0, (AnsweredQuestion.indexOf('=') + 1) - 1);
        UTMValue = AnsweredQuestion.slice(((AnsweredQuestion.indexOf('=') + 1 + 1) - 1), AnsweredQuestion.length);
      ; return ({ [`utmName`]: UTMName,[`utmValue`]: UTMValue });})));
      for (var Parameter_index in ParameterList) {
        Parameter = ParameterList[Parameter_index];
        ___arguments.context.pageData[(getObjectProperty(Parameter, 'utmName'))] = (getObjectProperty(Parameter, 'utmValue'));
      }
    }

  } catch (error) {
    console.log(error);

  }
  try {
    StudentDIRObject = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name = \'',(getObjectProperty(___arguments.context.pageData, 'student_name')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['sendEmailLabel'] = 'Send a One-Time-Password to my email';
    ___arguments.context.pageData['otp'] = (getObjectProperty(StudentDIRObject, 'OTP'));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/ParentOTPLogin/components/81da1a78fcd6605f59c468a608245fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'OneTimePin')) == (getObjectProperty(___arguments.context.pageData, 'otp'))) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/?page=student_form&from=ParentOTPLogin&lead_id=',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'&student_name=',(getObjectProperty(___arguments.context.pageData, 'student_name'))].join('')), false, undefined);
  } else {
    (function (message) { alert(message) })('Invalid OTP. Please check and try again');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Parent_OTP_Page/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item, StudentList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76e7f203200bddba9e4d60ed7351f5df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', false);
  try {
    StudentList = [];
    StudentList = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and status=\'enrolled\''].join(''))).setSortBy('student_name').setGroupBy('student_name').setPageSize(100).setDistinct(true)));
    ___arguments.context.pageData['parent_name'] = (getObjectProperty((StudentList[0]), 'parent_name'));
    ___arguments.context.pageData['StudentList'] = (await Promise.all(StudentList.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'student_name')),[`label`]: (getObjectProperty(item, 'student_name')) });})));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('723a2a3cd9c4084bc9c340214a46aeeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Assistant Teacher').debug((['Assistant Teacher Error | Error in Page Enter AP:',(decodeURIComponent((getObjectProperty(___arguments.context.pageData, 'name')))),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Parent_OTP_Page/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Parent_OTP_Page/components/dd141a5dafda4595aa794a8cf933921a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, selectedStudentObject, studentWeeklySlotObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    selectedStudentObject = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['student_name=\'',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'\' and status = \'enrolled\' and lead_id=\'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\''].join(''))).setPageSize(10)))[0];
    studentWeeklySlotObject = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['student_name=\'',(___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')),'\' and status=\'enrolled\' and lead_id=\'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\''].join(''))).setPageSize(10)))[0];
    console.log(studentWeeklySlotObject);
    ___arguments.context.pageData['studentName'] = (getObjectProperty(selectedStudentObject, 'student_name'));
    ___arguments.context.pageData['studentSubject'] = (getObjectProperty(studentWeeklySlotObject, 'subject'));
    ___arguments.context.pageData['studentGrade'] = (getObjectProperty(studentWeeklySlotObject, 'grade'));
    ___arguments.context.pageData['selectedStudentObject'] = selectedStudentObject;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff64453889bc48c39e52838ae79cfd28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cf9821da0f97c280e0f232cd7b4205d', true);

  } catch (error) {
    Backendless.Logging.getLogger('Parent OTP Page').debug((['Error in selecting a teacher in Parent OTP Page Page \\nError:\\n',error,'\\n',(getObjectProperty(error, 'message'))].join('')));
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Parent_OTP_Page/components/d17c61b1f2f49205db7b77f54acf08e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var TeacherObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TeacherObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('49d74029aad92b9437d68cc1ef480b99'), 'teacher')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(TeacherObject, 'video')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Parent_OTP_Page/components/f2cf7c12cce79b32cfba4c0dd7517f13/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  name2 = 'Dashboard';
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'parent_name')) === 'undefined')) {
    name2 = ['Hi ',(getObjectProperty(___arguments.context.pageData, 'parent_name')),', welcome back!'].join('');
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Parent_OTP_Page/components/563cb02864d70a74580cbaacaa2db2e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Student' }) })), false, ({ [`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedStudentObject')), 'lead_id')),[`student_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedStudentObject')), 'student_name')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Login Student From Parent').debug((['Login Student From Parent Error:\n',error,'\n',(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Parent_OTP_Page/components/e1f6c38ad287b682ab7849c144e72da3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  name2 = '';
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'studentName')) === 'undefined') && !((getObjectProperty(___arguments.context.pageData, 'studentName')) === null)) {
    name2 = String(name2) + String(String(getObjectProperty(___arguments.context.pageData, 'studentName')) + String('\'s Information'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var pageTitle, TeacherDB, item, ObjectList, ClassSlug, _oldClassSlug, weeklySlot, offset, _unused, TeacherID, StudentDIRData, StudentInfo, percentCompleted, NotCompletedFields, lengthCompetedFields, StateRegObject, RegFormCompleteTask, j, Checker, TempList, _tempStudentDir, StudentNameChecker, StudentMap, UserData, tutorData, User, DriveTokenObject, Parameter, ParameterList, UTMValue, UTMName, AnsweredQuestion, Parameters, URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('257cdf3168d77145439adb339c2e01b4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
  URL2 = ((function () { return window.location.href })());
  Backendless.Logging.getLogger('SIS Login - URL').debug(URL2);
  pageTitle = 'Student Information';
  if (URL2.indexOf('#') !== -1) {
    Parameters = URL2.slice(((URL2.indexOf('#') + 1 + 1) - 1), URL2.length);
    ParameterList = (await Promise.all((Parameters.split('&')).map(async AnsweredQuestion => {  UTMName = AnsweredQuestion.slice(0, (AnsweredQuestion.indexOf('=') + 1) - 1);
      UTMValue = AnsweredQuestion.slice(((AnsweredQuestion.indexOf('=') + 1 + 1) - 1), AnsweredQuestion.length);
    ; return ({ [`utmName`]: UTMName,[`utmValue`]: UTMValue });})));
    for (var Parameter_index in ParameterList) {
      Parameter = ParameterList[Parameter_index];
      ___arguments.context.pageData[(getObjectProperty(Parameter, 'utmName'))] = (getObjectProperty(Parameter, 'utmValue'));
    }
  }
  DriveTokenObject = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0];
  ___arguments.context.pageData['DriveTokenObject'] = DriveTokenObject;
  ___arguments.context.pageData['sectionClicked'] = 'studentInfo';
  console.log('Valid session?');
  console.log(await Backendless.UserService.isValidLogin());
  if (!(await Backendless.UserService.isValidLogin()) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined')) {
    console.log('parent view not logged in');
    console.log(['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''));
    TempList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''))).setRelated('slots').setRelationsDepth(2).setRelationsPageSize(100).setPageSize(100)));
    StudentDIRData = [];
    Checker = [];
    for (var j_index in TempList) {
      j = TempList[j_index];
      if (!(Checker.includes((getObjectProperty(j, 'objectId'))))) {
        addItemToList(Checker, (getObjectProperty(j, 'objectId')));
        addItemToList(StudentDIRData, j);
      }
    }
    ___arguments.context.pageData['StudentSelectionOptions'] = (await Promise.all(StudentDIRData.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'student_name')) });})));
    ___arguments.context.pageData['userType'] = 'Parent';
    ___arguments.context.pageData['student_name'] = (getObjectProperty((StudentDIRData[0]), 'student_name'));
    ___arguments.context.pageData['StudentDIRParent'] = StudentDIRData;
  } else if ((await Backendless.UserService.isValidLogin()) && ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1) && (typeof (getObjectProperty(___arguments.context.pageData, 'SSO')) === 'undefined')) {
    console.log('student view');
    console.log(await Backendless.UserService.getCurrentUser(false));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'ilya.test@bms.family' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'arabella.test@bms.family') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('parent_student_sso', undefined);
    } else {
      UserData = ({ [`access_level`]: 'Student' });
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': UserData })), false, ({ [`fromMainPortal`]: true }));
    }
  } else if ((await Backendless.UserService.isValidLogin()) && (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string') || (typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'string') || !(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
    console.log('parent view');
    console.log(['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''));
    pageTitle = String(getObjectProperty(___arguments.context.pageData, 'student_name')) + String('\'s Information');
    TempList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''))).setRelated('slots').setRelationsDepth(2).setRelationsPageSize(100).setPageSize(100)));
    StudentDIRData = [];
    Checker = [];
    for (var j_index2 in TempList) {
      j = TempList[j_index2];
      if (!(Checker.includes((getObjectProperty(j, 'objectId'))))) {
        addItemToList(Checker, (getObjectProperty(j, 'objectId')));
        addItemToList(StudentDIRData, j);
      }
    }
    if (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string') {
      StudentNameChecker = !(await asyncListFilter(StudentDIRData, async (item) => {


       return ((getObjectProperty(___arguments.context.pageData, 'student_name')).toUpperCase() == (getObjectProperty(item, 'student_name')).toUpperCase());
      })).length;
      if (StudentNameChecker) {
        if (StudentDIRData.length == 1) {
          await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty((StudentDIRData[0]), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.pageData, 'student_name')) }) );
        } else {
          _tempStudentDir = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and slots.status = \'enrolled\' and student_nick_name =\'',((getObjectProperty(___arguments.context.pageData, 'student_name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setRelated('slots').setRelationsDepth(2).setRelationsPageSize(100).setPageSize(100)));
          if (!_tempStudentDir.length) {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('48ff4f09ea24a203eb410b8a6b9b8a4e', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
            return null;
          }
          await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty((_tempStudentDir[0]), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.pageData, 'student_name')) }) );
        }
        TempList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''))).setRelated('slots').setRelationsDepth(2).setRelationsPageSize(100).setPageSize(100)));
        StudentDIRData = [];
        Checker = [];
        for (var j_index3 in TempList) {
          j = TempList[j_index3];
          if (!(Checker.includes((getObjectProperty(j, 'objectId'))))) {
            addItemToList(Checker, (getObjectProperty(j, 'objectId')));
            addItemToList(StudentDIRData, j);
          }
        }
      }
      ___arguments.context.pageData['StudentSelectionOptions'] = (await Promise.all(StudentDIRData.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'student_name')) });})));
      ___arguments.context.pageData['student_name'] = (decodeURIComponent((getObjectProperty(___arguments.context.pageData, 'student_name'))));
      ___arguments.context.pageData['StudentSelectionLabel'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'StudentSelectionOptions')), async (item) => {


       return ((getObjectProperty(___arguments.context.pageData, 'student_name')).toUpperCase() == (getObjectProperty(item, 'label')).toUpperCase());
      }))[0]), 'label'));
      StudentInfo = (await asyncListFilter(StudentDIRData, async (item) => {


       return ((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'StudentSelectionOptions')), async (item) => {


       return ((getObjectProperty(___arguments.context.pageData, 'student_name')).toUpperCase() == (getObjectProperty(item, 'label')).toUpperCase());
      }))[0]), 'value')) == (getObjectProperty(item, 'objectId')));
      }))[0];
      if (!(typeof StudentInfo === 'undefined')) {
        console.log(StudentInfo);
        RegFormCompleteTask = !((getObjectProperty(StudentInfo, 'student_last_name')) === null);
        ___arguments.context.pageData['isSubmitted'] = RegFormCompleteTask;
        StudentInfo['ethnicityValue'] = ((getObjectProperty(StudentInfo, 'African_American')) ? 'African-American' : ((getObjectProperty(StudentInfo, 'Asian')) ? 'Asian' : ((getObjectProperty(StudentInfo, 'Caucasian')) ? 'Caucasian' : ((getObjectProperty(StudentInfo, 'Latino_Hispanic')) ? 'Latino or Hispanic' : ((getObjectProperty(StudentInfo, 'Native_American')) ? 'Native American' : ((getObjectProperty(StudentInfo, 'Native_Hawaiian')) ? 'Native Hawaiian' : ((getObjectProperty(StudentInfo, 'other_unknown_ethnicity')) ? 'Other/Unknown' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_ethnicity')) ? 'Prefer not to say' : null))))))));
        StudentInfo['genderValue'] = ((getObjectProperty(StudentInfo, 'female')) ? 'Female' : ((getObjectProperty(StudentInfo, 'male')) ? 'Male' : ((getObjectProperty(StudentInfo, 'transgender')) ? 'Transgender' : ((getObjectProperty(StudentInfo, 'gender_variant_non_conforming')) ? 'Gender Variant/Non-Conforming' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_gender')) ? 'Prefer not to say' : (!((getObjectProperty(StudentInfo, 'other_gender')) === null) ? (getObjectProperty(StudentInfo, 'other_gender')) : null))))));
        StudentInfo['slots'] = (await Backendless.Data.of('ms_student_dir').loadRelations((getObjectProperty(StudentInfo, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('slots').setPageSize(100).setOffset(0)));
        if (!((getObjectProperty(StudentInfo, 'home_state')) === null)) {
          StateRegObject = (await Backendless.Data.of('state_regs').find(Backendless.DataQueryBuilder.create().setWhereClause((['State_Name = \'',(getObjectProperty(StudentInfo, 'home_state')),'\''].join(''))).setPageSize(10)))[0];
          ___arguments.context.pageData['StateRegObject'] = StateRegObject;
        }
        if (true) {
          StudentInfo['behavior'] = [];
          if (getObjectProperty(StudentInfo, 'Dyslexia')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyslexia');
          }
          if (getObjectProperty(StudentInfo, 'Dysgraphia')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dysgraphia');
          }
          if (getObjectProperty(StudentInfo, 'Dyscalculia')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyscalculia');
          }
          if (getObjectProperty(StudentInfo, 'ADHD')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'ADHD');
          }
          if (getObjectProperty(StudentInfo, 'auditory_processing_disorder')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Auditory processing disorder');
          }
          if (getObjectProperty(StudentInfo, 'language_processing_disorder')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Language processing disorder');
          }
          if (getObjectProperty(StudentInfo, 'nonverbal_learning_disorder')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Nonverbal learning disorder');
          }
          if (getObjectProperty(StudentInfo, 'visual_perceptual_or_visual_motor_defecit')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Visual perceptual/visual motor deficit');
          }
          if (getObjectProperty(StudentInfo, 'austism_spectrum_discorder')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Autism spectrum disorder');
          }
          if (getObjectProperty(StudentInfo, 'asperger')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Asperger’s');
          }
          if (getObjectProperty(StudentInfo, 'anxiety')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Anxiety');
          }
          if (getObjectProperty(StudentInfo, 'depression')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Depression');
          }
          if (getObjectProperty(StudentInfo, 'behavioral_issues')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Behavioral issues');
          }
          if ((typeof (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) === 'string') && (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) != '') {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Other');
          }
        }
        if (!((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')) === null)) {
          StudentInfo['learningList'] = (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')), (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
        }
        if (!((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')) === null)) {
          StudentInfo['IEPDocs'] = (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')), (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
        }
        StudentInfo['secondary_guardian_show'] = (!((getObjectProperty(StudentInfo, 'secondary_guardian')) === null));
        StudentInfo['ShowPTOQuestions'] = (!((getObjectProperty(StudentInfo, 'PTO')) === null));
        StudentInfo['honorCodeStudentName'] = (getObjectProperty(StudentInfo, 'student_name'));
        StudentInfo['honorCodeParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
        StudentInfo['ToSParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
        if ((getObjectProperty(StudentInfo, 'CallNotes')) === null) {
          StudentInfo['CallNotes'] = [];
        }
        if ((getObjectProperty(StudentInfo, 'teacherNotes')) === null) {
          StudentInfo['teacherNotes'] = [];
        }
        if ((getObjectProperty(StudentInfo, 'PSNotes')) === null) {
          StudentInfo['PSNotes'] = [];
        }
        if (!(getObjectProperty(StudentInfo, 'transferCredit'))) {
          StudentInfo['CreditTransfer'] = [];
        }
        StudentInfo['English'] = ['English 1', 'English 2', 'English 3', 'English 4'];
        StudentInfo['Math'] = ['Pre-Algebra', 'Algebra 1', 'Algebra 2', 'Geometry', 'Pre-Calculus', 'Calculus', 'Statistics', 'Integrated Math 1', 'Integrated Math 2', 'Integrated Math 3'];
        StudentInfo['SocialStudies'] = ['World History', 'Global Studies', 'U.S. History', 'U.S. Government', 'Economics', 'Geography', 'Psychology', 'Sociology'];
        StudentInfo['Science'] = ['Biology', 'Chemistry', 'Physics', 'Environmental Science', 'Anatomy and Physiology'];
        StudentInfo['PE&Health'] = ['Physical Education', 'Health Education'];
        StudentInfo['WorldLanguage'] = ['Spanish', 'French', 'German', 'Chinese'];
        StudentInfo['FineArts'] = ['Band', 'Orchestra', 'Choir', 'Theatre Arts/Drama', 'Visual Arts', 'Digital Design', 'Photography'];
        StudentInfo['CTE'] = ['Computer Science', 'Business and Marketing', 'Health Sciences', 'Culinary Arts', 'Automotive Technology', 'Agriculture Sciences', 'Audio/Video Production', 'Creative Writing', 'Journalism', 'Debate'];
        StudentInfo['grade'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


         return (((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1) || ((getObjectProperty(item, 'status')).indexOf('churn') !== -1));
        }))[0]), 'grade'));
        StudentInfo['chargebeeID'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


         return (((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1) || ((getObjectProperty(item, 'status')).indexOf('churn') !== -1));
        }))[0]), 'chargebee'));
        if (typeof (getObjectProperty(StudentInfo, 'studentMSEmail')) === 'string') {
          StudentInfo['1disabled'] = true;
          StudentInfo['1.5disabled'] = true;
          StudentInfo['1.6disabled'] = true;
          StudentInfo['2disabled'] = true;
          StudentInfo['3disabled'] = true;
          StudentInfo['4disabled'] = true;
          StudentInfo['5disabled'] = true;
          StudentInfo['6disabled'] = true;
          StudentInfo['6.1disabled'] = true;
          StudentInfo['7disabled'] = true;
          StudentInfo['8disabled'] = true;
          StudentInfo['8.1disabled'] = true;
          StudentInfo['8.2disabled'] = true;
          StudentInfo['9disabled'] = true;
        }
        StudentInfo['requiredList'] = ['Ethnicity', 'student_name', 'student_last_name', 'student_birth_date', 'most_interested_in', 'behavior', 'parent_address', 'email', 'parent_phone', 'parent_name', 'parent_last_name', 'science_grade_level', 'ela_grade_level', 'math_grade_level', 'learning_environment_past_12_months', 'learning_experiece_past_12_months', 'upload_copy_EIP_504_plan', 'CreditTransfer', 'home_state', 'honorCodeSigned'];
        NotCompletedFields = (await asyncListFilter((getObjectProperty(StudentInfo, 'requiredList')), async (item) => {


         return ((item.indexOf('behavior') !== -1) && (getObjectProperty(StudentInfo, 'learning_or_behavioral_challenges')) != false && !(getObjectProperty(StudentInfo, item)).length || (item.indexOf('CreditTransfer') !== -1) && (getObjectProperty(StudentInfo, 'transferCredit')) && !((getObjectProperty(StudentInfo, 'grade')).indexOf('Kindergarten') !== -1) && (((getObjectProperty(StudentInfo, item)) === null) || !(getObjectProperty(StudentInfo, item)).length) || (item.indexOf('upload_copy_EIP_504_plan') !== -1) && (getObjectProperty(StudentInfo, 'IEP_or_504_plan')) != false && ((getObjectProperty(StudentInfo, item)) === null) || (item.indexOf('Ethnicity') !== -1) && ((getObjectProperty(StudentInfo, 'ethnicityValue')) === null) || (item.indexOf('honorCodeSigned') !== -1) && !(getObjectProperty(StudentInfo, item)) || !(item.indexOf('upload_copy_EIP_504_plan') !== -1) && ((getObjectProperty(StudentInfo, item)) === null));
        }));
        lengthCompetedFields = (getObjectProperty(StudentInfo, 'requiredList')).length - NotCompletedFields.length;
        percentCompleted = (lengthCompetedFields / (getObjectProperty(StudentInfo, 'requiredList')).length) * 100;
        StudentInfo['NotCompletedFields'] = NotCompletedFields;
        StudentInfo['PercentCompleted'] = percentCompleted;
        ___arguments.context.pageData['StudentInfo'] = (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(StudentInfo, 'lead_id')),'studentDirObject': StudentInfo,'process': 'decrypt' }));
        ___arguments.context.pageData['ShareParentContact'] = (getObjectProperty(StudentInfo, 'share_contact'));
      }
    }
    ___arguments.context.pageData['StudentDIRParent'] = StudentDIRData;
  } else if (!(await Backendless.UserService.isValidLogin()) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'string') || (typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'undefined')) && ((typeof (getObjectProperty(___arguments.context.pageData, 'fromTutorSSO')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) === 'undefined'))) {
    console.log('back to main page');
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(((typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string') ? ['https://portal.brilliantgrades.com/Clever/index.html?#lead_id=',(getObjectProperty(___arguments.context.pageData, 'lead_id')),(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string') ? ['&student_name=',(getObjectProperty(___arguments.context.pageData, 'student_name')),''].join('') : null].join('') : (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send())), false, undefined);
  } else {
    console.log('admin tutor view');
    console.log(getObjectProperty(___arguments.context.pageData, 'tutorEmail'));
    TeacherDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) || (getObjectProperty(___arguments.context.pageData, 'fromTutorSSO')) ? ['email = \'',(getObjectProperty(___arguments.context.pageData, 'tutorEmail')),'\''].join('') : ['MS_teacher_email = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\''].join(''))).setPageSize(100)))[0];
    if ((TeacherDB !== null && !Array.isArray(TeacherDB) && (typeof TeacherDB === 'object')) && (getObjectProperty(TeacherDB, 'userType')) == 'Teacher') {
      try {
        await Backendless.UserService.login( (getObjectProperty(TeacherDB, 'email')), (getObjectProperty(TeacherDB, 'zoomid')), true  );

      } catch (error) {
        await Backendless.UserService.login( (getObjectProperty(TeacherDB, 'email')), (getObjectProperty(TeacherDB, 'MS_teacher_password')), true  );

      }
      console.log(await Backendless.UserService.getCurrentUser(false));
      pageTitle = String((getObjectProperty(TeacherDB, 'name')).split(' ')[0]) + String('\'s Students Information');
      TeacherID = (await BackendlessUI.Functions.Custom['fn_0df128e4d9c37ba41e7beec18fa5414e']((getObjectProperty(TeacherDB, 'lead_id'))));
      ___arguments.context.pageData['isTeacher'] = ((getObjectProperty(TeacherDB, 'name')) != 'Rachel Gentillon' && (getObjectProperty(TeacherDB, 'name')) != 'Jordan Knoetgen' && (getObjectProperty(TeacherDB, 'name')) != 'Kelly Radigan' && (getObjectProperty(TeacherDB, 'name')) != 'River Lotus' && (getObjectProperty(TeacherDB, 'name')) != 'Deborah Buttridge' && (getObjectProperty(TeacherDB, 'name')) != 'Lori Anderson' && (getObjectProperty(TeacherDB, 'name')) != 'Katie Campos');
    } else {
      ___arguments.context.pageData['isTeacher'] = false;
    }
    ObjectList = [];
    offset = 0;
    var repeat_end = Math.ceil((await Backendless.Data.of('ms_classes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'isTeacher')) ? ['(teacher = \'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\' or assistant_teacher = \'',TeacherID,'\') and ((Class like \'%MICROSCHOOL%\' OR Class like \'%ELECTIVE%\' OR Class like \'%MS_GROUP%\')) and Class not like \'%MS_BREAK%\''].join('') : 'teacher not like \'TestNicolasTutor Live\' and teacher not like \'JomarTutor live\' and students.lead_id not like \'lead_LxXPvI8zzYVdVWGBqWgtZzHqF40H956TFOd0Rn9cWNr\' and ((Class like \'%MICROSCHOOL%\' OR Class like \'%ELECTIVE%\' OR Class like \'%MS_GROUP%\')) and Class not like \'%MS_BREAK%\'')))) / 100);
    for (var count = 0; count < repeat_end; count++) {
      _unused = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'isTeacher')) ? ['(teacher = \'',((getObjectProperty(TeacherDB, 'name')).replace((new RegExp('\'', '')), '\'\'')),'\' or assistant_teacher = \'',TeacherID,'\') and ((Class like \'%MICROSCHOOL%\' OR Class like \'%ELECTIVE%\' OR Class like \'%MS_GROUP%\')) and Class not like \'%MS_BREAK%\''].join('') : 'teacher not like \'TestNicolasTutor Live\' and teacher not like \'JomarTutor live\' and students.lead_id not like \'lead_LxXPvI8zzYVdVWGBqWgtZzHqF40H956TFOd0Rn9cWNr\' and ((Class like \'%MICROSCHOOL%\' OR Class like \'%ELECTIVE%\' OR Class like \'%MS_GROUP%\')) and Class not like \'%MS_BREAK%\'')).setRelated('students').setRelationsPageSize(100).setPageSize(100).setOffset(offset).setDistinct(true)));
      addItemToList(ObjectList, _unused);
      offset = (typeof offset == 'number' ? offset : 0) + 100;
    }
    ___arguments.context.pageData['ClassList'] = (await asyncListFilter(ObjectList, async (item) => {
       if ((getObjectProperty(item, 'Class')).indexOf('1ON1') !== -1) {
        weeklySlot = (getObjectProperty(item, 'students'))[0];
        _oldClassSlug = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendCreateMSSlotSlugFor1on1`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'SlotObject': (getObjectProperty(weeklySlot, 'slots_sort')),'Tutor': (getObjectProperty(weeklySlot, 'tutor')),'Grade': (getObjectProperty(weeklySlot, 'grade')),'Subject': (getObjectProperty(weeklySlot, 'subject')),'Group': (getObjectProperty(weeklySlot, 'group')),'Year': ((getObjectProperty(weeklySlot, 'slot_slug')).split('-')[6]),'Timezone': (getObjectProperty(weeklySlot, 'timezone')),'lead_id': (getObjectProperty(weeklySlot, 'lead_id')),'contact_id': (getObjectProperty(weeklySlot, 'contact_id')),'CurrentClassSlug': (getObjectProperty(item, 'Class')) }));
        ClassSlug = (getObjectProperty(_oldClassSlug, 'SlotSlugWithRandomChar'));
        item['Class'] = ClassSlug;
      } else {
        ClassSlug = (getObjectProperty(item, 'Class'));
      }


     return (!(ClassSlug === null) && !((getObjectProperty(item, 'students')) === null) && !!(await asyncListFilter((getObjectProperty(item, 'students')), async (item) => {


     return ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1);
    })).length && !(ClassSlug.indexOf('MS_BREAK') !== -1));
    }));
    console.log(ObjectList);
    console.log(getObjectProperty(___arguments.context.pageData, 'ClassList'));
    if (true) {
      ___arguments.context.pageData['searchBar'] = ({ [`blank_property`]: undefined });
      (getObjectProperty(___arguments.context.pageData, 'searchBar'))['ClassOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'ClassList')).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join(''),[`value`]: (getObjectProperty(item, 'Class')) });})));
      if (getObjectProperty(___arguments.context.pageData, 'isTeacher')) {
        (getObjectProperty(___arguments.context.pageData, 'searchBar'))['searchInput'] = (getObjectProperty(TeacherDB, 'name'));
        (getObjectProperty(___arguments.context.pageData, 'searchBar'))['searchDisabled'] = true;
      }
      (getObjectProperty(___arguments.context.pageData, 'searchBar'))['ClassLabel'] = 'Choose a classroom';
      (getObjectProperty(___arguments.context.pageData, 'searchBar'))['StudentLabel'] = 'Choose a student';
    }
    ___arguments.context.pageData['TeacherNotes'] = [];
    ___arguments.context.pageData['PSNotes'] = [];
  }
  ___arguments.context.pageData['ListForNote'] = [];
  ___arguments.context.pageData['ListForInterests'] = [];
  ___arguments.context.pageData['interestDropdown'] = [];
  ___arguments.context.pageData['IEPList'] = [];
  ___arguments.context.pageData['pageTitle'] = pageTitle;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('257cdf3168d77145439adb339c2e01b4', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
  ___arguments.context.pageData['mobile-menu-action'] = 'open';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var leadData, tutorData, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(await Backendless.UserService.getCurrentUser(false));
  if ((await Backendless.UserService.getCurrentUser(false)) === null) {
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'fromTutorSSO')) || (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel'))) {
    tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email=\'',(getObjectProperty(___arguments.context.pageData, 'tutorEmail')),'\' and accountType=\'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
    console.log(tutorData);
    if (!((getObjectProperty(tutorData, 'userType')) === null) && (getObjectProperty(tutorData, 'userType')) != 'Teacher') {
      return null;
    }
    try {
      await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'zoomid')), true  );

    } catch (error) {
      console.log(error);
      await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'ms_teacher_password')), true  );

    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'accountType')) == 'OAUTH' && !((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1)) {
    leadData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and name=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(1)))[0];
    if ((getObjectProperty(leadData, 'userType')) == 'Teacher' && (getObjectProperty(leadData, 'name')) == 'TestNicolasTutor Live') {
      if (!(getObjectProperty(___arguments.context.pageData, 'fromTutorSSO'))) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_sso', undefined);
      }
    }
  }
  await new Promise(r => setTimeout(r, 2000 || 0));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/SIS/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    await Backendless.UserService.logout();
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS').error((String('Error in Navigating back to Dashboard | Error:\n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/851767025f0eaaabf65cb5931f5dfe8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, parent_map, masked_location, geocode, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    console.log(getObjectProperty(___arguments.context.pageData, 'isTeacher'));
    console.log('Check if First Name is present');
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b4974c1ef74876e133355b63bc60e74', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd04334b6225acf734c996bf54a1c467')));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fe6031dbcc353dd3ecc3287da81478c'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fe6031dbcc353dd3ecc3287da81478c'))['border-color'] = 'red';
      return null;
    }
    console.log('Check if Last Name is present');
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b4974c1ef74876e133355b63bc60e74', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd04334b6225acf734c996bf54a1c467')));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e9ae931b3597e12257f3345788f8b45'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e9ae931b3597e12257f3345788f8b45'))['border-color'] = 'red';
      return null;
    }
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      await new Promise(r => setTimeout(r, 50 || 0));
      console.log(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd04334b6225acf734c996bf54a1c467')), 'display'));
      console.log(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e5f314a35c9f002d111bdc870863e4e')), 'display'));
      Object2 = ({ [`Student Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')).trim(),[`Student Last Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')).trim(),[`Student Nick Name`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')).trim(),[`Student Birth Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`Gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'genderValue')),[`Ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ethnicityValue')),[`Student Birth Certificate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`Student Picture`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',j == 'Student Birth Date' ? ((new Date((getObjectProperty(Object2, j)))).toDateString()) : (getObjectProperty(Object2, j))].join(''))))) {
          console.log(j == 'Student Birth Date' ? ((new Date((getObjectProperty(Object2, j)))).toDateString()) : (getObjectProperty(Object2, j)));
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',j == 'Student Birth Date' ? ((new Date((getObjectProperty(Object2, j)))).toDateString()) : (getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContact'] = (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) === null) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) : true);
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic'));
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send((true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: undefined,[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: true ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')) : (new Date(([(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date'))))).getDate()),'/',(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date'))))).getFullYear()),' 00:00 UTC'].join('')))),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: undefined,[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) })));
    if ((await Backendless.Data.of('parent_maps').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join(''))))) == 0) {
      geocode = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeChargebeeAddressConversion`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')))));
      masked_location = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeMaskLocation`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat': (Number((getObjectProperty(geocode, 'lat')))),'lon': (Number((getObjectProperty(geocode, 'lon')))) }));
      parent_map = (await Backendless.Data.of('parent_maps').save( ({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`share_contact`]: 'Yes',[`location`]: (new Backendless.Data.Point().setX((getObjectProperty(geocode, 'lon'))).setY((getObjectProperty(geocode, 'lat')))),[`masked_location`]: (new Backendless.Data.Point().setX((getObjectProperty(masked_location, 'lon'))).setY((getObjectProperty(masked_location, 'lat')))) }) ));
      await Backendless.Data.of('parent_maps').setRelation(({ [`objectId`]: (getObjectProperty(parent_map, 'objectId')) }), 'student_dir', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId'))]);
      await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`share_contact`]: 'Yes' }) );
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 1st Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/2ab378fd07e4e08fcca5a14404b8ebe6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/62dae2236ff36b2e05a7ff0f029626f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Student Interest`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 4th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/8ac84fa8a27730e9807452d8affd7f15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/6c04c8c420e6bad4c54637e71b0aae55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, itemObj, behaviorFormatName, j, Object2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', true);
      if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')))) {
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyslexia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyslexia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dysgraphia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dysgraphia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyscalculia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyscalculia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ADHD'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('ADHD')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['auditory_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Auditory processing disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['language_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Language processing disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['nonverbal_learning_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Nonverbal learning disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['visual_perceptual_or_visual_motor_defecit'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Visual perceptual/visual motor deficit')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['austism_spectrum_discorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Autism spectrum disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['asperger'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Asperger’s')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['anxiety'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Anxiety')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['depression'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Depression')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavioral_issues'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Behavioral issues')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_behavioral_challenges'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')) : '');
      }
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Behavioral Challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')),[`Additional information on behavioral challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',j == 'Behavioral Challenges' ? [(getObjectProperty(Object2, j)),':',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges'))].join('') : (getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',j == 'Behavioral Challenges' ? [(getObjectProperty(Object2, j)),':',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges'))].join('') : (getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',j == 'Behavioral Challenges' ? [(getObjectProperty(Object2, j)),':',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges'))].join('') : (getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    itemObj = true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    var j_list2 = ['Inattention/poor focus', 'Impulsivity/hyperactivity', 'Disorganization', 'Frustration/overwhelm', 'Mood swings/emotional disregulation', 'Anxiety/fear', 'Social withdrawal/shyness', 'Emotional outbursts', 'Difficulty transitioning', 'Defiance', 'Low perseverance', 'Forgetfulness', 'Perfectionism'];
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      behaviorFormatName = ((j.replace((new RegExp(' ', 'g')), '_')).replace((new RegExp('/', 'g')), '_')).toLowerCase();
      if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), behaviorFormatName)) === 'undefined')) {
        itemObj[behaviorFormatName] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), behaviorFormatName));
      }
    }
    console.log(itemObj);
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(itemObj);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 5th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/b8118538e1b944f2c286d2b83b189713/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/c2e758d4431aaf625f07c78312e1fcdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`ELA Grade Level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`MATH Grade Level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`SCIENCE Grade Level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 6th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/19ee626322062e87a2bb85b541ad9119/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/30eac0e74114c9540b65f04abf5e760c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
      console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade'));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Kindergarten') !== -1) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', true);
      }
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Learning Environment for the past 12 months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`Student's Last School Address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`Learnong experience for the past 12 Months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP 504 Files`]: ((String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles'))).replace((new RegExp(',', 'g')), '\n')),[`Current Learning Example`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`Student's Last School`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`What the parent would like to see in our school`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`Student Last School Contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`Student Last School Contact Person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send((true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`IEPFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`IEPFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) })));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 8th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/4aad223fe72f516eb96af88e2b93c3da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Kindergarten') !== -1) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', true);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/f38a88531d421da4f86ea2e515b5fd79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07dc116efb3653f910fb001dc4228ded', true);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-style'] = 'solid';
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-color'] = 'red';
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218')));
        await new Promise(r => setTimeout(r, 2000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07dc116efb3653f910fb001dc4228ded', false);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-style'] = 'none';
        return null;
      }
    }
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Home State`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`Step Up ID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`Student Award ID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`Vaccine Situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 10th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/24aed774d441fcef440e2d0957bf3608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/f61f81f65217443abff5959d6e9a6be5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d409fdfd091677ebd7eefd8664b75f26'))['border-style'] = 'solid';
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d409fdfd091677ebd7eefd8664b75f26'))['border-color'] = 'red';
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d409fdfd091677ebd7eefd8664b75f26')));
        await new Promise(r => setTimeout(r, 2000 || 0));
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d409fdfd091677ebd7eefd8664b75f26'))['border-style'] = 'none';
        return null;
      }
    }
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Starting Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`Email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`Computer System`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`Length of Staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`Electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',j == 'Starting Date' ? ((new Date((getObjectProperty(Object2, j)))).toDateString()) : (getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 11th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/883c65fd263cbd39e9b7b86a49cc5a5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/a4fc94ab7b2b559aece5136e2bcf526c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Confidence in collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`Confidence in engaging independent work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`Confidence in writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`Confidence in using technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`Confidence in reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`Connecting in engaging with adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 7th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/dd04334b6225acf734c996bf54a1c467/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/41b657385909ff1c98ae26c177aee544/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/dc9437ec826dd44d2ba2d40d2729992a/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/ba0f86727c8f81bb002460a80b7dabb8/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/343ac0d3bd63aac25a73972fa1ae9b41/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/4ba661be6b2c122691289404915f8d68/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/62f4c62fcd4eb26d864109c9e4591c22/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/506d3ac2bf8d8126d934a7c89c3a54df/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/57b998ec90b97f7b2955ccc23b2130b3/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#F5713C';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/5fb5631c318616d6b3c4bd8d4f2c79ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['learning_or_behavioral_challenges'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowLearningBehavioral')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowLearningBehavioral')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowLearningBehavioral')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowLearningBehavioral'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowLearningBehavioral'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/3a3f0cc940ab89bd784f5739245ec5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['learning_or_behavioral_challenges'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavior'] = [];

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowLearningBehavioral')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowLearningBehavioral')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowLearningBehavioral')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowLearningBehavioral'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowLearningBehavioral'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/edbc76978df8ee28a3b944323814a072/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('37b6d8866f3769068be8e65e52e64c3e')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/2c664168765d30c68ddf816f65f19afa/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Dyslexia', 'Dysgraphia', 'Dyscalculia', 'ADHD', 'Auditory processing disorder', 'Language processing disorder', 'Nonverbal learning disorder', 'Visual perceptual/visual motor deficit', 'Autism spectrum disorder', 'Asperger’s', 'Anxiety', 'Depression', 'Behavioral issues', 'Other']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS/components/37b6d8866f3769068be8e65e52e64c3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
      return null;
    }
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37b6d8866f3769068be8e65e52e64c3e')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
      if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).length) {
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavior'] = [___arguments.context.dataModel];
      } else {
        addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')), ___arguments.context.dataModel);
      }
    } else {
      removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')), ___arguments.context.dataModel, '');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
      return null;
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredBehavior'] = ___arguments.context.dataModel;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
      return null;
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredBehavior'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/1cdcc6a82167c5529a64ff17c8dd2a13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/5a9fa86b193d69ff182715a2c31dc008/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/8e8ba9b86bacee9ca79a2376e581cf4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/c9ebe788865e9acaa016c3ff5811b386/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/6e0220912801faf75a264e9971b8c0e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/e3ae8edbfa56a69e5d07961c55af363b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/bff2880367d4652b13ce26c3cfff9572/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/54f4bfceae53a73545970dda60a16aa5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/a25f1c0c7f9391e87e9749b939ab98cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/bf4a0f82f4646bf514f6688f7883179d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/29e4338480cf1ecf90fbfbe48f46bc92/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/1bebd2e4e4d7db77c4c106f1b259a184/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/11d1532aeb8143df74db0e03a8b4e17b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/4ff899d45123de99b8175d45fae112d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/d9cb6618a02f889b939148aaa045081f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/ce6762e9ce0dd3ffa08dd24ffe0175b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/9595340684216613735be35867b6b0be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/495a2d43c571e6896ce54c9e97cab451/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/a6381c54209c7c02bd7876f9190a5f5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/391e7105c955e2f67a3b7c2c2537af1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/ef1b6a7d5c16761620fac9bf5bbcab09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/64384a9734b93b43e6d5c1aff7858af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/fdf48309004f8d6cb16b7bd803768732/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/133586cecb2b45ccdf6c514ebe97316c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/85d81ac22581f8796b8783944a639595/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/8c5f484b7805c917f64585f4ce4f9659/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['IEP_or_504_plan'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowIEPHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowIEPHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowIEPHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowIEPHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowIEPHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/9f5d7ea81e195527e3c8594c2e457469/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['IEP_or_504_plan'] = false;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowIEPHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowIEPHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowIEPHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowIEPHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowIEPHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/8c993f6a22358c58b2cae42a6ba55757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['submit_step_up'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowSubmitStepupHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowSubmitStepupHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowSubmitStepupHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowSubmitStepupHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowSubmitStepupHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/a2d5274e753c8d26b024978323d30b26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['submit_step_up'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['step_up_id'] = null;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['student_award_id'] = null;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowSubmitStepupHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowSubmitStepupHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowSubmitStepupHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowSubmitStepupHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowSubmitStepupHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/5675b91b3047a151234624423b94fa5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['determining_required_paperwork_home_state'] = 'I need support with local paperwork';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')) == 'I need support with local paperwork' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesPaperworkHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesPaperworkHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesPaperworkHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['YesPaperworkHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['YesPaperworkHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/c47bd83295659ac262472e8dd22e9974/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['determining_required_paperwork_home_state'] = 'I don\'t need support with local paperwork';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')) == 'I don\'t need support with local paperwork' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoPaperworkHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoPaperworkHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoPaperworkHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['NoPaperworkHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['NoPaperworkHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/6e28c656b1535b2d67099fcb3c4c8043/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['learningCenterBool'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesLearningCenterHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesLearningCenterHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesLearningCenterHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['YesLearningCenterHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['YesLearningCenterHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/8117ff97f96151ef0af67881d3dfdc25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['learningCenterBool'] = false;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoLearningCenterHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoLearningCenterHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoLearningCenterHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['NoLearningCenterHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['NoLearningCenterHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/3a4ecf94f7c4e233e5d846fe2eb78c0c/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Beginner Spanish (full program)', 'Beginner Art (full program)', 'Beginner Coding (full program)', 'Beginner Health & PE (full program)', 'I prefer not to have any electives', 'I could not find what I was looking for', 'Please keep me in the loop about new/upcoming After School Clubs!']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS/components/39da0cced587c8499cc2c92633e3efb1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('39da0cced587c8499cc2c92633e3efb1')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['electives'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')), ___arguments.context.dataModel, '');
  }
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives'));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) === null)) ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredElectives'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredElectives'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/235898fcb77bc15429618b98d82c9b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('39da0cced587c8499cc2c92633e3efb1')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/511a701d1a63335a92a7490a09f77d17/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if (true) {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('511a701d1a63335a92a7490a09f77d17');
    console.log('IEPLinkList');
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['IEPFiles'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'IEPList')).map(async item => {; return (['https://drive.google.com/file/d/',(getObjectProperty(item, 'id')),'/view'].join(''));})));
    console.log(___arguments.uploadedFiles);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Files.remove(encodePath((___arguments.uploadedFiles[0])));
  } else {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('511a701d1a63335a92a7490a09f77d17');
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['upload_copy_EIP_504_plan'] = (['https://drive.google.com/file/d/',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f2923cbac91ee3c38c4349b78f3f5f04'))[0]), 'id')),'/view'].join(''));
    await Backendless.Data.of('ms_student_dir').save( (true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')) })) );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (true) {
    try {
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: !(getObjectProperty(___arguments.context.pageData, 'IEPList')).length ? ['IEP_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join('') : ['IEP_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'_',(getObjectProperty(___arguments.context.pageData, 'IEPList')).length + 1].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
      console.log(Metadata);
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
      addItemToList((getObjectProperty(___arguments.context.pageData, 'IEPList')), Metadata);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2923cbac91ee3c38c4349b78f3f5f04', (getObjectProperty(___arguments.context.pageData, 'IEPList')));
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f2923cbac91ee3c38c4349b78f3f5f04'));

    } catch (error) {
      console.log(error);

    }
  } else {
    try {
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['IEP_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
      console.log(Metadata);
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2923cbac91ee3c38c4349b78f3f5f04', [Metadata]);
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f2923cbac91ee3c38c4349b78f3f5f04'));

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onBeforeUpload */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['IEP_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS/components/14d528460d2c273f50c44341aff5abe4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c873f39fc6b0d99380bc7d408c8db6e'), 'id')).indexOf('typeform') !== -1)) {
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c873f39fc6b0d99380bc7d408c8db6e'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['upload_copy_EIP_504_plan '] = null;
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f2923cbac91ee3c38c4349b78f3f5f04')), ___arguments.context.getComponentDataStoreByUid('4c873f39fc6b0d99380bc7d408c8db6e'), '');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/f6dca288407dbde32e2cac217299f548/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['learningFiles_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    console.log(Metadata);
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('516b0a2c8c02e8c16262283908e75071', [Metadata]);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6dca288407dbde32e2cac217299f548');
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['upload_student_curreny_learning'] = (['https://drive.google.com/file/d/',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('516b0a2c8c02e8c16262283908e75071'))[0]), 'id')),'/view'].join(''));
  await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')) }) );

  },
  /* handler:onUploadSuccess */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['learningFiles_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS/components/445e58961b448a72be8981b5431d8a4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('144a68dadf12889f23ce5d2285eecc7a'), 'id')).indexOf('typeform') !== -1)) {
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('144a68dadf12889f23ce5d2285eecc7a'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['upload_student_curreny_learning'] = null;
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('516b0a2c8c02e8c16262283908e75071')), ___arguments.context.getComponentDataStoreByUid('144a68dadf12889f23ce5d2285eecc7a'), '');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/6c15b822abd79b583a6c90d6559b4a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89e976bbc472d90d055fb9697b0cdcda', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/11f4392dee67c2c17642cb7c552ebef9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, DateNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['teacherNotes'] = [];
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')), ({ [`title`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNoteTitle')),[`type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNoteType')),[`description`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNoteDescription')),[`date`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()),' ',getValueLength(String(new Date((new Date())).getHours())) == 1 ? String('0') + String(new Date((new Date())).getHours()) : (new Date((new Date())).getHours()),':',getValueLength(String(new Date((new Date())).getMinutes())) == 1 ? String('0') + String(new Date((new Date())).getMinutes()) : (new Date((new Date())).getMinutes()),':',getValueLength(String(new Date((new Date())).getSeconds())) == 1 ? String('0') + String(new Date((new Date())).getSeconds()) : (new Date((new Date())).getSeconds())].join(''),[`teacher`]: (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'boolean') && (getObjectProperty(___arguments.context.pageData, 'isTeacher')) ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) : 'TestNicolasTutor Live' }));
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) }) );
    DateNow = (new Date());
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': (String('New student note added by ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name'))),'date': DateNow,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89e976bbc472d90d055fb9697b0cdcda', false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['teacherNoteTitle'] = null;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['teacherNoteType'] = null;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['teacherNoteDescription'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/11c398ee4e1ef6db80a3b325bd9bedf4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/f591ed3d0afaad88133d09bc6bba8101/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89e976bbc472d90d055fb9697b0cdcda', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/46546a4e28488c3398fc2bbfd2e2b325/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')).length))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/f38de707d68c9eab309ce5ce39c7c59b/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/566ed33c0d7aec63a5f417a5ff97408e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/3eb63b3c000eff275494fe07007cb4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a910f3ecd066ae6adc1a8d8b381a0c3', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/966b8775b508377b7cff6882aa0d42a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a910f3ecd066ae6adc1a8d8b381a0c3', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/d8abb7d7e5b44fbbb5529468762e705e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/bdd55efe404e282133797d9e10147e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, TutorObject, dateScheduled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PSNotes'] = [];
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')), ({ [`title`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNoteTitle')),[`type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNoteType')),[`description`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNoteDescription')),[`date`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()),' ',(new Date((new Date())).getHours()),':',(new Date((new Date())).getMinutes()) == 0 ? '00' : (new Date((new Date())).getMinutes()),':',(new Date((new Date())).getSeconds()) == 0 ? '00' : (new Date((new Date())).getSeconds())].join(''),[`PS`]: '' }));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a910f3ecd066ae6adc1a8d8b381a0c3', false);
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) }) );
    dateScheduled = (new Date((new Date()).getTime() + (600 * 1000)));
    TutorObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'slots'))[0]), 'tutor')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': dateScheduled,'lead_id': (getObjectProperty(TutorObject, 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(TutorObject, 'MS_teacher_email')),'body_html': (['Dear ',(getObjectProperty(TutorObject, 'name')),', <br><br>','This is to inform you that a PS Team Member has added a note regarding your student, ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'. <br><br>You can see the note in the <a href = "https://portal.brilliantgrades.com/Clever/index.html?page=Main_Page">Student Information System</a> on the Extra Notes -> PS Notes Section<br>','<br><br>Parent Support Team<br><img src= \'https://lh6.googleusercontent.com/hnkDEFumM6CbPs3YxDAwWOcvchVNNwOawvbe-zzLebpvQ1HaJSrBBhJrpn-PeVYUHesnL6zm_31TBdeCqMVBlaTkq-NVaJFrk5zrl0f4EZn0rvc6-ftZkvxJ71oN0HQxIw-KqrPwB8Jj2bgYoO84rng\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': 'New Note Added by PS Team' });
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PSNoteTitle'] = null;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PSNoteType'] = null;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PSNoteDescription'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/e8e93c6e8a355251d61bb336361d9aaa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')).length))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/ab35210785a3b846ffc89bfc3aa1731a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/fface34474bdfff5f5367151549cfb4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/e63c38c628be877b4ea9c7f800f9c5bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/664528e2ea7e8422836919767aafc28f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01259b7992242d645472a27bd1abb789', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4219cad74346f3461e5e7d8c557d8b97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/0c5dc3ade5e9d08a85791781f28f6a3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/38d73e1a849c8d0a69d47c8e63174ff1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/550374cdba6f5ad446537e4c899b3afd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item, NotesList, teacherNotes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6da239cf645da1552382003941da429f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66572449a018615fba98bc7ed3380217', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('550374cdba6f5ad446537e4c899b3afd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fd9369f7a7eeb0c9154bdc95ba5d02f', true);
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/7fd9369f7a7eeb0c9154bdc95ba5d02f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6da239cf645da1552382003941da429f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66572449a018615fba98bc7ed3380217', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('550374cdba6f5ad446537e4c899b3afd', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fd9369f7a7eeb0c9154bdc95ba5d02f', false);
  ___arguments.context.getComponentDataStoreByUid('6f7bc14d5a17091862218bd7e78f92a1')['date'] = ([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()),' ',String(new Date((new Date())).getHours()).length == 1 ? String('0') + String(new Date((new Date())).getHours()) : (new Date((new Date())).getHours()),':',String(new Date((new Date())).getMinutes()).length == 1 ? String('0') + String(new Date((new Date())).getMinutes()) : (new Date((new Date())).getMinutes()),':',String(new Date((new Date())).getSeconds()).length == 1 ? String('0') + String(new Date((new Date())).getSeconds()) : (new Date((new Date())).getSeconds())].join(''));
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) ? (JSON.stringify((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) : (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/f6248bf1caaa40e94ecef8a51d429837/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e23a48f346b9bf74d0a4e469a39f164', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bea90e936197bf1145a69373abce858d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6248bf1caaa40e94ecef8a51d429837', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f09c9176bc21bdf5cd06b1add8636a68', true);
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/f09c9176bc21bdf5cd06b1add8636a68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e23a48f346b9bf74d0a4e469a39f164', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bea90e936197bf1145a69373abce858d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6248bf1caaa40e94ecef8a51d429837', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f09c9176bc21bdf5cd06b1add8636a68', false);
  ___arguments.context.getComponentDataStoreByUid('1bf5d267ecb65cf1265874c889a7226b')['date'] = ([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()),' ',String(new Date((new Date())).getHours()).length == 1 ? String('0') + String(new Date((new Date())).getHours()) : (new Date((new Date())).getMinutes()),':',String(new Date((new Date())).getMinutes()).length == 1 ? String('0') + String(new Date((new Date())).getMinutes()) : (new Date((new Date())).getMinutes()),':',String(new Date((new Date())).getSeconds()).length == 1 ? String('0') + String(new Date((new Date())).getSeconds()) : (new Date((new Date())).getSeconds())].join(''));
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) ? (JSON.stringify((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) : (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/40470eac1bdc42484f6e84aae0f39b01/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Found, item, Classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd'), 'searchInput'))) == 0) {
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['TimeTable'] = [];
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['ClassValue'] = '';
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['StudentValue'] = '';
    ___arguments.context.pageData['infoTitle'] = '';
  } else {
    Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


     return ((([(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join('').toUpperCase()).indexOf(((___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')).toUpperCase())) !== -1) && !((getObjectProperty(item, 'students')) === null) && !!(await asyncListFilter((getObjectProperty(item, 'students')), async (item) => {


     return ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1);
    })).length && !((getObjectProperty(item, 'Class')).indexOf('MS_BREAK') !== -1));
    }));
    console.log(Classes);
    if (!Classes.length) {
      return null;
    }
    Found = (await Promise.all(Classes.map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join(''),[`value`]: (getObjectProperty(item, 'Class')) });})));
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['ClassOptions'] = Found;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/8e5b6b1d967569d32467154477991b34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, FinalStudents, j, FinalStudentChecker, Students, Classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


   return ((getObjectProperty(item, 'Class')).startsWith(___arguments.value));
  }));
  Students = (await asyncListFilter((getObjectProperty((Classes[0]), 'students')), async (item) => {


   return ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1);
  }));
  console.log(Students);
  FinalStudents = [];
  FinalStudentChecker = [];
  for (var j_index in Students) {
    j = Students[j_index];
    if (!(FinalStudentChecker.includes((getObjectProperty(j, 'contact_id'))))) {
      addItemToList(FinalStudents, j);
      addItemToList(FinalStudentChecker, (getObjectProperty(j, 'contact_id')));
    }
  }
  ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['StudentOptions'] = (await Promise.all(FinalStudents.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'student_name')),[`value`]: (getObjectProperty(item, 'contact_id')) });})));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/8459700acc028dc5e7a31e213a2c0d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, StudentInfo, percentCompleted, NotCompletedFields, lengthCompetedFields, item, Students, StateRegObject, Classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  try {
    Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


     return ((getObjectProperty(item, 'Class')).startsWith((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd'), 'ClassValue'))));
    }));
    Students = (await asyncListFilter((getObjectProperty((Classes[0]), 'students')), async (item) => {


     return ((getObjectProperty(item, 'contact_id')).indexOf(___arguments.value) !== -1);
    }));
    console.log(JSON.stringify(Students));
    StudentInfo = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['student_name = \'',((getObjectProperty((Students[0]), 'student_name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and lead_id = \'',(getObjectProperty((Students[0]), 'lead_id')),'\''].join(''))).setRelated('slots').setRelationsPageSize(100).setPageSize(100)))[0];
    if (!(typeof StudentInfo === 'undefined')) {
      if ((getObjectProperty(StudentInfo, 'parent_name')).indexOf('TestPeterLive') !== -1) {
        StudentInfo = (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(StudentInfo, 'lead_id')),'studentDirObject': StudentInfo,'process': 'decrypt' }));
      }
      if (true) {
        StudentInfo['behavior'] = [];
        if (getObjectProperty(StudentInfo, 'Dyslexia')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyslexia');
        }
        if (getObjectProperty(StudentInfo, 'Dysgraphia')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dysgraphia');
        }
        if (getObjectProperty(StudentInfo, 'Dyscalculia')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyscalculia');
        }
        if (getObjectProperty(StudentInfo, 'ADHD')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'ADHD');
        }
        if (getObjectProperty(StudentInfo, 'auditory_processing_disorder')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Auditory processing disorder');
        }
        if (getObjectProperty(StudentInfo, 'language_processing_disorder')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Language processing disorder');
        }
        if (getObjectProperty(StudentInfo, 'nonverbal_learning_disorder')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Nonverbal learning disorder');
        }
        if (getObjectProperty(StudentInfo, 'visual_perceptual_or_visual_motor_defecit')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Visual perceptual/visual motor deficit');
        }
        if (getObjectProperty(StudentInfo, 'austism_spectrum_discorder')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Autism spectrum disorder');
        }
        if (getObjectProperty(StudentInfo, 'asperger')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Asperger’s');
        }
        if (getObjectProperty(StudentInfo, 'anxiety')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Anxiety');
        }
        if (getObjectProperty(StudentInfo, 'depression')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Depression');
        }
        if (getObjectProperty(StudentInfo, 'behavioral_issues')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Behavioral issues');
        }
        if ((typeof (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) === 'string') && (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) != '') {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Other');
        }
      }
      if (!((getObjectProperty(StudentInfo, 'home_state')) === null)) {
        StateRegObject = (await Backendless.Data.of('state_regs').find(Backendless.DataQueryBuilder.create().setWhereClause((['State_Name = \'',(getObjectProperty(StudentInfo, 'home_state')),'\''].join(''))).setPageSize(10)))[0];
        ___arguments.context.pageData['StateRegObject'] = StateRegObject;
      }
      console.log(Students);
      console.log('first day');
      console.log(getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'firstDay'));
      ___arguments.context.pageData['ShareParentContact'] = (getObjectProperty(StudentInfo, 'share_contact'));
      StudentInfo['firstDay'] = (((getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'firstDay')) === null) || ((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })) === null) ? null : (new Date((getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'firstDay')))));
      StudentInfo['ethnicityValue'] = ((getObjectProperty(StudentInfo, 'African_American')) ? 'African-American' : ((getObjectProperty(StudentInfo, 'Asian')) ? 'Asian' : ((getObjectProperty(StudentInfo, 'Caucasian')) ? 'Caucasian' : ((getObjectProperty(StudentInfo, 'Latino_Hispanic')) ? 'Latino or Hispanic' : ((getObjectProperty(StudentInfo, 'Native_American')) ? 'Native American' : ((getObjectProperty(StudentInfo, 'Native_Hawaiian')) ? 'Native Hawaiian' : ((getObjectProperty(StudentInfo, 'other_unknown_ethnicity')) ? 'Other/Unknown' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_ethnicity')) ? 'Prefer not to say' : null))))))));
      StudentInfo['genderValue'] = ((getObjectProperty(StudentInfo, 'female')) ? 'Female' : ((getObjectProperty(StudentInfo, 'male')) ? 'Male' : ((getObjectProperty(StudentInfo, 'transgender')) ? 'Transgender' : ((getObjectProperty(StudentInfo, 'gender_variant_non_conforming')) ? 'Gender Variant/Non-Conforming' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_gender')) ? 'Prefer not to say' : (!((getObjectProperty(StudentInfo, 'other_gender')) === null) ? (getObjectProperty(StudentInfo, 'other_gender')) : null))))));
      StudentInfo['learningList'] = ((typeof (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')) === 'string') && ((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')), (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
      StudentInfo['IEPDocs'] = ((typeof (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')) === 'string') && ((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')), (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
      StudentInfo['secondary_guardian_show'] = (!((getObjectProperty(StudentInfo, 'secondary_guardian')) === null));
      StudentInfo['ShowPTOQuestions'] = (!((getObjectProperty(StudentInfo, 'PTO')) === null));
      StudentInfo['ShowPTOQuestions'] = (!((getObjectProperty(StudentInfo, 'PTO')) === null));
      StudentInfo['honorCodeStudentName'] = (getObjectProperty(StudentInfo, 'student_name'));
      StudentInfo['honorCodeParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
      StudentInfo['ToSParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
      if ((getObjectProperty(StudentInfo, 'CallNotes')) === null) {
        StudentInfo['CallNotes'] = [];
      }
      if ((getObjectProperty(StudentInfo, 'teacherNotes')) === null) {
        StudentInfo['teacherNotes'] = [];
      }
      if ((getObjectProperty(StudentInfo, 'PTO')) === null) {
        StudentInfo['PTO'] = ({ [`PTOOptions`]: [] });
      }
      if ((getObjectProperty(StudentInfo, 'PSNotes')) === null) {
        StudentInfo['PSNotes'] = [];
      }
      if (!(getObjectProperty(StudentInfo, 'transferCredit'))) {
        StudentInfo['CreditTransfer'] = [];
      }
      StudentInfo['grade'] = (getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'grade'));
      StudentInfo['chargebeeID'] = (getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'chargebee'));
      StudentInfo['English'] = ['English 1', 'English 2', 'English 3', 'English 4'];
      StudentInfo['Math'] = ['Pre-Algebra', 'Algebra 1', 'Algebra 2', 'Geometry', 'Pre-Calculus', 'Calculus', 'Statistics', 'Integrated Math 1', 'Integrated Math 2', 'Integrated Math 3'];
      StudentInfo['SocialStudies'] = ['World History', 'Global Studies', 'U.S. History', 'U.S. Government', 'Economics', 'Geography', 'Psychology', 'Sociology'];
      StudentInfo['Science'] = ['Biology', 'Chemistry', 'Physics', 'Environmental Science', 'Anatomy and Physiology'];
      StudentInfo['PE&Health'] = ['Physical Education', 'Health Education'];
      StudentInfo['WorldLanguage'] = ['Spanish', 'French', 'German', 'Chinese'];
      StudentInfo['FineArts'] = ['Band', 'Orchestra', 'Choir', 'Theatre Arts/Drama', 'Visual Arts', 'Digital Design', 'Photography'];
      StudentInfo['CTE'] = ['Computer Science', 'Business and Marketing', 'Health Sciences', 'Culinary Arts', 'Automotive Technology', 'Agriculture Sciences', 'Audio/Video Production', 'Creative Writing', 'Journalism', 'Debate'];
      if (typeof (getObjectProperty(StudentInfo, 'studentMSEmail')) === 'string') {
        StudentInfo['1disabled'] = true;
        StudentInfo['1.5disabled'] = true;
        StudentInfo['1.6disabled'] = true;
        StudentInfo['2disabled'] = true;
        StudentInfo['3disabled'] = true;
        StudentInfo['4disabled'] = true;
        StudentInfo['5disabled'] = true;
        StudentInfo['6disabled'] = true;
        StudentInfo['6.1disabled'] = true;
        StudentInfo['7disabled'] = true;
        StudentInfo['8disabled'] = true;
        StudentInfo['8.1disabled'] = true;
        StudentInfo['8.2disabled'] = true;
        StudentInfo['9disabled'] = true;
        console.log(StudentInfo);
      }
      StudentInfo['requiredList'] = ['Ethnicity', 'student_name', 'student_last_name', 'student_birth_date', 'most_interested_in', 'behavior', 'parent_address', 'email', 'parent_phone', 'parent_name', 'parent_last_name', 'science_grade_level', 'ela_grade_level', 'math_grade_level', 'learning_environment_past_12_months', 'learning_experiece_past_12_months', 'upload_copy_EIP_504_plan', 'CreditTransfer', 'home_state', 'honorCodeSigned'];
      NotCompletedFields = (await asyncListFilter((getObjectProperty(StudentInfo, 'requiredList')), async (item) => {


       return ((item.indexOf('behavior') !== -1) && (getObjectProperty(StudentInfo, 'learning_or_behavioral_challenges')) != false && !(getObjectProperty(StudentInfo, item)).length || (item.indexOf('CreditTransfer') !== -1) && (getObjectProperty(StudentInfo, 'transferCredit')) && !((getObjectProperty(StudentInfo, 'grade')).indexOf('Kindergarten') !== -1) && (((getObjectProperty(StudentInfo, item)) === null) || !(getObjectProperty(StudentInfo, item)).length) || (item.indexOf('upload_copy_EIP_504_plan') !== -1) && (getObjectProperty(StudentInfo, 'IEP_or_504_plan')) != false && ((getObjectProperty(StudentInfo, item)) === null) || (item.indexOf('Ethnicity') !== -1) && ((getObjectProperty(StudentInfo, 'ethnicityValue')) === null) || (item.indexOf('honorCodeSigned') !== -1) && !(getObjectProperty(StudentInfo, item)) || !(item.indexOf('upload_copy_EIP_504_plan') !== -1) && ((getObjectProperty(StudentInfo, item)) === null));
      }));
      console.log(NotCompletedFields);
      lengthCompetedFields = (getObjectProperty(StudentInfo, 'requiredList')).length - NotCompletedFields.length;
      console.log(lengthCompetedFields);
      percentCompleted = (lengthCompetedFields / (getObjectProperty(StudentInfo, 'requiredList')).length) * 100;
      console.log(String(percentCompleted) + String('%'));
      StudentInfo['NotCompletedFields'] = NotCompletedFields;
      StudentInfo['PercentCompleted'] = percentCompleted;
      ___arguments.context.pageData['StudentInfo'] = StudentInfo;
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/2a591b197cad317c0cbb162e16a36616/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/ace552a827a5700e870e4e050e770166/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, StudentInfo;


  var j_list = ['female', 'male', 'transgender', 'gender_variant_non_conforming', 'prefer_not_to_say_gender', 'other_gender'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')[j] = (j == 'other_gender' ? null : false);
  }
  if (___arguments.value == 'Female') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['female'] = true;
  } else if (___arguments.value == 'Male') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['male'] = true;
  } else if (___arguments.value == 'Transgender') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transgender'] = true;
  } else if (___arguments.value == 'Gender Variant/Non-Conforming') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['gender_variant_non_conforming'] = true;
  } else if (___arguments.value == 'Prefer not to say') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['prefer_not_to_say_gender'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_gender'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/ba1c4efc1547f2bbcd2fe6cb9cab4efc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j;


  var j_list = ['African_American', 'Asian', 'Caucasian', 'Latino_Hispanic', 'Native_American', 'Native_Hawaiian', 'other_unknown_ethnicity', 'prefer_not_to_say_ethnicity'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')[j] = false;
  }
  if (___arguments.value == 'African-American') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['African_American'] = true;
  } else if (___arguments.value == 'Asian') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Asian'] = true;
  } else if (___arguments.value == 'Caucasian') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Caucasian'] = true;
  } else if (___arguments.value == 'Latino or Hispanic') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Latino_Hispanic'] = true;
  } else if (___arguments.value == 'Native American') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Native_American'] = true;
  } else if (___arguments.value == 'Native Hawaiian') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Native_Hawaiian'] = true;
  } else if (___arguments.value == 'Other/Unknown') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_unknown_ethnicity'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['prefer_not_to_say_ethnicity'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/ebec95de013e9df4be5250e7e989fcb5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/4b4f9ad7e5c23f2fbb58c7d211314edf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')) === 'undefined')) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Physical private school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Virtual private school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Physical public/charter school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Virtual public/charter school') !== -1)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/f2923cbac91ee3c38c4349b78f3f5f04/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!!(getObjectProperty(___arguments.context.pageData, 'IEPList')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/516b0a2c8c02e8c16262283908e75071/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/4c873f39fc6b0d99380bc7d408c8db6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'id')).indexOf('typeform') !== -1) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.dataModel, 'id')), true, undefined);
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/144a68dadf12889f23ce5d2285eecc7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'id')).indexOf('typeform') !== -1) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.dataModel, 'id')), true, undefined);
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/b98d141bbc783d419dcfe3b71e0ad4a5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;



  return (await Promise.all(('Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, District of Columbia, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina, North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina, South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia, Wisconsin, Wyoming, International Territories, Cayman Islands'.split(', ')).map(async item => {; return ({ [`value`]: item,[`label`]: item,[`disabled`]: item == 'International Territories' });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var StateRegObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  StateRegObject = (await Backendless.Data.of('state_regs').find(Backendless.DataQueryBuilder.create().setWhereClause((['State_Name = \'',___arguments.value,'\''].join(''))).setPageSize(10)))[0];
  ___arguments.context.pageData['StateRegObject'] = StateRegObject;
  console.log(getObjectProperty(___arguments.context.pageData, 'StateRegObject'));
  await new Promise(r => setTimeout(r, 1000 || 0));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/e487d36e0f3af45e701572ebb508bcd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/127636bd353265f27b4d9f52ebd3450e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  }

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/SIS/components/60acfec20618643567364af31db57952/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/90c20b9ae3abe035ae9587b194ef30b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/da44d7d4a1c69648f32e6c21bf27f328/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/b8af85447dd9709542c94d6dd7c4c0e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/b8815e1a5434df4f94a6443a33f9c3a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/b8146bf5afa16f197d4d48e16225bf71/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/1d1919c5953e41522d5490bd85460f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')) === 'undefined')) && !(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Physical private school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Virtual private school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Physical public/charter school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Virtual public/charter school') !== -1))) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['student_last_school_address'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/3d4a32731c5b9604374efd4fba14771f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/01212aeb955c082f1715cb0723cd349b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/4ed9b5593c9159be43bd53ca8c21ae45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/e89c1559e767215845ed4954ff16779f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/53e23462f0713562d535ae2774cefdd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/77f4602e44a7ebe91928ca074bded7b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/a15f6d84c3fd06cef36ae28d4a36494b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value != 'More than one academic year') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['electives'] = [];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/801eb33e551fe7670239913725169cb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1disabled'] = true;
  if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
    return null;
  }
  changed_fields = [];
  oldData = ({  });
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
  }
  var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) })));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
      addItemToList(changed_fields, j);
      oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
    }
  }
  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
  console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
  await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/e06f7907c4cc9e098ad178a1c46540da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/682eb4824fde031e6da964d3e9a7ac88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['2disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/ae933ee6d245a606c1e223fc23538a96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['2disabled'] = true;
  if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
    return null;
  }
  changed_fields = [];
  oldData = ({  });
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
  }
  var j_list = (Object.keys(({ [`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) })));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
      addItemToList(changed_fields, j);
      oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
    }
  }
  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
  console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
  await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/853f542a8f1c8ec53d3a14388c23057c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['3disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/dc4f24c68d36264dd7fa8f03e3069f32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['3disabled'] = true;
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')))) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyslexia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyslexia')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dysgraphia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dysgraphia')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyscalculia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyscalculia')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ADHD'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('ADHD')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['auditory_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Auditory processing disorder')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['language_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Language processing disorder')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['nonverbal_learning_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Nonverbal learning disorder')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['visual_perceptual_or_visual_motor_defecit'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Visual perceptual/visual motor deficit')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['austism_spectrum_discorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Autism spectrum disorder')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['asperger'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Asperger’s')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['anxiety'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Anxiety')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['depression'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Depression')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavioral_issues'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Behavioral issues')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_behavioral_challenges'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')) : '');
  }
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/5872977e2d21337c47ae934ff19734dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['4disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/fc0e0a93d003671df71ef2e7157459bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['4disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/22ea9548ec5e3e066015d58e4045e5b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['5disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/1a25eb7189843615d481e8616a298fdc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['5disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/5872f9751de7523823b9fb5ac5dfd2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/b599431e9fb1121bc232dd01cc0ea053/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/536e104b6144372c0ea7139c2704104b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['7disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/ab5d5e382a6229b6a33be84e00efde85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['7disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/de24e51c84d3405e917a526eee2cd67e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var electives, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['8disabled'] = false;
  electives = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')).map(async item => {; return item;})));
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: electives });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/e7bccfdba5c2d572f6f2339821c92d21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['8disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (j == 'electives') {
        console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j));
        console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) ? (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/ffb1b8afa99e30adb4e2deb6c0bcb8cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (getObjectProperty(___arguments.context.pageData, 'isTeacher'))) && !(typeof (getObjectProperty(___arguments.context.pageData, 'ClassList')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/a5ede64a7781ca7eba7d501604a85d09/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var StudentInfo, ChargebeeCustomer, LeadHolder, percentCompleted, NotCompletedFields, lengthCompetedFields, item, StateRegObject, RegFormCompleteTask, j, StudentDIR;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  StudentInfo = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')), async (item) => {


   return ((getObjectProperty(___arguments.context.pageData, 'StudentSelectionValue')) == (getObjectProperty(item, 'objectId')));
  }))[0];
  if (!(typeof StudentInfo === 'undefined')) {
    if ((getObjectProperty(StudentInfo, 'parent_name')).indexOf('TestPeterLive') !== -1) {
      StudentInfo = (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(StudentInfo, 'lead_id')),'studentDirObject': StudentInfo,'process': 'decrypt' }));
    }
    RegFormCompleteTask = !((getObjectProperty(StudentInfo, 'studentMSEmail')) === null);
    ___arguments.context.pageData['isSubmitted'] = RegFormCompleteTask;
    console.log(StudentInfo);
    StudentInfo['ethnicityValue'] = ((getObjectProperty(StudentInfo, 'African_American')) ? 'African-American' : ((getObjectProperty(StudentInfo, 'Asian')) ? 'Asian' : ((getObjectProperty(StudentInfo, 'Caucasian')) ? 'Caucasian' : ((getObjectProperty(StudentInfo, 'Latino_Hispanic')) ? 'Latino or Hispanic' : ((getObjectProperty(StudentInfo, 'Native_American')) ? 'Native American' : ((getObjectProperty(StudentInfo, 'Native_Hawaiian')) ? 'Native Hawaiian' : ((getObjectProperty(StudentInfo, 'other_unknown_ethnicity')) ? 'Other/Unknown' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_ethnicity')) ? 'Prefer not to say' : null))))))));
    StudentInfo['genderValue'] = ((getObjectProperty(StudentInfo, 'female')) ? 'Female' : ((getObjectProperty(StudentInfo, 'male')) ? 'Male' : ((getObjectProperty(StudentInfo, 'transgender')) ? 'Transgender' : ((getObjectProperty(StudentInfo, 'gender_variant_non_conforming')) ? 'Gender Variant/Non-Conforming' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_gender')) ? 'Prefer not to say' : (!((getObjectProperty(StudentInfo, 'other_gender')) === null) ? (getObjectProperty(StudentInfo, 'other_gender')) : null))))));
    console.log((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
    }))[0]);
    StudentInfo['firstDay'] = (((getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
    }))[0]), 'firstDay')) === null) || (((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
    }))[0]) === null) ? null : (new Date((getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
    }))[0]), 'firstDay')))));
    if (true) {
      StudentInfo['behavior'] = [];
      if (getObjectProperty(StudentInfo, 'Dyslexia')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyslexia');
      }
      if (getObjectProperty(StudentInfo, 'Dysgraphia')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dysgraphia');
      }
      if (getObjectProperty(StudentInfo, 'Dyscalculia')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyscalculia');
      }
      if (getObjectProperty(StudentInfo, 'ADHD')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'ADHD');
      }
      if (getObjectProperty(StudentInfo, 'auditory_processing_disorder')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Auditory processing disorder');
      }
      if (getObjectProperty(StudentInfo, 'language_processing_disorder')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Language processing disorder');
      }
      if (getObjectProperty(StudentInfo, 'nonverbal_learning_disorder')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Nonverbal learning disorder');
      }
      if (getObjectProperty(StudentInfo, 'visual_perceptual_or_visual_motor_defecit')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Visual perceptual/visual motor deficit');
      }
      if (getObjectProperty(StudentInfo, 'austism_spectrum_discorder')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Autism spectrum disorder');
      }
      if (getObjectProperty(StudentInfo, 'asperger')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Asperger’s');
      }
      if (getObjectProperty(StudentInfo, 'anxiety')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Anxiety');
      }
      if (getObjectProperty(StudentInfo, 'depression')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Depression');
      }
      if (getObjectProperty(StudentInfo, 'behavioral_issues')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Behavioral issues');
      }
      if ((typeof (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) === 'string') && (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) != '') {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Other');
      }
    }
    if (!((getObjectProperty(StudentInfo, 'home_state')) === null)) {
      StateRegObject = (await Backendless.Data.of('state_regs').find(Backendless.DataQueryBuilder.create().setWhereClause((['State_Name = \'',(getObjectProperty(StudentInfo, 'home_state')),'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['StateRegObject'] = StateRegObject;
    }
    if (!((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')) === null)) {
      StudentInfo['learningList'] = (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')), (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
    }
    if (!((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')) === null)) {
      StudentInfo['IEPDocs'] = (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')), (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
    }
    if ((getObjectProperty(StudentInfo, 'transcriptFiles')) === null) {
      StudentInfo['transcriptFiles'] = [];
    }
    StudentInfo['secondary_guardian_show'] = (!((getObjectProperty(StudentInfo, 'secondary_guardian')) === null));
    StudentInfo['ShowPTOQuestions'] = (!((getObjectProperty(StudentInfo, 'PTO')) === null));
    StudentInfo['honorCodeStudentName'] = (getObjectProperty(StudentInfo, 'student_name'));
    StudentInfo['honorCodeParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
    StudentInfo['ToSParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
    if ((getObjectProperty(StudentInfo, 'CallNotes')) === null) {
      StudentInfo['CallNotes'] = [];
    }
    if ((getObjectProperty(StudentInfo, 'teacherNotes')) === null) {
      StudentInfo['teacherNotes'] = [];
    }
    if ((getObjectProperty(StudentInfo, 'PSNotes')) === null) {
      StudentInfo['PSNotes'] = [];
    }
    if (!(getObjectProperty(StudentInfo, 'transferCredit'))) {
      StudentInfo['CreditTransfer'] = [];
    }
    StudentInfo['English'] = ['English 1', 'English 2', 'English 3', 'English 4'];
    StudentInfo['Math'] = ['Pre-Algebra', 'Algebra 1', 'Algebra 2', 'Geometry', 'Pre-Calculus', 'Calculus', 'Statistics', 'Integrated Math 1', 'Integrated Math 2', 'Integrated Math 3'];
    StudentInfo['SocialStudies'] = ['World History', 'Global Studies', 'U.S. History', 'U.S. Government', 'Economics', 'Geography', 'Psychology', 'Sociology'];
    StudentInfo['Science'] = ['Biology', 'Chemistry', 'Physics', 'Environmental Science', 'Anatomy and Physiology'];
    StudentInfo['PE&Health'] = ['Physical Education', 'Health Education'];
    StudentInfo['WorldLanguage'] = ['Spanish', 'French', 'German', 'Chinese'];
    StudentInfo['FineArts'] = ['Band', 'Orchestra', 'Choir', 'Theatre Arts/Drama', 'Visual Arts', 'Digital Design', 'Photography'];
    StudentInfo['CTE'] = ['Computer Science', 'Business and Marketing', 'Health Sciences', 'Culinary Arts', 'Automotive Technology', 'Agriculture Sciences', 'Audio/Video Production', 'Creative Writing', 'Journalism', 'Debate'];
    StudentInfo['grade'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1) || ((getObjectProperty(item, 'status')).indexOf('churn') !== -1));
    }))[0]), 'grade'));
    StudentInfo['chargebeeID'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1) || ((getObjectProperty(item, 'status')).indexOf('churn') !== -1));
    }))[0]), 'chargebee'));
    if (typeof (getObjectProperty(StudentInfo, 'studentMSEmail')) === 'string') {
      StudentInfo['1disabled'] = true;
      StudentInfo['1.5disabled'] = true;
      StudentInfo['1.6disabled'] = true;
      StudentInfo['2disabled'] = true;
      StudentInfo['3disabled'] = true;
      StudentInfo['4disabled'] = true;
      StudentInfo['5disabled'] = true;
      StudentInfo['6disabled'] = true;
      StudentInfo['6.1disabled'] = true;
      StudentInfo['7disabled'] = true;
      StudentInfo['8disabled'] = true;
      StudentInfo['8.1disabled'] = true;
      StudentInfo['8.2disabled'] = true;
      StudentInfo['9disabled'] = true;
      console.log(StudentInfo);
    }
    StudentInfo['requiredList'] = ['Ethnicity', 'student_name', 'student_last_name', 'student_birth_date', 'most_interested_in', 'behavior', 'parent_address', 'email', 'parent_phone', 'parent_name', 'parent_last_name', 'science_grade_level', 'ela_grade_level', 'math_grade_level', 'learning_environment_past_12_months', 'learning_experiece_past_12_months', 'upload_copy_EIP_504_plan', 'CreditTransfer', 'home_state', 'honorCodeSigned', 'transcriptFiles'];
    NotCompletedFields = (await asyncListFilter((getObjectProperty(StudentInfo, 'requiredList')), async (item) => {


     return ((item.indexOf('behavior') !== -1) && (getObjectProperty(StudentInfo, 'learning_or_behavioral_challenges')) != false && !(getObjectProperty(StudentInfo, item)).length || (item.indexOf('CreditTransfer') !== -1) && (getObjectProperty(StudentInfo, 'transferCredit')) && !((getObjectProperty(StudentInfo, 'grade')).indexOf('Kindergarten') !== -1) && (((getObjectProperty(StudentInfo, item)) === null) || !(getObjectProperty(StudentInfo, item)).length) || (item.indexOf('transcriptFiles') !== -1) && (getObjectProperty(StudentInfo, 'uploadTranscript')) == 'I can upload them' && !(getObjectProperty(StudentInfo, item)).length || (item.indexOf('upload_copy_EIP_504_plan') !== -1) && (getObjectProperty(StudentInfo, 'IEP_or_504_plan')) != false && ((getObjectProperty(StudentInfo, item)) === null) || (item.indexOf('Ethnicity') !== -1) && ((getObjectProperty(StudentInfo, 'ethnicityValue')) === null) || (item.indexOf('honorCodeSigned') !== -1) && !(getObjectProperty(StudentInfo, item)) || !(item.indexOf('upload_copy_EIP_504_plan') !== -1) && ((getObjectProperty(StudentInfo, item)) === null));
    }));
    console.log(NotCompletedFields);
    lengthCompetedFields = (getObjectProperty(StudentInfo, 'requiredList')).length - NotCompletedFields.length;
    console.log(lengthCompetedFields);
    percentCompleted = (lengthCompetedFields / (getObjectProperty(StudentInfo, 'requiredList')).length) * 100;
    console.log(String(percentCompleted) + String('%'));
    StudentInfo['NotCompletedFields'] = NotCompletedFields;
    StudentInfo['PercentCompleted'] = percentCompleted;
  }
  ___arguments.context.pageData['StudentInfo'] = StudentInfo;
  ___arguments.context.pageData['ShareParentContact'] = (getObjectProperty(StudentInfo, 'share_contact'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/2917e6f79362c86ddf23ece5b6eb9362/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/1bbfc25fdf15be1929c420f79dd750f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['To edit ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s information, click the edit button above. Don\'t forget to save your progress once you are done editing. '].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/f4b96b552685c1aa56dfeaee7ef90a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/938f0503dde3755c4498266a1947235a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/c2e45eefeec557dbf91fed44aa9b7ad9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What is  ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' most interested in?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/3deed936f9210b98d6765dbfce5c04db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Does ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' have any learning or behavioral challenges '].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/cee8a2e1f038cde8921cb7237efd9d53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Please choose any challenges ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' is experiencing that may '].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/15844f36803830d5469497af2ac3220e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s learning or behavioral challenges?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/98811e425949e082adb5db012521a2e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['To the best of your knowledge,  what is ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s grade level in these subjects?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/7e9f8eca23ef603d7c3c461ae6c3dcd4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Rate ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s confidence in these subjects'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/316acce9798dff1ed2c9cfcb3306b31f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What best describes ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s learning environment '].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/b9bc5298be5e370c40d414c8dc17ad37/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What was the name of ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s last school?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/6a31d8e57048ff2815f1dce2763337f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Can you briefly describe ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s past learning experience'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/6e9475b589daee24f3011c4ee6351a6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['what ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' liked/disliked, where ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' thrived/struggled..'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/68c8b098120d6aaada9588b8f5011215/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Does ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' have an IEP or 504 plan?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/77aaa9523151c9880a49d396a1573b2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Feel free to upload a copy so that we can better understand how to serve ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/744e3e5f79ba1bd52d325bc9a56efb94/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['exemplifies ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s current learning?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/100bee2eff531bea314537b59178335c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What computer system will ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' be using?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/9f99f8e74f82aa6a17cf8909f46673de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['If our microschool is a good fit for  ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s learning environment '].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/4d2b1f121dbf67c3762b60f388a8ae8f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Would you like to enroll ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' in one or more electives?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/98bdf9e5868da7a97902860594c44253/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') ? ({ [`margin-left`]: '100px' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/3263884eef02089294d1c70166c50a43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.5disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/7e5f314a35c9f002d111bdc870863e4e/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/0c3817c3d698ca05fb143d5d1c615436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (false) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.5disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/8a794065b704ad73f532701467d7598f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, checkMap, parent_map, masked_location, geocode, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d647136d1b60fd6ecdb4f796a5b53e', true);
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e5f314a35c9f002d111bdc870863e4e')));
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c6d81b44bdfba1a61526b2973e401f1'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c6d81b44bdfba1a61526b2973e401f1'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfb57096f662ccbaf9313afcd7032ac4'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfb57096f662ccbaf9313afcd7032ac4'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1569180130fc8c47fa595b6d62aecb1e'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1569180130fc8c47fa595b6d62aecb1e'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('97a522e1ea357b72b6219366dd06fb01'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('97a522e1ea357b72b6219366dd06fb01'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5d4edf1880f675f42dfeaf2481c37b2'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5d4edf1880f675f42dfeaf2481c37b2'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c9bebdf97d7b2932919d151169f2efbf'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c9bebdf97d7b2932919d151169f2efbf'))['border-color'] = 'red';
        }
        await new Promise(r => setTimeout(r, 3000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d647136d1b60fd6ecdb4f796a5b53e', false);
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c6d81b44bdfba1a61526b2973e401f1'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfb57096f662ccbaf9313afcd7032ac4'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1569180130fc8c47fa595b6d62aecb1e'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('97a522e1ea357b72b6219366dd06fb01'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5d4edf1880f675f42dfeaf2481c37b2'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c9bebdf97d7b2932919d151169f2efbf'))['border-style'] = 'none';
        }
        return null;
      }
    }
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Parent Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`Parent Last Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`Parent Email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`Parent Phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`Parent Address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`Parent Relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContact'] = (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) === null) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) : true);
    checkMap = (await Backendless.Data.of('parent_maps').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join(''))).setPageSize(10)));
    if (!checkMap.length) {
      geocode = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeChargebeeAddressConversion`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')))));
      masked_location = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeMaskLocation`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat': (Number((getObjectProperty(geocode, 'lat')))),'lon': (Number((getObjectProperty(geocode, 'lon')))) }));
      parent_map = (await Backendless.Data.of('parent_maps').save( ({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`share_contact`]: 'Yes',[`location`]: (new Backendless.Data.Point().setX((getObjectProperty(geocode, 'lon'))).setY((getObjectProperty(geocode, 'lat')))),[`masked_location`]: (new Backendless.Data.Point().setX((getObjectProperty(masked_location, 'lon'))).setY((getObjectProperty(masked_location, 'lat')))) }) ));
      await Backendless.Data.of('parent_maps').setRelation(({ [`objectId`]: (getObjectProperty(parent_map, 'objectId')) }), 'student_dir', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId'))]);
      await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`share_contact`]: 'Yes' }) );
    } else {
      await Backendless.Data.of('parent_maps').save( ({ [`objectId`]: (getObjectProperty((checkMap[0]), 'objectId')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) }) );
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send((true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) })));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 2nd Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/b0533e09442c07b1fa1bc4340543bccc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/3e748f3b3e9ab433bb12640eff6650cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/c51f833774ac25c2e7877565349624fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/6d738d39260f4e583da4ab0cd6d838be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['interests'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentInfo')), 'interests'));
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['secondary_guardian'] = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716'));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['tertiary_guardian'] = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8'));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PTO'] = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3'));
      Object2 = ({ [`Secondary Guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`Tertiary Guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO Interests`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',j == 'Secondary Guardian' || j == 'Tertiary Guardian' ? ['\nFirst Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_name')),'\nLast Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_last_name')),'\nEmail:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_email')),'\nPhone:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_phone')),'\nAddress:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_address')),'\nRelation:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_relation'))].join('') : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? String(getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')) + String(((getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')).includes('Other ideas')) ? String(':') + String(getObjectProperty((getObjectProperty(Object2, j)), 'Other')) : '') : '')].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',j == 'Secondary Guardian' || j == 'Tertiary Guardian' ? ['\nFirst Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_name')),'\nLast Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_last_name')),'\nEmail:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_email')),'\nPhone:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_phone')),'\nAddress:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_address')),'\nRelation:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_relation'))].join('') : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? String(getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')) + String(((getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')).includes('Other ideas')) ? String(':') + String(getObjectProperty((getObjectProperty(Object2, j)), 'Other')) : '') : '')].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',j == 'Secondary Guardian' || j == 'Tertiary Guardian' ? ['\nFirst Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_name')),'\nLast Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_last_name')),'\nEmail:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_email')),'\nPhone:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_phone')),'\nAddress:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_address')),'\nRelation:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_relation'))].join('') : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? String(getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')) + String(((getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')).includes('Other ideas')) ? String(':') + String(getObjectProperty((getObjectProperty(Object2, j)), 'Other')) : '') : '')].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send((true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`tertiary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`tertiary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) })));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 3rd Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/cf45d6e16c3d9a34d9a3bb7fa68f6555/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/30084e4e0553f76a546808bff8cb5def/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/2ae80c656e01f3886fc152384b498e7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.6disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/e54cbd01874556f909cbb7c47b453643/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.6disabled'] = true;
  if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
    return null;
  }
  changed_fields = [];
  oldData = ({  });
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
  }
  var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) })));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) !== null && !Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) === 'object')) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != (((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)) !== null && !Array.isArray((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j))) && (typeof (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)) === 'object')) ? (JSON.stringify((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) : (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) {
      addItemToList(changed_fields, j);
      oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
    }
  }
  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
  console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
  await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/94e617e2071c15dbbbd4b14b6bbbe6af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['secondary_guardian_show'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowGuardianHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowGuardianHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowGuardianHovered')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowGuardianHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowGuardianHovered'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/6446fa6c54abaf8bac66358eb2ed02fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['secondary_guardian_show'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['secondary_guardian'] = null;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowGuardianHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowGuardianHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowGuardianHovered')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowGuardianHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowGuardianHovered'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/2c6824b1c9fc9b04fc2424c31ecd9716/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) === 'boolean')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/0b02e254208d1541598583546c4480e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/ff5deb6bc77dbb81ce1bdd4caa4cce15/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/4a0f4741af8ec4eaba74d4e71da7b496/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/9e5eeba8104634048e39dc62d87cc961/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/7c3fab816a4dd4f939279ec20d7f3a51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/0bfc45e1d55d5ecb72552d0aa43696e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Organize parent meetups in your area', 'Participate in parent meetups in your area', 'Host afternoon clubs on zoom, eg. chess club', 'Host midday recess in a zoom room', 'Help organize one-off themed events', 'Other ideas']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS/components/2b8b4e22d5ecf839c1c5a7fbcc16be2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2b8b4e22d5ecf839c1c5a7fbcc16be2b')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')).length) {
      ___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3')['PTOOptions'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')), ___arguments.context.dataModel, '');
    if (___arguments.context.dataModel == 'Other ideas') {
      ___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3')['Other'] = null;
    }
  }
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions'));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPTO'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPTO'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/1852c2a7cd6180f659a3a6f7550ad602/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('2b8b4e22d5ecf839c1c5a7fbcc16be2b')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/2757bcb836de8c3855e11a14e8e43942/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) == 'Florida' && true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/54cce2629fed97f38322198de364fcdb/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return [({ [`choice`]: 'Confirming',[`description`]: 'We have already completed the necessary vaccinations and have sent relevant form for to the state’s' }), ({ [`choice`]: 'Pending',[`description`]: 'We don\'t currently have the form, but we will be submitting it shortly.' }), ({ [`choice`]: 'Exemption',[`description`]: 'We are seeking an exemption and will be submitting it soon' })]

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS/components/c76ec7713d240401ad3bf0fd775e304c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c76ec7713d240401ad3bf0fd775e304c')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ExemptionShow'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = 'Confirming';
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = null;
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) === null)) ? ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) == 'Confirming' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) == 'Confirming' ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) == 'Confirming' ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredConfirming'] = 'Confirming';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredConfirming'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/42f4d6b8dd0b3278dab5daae62499456/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ExemptionShow')) === 'boolean') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ExemptionShow')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/2209e0c9e42b3db55407737f3c9d0f3c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2209e0c9e42b3db55407737f3c9d0f3c')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ExemptionShow'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = 'Pending';
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = null;
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) === null)) ? ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) == 'Pending' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) == 'Pending' ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) == 'Pending' ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPending'] = 'Pending';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPending'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/fb1ae4f43012bcffcee6bc2d2cbb40c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb1ae4f43012bcffcee6bc2d2cbb40c2')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ExemptionShow'] = true;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = null;
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ExemptionShow'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ExemptionShow')) === 'boolean') ? ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ExemptionShow')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredExemption'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredExemption'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/9e69fea177555565b8c91a2f52d7e354/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/8886358f6346b03b1dd2dce24cb9db7e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What was the address of ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s last school?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/c7c344ab35c1346f3ea97687a6b3697f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('663db5f617bd76ac60880ea579194c34')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/663db5f617bd76ac60880ea579194c34/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (___arguments.context.dataModel == 'English 1' ? '9th Grade English or Freshman English' : (___arguments.context.dataModel == 'English 2' ? '10th Grade English or Sophomore English' : (___arguments.context.dataModel == 'English 3' ? '11th Grade English or Junior English' : '12th Grade English or Senior English')))

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('663db5f617bd76ac60880ea579194c34')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredEnglish'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredEnglish'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/53eb2d3228423c2d6a645824c463f6d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/c66a2e5f84ce5e5545fa0f3c89889def/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66a2e5f84ce5e5545fa0f3c89889def')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredMath'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredMath'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/310f12a2da325905d658d54a8467c5ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('c66a2e5f84ce5e5545fa0f3c89889def')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/683d024c0d0e744e5b915c7742e4cfd4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/85bbb92a9cafcd619eee1da95cfa3ac4/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (___arguments.context.dataModel == 'Psychology' ? 'or AP Psychology' : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85bbb92a9cafcd619eee1da95cfa3ac4')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredSocStud'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredSocStud'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/009cc2d488836768456af091bcb261bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('85bbb92a9cafcd619eee1da95cfa3ac4')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/5829ab0a7598a5cd423a649564991d27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5829ab0a7598a5cd423a649564991d27')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredScience'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredScience'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/f0bcb7eef2bede3f7a6585f768c4f0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('5829ab0a7598a5cd423a649564991d27')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/43358406225d115bdb1210032e983052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/9f6ba791c8ea28c66162a3d8cdd75d97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('0b276207d3bf2a94b1bc6763e862a974')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/0b276207d3bf2a94b1bc6763e862a974/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0b276207d3bf2a94b1bc6763e862a974')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPEH'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPEH'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/66c512d9a5f9391dcefa8a916fd66d4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/cf0975d97a29bf3529188505ba927209/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf0975d97a29bf3529188505ba927209')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (___arguments.context.dataModel == 'Spanish' ? 'Levels 1-5, including AP Spanish Language or AP Spanish Literature' : (___arguments.context.dataModel == 'French' ? 'Levels 1-5, or AP French Language' : (___arguments.context.dataModel == 'German' ? 'Levels 1-4 or 5' : 'Levels 1-4 or 5, or AP Chinese Language')))

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredWorldLang'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredWorldLang'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/0e8518f2583e1e266d951353e716b2b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('cf0975d97a29bf3529188505ba927209')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/500b35e231c83ca521d328bacdc886bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/dc937c0b4fe157bc97c4a7241f8e92be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('929f144ea0ef31f4b6a4a486079bef7f')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/929f144ea0ef31f4b6a4a486079bef7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('929f144ea0ef31f4b6a4a486079bef7f')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredFineArts'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredFineArts'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/e84d3971a5ead984d9a3c18ddd3133dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/dfe4da3438bf20c5a6838c04954b6785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('452ff1ec3a5ed5615b3416ad537e1697')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/452ff1ec3a5ed5615b3416ad537e1697/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('452ff1ec3a5ed5615b3416ad537e1697')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (___arguments.context.dataModel == 'Computer Science' ? 'Including AP Computer Science A and Principles' : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredCTE'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredCTE'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/f0a5904fce4fe3f5de5765a7a516676a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6.1disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/29acfd66c685c296d2884ef672d148bf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, date, j, oldData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6.1disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I prefer you source them from the school ($5 processing fee)') {
      date = (new Date());
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': (['Collect ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s Records ($5 fee)'].join('')),'date': date,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/89cc536a06a6fe8c67bc3951356544a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/5a4b671dc6542eb8a3f4293d053b8271/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Credit Transfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`Transcript Files`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send((true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) })));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 9th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/eccc9e69245e0babd422c7e9a9728261/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/30feead2b9e174a496f94fa73dfb042b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowPTOQuestions'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOHovered')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowPTOHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowPTOHovered'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/b4fc77a3e9148b6db6aeb983f97c34b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/6d7e20ec1235f4a8a0bd2946429b1fd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowPTOQuestions'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PTO'] = null;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowPTOHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowPTOHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowPTOHovered')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowPTOHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowPTOHovered'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/e19ca2d70fc323a873099c596c61c3b4/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'English')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['EnglishShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['EnglishShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/b41283063c912739b4c1f73c13249301/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Math')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['MathShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['MathShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/a7c38fdf85a98fe2dcd9ba422a25d245/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocialStudies')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['SocStudShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['SocStudShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/3cd12f8dbbdbfd6c2104e0bbe68fc659/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Science')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ScienceShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ScienceShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/c50e3ef60efb74bd09840c3b5699d797/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PE&Health')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PEHShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PEHShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/7817ff9e102ae21ccaef5543e47f570f/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLanguage')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['WorldLangShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['WorldLangShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/d88540a6a8749eca66e8cf3390189843/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArts')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['FineArtsShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['FineArtsShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/034af72122456c5d4d1327b868dd9b4e/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTE')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CTEShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CTEShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/02bc09052fc5492afb0454e2dece4e8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/7c15baf6c5f42a8e23e2da93ee510f82/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CallNotes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/bee16249008955367aa87137091c7aff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CallNotes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/df6e488df9c72379ed84298168fdfb69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['noteTextVisible'] = (!(getObjectProperty(___arguments.context.dataModel, 'noteTextVisible')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/853cf34f946fc484c3dbb39847b68ca2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Note;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.dataModel, 'noteTextVisible')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'noteTextVisible')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/b0446715cd37d435b47390d6f6864245/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://app.close.com/lead/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'lead_id')),'/'].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/4db5af31c231a0a1c17d7e2a12ffbc1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var StudentList, item, StudentLeadIDs;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['StudentsWithMissingValues'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', true);
  ___arguments.context.pageData['QCclicked'] = 'QC1';
  StudentLeadIDs = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIfindLeadObjectByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`entityName`]: 'lead',[`entityID`]: undefined,[`queryParam`]: '"custom.*bg service":(Microschool) "custom.*lifetime amount" > 500 lead_status in ("Families (Tutoring)") ',[`outputField`]: 'id',[`outputCount`]: 1000 })))).map(async item => {; return (getObjectProperty(item, 'id'));})));
  StudentList = (await asyncListFilter((await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause('most_interested_in is null and subjects not like \'%_ESE_%\' and subjects like \'%MS%\'').setRelated('slots').setPageSize(100))), async (item) => {


   return (StudentLeadIDs.includes((getObjectProperty(item, 'lead_id'))));
  }));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', false);
  ___arguments.context.pageData['StudentsWithMissingValues'] = StudentList;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'QCclicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'QCclicked')) == 'QC1' ? ({ [`box-shadow`]: '0px 0px 0px 2px #F5713C inset' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/0fac23642a4a1a5229c3bcd2c14a7018/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var StudentList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['StudentsWithMissingValues'] = null;
  ___arguments.context.pageData['QCclicked'] = 'QC2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', true);
  StudentList = (await asyncListFilter((await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause('submit_step_up = true').setRelated('slots').setPageSize(100))), async (item) => {


   return (((getObjectProperty(item, 'step_up_id')) === null) || !((getObjectProperty(item, 'step_up_id')) === null) && !(typeof (Number((getObjectProperty(item, 'step_up_id')))) === 'number' && !isNaN((Number((getObjectProperty(item, 'step_up_id')))))));
  }));
  console.log(StudentList);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', false);
  ___arguments.context.pageData['StudentsWithMissingValues'] = StudentList;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'QCclicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'QCclicked')) == 'QC2' ? ({ [`box-shadow`]: '0px 0px 0px 2px #F5713C inset' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/0f62689ee309f3e3ae8d3b923438963e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === null)) && !!(getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/9bad409a3fb5d3896513cf8187f71f39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var StudentList;


  ___arguments.context.pageData['StudentsWithMissingValues'] = null;
  ___arguments.context.pageData['QCclicked'] = 'QC3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', true);
  StudentList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause('learning_environment_past_12_months not like \'%Homeschool%\' and transcriptFiles is null and status = \'enrolled\'').setRelated('slots').setPageSize(100)));
  console.log(StudentList);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', false);
  ___arguments.context.pageData['StudentsWithMissingValues'] = StudentList;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'QCclicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'QCclicked')) == 'QC3' ? ({ [`box-shadow`]: '0px 0px 0px 2px #F5713C inset' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/87be630d169dbcabfc39d26d2f1cf1ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var StudentList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['StudentsWithMissingValues'] = null;
  ___arguments.context.pageData['QCclicked'] = 'QC4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', true);
  StudentList = (await asyncListFilter((await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause('vaccine_situation is null').setRelated('slots').setPageSize(100))), async (item) => {


   return ((getObjectProperty(((getObjectProperty(item, 'slots'))[0]), 'grade')) == 'Kindergarten' || (getObjectProperty(((getObjectProperty(item, 'slots'))[0]), 'grade')) == 'Grade 7');
  }));
  console.log(StudentList);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', false);
  ___arguments.context.pageData['StudentsWithMissingValues'] = StudentList;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'QCclicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'QCclicked')) == 'QC4' ? ({ [`box-shadow`]: '0px 0px 0px 2px #F5713C inset' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/c978e87c0d5bef09d1361e8b8b417ca9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === null)) && !(getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/6c9fdd7df2aa7c357437b51174882da4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['sectionClicked'] = 'studentQC';
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b32531b25d7b13d73b9cf3e1b28fe138')), 'display')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b32531b25d7b13d73b9cf3e1b28fe138', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02e89d912cb30fafe9428e752623b0d8', true);
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'sectionClicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'sectionClicked')) == 'studentQC' ? ({ [`box-shadow`]: '0px 4px 0px 0px #32325D' }) : ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') && (await Backendless.UserService.isValidLogin()) ? true : (!(getObjectProperty(___arguments.context.pageData, 'isTeacher')) && (await Backendless.UserService.isValidLogin()) ? true : (!(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/926bf66956dc230fbbfdb2377d68a85a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('02e89d912cb30fafe9428e752623b0d8')), 'display')) {
    ___arguments.context.pageData['sectionClicked'] = 'studentInfo';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b32531b25d7b13d73b9cf3e1b28fe138', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02e89d912cb30fafe9428e752623b0d8', false);
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'sectionClicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'sectionClicked')) == 'studentInfo' ? ({ [`box-shadow`]: '0px 4px 0px 0px #32325D' }) : ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') && (await Backendless.UserService.isValidLogin()) ? true : (!(getObjectProperty(___arguments.context.pageData, 'isTeacher')) && (await Backendless.UserService.isValidLogin()) ? true : (!(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/b8d363c75b75ed3397fc3e8f05c7cbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var date, j, reminderLastSent, scheduled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  reminderLastSent = (new Date());
  var j_list = (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`reminderLastSent`]: reminderLastSent }) );
    j['loadingReminder'] = true;
    scheduled = (new Date((new Date()).getTime() + (300 * 1000)));
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': scheduled,'lead_id': (getObjectProperty(j, 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(((getObjectProperty(j, 'slots'))[0]), 'email')),'body_html': (['Dear ',(getObjectProperty(j, 'parent_name')),',<br><br>There are a few important fields in your Student Information that require an update.','<br><br>Please log on <a href="https://portal.brilliantgrades.com/Clever/?page=student_form&lead_id=',(getObjectProperty(j, 'lead_id')),'">here</a> to quickly add the required information.<br>Kindly note that all students\' information are kept secure and in compliance with FERPA.','<br><br>Best regards,','<br>The Parent Support Team'].join('')),'subject': 'Reminder to update your Student Information' });
    j['loadingReminder'] = false;
    j['reminderSent'] = true;
    await new Promise(r => setTimeout(r, 1000 || 0));
    j['reminderSent'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/8e1fda824169117ff95a4c93c2dd55e7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'reminderSent')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'reminderSent')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/f9b538bd90e1abe14c1207a9950eb364/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'loadingReminder')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'loadingReminder')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/d801ea279c99052fdb5d3f548a41e233/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === null)) && !!(getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/665bfd758f4ce9eb55d256518f5ecb6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === 'undefined') ? (!((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues'))[0]), 'reminderLastSent')) === null) ? ((String(String(new Date((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues'))[0]), 'reminderLastSent')))).split(' ').slice(0, 5))).replace((new RegExp(',', 'g')), ' ')) : '') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/b8b42495e142c6bfcc122ba3d73b53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dateScheduled, updateFile, accessTokenString, copyInvoiceTemplate, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
    console.log('new Google Drive API auth code needed');
    accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
    await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
    accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
  } else {
    accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae9cf60c2bee1ec2b71324460329614e', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b8b42495e142c6bfcc122ba3d73b53d4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('509d3857dcd39544596591dcdaa79601', true);
    if (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeParentName')) === null) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeStudentName')) === null))) {
      copyInvoiceTemplate = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveCopyFileIDtoFolderIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'sourceFileID': '1leXqbMKzIwI2EXnavTZX-XKMajr0m2TMqpkmV-5-hj8','fileName': (['BMS Honor Code - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),' and ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join('')),'destinationFolderID': '1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K' }));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveAllowFileAccessByFileIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(copyInvoiceTemplate, 'id'))));
      updateFile = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://docs.googleapis.com/v1/documents/',(getObjectProperty(copyInvoiceTemplate, 'id')),':batchUpdate'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`requests`]: [({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{parentSignature}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeParentName')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{studentSignature}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeParentName')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{dateSigned}}',[`matchCase`]: true }),[`replaceText`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('') }) })] })));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['honorCodeURL'] = (['https://docs.google.com/feeds/download/documents/export/Export?id=',(getObjectProperty(updateFile, 'documentId')),'&exportFormat=pdf'].join(''));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['honorCodeSigned'] = 'Completed';
      await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`honorCodeSigned`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')),[`honorCodeURL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) }) );
      dateScheduled = (new Date((new Date()).getTime() + (300 * 1000)));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': dateScheduled,'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),'body_html': (['Dear ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),',','<br><br>I trust this email finds you well. Thank you for taking the time to review and sign the honor code. Your commitment to our shared values is greatly appreciated.','<br><br>Attached to this email, you will find a copy of the signed honor code for your records. Please feel free to reach out if you have any questions',['<br><br><a href=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')),'\'>Brilliant Microschool Honor Code</a>'].join(''),'<br><br>Best Regards,','<br><br>Parent Support Team<br><img src= \'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/images/bms-logo.png\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': 'Signed Honor Code' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('509d3857dcd39544596591dcdaa79601', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b8b42495e142c6bfcc122ba3d73b53d4', true);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/1df16677f5435328fce7de6789249efc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' ? 'View Signed Code' : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed through PandaDoc' ? 'Signed' : 'Sign'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/3716c848f5613d129cd50d5390755802/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/015eb939bb2741f8e13fc0288bb5e079/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/661c2ccb0be5a8dede7bac6e57eed2ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Not Completed' && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) === 'undefined')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('883bcde55757843909fcb379d4a7b5a2', true);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-style'] = 'solid';
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-color'] = 'red';
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a')));
        await new Promise(r => setTimeout(r, 2000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('883bcde55757843909fcb379d4a7b5a2', false);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-style'] = 'none';
        return null;
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
    Object2 = ({ [`Honor Code URL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) });
    var j_list = (Object.keys(Object2));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
      } else {
        replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
      }
    }
    console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 12th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/d2afb5bd7ab7c3d3ae19739310193834/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae9cf60c2bee1ec2b71324460329614e', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/2e66bc8fd371831c28e612adb699ae52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) : 'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/honor+codes/honorCodeDefault.pdf';
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(value, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/338b0e0d31d9d6cf2d4f878108b5ac71/bundle.js', [], () => ({
  /* content */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) : 'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/honor+codes/honorCodeDefault.pdf')

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/SIS/components/71d47d08a45594c2bbf431a1900df34a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('BMS_time_table', (((getObjectProperty(___arguments.context.pageData, 'StudentInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'StudentInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'object')) ? ({ [`studentMSEmail`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentInfo')), 'studentMSEmail')),[`student_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentInfo')), 'student_name')) }) : ___arguments.context.pageData));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/bf79eafbca1136ca142c21f810d24283/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa3ab1fb3efac5c929317a26c8cb5bdd', true);
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['BirthCert_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    console.log(Metadata);
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['birthCertMetaData'] = Metadata;

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa3ab1fb3efac5c929317a26c8cb5bdd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9892234da445d2f3c468f228d9093e73', true);
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('Birth Certificate Upload', 'An issue has occured while the upload was running', error);

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa3ab1fb3efac5c929317a26c8cb5bdd', false);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var studentInfo;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('bf79eafbca1136ca142c21f810d24283');
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentBirthCert'] = (['https://drive.google.com/file/d/',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'birthCertMetaData')), 'id')),'/view'].join(''));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')).indexOf('TestPeterLive') !== -1) {
    studentInfo = (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'),'process': 'encrypt' }));
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(studentInfo, 'objectId')),[`studentBirthCert`]: (getObjectProperty(studentInfo, 'studentBirthCert')) }) );
  } else {
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')) }) );
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c01ba0c726de33f3046b2ccd3848dea', true);
  await new Promise(r => setTimeout(r, 5600 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c01ba0c726de33f3046b2ccd3848dea', false);

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['BirthCert_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS/components/5bc79764702eed53488c4e2f6d3cd5e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'birthCertMetaData')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'birthCertMetaData')) === null)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/0108c5c8e32c13b6c4923262daee2691/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5bc79764702eed53488c4e2f6d3cd5e2'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['birthCertMetaData'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/2d043a6fee89e7e95fb18aa5797faa0d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, ImageFetch, access_token, GDriveAuthCode, RefreshAuthCode, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfbd565a4aa9ba2f8d6232021c5f02dc', true);
    GDriveAuthCode = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['api=\'','GoogleImageAPI','\''].join(''))).setPageSize(10)))[0];
    if (((new Date()).valueOf()) > ((getObjectProperty(GDriveAuthCode, 'expiring')).valueOf())) {
      RefreshAuthCode = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=1096446449962-1ni3r08aeqnm6rrdao6nofrvcl1j9nif.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty(GDriveAuthCode, 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty(GDriveAuthCode, 'objectId')),[`access_token`]: (getObjectProperty(RefreshAuthCode, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + ((getObjectProperty(RefreshAuthCode, 'expires_in')) * 1000))) }) );
      access_token = (getObjectProperty(RefreshAuthCode, 'access_token'));
    } else {
      access_token = (getObjectProperty(GDriveAuthCode, 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(access_token),[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(({ [`name`]: ['Student_ID_',((getObjectProperty(___arguments.context.pageData, 'student_name')).replace((new RegExp(' ', 'g')), '_')),'_',(generateUUID().short())].join(''),[`parents`]: ['1w3I9OTPmJbeb4Ca-wkeDGAc07cESseiz'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    ImageFetch = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(access_token),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0])));
    ___arguments.context.pageData['ImageFetch_Student'] = ImageFetch;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentPicMetaData'] = Metadata;

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('40b78b66569c3a8df489ee7e6fde5d4c', true);
    console.log(error);

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfbd565a4aa9ba2f8d6232021c5f02dc', false);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var ImageFetch, studentInfo;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('2d043a6fee89e7e95fb18aa5797faa0d');
  ImageFetch = (getObjectProperty(___arguments.context.pageData, 'ImageFetch_Student'));
  console.log(getObjectProperty(ImageFetch, 'selfLink'));
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentPic'] = (String('https://drive.google.com/thumbnail?id=') + String((getObjectProperty(ImageFetch, 'selfLink')).split('/').slice(-1)[0]));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')).indexOf('TestPeterLive') !== -1) {
    studentInfo = (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'),'process': 'encrypt' }));
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(studentInfo, 'objectId')),[`studentPic`]: (getObjectProperty(studentInfo, 'studentPic')) }) );
  } else {
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) }) );
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3c24c754e2b35b613ee43f7769bf3fa', true);
  await new Promise(r => setTimeout(r, 5600 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b3c24c754e2b35b613ee43f7769bf3fa', false);

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['StudentPic_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS/components/3ecbd2d7774be4f7e44f93ae2c918526/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPicMetaData')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPicMetaData')) === null)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/79ccef7ab42631a33c4e80d41e45b0ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3ecbd2d7774be4f7e44f93ae2c918526'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentPicMetaData'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/12d48721fb0900cb04b60141830126f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/65bbab8c95cfc0539bb13be7d3f67201/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/e42fe89912f7a5de822f4994c7cf9e16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'requiredList')) === 'undefined') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'requiredList')).includes('student_name')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/5c186baacc043fa9f5ae44ed09859505/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'requiredList')) === 'undefined') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'requiredList')).includes('student_last_name')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/9f43f04b940ae486bbaf4c070c242d46/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHovered')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransferHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransferHovered'] = false;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transferCredit'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/3ee4bbcbd5552c7262650d561e1839be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transferCredit'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [];

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var StudentInfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHoveredNo')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHoveredNo')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHoveredNo')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransferHoveredNo'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransferHoveredNo'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/6bef1c7b36d86cf67aee127af0e7e389/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/27a3a738e1735a671e9ffeae72c3cc78/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')).includes('Other ideas')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/c87d8e8560d3d46367fcba43a73972e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Please share any records or transcripts from ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s prior school(s)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/a94a02f75ea530fb5a1ed2ec441f2f95/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I can upload them' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscriptHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscriptHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscriptHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['uploadTranscript'] = 'I can upload them';

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['uploadTranscriptHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['uploadTranscriptHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/2571eb09175cf6fd1bfe925dd035c673/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I prefer you source them from the school ($50 processing fee)' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'dontUploadTranscriptHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'dontUploadTranscriptHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'dontUploadTranscriptHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['uploadTranscript'] = 'I prefer you source them from the school ($50 processing fee)';

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['dontUploadTranscriptHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['dontUploadTranscriptHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS/components/e6530f5a1c1dac85e0c27c7c181328c2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I can upload them')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/71dbbd1be5758d3352a21af8b3155406/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    console.log('1');
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['Transcript_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    console.log(Metadata);
    console.log('2');
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
    if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')).length) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2bee94e2c48eb648a19a0a395af70b4f', [Metadata]);
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')), Metadata);
    }
    console.log('3');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var item;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('1sdfe');
  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  console.log('Upload Success!');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('71dbbd1be5758d3352a21af8b3155406');
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transcriptFiles'] = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')).map(async item => {; return (['https://drive.google.com/file/d/',(getObjectProperty(item, 'id')),'/view'].join(''));})));
  console.log('1');
  await Backendless.Data.of('ms_student_dir').save( (true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })) );
  console.log('2');
  await new Promise(r => setTimeout(r, 500 || 0));
  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) === 'undefined') || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) === null)) {
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`note`]: String('Transcript has been uploaded via SIS - \n') + String((String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles'))).replace((new RegExp(',', 'g')), '\n')) })));
  }
  console.log('4');

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Transcript_',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')).replace((new RegExp('\'', 'g')), '')),'_',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')).replace((new RegExp('\'', 'g')), ''))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS/components/bf3436869c7d27eb9064d231cc2c40a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var accessTokenObject, accessTokenString, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce310896e2297c946d1544c84cc5613d'), 'id')).indexOf('typeform') !== -1)) {
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce310896e2297c946d1544c84cc5613d'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    }
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')), ___arguments.context.getComponentDataStoreByUid('ce310896e2297c946d1544c84cc5613d'), '');
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transcriptFiles'] = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')).map(async item => {; return (['https://drive.google.com/file/d/',(getObjectProperty(item, 'id')),'/view'].join(''));})));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/ab564af2dd0ec3ced2313df90da9ceed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/0fbc747969a1dc23f07db92d7e41a33a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/7b62f89607da6ff34c42ba04b0568f7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/9fbe3e64a914ea2ff1be143b8ed53de5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/34b6661a385f8066585fbfee59f162a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/a2dbbcb5b30a5fafdd9844971deb422c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/11c8c349cf3323eb82661afe4cec7b55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/37ae315e43343c8cce161c2c92f55b31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/890bdfe8a7a30a5650b70f0c6b873b3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/2b2a6248968194c91bfcca06944a5a7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/ffe54f9c4b134d01dd21542c6e6b2ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/89ac2a4a23f9cc5e164f465276d5e872/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['9disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/51299101a47bc22ffdcd427d00d450cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['9disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) ? (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`lastQuestionBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lastQuestionBool')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`lastQuestionBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lastQuestionBool')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '9disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/2c0f370547bac0f138f874ef942920dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['The form\'s required fields are ',Math.round(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PercentCompleted')),'% completed.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/f4faf2094324352ed5bef53a47dc1899/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NotCompletedFields')) === 'undefined') ? null : String(' - ') + String((String(await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NotCompletedFields')).map(async item => {; return (item == 'Ethnicity' ? 'Ethnicity' : (item == 'student_name' ? 'Student Name' : (item == 'student_last_name' ? 'Student Last Name' : (item == 'student_birth_date' ? 'Student Birth Date ' : (item == 'most_interested_in' ? 'Student Most Interested in' : (item == 'behavior' ? 'Behaviorial Challenges' : (item == 'parent_address' ? 'Parent Address' : (item == 'email' ? 'Parent Email' : (item == 'parent_phone' ? 'Parent Phone' : (item == 'parent_name' ? 'Parent Name' : (item == 'parent_last_name' ? 'Parent Last Name' : (item == 'science_grade_level' ? 'Science Grade Level' : (item == 'ela_grade_level' ? 'ELA Grade Level' : (item == 'math_grade_level' ? 'Math Grade Level' : (item == 'learning_environment_past_12_months' ? 'Learning ENVIRONMENT for the past 12 months' : (item == 'learning_experiece_past_12_months' ? 'Learning EXPERIENCE for the past 12 months' : (item == 'upload_copy_EIP_504_plan' ? 'Upload a copy of the EIP Plan' : (item == 'CreditTransfer' ? 'Credit Transfer Subjects' : (item == 'home_state' ? 'Home State' : (item == 'honorCodeSigned' ? 'Sign the Honor Code' : 'Transcript for Credit Transfer'))))))))))))))))))));})))).replace((new RegExp(',', 'g')), '\n - ')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/6758c6352b86b81d7bf7081596f8d29e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') ? false : ((typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') && (await Backendless.UserService.isValidLogin()) ? true : (!(getObjectProperty(___arguments.context.pageData, 'isTeacher')) && (await Backendless.UserService.isValidLogin()) ? true : (!(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') ? true : false)))) && (await Backendless.UserService.isValidLogin()) && Math.round(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PercentCompleted')) != 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/fc278ebd9082c595526f3f26a80a91c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fbfbe341023d509b126c6aea08e7172', true);
  date = (new Date((new Date()).getTime() + (600 * 1000)));
  await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': date,'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'sender_name': 'Brilliant Microschool','sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'slots'))[0]), 'email')),'body_html': (['<p>Dear ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'</p><p>I hope this message finds you well. We noticed that some fields in ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s registration form are incomplete. Please complete the following fields:</p>','<ol>',((String(await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NotCompletedFields')).map(async item => {; return (item == 'Ethnicity' ? '<li>Ethnicity</li>' : (item == 'student_name' ? '<li>Student Name</li>' : (item == 'student_last_name' ? '<li>Student Last Name</li>' : (item == 'student_birth_date' ? '<li>Student Birth Date</li>' : (item == 'most_interested_in' ? '<li>Student Most Interested in</li>' : (item == 'behavior' ? '<li>Behaviorial Challenges</li>' : (item == 'parent_address' ? '<li>Parent Address</li>' : (item == 'parent_email' ? '<li>Parent Email</li>' : (item == 'parent_phone' ? '<li>Parent Phone</li>' : (item == 'parent_name' ? '<li>Parent Name</li>' : (item == 'parent_last_name' ? '<li>Parent Last Name</li>' : (item == 'science_grade_level' ? '<li>Science Grade Level</li>' : (item == 'ela_grade_level' ? '<li>ELA Grade Level</li>' : (item == 'math_grade_level' ? '<li>Math Grade Level</li>' : (item == 'learning_environment_past_12_months' ? '<li>Learning ENVIRONMENT for the past 12 months</li>' : (item == 'learning_experiece_past_12_months' ? '<li>Learning EXPERIENCE for the past 12 months</li>' : (item == 'upload_copy_EIP_504_plan' ? '<li>Upload a copy of the EIP Plan</li>' : (item == 'CreditTransfer' ? '<li>Credit Transfer Subjects</li>' : (item == 'home_state' ? '<li>Home State</li>' : (item == 'honorCodeSigned' ? '<li>Sign the Honor Code</li>' : '<li>Transcript for Credit Transfer</li>'))))))))))))))))))));})))).replace((new RegExp(',', 'g')), '\n')),'</ol><p>Your prompt attention to this matter is appreciated. If you need assistance, please don\'t hesitate to contact us.<p>Best regards,<br>','<br><br>Parent Support Team<br><img src= \'https://lh6.googleusercontent.com/hnkDEFumM6CbPs3YxDAwWOcvchVNNwOawvbe-zzLebpvQ1HaJSrBBhJrpn-PeVYUHesnL6zm_31TBdeCqMVBlaTkq-NVaJFrk5zrl0f4EZn0rvc6-ftZkvxJ71oN0HQxIw-KqrPwB8Jj2bgYoO84rng\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': (String('Registration form completion required') + String('')) });
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fbfbe341023d509b126c6aea08e7172', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/9a12d1dc3b06970e1ad83f39097975d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Kindergarten') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/0827f4d123ca93c9aab18336538f24df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 9') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 10') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 11') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 12') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 13') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/8674d858447b8ca18ee899d4634b0023/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 9') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 10') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 11') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 12') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 13') !== -1)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/0a72d4f4e0734d3ecdbc5974e7e2c505/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) === 'undefined')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99e5d6d74b42a38337c84ceab5a3b8df', true);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-style'] = 'solid';
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-color'] = 'red';
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e')));
        await new Promise(r => setTimeout(r, 2000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99e5d6d74b42a38337c84ceab5a3b8df', false);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-style'] = 'none';
        return null;
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
    Object2 = ({ [`Terms of Service URL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) });
    var j_list = (Object.keys(Object2));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
      } else {
        replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
      }
    }
    console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    console.log('Next Final Submit');

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 13th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/bf9e90475c8300db7daaa3c653798b44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/7c64b48c3b0c3bfebd4bdd989495d4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed through PandaDoc')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/81c9d80c1223c3b871b2a62c9ea5489f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed through PandaDoc')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/29274685236b31a3754f97dd69bcb9ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dateScheduled, updateFile, price, units, plan, last_name, first_name, address, IP, accessTokenString, copyInvoiceTemplate, chargebee, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
    console.log('new Google Drive API auth code needed');
    accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
    await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
    accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
  } else {
    accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a3742e89d91c31cbaf3df3a5fccd8a4', true);
  } else {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSParentName')) === null)) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29274685236b31a3754f97dd69bcb9ef', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0359ab94813e96756fab3303ab8edb56', true);
      console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'chargebeeID'));
      chargebee = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIChargebeeGetObjectListByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'returnCount': 1,'isLiveCB': (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')).indexOf('TestPeterLive') !== -1)),'entityName': 'subscriptions','utmParan': (String('?customer_id[is]=') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'chargebeeID'))) }))[0];
      console.log(chargebee);
      plan = (getObjectProperty((getObjectProperty(chargebee, 'subscription')), 'plan_id'));
      units = (getObjectProperty((getObjectProperty(chargebee, 'subscription')), 'plan_quantity'));
      price = (getObjectProperty((getObjectProperty(chargebee, 'subscription')), 'plan_unit_price')) / 100;
      last_name = ((getObjectProperty(chargebee, 'card')) !== null && !Array.isArray((getObjectProperty(chargebee, 'card'))) && (typeof (getObjectProperty(chargebee, 'card')) === 'object')) ? (getObjectProperty((getObjectProperty(chargebee, 'card')), 'last_name')) : (getObjectProperty((getObjectProperty(chargebee, 'customer')), 'last_name'));
      first_name = ((getObjectProperty(chargebee, 'card')) !== null && !Array.isArray((getObjectProperty(chargebee, 'card'))) && (typeof (getObjectProperty(chargebee, 'card')) === 'object')) ? (getObjectProperty((getObjectProperty(chargebee, 'card')), 'first_name')) : (getObjectProperty((getObjectProperty(chargebee, 'customer')), 'first_name'));
      address = ((getObjectProperty(chargebee, 'card')) !== null && !Array.isArray((getObjectProperty(chargebee, 'card'))) && (typeof (getObjectProperty(chargebee, 'card')) === 'object')) ? [(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_addr1')),' ',(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_city')),' ',(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_zip')),' ',(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_state_code')),' ',(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_country'))].join('') : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address'));
      IP = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GetIPFrontEnd`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), 'X-Real-IP'));
      copyInvoiceTemplate = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveCopyFileIDtoFolderIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'sourceFileID': '1WKFdWXqTCNfdpy9WfpzXyLwM_rrsSEV1aiRHIg_4Ztg','fileName': (String('BMS ToS - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name'))),'destinationFolderID': '1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K' }));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveAllowFileAccessByFileIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(copyInvoiceTemplate, 'id'))));
      updateFile = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://docs.googleapis.com/v1/documents/',(getObjectProperty(copyInvoiceTemplate, 'id')),':batchUpdate'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`requests`]: [({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{parentSignature}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSParentName')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{userIP}}',[`matchCase`]: true }),[`replaceText`]: IP }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{dateSigned}}',[`matchCase`]: true }),[`replaceText`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('') }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{address}}',[`matchCase`]: true }),[`replaceText`]: address }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{contactName}}',[`matchCase`]: true }),[`replaceText`]: [first_name,' ',last_name].join('') }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{contactEmail}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{chargebeePlan}}',[`matchCase`]: true }),[`replaceText`]: plan }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{quantity}}',[`matchCase`]: true }),[`replaceText`]: String(units) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{price}}',[`matchCase`]: true }),[`replaceText`]: String(price) }) })] })));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ToSURL'] = (['https://docs.google.com/feeds/download/documents/export/Export?id=',(getObjectProperty(updateFile, 'documentId')),'&exportFormat=pdf'].join(''));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ToSBool'] = true;
      await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ToSBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')),[`ToSURL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) }) );
      dateScheduled = (new Date((new Date()).getTime() + (300 * 1000)));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': dateScheduled,'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),'body_html': (['Dear ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),',','<br><br>I trust this email finds you well. Thank you for taking the time to review and sign the Terms of Service. ','<br><br>Attached to this email, you will find a copy of the signed Terms of Service for your records. Please feel free to reach out if you have any questions',['<br><br><a href=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')),'\'>Brilliant Microschool Terms of Service</a>'].join(''),'<br><br>Best Regards,','<br><br>Parent Support Team<br><img src= \'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/images/bms-logo.png\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': 'Signed Terms of Service' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0359ab94813e96756fab3303ab8edb56', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29274685236b31a3754f97dd69bcb9ef', true);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/85ba7c657ebdd2b9e0ce0f22abbf2d16/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) ? 'View Signed ToS' : 'Sign')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/48a3e4da787c432cf6a3571ffa132342/bundle.js', [], () => ({
  /* content */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) : null)

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/SIS/components/f78564ffd6a98113224af9a7b0465a52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a3742e89d91c31cbaf3df3a5fccd8a4', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/3905c14ac74d5be6395392ce78a6a1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 1;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/41dab42f464563920f4ecd591eaca32a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 2;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/47ae4948596eca6b7d127837741cd482/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 3;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/d68b0bef223bcc3f0a46965b8f83d5bb/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 4;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/e4ce46f7c4f49b75b382e3769c583d01/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 5;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/c68687d5e0591343372d5b612ccbd2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/f95ddaf208faae38b9f24d62197812e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, existingParentMap, parent_map, student_dir_data, masked_location, geocode, changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('SIS Save Location');
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c68687d5e0591343372d5b612ccbd2b6')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.5disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.5disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    try {
      var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) })));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
          addItemToList(changed_fields, j);
          oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
        }
      }
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
      console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
      student_dir_data = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send((true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No' }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No' }))));
      existingParentMap = (await Backendless.Data.of('parent_maps').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join(''))).setPageSize(1)))[0];
      console.log('check existing');
      console.log(existingParentMap);
      console.log(await Backendless.Data.of('parent_maps').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join('')))));
      if ((await Backendless.Data.of('parent_maps').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join(''))))) == 0) {
        geocode = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeChargebeeAddressConversion`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')))));
        masked_location = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeMaskLocation`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat': (Number((getObjectProperty(geocode, 'lat')))),'lon': (Number((getObjectProperty(geocode, 'lon')))) }));
        parent_map = (await Backendless.Data.of('parent_maps').save( ({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`share_contact`]: !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === 'undefined') || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === null) || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) !== null && !Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact'))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === 'object')) ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No') : 'No',[`location`]: (new Backendless.Data.Point().setX((getObjectProperty(geocode, 'lon'))).setY((getObjectProperty(geocode, 'lat')))),[`masked_location`]: (new Backendless.Data.Point().setX((getObjectProperty(masked_location, 'lon'))).setY((getObjectProperty(masked_location, 'lat')))) }) ));
        await Backendless.Data.of('parent_maps').setRelation(({ [`objectId`]: (getObjectProperty(parent_map, 'objectId')) }), 'student_dir', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId'))]);
      } else {
        student_dir_data = (await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No' }) ));
        parent_map = (await Backendless.Data.of('parent_maps').save( ({ [`objectId`]: (getObjectProperty(existingParentMap, 'objectId')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No',[`location`]: (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(existingParentMap, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(existingParentMap, 'location')), 'lat')))),[`masked_location`]: (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(existingParentMap, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(existingParentMap, 'location')), 'lat')))) }) ));
      }

    } catch (error) {
      console.log(error);
      console.log(getObjectProperty(error, 'message'));

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/03def3a850adab2bef692134646ad1de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/39dca496a4b68dbdc81ad9b6078c2ac3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, changed_fields, oldData, j, arrayOptions, _unused, item, reply, prompt2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03def3a850adab2bef692134646ad1de')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['2disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`intersts`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['2disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`interests`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    try {
      var j_list = (Object.keys(({ [`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) })));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
          addItemToList(changed_fields, j);
          oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
        }
      }
      if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) === null) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) === null)) {
        prompt2 = ['From the options below, choose whatever is closely related to this text - "',(getObjectProperty(j, 'most_interested_in')),'" do not include that is not in the option but you can choose multiple options below:','Sports: Soccer, Basketball, Swimming, Tennis, Gymnastics, etc.','Music: Playing an instrument, Singing, Listening to music, Music composition, etc.','Arts and Crafts: Drawing, Painting, Sculpting, Pottery, Knitting, DIY projects, etc.','Science and Nature: Astronomy, Biology, Chemistry, Environmental conservation, Gardening, etc.','Reading and Writing: Fiction, Non-fiction, Poetry, Creative writing, Comics, etc.','Technology and Computing: Video games, Coding, Robotics, Web design, etc.','Performing Arts: Theater, Dance, Magic, Circus arts, etc.','History and Geography: World history, Archaeology, Cultural studies, Map reading, etc.','Languages and Linguistics: Learning foreign languages, Sign language, Linguistics, etc.','Mathematics: Solving puzzles, Math competitions, etc.','Cooking and Baking: Trying new recipes, Cake decorating, etc.','Board Games and Puzzles: Chess, Card games, Jigsaw puzzles, etc.','Movies and Television: Watching films, Animation, Documentary, etc.','Outdoor Activities: Hiking, Camping, Birdwatching, Fishing, etc.','Animals and Pets: Learning about animals, Pet care, Horseback riding, etc.','Volunteering and Community Service: Charity work, Community clean-up, Helping at animal shelters, etc.','Photography and Videography: Taking photos, Making videos, Editing, etc.','Fashion and Design: Clothing design, Fashion blogging, Interior design, etc.','Collecting: Stamps, Coins, Figurines, etc.','Health and Fitness: Yoga, Meditation, Running, Weightlifting, etc.','Astronomy and Space Exploration: Stargazing, Learning about space missions, etc.','Mind and Brain Games: Sudoku, Crossword puzzles, Brain teasers, etc.','Vehicles and Mechanics: Cars, Bikes, Model building, etc.'].join('');
        reply = (getObjectProperty((getObjectProperty(((getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.openai.com/v1/chat/completions')).set(({ [`Content-Type`]: 'application/json',[`Authorization`]: String('Bearer ') + String('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') })).setEncoding('utf8').send(({ [`model`]: 'gpt-4',[`temperature`]: 0.7,[`max_tokens`]: undefined,[`messages`]: [({ [`role`]: 'user',[`content`]: prompt2 })] }))), 'choices'))[0]), 'message')), 'content'));
        arrayOptions = (removeItemInList((await Promise.all((reply.split('.')).map(async item => {; return (item.replace((new RegExp('\\n', 'g')), ''));}))), '', ''));
        _unused = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`interests`]: arrayOptions })));
      }
      var j_list2 = (Object.keys(({ [`interests`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) })));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
          addItemToList(changed_fields, j);
          oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
        }
      }
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/349358fdd8544d67f448b7135dca2e2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/ae6eae519fa3629b3b5ba57129aa632e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var itemObj, behaviorFormatName, j, changed_fields, oldData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('349358fdd8544d67f448b7135dca2e2d')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['3disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['3disabled'] = true;
    if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')))) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyslexia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyslexia')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dysgraphia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dysgraphia')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyscalculia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyscalculia')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ADHD'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('ADHD')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['auditory_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Auditory processing disorder')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['language_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Language processing disorder')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['nonverbal_learning_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Nonverbal learning disorder')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['visual_perceptual_or_visual_motor_defecit'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Visual perceptual/visual motor deficit')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['austism_spectrum_discorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Autism spectrum disorder')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['asperger'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Asperger’s')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['anxiety'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Anxiety')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['depression'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Depression')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavioral_issues'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Behavioral issues')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_behavioral_challenges'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')) : '');
    }
    if (true) {
      if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
        return null;
      }
      changed_fields = [];
      oldData = ({  });
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
      }
      var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) })));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
          addItemToList(changed_fields, j);
          oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
        }
      }
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
      console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
      itemObj = true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
      var j_list2 = ['Inattention/poor focus', 'Impulsivity/hyperactivity', 'Disorganization', 'Frustration/overwhelm', 'Mood swings/emotional disregulation', 'Anxiety/fear', 'Social withdrawal/shyness', 'Emotional outbursts', 'Difficulty transitioning', 'Defiance', 'Low perseverance', 'Forgetfulness', 'Perfectionism'];
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        behaviorFormatName = ((j.replace((new RegExp(' ', 'g')), '_')).replace((new RegExp('/', 'g')), '_')).toLowerCase();
        if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), behaviorFormatName)) === 'undefined')) {
          itemObj[behaviorFormatName] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), behaviorFormatName));
        }
      }
      console.log(itemObj);
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(itemObj);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/7ca67a2aab794a4df4134b7892dd307d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28cd95ff0fe5379ac056c13862813daf')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['4disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['4disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/aa41dd2b1fa4d8f6413de5c291349c49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/085b63df4426142c0852477e809ea76c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aa41dd2b1fa4d8f6413de5c291349c49')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['5disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['5disabled'] = true;
    if ((JSON.stringify(({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/28cd95ff0fe5379ac056c13862813daf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/0ef745812d5ddb3807e98c26748f975c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/e72d7c2d9d4946842ee6186a9707cb98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0ef745812d5ddb3807e98c26748f975c')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`IEPFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`IEPFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`IEPFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) });
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) === 'undefined') || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) === null)) {
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`note`]: String('IEP has been uploaded via SIS - \n') + String((String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles'))).replace((new RegExp(',', 'g')), '\n')) })));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send((true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`IEPFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`IEPFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEPFiles')) })));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/19074a1e47d181d74e9bcd4b19cc0eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/1385f2be8c499e64f47169e293dc85b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var date, changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19074a1e47d181d74e9bcd4b19cc0eb9')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6.1disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })));
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6.1disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I prefer you source them from the school ($50 processing fee)') {
      date = (new Date());
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': (['Collect ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s Records ($50 fee)'].join('')),'date': date,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send((true ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) })));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) === 'undefined') || !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/a9675fc8f10ee0972f84812b5b7bd405/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/95dd651de3e1baeabb47253fc4828208/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var datescheduled, changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a9675fc8f10ee0972f84812b5b7bd405')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['7disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['7disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) == 'Alabama') {
      datescheduled = (new Date((new Date()).getTime() + (600 * 1000)));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': 'Alabama family: difficult homeschool paperwork, review with Andreas','date': datescheduled,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
    }
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/bedf93384f546d666f11663294bc659d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/24ef50bb87882e15d66aefc874fc2952/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j, electives;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bedf93384f546d666f11663294bc659d')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['8disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['8disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (j == 'electives') {
        console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j));
        console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) ? (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/14f2142d3231a2427b5c82f5be27991e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/2bbbdcb9ae368d072f63e3034f55bd6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/365d57b8da71441443a206ddc815af6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Please complete the typeform above to complete ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s information.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/b1e49d1b23097583c92bcee4996c0484/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/82bc13eb1d93916c8bcf279b53ae299b/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/c43ed6ac19b48f0510d9037a50732667/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#F5713C';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS/components/074164d44f217beb682dd8b49ef5762d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/8f2eee747b3912ebf6f4cc5d41ce1a2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/d1afa3426ef476ee0e03501f706ed294/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/1cc89ffc12f6d8c8ee86134609092907/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/524bd0a88f3177de0163c2885c297c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/c873c113361b2a67cbf1cd6d2e81d8d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/735cd4b1edc58d7e111ed494d5f1bd9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/f35c19d92266442ec508982de406d5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/38e4f32b984ea4b6e6f934534e0335db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Kindergarten') !== -1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/2bead3d62d1b596ff062bc05484aeff5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/9a83e92e755ebf894f917c3bc71245f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
    if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07dc116efb3653f910fb001dc4228ded', true);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-color'] = 'red';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07dc116efb3653f910fb001dc4228ded', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-style'] = 'none';
      return null;
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/01259b7992242d645472a27bd1abb789/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/4219cad74346f3461e5e7d8c557d8b97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Not Completed' && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) === 'undefined'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('883bcde55757843909fcb379d4a7b5a2', true);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-color'] = 'red';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('883bcde55757843909fcb379d4a7b5a2', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-style'] = 'none';
      return null;
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/83fca12852c4326f1c554ba602be934d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) === 'undefined'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99e5d6d74b42a38337c84ceab5a3b8df', true);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-color'] = 'red';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99e5d6d74b42a38337c84ceab5a3b8df', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-style'] = 'none';
      return null;
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/fb06b192422aab4b24d54adcfb36617d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/313d60652323f37f3f85470573714ede/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/ba0a7dbc8b4811bff70d129c68ae02b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/82341e8fa12d3ee27a0c1c19cc8efd21/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['If applicable, what would you have liked to see more/less of in ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s previous educational establishment?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/72029cb6c53674f3b904f29bb95fd602/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')) + String(' classifies families as homeschoolers when attending out-of-state private schools (we are a Florida private school). That is nothing to worry about; it just means that you should submit some simple paperwork. '))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StateRegObject')) === 'undefined') && !((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'enrollment_type')) == 'private' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'difficulty')) == 'easy' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')) == 'Alabama'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/590d953e7512130e69837b652406d828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StateRegObject')) === 'undefined') && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'enrollment_type')) != 'private' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Difficulty')) != 'easy' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')) != 'Alabama')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/d8fe95fcc02bc76c4c028bcfd6fbfbe9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['While we are not legal professionals, here is what our families from ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')),' usually do:'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StateRegObject')) === 'undefined') && !((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'enrollment_type')) == 'private' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'difficulty')) == 'easy' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')) == 'Alabama'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/3a83d42893ad44f39727225503cccffd/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/6b7ecb4e441c5ca3c0ac1e3a76bb809e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Affidavit'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/3fd3abd926e93bea042a516c80fb2f6c/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/42d2229b371a85a3d3188f02b5c5da46/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Register_with_the_DoE'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/865eaddffe7c50f961edd284ce4fe0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Individualized_Home_Instruction_Plan'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/6cfb0efee86217bd3e86af71496467c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Quarterly_Reports'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/df6895d5aa085bb5af73f6b1d3f8f3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Annual_Evaluation'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/d75e3294065ec2b535e4f3fd8bbedc93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StateRegObject')) === 'undefined') ? ['- ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')),' asks families to do one nationally-normed diagnostic per year. We provide this for you, but make sure ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' participates in our diagnostic when the time comes!'].join('') : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/d26f9bbff30d01253d4a2b72068de39f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Minimum_number_of_hours')).indexOf('no minimum hours') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/4d63cad25013db7b464ae214cbc9da78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['- When planning your annual calendar, we recommend staying with us until the end of June and starting in early August, since ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')),' requires  ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Minimum_number_of_hours')),' of school. This way you will be covered 100%.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/94261251b48f98716b6d2c76117ae3d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Comments')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/fe7e879de2fd0b9498129e067bfc3bd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Comments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/91b54073a95235612b8e9105d4ff49e7/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/4856ecf6577a64ed87cf934e153ab4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/7c770a6260d82999ace75cf864ad3f17/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' })

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('GMeet_Recordings', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/e9d3320c3503424908686531be944bad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Grade_Switcher', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/8384fe5ec8058a217d6c70929782516f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['How can we contact ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s last school?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/501c8d6bc01f9114ee18c0de76688119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Person to speak with from ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s last school?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/921225ead5d65b2fe1efb32e32e568f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/2a5910718f4adafc67e81e18f2e25b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/f7ee64acdde690d5fc4ee02373645656/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MobyMax_CSV', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var user;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/543d0da5751b37d60b68c966f0c83b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === null) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContactHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContactHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContactHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContactHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContactHover'] = false;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContact'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/e78396ca7f12dba96732c898a376836c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === null) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShareParentContactHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShareParentContactHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShareParentContactHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.pageData['DontShareParentContactHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShareParentContactHover'] = false;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContact'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/ff97bf7224e7ef222b5bf781cffce1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'mobile-menu-action')) == 'close') {
    ___arguments.context.pageData['mobile-menu-action'] = 'open';
  } else {
    ___arguments.context.pageData['mobile-menu-action'] = 'close';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/d88814b596863fe889d5be0accfea2e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'mobile-menu-action')) == 'open' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/9447ac2a6434312fa91405ec03d930c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') ? false : ((typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') && (await Backendless.UserService.isValidLogin()) ? true : (!(getObjectProperty(___arguments.context.pageData, 'isTeacher')) && (await Backendless.UserService.isValidLogin()) ? true : (!(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/f313f7adfa11d43ddc8171f51b3e2bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, selectedList, InterestsList, interestAdded, j, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89d43d6d9fed15843bd8c44d4f7954ac', false);
    interestAdded = false;
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) === null)) {
      InterestsList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests'));
      selectedList = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')).map(async item => {; return ({ [`interest`]: item });})));
      for (var j_index in selectedList) {
        j = selectedList[j_index];
        if ((getObjectProperty(j, 'interest')) == ___arguments.value) {
          interestAdded = true;
          break;
        }
      }
    } else {
      InterestsList = [];
      selectedList = [];
    }
    if (interestAdded) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89d43d6d9fed15843bd8c44d4f7954ac', true);
    } else {
      addItemToList(InterestsList, ___arguments.value);
      addItemToList(selectedList, ({ [`interest`]: ___arguments.value }));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['interests'] = InterestsList;
      ___arguments.context.pageData['ListForInterests'] = selectedList;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89d43d6d9fed15843bd8c44d4f7954ac', false);
    }

  } catch (error) {
    console.log(error);
    console.log(getObjectProperty(error, 'message'));

  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS/components/257cdf3168d77145439adb339c2e01b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var StudentInfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/57c6c1c4dcb252b2856929345a4bb118/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, list, selectedList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    list = (getObjectProperty(___arguments.context.pageData, 'ListForInterests'));
    selectedList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2abd08dd5b943bfad744cbd9fc7e6423'), 'interest'));
    ___arguments.context.pageData['ListForInterests'] = (removeItemInList(list, ({ [`interest`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2abd08dd5b943bfad744cbd9fc7e6423'), 'interest')) }), 'interest'));

  } catch (error) {
    console.log(error);
    console.log(getObjectProperty(error, 'message'));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/2abd08dd5b943bfad744cbd9fc7e6423/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, newList, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled'))) {
      list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests'));
      newList = [];
      for (var j_index in list) {
        j = list[j_index];
        if (j != (getObjectProperty(___arguments.context.dataModel, 'interest'))) {
          addItemToList(newList, j);
        }
      }
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['interests'] = newList;
    }

  } catch (error) {
    console.log(error);
    console.log(getObjectProperty(error, 'message'));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/23b5c10d1c55c494a8784877d5f8e9be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')).length || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')).length == 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/54f35a855e3ea1762ad5c26b393d1016/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam, url;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    urlParam = ({  });
    url = '';
    if ((getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin' || !(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
      url = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Student' }) }));
      urlParam['lead_id'] = (getObjectProperty(___arguments.context.pageData, 'lead_id'));
      urlParam['student_name'] = (getObjectProperty(___arguments.context.pageData, 'student_name'));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
        urlParam['fromParentOTP'] = true;
      }
    } else {
      url = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Teacher' }) }));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
        urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
        urlParam['fromAP'] = true;
        urlParam['fromDashboard'] = true;
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
        urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
        urlParam['fromSA'] = true;
        urlParam['fromDashboard'] = true;
      }
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(url, false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS').debug((String('Problem occurs in breadcrumbs | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/b9f59319cecac1483756e8c466a43749/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'jomar.balanag@brilliantmicroschool.org' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/68f73f9a356258d315a67a1e5366d803/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) === null) ? (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')).map(async item => {; return ({ [`interest`]: item });}))) : null)

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS/components/f435063776a9a3282ed4e31be579d54d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/MS_Pages/index.html?page=Parent_Mapping', true, ({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`fromSIS`]: true }));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/7131f6ea11feab8c2071c4584c3ba106/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, StudentDIR, j, StudentInfo, Checker, TempList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (___arguments.value != '') {
    TempList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['student_name = \'',___arguments.value,'','','\' and slots.status = \'enrolled\''].join(''))).setRelated('slots').setRelationsPageSize(100).setPageSize(100)));
    StudentDIR = [];
    Checker = [];
    for (var j_index in TempList) {
      j = TempList[j_index];
      if (!(Checker.includes((getObjectProperty(j, 'objectId'))))) {
        addItemToList(Checker, (getObjectProperty(j, 'objectId')));
        if ((getObjectProperty(j, 'parent_name')).indexOf('TestPeterLive') !== -1) {
          StudentInfo = (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(j, 'lead_id')),'studentDirObject': j,'process': 'decrypt' }));
          addItemToList(StudentDIR, StudentInfo);
        } else {
          addItemToList(StudentDIR, j);
        }
      }
    }
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['SearchByStudentResults'] = StudentDIR;
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['SearchByStudentOptions'] = (await Promise.all((await asyncListSort(StudentDIR, -1, async (item) => {


     return ___arguments.value;
    })).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'parent_name')),' | ',(getObjectProperty(item, 'student_name'))].join(''),[`value`]: (getObjectProperty(item, 'objectId')) });})));
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['SearchByStudentLabel'] = 'Choose a parent/student';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/761cbf4754ffc963b15a5945f84ff335/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var FiltereResults, item, StudentInfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  console.log(___arguments.value);
  FiltereResults = (await asyncListFind((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd'), 'SearchByStudentResults')), async (item) => {


   return (___arguments.value == (getObjectProperty(item, 'objectId')));
  }));
  FiltereResults['firstDay'] = (((getObjectProperty((await asyncListFind((getObjectProperty(FiltereResults, 'slots')), async (item) => {


   return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
  })), 'firstDay')) === null) || ((await asyncListFind((getObjectProperty(FiltereResults, 'slots')), async (item) => {


   return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
  })) === null) ? null : (new Date((getObjectProperty((await asyncListFind((getObjectProperty(FiltereResults, 'slots')), async (item) => {


   return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
  })), 'firstDay')))));
  ___arguments.context.pageData['StudentInfo'] = FiltereResults;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/2d46b26422e34d17d26a9d36f3928611/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, studentContact, result, changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`onBreak`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) });
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) && ___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['onBreak'] = true;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) && !___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['onBreak'] = false;
  }
  if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`onBreak`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
    return null;
  }
  changed_fields = [];
  oldData = ({  });
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
  }
  try {
    var j_list = (Object.keys(({ [`onBreak`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    result = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`onBreak`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) })));
    studentContact = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(result, 'lead_id')),'\' and student_name=\'',(getObjectProperty(result, 'student_name')),'\' and status = \'enrolled\' and slot_slug like \'%MS_%\''].join(''))).setPageSize(10)))[0];
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseContactUpdateByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`contact_id`]: (getObjectProperty(studentContact, 'contact_id')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) ? 'MS_Break_Not_Attending' : (getObjectProperty(studentContact, 'subject')) })));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['onBreak'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentInfo')), 'onBreak'));

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/SIS/components/fc7c521bea53065c0b821b7e1813bc85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.UserService.isValidLogin()) && !(typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') && !(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') || (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) && true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/1029879d048337ffa6c13b4c72112e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'firstDay')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'firstDay')) === null) ? '' : (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'firstDay')).getTime() + (14400 * 1000))))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/SIS/components/fd634705c423823d4219cbc2b107a3b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin' && (getObjectProperty(___arguments.context.pageData, 'SSO')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/e77c626f2c1566618d951dc52d82f96c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    urlParam = ({  });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['fromAP'] = true;
      urlParam['fromDashboard'] = true;
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['fromDashboard'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/8908bd23ca3ef3f9f9995e4977ea8daf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS').debug((String('Problem with Back To Admin button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/134243c585479f580c316e73dc34e2b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Parent' }) })), false, ({ [`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').debug((String('Problem encountered in clicking Back to Student List | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/ae65ab9a5d8e8dc50914270aadc3483a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  display = true;
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'SSO')) === 'undefined')) {
    display = false;
  }
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined')) {
    display = false;
  }
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'undefined') || (getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin') {
    display = false;
  }
  if (await Backendless.UserService.isValidLogin()) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'access_level')) != 'Core Administrator') {
      display = false;
    } else {
      display = true;
    }
  } else {
    display = false;
  }

  return display

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/af9a3f33d7f8238f1368cc3b55228c3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS/components/836f64b7118bcd3ea80cea8a250488f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, RegFormTaskObject, item, UpdateDIR, TaskCreated, ContactUpdated, updateFile, date_scheduled, LeadfromDB, accessTokenString, copyFile, accessTokenObject, date, UpdateStudentDIR, ExistStudentDir, StudentNumber, GoogleAccount, Note, j, TeacherLead, AssistantTeacherLead, HouseLeaderDB, datescheduled, studentBMSPassword, slot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  try {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('acf20b0c97535768641d432c511e3e99')), 'display')) || false) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), (['Prefer online only approach',',',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool'))].join('')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
      LeadfromDB = (await asyncListFilter((await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'slots')), 1, async (item) => {


       return (getObjectProperty(item, 'created'));
      })), async (item) => {


       return (((getObjectProperty(item, 'subject')).indexOf('MS_') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      }))[0];
      TeacherLead = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',((getObjectProperty(LeadfromDB, 'tutor')).replace((new RegExp('\'', '')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
      if (!((getObjectProperty(LeadfromDB, 'assistant_teacher')) === null)) {
        AssistantTeacherLead = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(LeadfromDB, 'assistant_teacher')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
      }
      slot = (getObjectProperty(LeadfromDB, 'slots_sort'));
      if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')))) {
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyslexia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyslexia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dysgraphia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dysgraphia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyscalculia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyscalculia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ADHD'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('ADHD')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['auditory_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Auditory processing disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['language_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Language processing disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['nonverbal_learning_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Nonverbal learning disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['visual_perceptual_or_visual_motor_defecit'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Visual perceptual/visual motor deficit')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['austism_spectrum_discorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Autism spectrum disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['asperger'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Asperger’s')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['anxiety'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Anxiety')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['depression'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Depression')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavioral_issues'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Behavioral issues')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_behavioral_challenges'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')) : '');
      }
      var j_list = ['ShowGuardianHovered', 'ShowLearningBehavioral', 'ShowPTOHovered', 'ShowSubmitStepupHover', 'uploadTranscriptHover', 'DontShowLearningBehavioral', 'DontShowPTOHovered', 'DontShowSubmitStepupHover', 'dontUploadTranscriptHover', 'requiredList', 'chargebeeID', 'DontShowIEPHover', 'grade', 'ethnicityValue', 'genderValue', 'secondary_guardian_show', 'ShowIEPHover', 'ToSParentName', 'PercentCompleted', 'NotCompletedFields', '1disabled', '2disabled', '1.5disabled', '1.6disabled', '3disabled', '4disabled', '5disabled', '6disabled', '6.1disabled', '7disabled', '8disabled', '8.1disabled', '8.2disabled', '9disabled', 'ExemptionShow', 'ItemHoveredPTO', 'behavior', 'IEPDocs', 'learningList', 'CTE', 'English', 'FineArts', 'ItemHoveredBehavior', 'ItemHoveredCTE', 'ItemHoveredConfirming', 'ItemHoveredElectives', 'ItemHoveredEnglish', 'ItemHoveredExemption', 'ItemHoveredFineArts', 'ItemHoveredMath', 'ItemHoveredNoCourses', 'ItemHoveredPEH', 'ItemHoveredPending', 'ItemHoveredScience', 'ItemHoveredSocStud', 'ItemHoveredWorldLang', 'Math', 'PE&Health', 'Science', 'ShowPTOQuestions', 'SocialStudies', 'WorldLanguage', 'birthCertMetaData', 'honorCodeParentName', 'honorCodeStudentName', 'pdfURL', 'studentPicMetaData'];
      for (var j_index in j_list) {
        j = j_list[j_index];
        delete ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')[j];
      }
      datescheduled = (new Date((new Date()).getTime() + (600 * 1000)));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) == 'Alabama') {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': 'Alabama family: difficult homeschool paperwork, review with Andreas','date': datescheduled,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });

        })();
        await new Promise(r => setTimeout(r, 100 || 0));
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) != 'Florida' && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')) == 'lead_9TrJ83ZxlCn8w8AlSTHirJ29rA3LWCxZDOiP31NgZFI' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')) == 'lead_vq5GIEbFlmZ8TwcWgnOPMnmsc387WfjFBQFx83W971z' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')) == 'lead_rM3I5bguDqDJ1Cl8g3pE6Qct2PwyHZcdOW9c5i4bYf8')) {
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SendStateRequirement`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) })));
      }
      await new Promise(r => setTimeout(r, 100 || 0));
      console.log('Create Google Account');
      studentBMSPassword = [(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendReplaceDiacriticsWithRegularLetters`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`text`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')).split(' ')[0] })))),'BMS',(getObjectProperty(LeadfromDB, 'contact_id')).slice(4, 11)].join('');
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/CreateGoogleAccountStudents`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`fullname`]: (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendReplaceDiacriticsWithRegularLetters`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`text`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')).split(' ')[0],' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')).split(' ')[0]].join('').trim() })))),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`display_name`]: (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendReplaceDiacriticsWithRegularLetters`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`text`]: (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) === null) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name'))).trim() })))),[`contact_id`]: (generateUUID().short()),[`type`]: 'student',[`password`]: studentBMSPassword,[`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`student_dir_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`contact_id`]: (getObjectProperty(LeadfromDB, 'contact_id')) })));
      await new Promise(r => setTimeout(r, 250 || 0));
      date_scheduled = (new Date((new Date()).getTime() + (600 * 1000)));
      console.log('Generate Student ID Number here');
      if (true) {
        StudentNumber = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICreateStudentNumber`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) }))));
        if (!(getObjectProperty(StudentNumber, 'processComplete'))) {
          console.log('Student ID Num failure');
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`note`]: String('#Student ID Number Generator Failure#') + String(' Please contact Dev Team for assistance.') })));
        } else {
          console.log('Student ID Num Success');
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`note`]: String('Student ID Number Generated Success: ') + String(getObjectProperty(StudentNumber, 'StudentIDNumber')) })));
          await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_id_number`]: (getObjectProperty(StudentNumber, 'StudentIDNumber')) }) );
        }
      }
      await new Promise(r => setTimeout(r, 100 || 0));
      HouseLeaderDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and opp_status=\'enrolled\' and name=\'',(getObjectProperty(TeacherLead, 'house_leader')),'\''].join(''))).setPageSize(10)))[0];
      console.log(HouseLeaderDB);
      ;(async () => {
          console.log('Email CC to Tutor and HouseLeader');
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontent_v2`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`status`]: 'scheduled',[`date_scheduled`]: date_scheduled,[`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`sender_name`]: undefined,[`sender_email`]: 'notifications@brilliantgrades.com',[`to`]: ((getObjectProperty(TeacherLead, 'MS_teacher_email')) === null) ? ((AssistantTeacherLead !== null && !Array.isArray(AssistantTeacherLead) && (typeof AssistantTeacherLead === 'object')) ? [(getObjectProperty(TeacherLead, 'email')), (getObjectProperty(AssistantTeacherLead, 'email'))] : (getObjectProperty(TeacherLead, 'email'))) : ((AssistantTeacherLead !== null && !Array.isArray(AssistantTeacherLead) && (typeof AssistantTeacherLead === 'object')) ? [(getObjectProperty(TeacherLead, 'MS_teacher_email')), (getObjectProperty(AssistantTeacherLead, 'MS_teacher_email'))] : (getObjectProperty(TeacherLead, 'MS_teacher_email'))),[`cc`]: (typeof (getObjectProperty(HouseLeaderDB, 'MS_teacher_email')) === 'undefined') ? null : (getObjectProperty(HouseLeaderDB, 'MS_teacher_email')),[`body`]: ['Dear ',(getObjectProperty(LeadfromDB, 'tutor')).split(' ')[0],',<br><br>','Your student, ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),', has completed the Microschool Registration Form.','<br>You can login <a href = \'https://portal.brilliantgrades.com/Clever/?page=Main_Page\'>here</a>',' with your Brilliant Microschool email to access the Student Information System page.','<br>Select the class where the student is enrolled in the Classroom dropdown and select the student\'s name in the Student dropdown to access the student\'s information. '].join(''),[`subject`]: 'Your student has completed the Microschool Registration Form' })));

      })();
      if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I can upload them' || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) === null)) && (getObjectProperty(___arguments.context.pageData, 'lead_id')) == 'lead_rM3I5bguDqDJ1Cl8g3pE6Qct2PwyHZcdOW9c5i4bYf8') {
        ;(async () => {
            console.log('Transcript Email');
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontent_v2`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`status`]: 'scheduled',[`date_scheduled`]: date_scheduled,[`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`sender_name`]: undefined,[`sender_email`]: 'help@brilliantmicroschool.org',[`to`]: (getObjectProperty(LeadfromDB, 'email')),[`cc`]: undefined,[`body`]: ['Hi ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),',<br><br>','We would like to request a copy of ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s previous transcripts or school records.','<br>Having comprehensive and up-to-date records is crucial for us to provide the best possible educational support to our students.','<br><br> It is crucial that we promptly receive transcripts from all prior high schools attended to assess eligibility for graduation. ','<br><br> Immediate attention is required to address any credit deficiencies and establish a plan for students to fulfill these requirements before the term concludes. ','<br><br> Delays in transcript submission may jeopardize the graduation prospects for the students. At your earliest convenience, could you please use this email thread to attach and send any of your child\'s prior high school transcripts? ','<br><br> We understand and appreciate the importance of maintaining the confidentiality of student records, and we assure you that the information will be handled with the utmost care and in accordance with privacy regulations. ','<br><br> We’ve provided an instructional video to guide you through the process of uploading transcripts or school records, which you can access here: <a href = \'https://www.loom.com/share/8391e66c09f04bbcbfef9c54226eec9a?sid=d2b83dd3-03e3-423d-b2af-dab885074803\'>Click here</a>','<br><br>Thank you very much for your prompt attention to this matter.  ','<br>We sincerely appreciate your cooperation and assistance in this process. ','<br><br> Best regards,'].join(''),[`subject`]: ['Action Required: Please Upload Your ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s Previous Transcript or School Records'].join('') })));

        })();
      }
      await new Promise(r => setTimeout(r, 100 || 0));
      console.log('close note to lead');
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`note`]: String('Microschool Registration Form forwarded to ') + String(getObjectProperty(LeadfromDB, 'tutor')) })));

      })();
      await new Promise(r => setTimeout(r, 100 || 0));
      Note = ['Registration form for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' has been completed!'].join('');
      var j_list2 = (getObjectProperty(___arguments.context.pageData, 'ListForNote'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        Note = String(Note) + String(String('\n\n') + String(j.replace((new RegExp(',', '')), '\n')));
      }
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`note`]: Note })));

      })();
      await new Promise(r => setTimeout(r, 100 || 0));
      console.log('update student name');
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['student_name'] = (getObjectProperty(LeadfromDB, 'student_name'));
      console.log('update student dir');
      console.log(['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\' and student_name=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\''].join(''));
      ExistStudentDir = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\' and student_name=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\''].join(''))).setPageSize(10)))[0];
      console.log('Update Student Dir');
      if (ExistStudentDir !== null && !Array.isArray(ExistStudentDir) && (typeof ExistStudentDir === 'object')) {
        UpdateStudentDIR = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/ms_student_dir')).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c048b5d25c10865a63206ccb82f056b', true);
        console.log('Update Student Dir');
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I prefer you source them from the school ($50 processing fee)') {
          date = (new Date());
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': (['Collect ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s Records ($50 fee)'].join('')),'date': date,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
        }
        await new Promise(r => setTimeout(r, 100 || 0));
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/sendSlackMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`channelId`]: 'C08VCBX4DKM',[`message`]: ['New Microschool Onboarding Form Submitted','--\n','Student name:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\nSubject:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'subjects')),'\n\n','Lead:','https://app.close.com/lead/',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'/'].join(''),[`userName`]: 'BMS Registration Form ',[`bot_icon`]: ':school_satchel:' })));

        })();
        RegFormTaskObject = (await asyncListFind((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseGetAllTasksByLeadID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')) })))), async (item) => {


         return (((getObjectProperty(item, 'text')).indexOf('MS: Check if Registration Form Completed') !== -1) && !(getObjectProperty(item, 'is_completed')));
        }));
        if (RegFormTaskObject !== null && !Array.isArray(RegFormTaskObject) && (typeof RegFormTaskObject === 'object')) {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseCompleteTaskByTaskID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(RegFormTaskObject, 'id'))));
        }
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      }
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', true);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Submit Button').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, UpdateDIR, TaskCreated, ContactUpdated, updateFile, date_scheduled, LeadfromDB, accessTokenString, copyFile, accessTokenObject, date, UpdateStudentDIR, GoogleAccount, Note, j, TeacherLead, AssistantTeacherLead, HouseLeaderDB, datescheduled, item, slot;



  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/acf20b0c97535768641d432c511e3e99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((!(await Backendless.UserService.isValidLogin()) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && true || !(typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/a13548b8d18e8ea91396a05fe99564a4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.UserService.isValidLogin()) && !((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && (((function () { return window.location.href })()).indexOf('student_name') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/df79905d72b865e826b844e8d3ac63f3/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Inattention/poor focus', 'Impulsivity/hyperactivity', 'Disorganization', 'Frustration/overwhelm', 'Mood swings/emotional disregulation', 'Anxiety/fear', 'Social withdrawal/shyness', 'Emotional outbursts', 'Difficulty transitioning', 'Defiance', 'Low perseverance', 'Forgetfulness', 'Perfectionism']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS/components/4fdd14c399431cb87cc8a8ccabcb2968/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
      return null;
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredBehavior'] = ___arguments.context.dataModel;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
      return null;
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredBehavior'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
      return null;
    }
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37b6d8866f3769068be8e65e52e64c3e')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
      if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).length) {
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavior'] = [___arguments.context.dataModel];
      } else {
        addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')), ___arguments.context.dataModel);
      }
    } else {
      removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')), ___arguments.context.dataModel, '');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS/components/ed9827b835b154e80a45a477f4582ef8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('4fdd14c399431cb87cc8a8ccabcb2968')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS/components/cca9ce982dc89818c6b31458caf82a78/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Inattention/poor focus', 'Impulsivity/hyperactivity', 'Disorganization', 'Frustration/overwhelm', 'Mood swings/emotional disregulation', 'Anxiety/fear', 'Social withdrawal/shyness', 'Emotional outbursts', 'Difficulty transitioning', 'Defiance', 'Low perseverance', 'Forgetfulness', 'Perfectionism']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS/components/e49de9a82db8bc5222e11dc8d398f758/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return ___arguments.context.dataModel

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(___arguments.value);
  console.log(((___arguments.context.dataModel.replace((new RegExp(' ', 'g')), '_')).replace((new RegExp('/', 'g')), '_')).toLowerCase());
  console.log(___arguments.context.dataModel);
  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')[(((___arguments.context.dataModel.replace((new RegExp(' ', 'g')), '_')).replace((new RegExp('/', 'g')), '_')).toLowerCase())] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')[(((___arguments.context.dataModel.replace((new RegExp(' ', 'g')), '_')).replace((new RegExp('/', 'g')), '_')).toLowerCase())] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS/components/7e38345c8148801868fd919f7c489634/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, parent_map, masked_location, geocode, Object2, j, changed_fields, oldData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('136cec68498f0b88c8960e58e2a82411')), 'content')).indexOf('Edit') !== -1) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1disabled'] = false;
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) });
    } else {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1disabled'] = true;
      if (true) {
        if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
          return null;
        }
        changed_fields = [];
        oldData = ({  });
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
          ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
        }
        var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) })));
        for (var j_index in j_list) {
          j = j_list[j_index];
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
            addItemToList(changed_fields, j);
            oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
          }
        }
        addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
        console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/CheckFNameSimilar_SIS`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`contact_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'contact_id')),[`new_fname`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) })));
        await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
        if ((!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) === null) || !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) === 'undefined')) && (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) || !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === 'undefined'))) {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGoogleUpdateUserDisplayNameByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')),'displayName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) });
        }
      }
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS/components/136cec68498f0b88c8960e58e2a82411/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var pageTitle, TeacherDB, item, ObjectList, offset, _unused, TeacherID, StudentDIRData, StudentInfo, percentCompleted, NotCompletedFields, lengthCompetedFields, StateRegObject, RegFormCompleteTask, StudentMap, j, Checker, TempList, UserData, tutorData, User, DriveTokenObject, Parameter, ParameterList, UTMValue, UTMName, AnsweredQuestion, Parameters, URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('257cdf3168d77145439adb339c2e01b4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
  URL2 = 'https://portal.brilliantgrades.com/Clever/?page=SIS_v2&from=ParentOTPLogin&lead_id=lead_9TrJ83ZxlCn8w8AlSTHirJ29rA3LWCxZDOiP31NgZFI&student_name=Yzabella';
  Backendless.Logging.getLogger('SIS Login - URL').debug(URL2);
  pageTitle = 'Student Information';
  if (URL2.indexOf('#') !== -1) {
    Parameters = URL2.slice(((URL2.indexOf('#') + 1 + 1) - 1), URL2.length);
    ParameterList = (await Promise.all((Parameters.split('&')).map(async AnsweredQuestion => {  UTMName = AnsweredQuestion.slice(0, (AnsweredQuestion.indexOf('=') + 1) - 1);
      UTMValue = AnsweredQuestion.slice(((AnsweredQuestion.indexOf('=') + 1 + 1) - 1), AnsweredQuestion.length);
    ; return ({ [`utmName`]: UTMName,[`utmValue`]: UTMValue });})));
    for (var Parameter_index in ParameterList) {
      Parameter = ParameterList[Parameter_index];
      ___arguments.context.pageData[(getObjectProperty(Parameter, 'utmName'))] = (getObjectProperty(Parameter, 'utmValue'));
    }
  }
  DriveTokenObject = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause('api = \'googleDrive\'').setPageSize(1)))[0];
  ___arguments.context.pageData['DriveTokenObject'] = DriveTokenObject;
  ___arguments.context.pageData['sectionClicked'] = 'studentInfo';
  console.log('Valid session?');
  console.log(await Backendless.UserService.isValidLogin());
  if (!(await Backendless.UserService.isValidLogin()) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined')) {
    console.log('parent view not logged in');
    console.log(['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''));
    TempList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''))).setRelated('slots').setRelationsDepth(2).setRelationsPageSize(100).setPageSize(100)));
    StudentDIRData = [];
    Checker = [];
    for (var j_index in TempList) {
      j = TempList[j_index];
      if (!(Checker.includes((getObjectProperty(j, 'objectId'))))) {
        addItemToList(Checker, (getObjectProperty(j, 'objectId')));
        addItemToList(StudentDIRData, j);
      }
    }
    ___arguments.context.pageData['StudentSelectionOptions'] = (await Promise.all(StudentDIRData.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'student_name')) });})));
    ___arguments.context.pageData['userType'] = 'Parent';
    ___arguments.context.pageData['student_name'] = (getObjectProperty((StudentDIRData[0]), 'student_name'));
    ___arguments.context.pageData['StudentDIRParent'] = StudentDIRData;
  } else if ((await Backendless.UserService.isValidLogin()) && ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1) && (typeof (getObjectProperty(___arguments.context.pageData, 'SSO')) === 'undefined')) {
    console.log('student view');
    console.log(await Backendless.UserService.getCurrentUser(false));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'ilya.test@bms.family' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'arabella.test@bms.family') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('parent_student_sso', undefined);
    } else {
      UserData = ({ [`access_level`]: 'Student' });
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': UserData })), false, ({ [`fromMainPortal`]: true }));
    }
  } else if ((await Backendless.UserService.isValidLogin()) && (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string') || (typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'string') || !(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
    console.log('parent view');
    console.log(['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''));
    pageTitle = String(getObjectProperty(___arguments.context.pageData, 'student_name')) + String('\'s Information');
    TempList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id = \'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name not like \'%[delete]%\' and slots.status = \'enrolled\''].join(''))).setRelated('slots').setRelationsDepth(2).setRelationsPageSize(100).setPageSize(100)));
    StudentDIRData = [];
    Checker = [];
    for (var j_index2 in TempList) {
      j = TempList[j_index2];
      if (!(Checker.includes((getObjectProperty(j, 'objectId'))))) {
        addItemToList(Checker, (getObjectProperty(j, 'objectId')));
        addItemToList(StudentDIRData, j);
      }
    }
    ___arguments.context.pageData['StudentSelectionOptions'] = (await Promise.all(StudentDIRData.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'student_name')) });})));
    if (typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string') {
      console.log(getObjectProperty(___arguments.context.pageData, 'StudentSelectionOptions'));
      ___arguments.context.pageData['student_name'] = (decodeURIComponent((getObjectProperty(___arguments.context.pageData, 'student_name'))));
      ___arguments.context.pageData['StudentSelectionLabel'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'StudentSelectionOptions')), async (item) => {


       return ((getObjectProperty(___arguments.context.pageData, 'student_name')).toUpperCase() == (getObjectProperty(item, 'label')).toUpperCase());
      }))[0]), 'label'));
      StudentInfo = (await asyncListFilter(StudentDIRData, async (item) => {


       return ((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'StudentSelectionOptions')), async (item) => {


       return ((getObjectProperty(___arguments.context.pageData, 'student_name')).toUpperCase() == (getObjectProperty(item, 'label')).toUpperCase());
      }))[0]), 'value')) == (getObjectProperty(item, 'objectId')));
      }))[0];
      if (!(typeof StudentInfo === 'undefined')) {
        console.log(StudentInfo);
        RegFormCompleteTask = !((getObjectProperty(StudentInfo, 'student_last_name')) === null);
        ___arguments.context.pageData['isSubmitted'] = RegFormCompleteTask;
        StudentInfo['ethnicityValue'] = ((getObjectProperty(StudentInfo, 'African_American')) ? 'African-American' : ((getObjectProperty(StudentInfo, 'Asian')) ? 'Asian' : ((getObjectProperty(StudentInfo, 'Caucasian')) ? 'Caucasian' : ((getObjectProperty(StudentInfo, 'Latino_Hispanic')) ? 'Latino or Hispanic' : ((getObjectProperty(StudentInfo, 'Native_American')) ? 'Native American' : ((getObjectProperty(StudentInfo, 'Native_Hawaiian')) ? 'Native Hawaiian' : ((getObjectProperty(StudentInfo, 'other_unknown_ethnicity')) ? 'Other/Unknown' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_ethnicity')) ? 'Prefer not to say' : null))))))));
        StudentInfo['genderValue'] = ((getObjectProperty(StudentInfo, 'female')) ? 'Female' : ((getObjectProperty(StudentInfo, 'male')) ? 'Male' : ((getObjectProperty(StudentInfo, 'transgender')) ? 'Transgender' : ((getObjectProperty(StudentInfo, 'gender_variant_non_conforming')) ? 'Gender Variant/Non-Conforming' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_gender')) ? 'Prefer not to say' : (!((getObjectProperty(StudentInfo, 'other_gender')) === null) ? (getObjectProperty(StudentInfo, 'other_gender')) : null))))));
        StudentInfo['slots'] = (await Backendless.Data.of('ms_student_dir').loadRelations((getObjectProperty(StudentInfo, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('slots').setPageSize(100).setOffset(0)));
        if (!((getObjectProperty(StudentInfo, 'home_state')) === null)) {
          StateRegObject = (await Backendless.Data.of('state_regs').find(Backendless.DataQueryBuilder.create().setWhereClause((['State_Name = \'',(getObjectProperty(StudentInfo, 'home_state')),'\''].join(''))).setPageSize(10)))[0];
          ___arguments.context.pageData['StateRegObject'] = StateRegObject;
        }
        if (true) {
          StudentInfo['behavior'] = [];
          if (getObjectProperty(StudentInfo, 'Dyslexia')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyslexia');
          }
          if (getObjectProperty(StudentInfo, 'Dysgraphia')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dysgraphia');
          }
          if (getObjectProperty(StudentInfo, 'Dyscalculia')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyscalculia');
          }
          if (getObjectProperty(StudentInfo, 'ADHD')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'ADHD');
          }
          if (getObjectProperty(StudentInfo, 'auditory_processing_disorder')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Auditory processing disorder');
          }
          if (getObjectProperty(StudentInfo, 'language_processing_disorder')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Language processing disorder');
          }
          if (getObjectProperty(StudentInfo, 'nonverbal_learning_disorder')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Nonverbal learning disorder');
          }
          if (getObjectProperty(StudentInfo, 'visual_perceptual_or_visual_motor_defecit')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Visual perceptual/visual motor deficit');
          }
          if (getObjectProperty(StudentInfo, 'austism_spectrum_discorder')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Autism spectrum disorder');
          }
          if (getObjectProperty(StudentInfo, 'asperger')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Asperger’s');
          }
          if (getObjectProperty(StudentInfo, 'anxiety')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Anxiety');
          }
          if (getObjectProperty(StudentInfo, 'depression')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Depression');
          }
          if (getObjectProperty(StudentInfo, 'behavioral_issues')) {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Behavioral issues');
          }
          if ((typeof (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) === 'string') && (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) != '') {
            addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Other');
          }
        }
        if (!((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')) === null)) {
          StudentInfo['learningList'] = (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')), (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
        }
        if (!((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')) === null)) {
          StudentInfo['IEPDocs'] = (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')), (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
        }
        StudentInfo['secondary_guardian_show'] = (!((getObjectProperty(StudentInfo, 'secondary_guardian')) === null));
        StudentInfo['ShowPTOQuestions'] = (!((getObjectProperty(StudentInfo, 'PTO')) === null));
        StudentInfo['honorCodeStudentName'] = (getObjectProperty(StudentInfo, 'student_name'));
        StudentInfo['honorCodeParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
        StudentInfo['ToSParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
        if ((getObjectProperty(StudentInfo, 'CallNotes')) === null) {
          StudentInfo['CallNotes'] = [];
        }
        if ((getObjectProperty(StudentInfo, 'teacherNotes')) === null) {
          StudentInfo['teacherNotes'] = [];
        }
        if ((getObjectProperty(StudentInfo, 'PSNotes')) === null) {
          StudentInfo['PSNotes'] = [];
        }
        if (!(getObjectProperty(StudentInfo, 'transferCredit'))) {
          StudentInfo['CreditTransfer'] = [];
        }
        StudentInfo['English'] = ['English 1', 'English 2', 'English 3', 'English 4'];
        StudentInfo['Math'] = ['Pre-Algebra', 'Algebra 1', 'Algebra 2', 'Geometry', 'Pre-Calculus', 'Calculus', 'Statistics', 'Integrated Math 1', 'Integrated Math 2', 'Integrated Math 3'];
        StudentInfo['SocialStudies'] = ['World History', 'Global Studies', 'U.S. History', 'U.S. Government', 'Economics', 'Geography', 'Psychology', 'Sociology'];
        StudentInfo['Science'] = ['Biology', 'Chemistry', 'Physics', 'Environmental Science', 'Anatomy and Physiology'];
        StudentInfo['PE&Health'] = ['Physical Education', 'Health Education'];
        StudentInfo['WorldLanguage'] = ['Spanish', 'French', 'German', 'Chinese'];
        StudentInfo['FineArts'] = ['Band', 'Orchestra', 'Choir', 'Theatre Arts/Drama', 'Visual Arts', 'Digital Design', 'Photography'];
        StudentInfo['CTE'] = ['Computer Science', 'Business and Marketing', 'Health Sciences', 'Culinary Arts', 'Automotive Technology', 'Agriculture Sciences', 'Audio/Video Production', 'Creative Writing', 'Journalism', 'Debate'];
        StudentInfo['grade'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


         return (((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1) || ((getObjectProperty(item, 'status')).indexOf('churn') !== -1));
        }))[0]), 'grade'));
        StudentInfo['chargebeeID'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


         return (((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1) || ((getObjectProperty(item, 'status')).indexOf('churn') !== -1));
        }))[0]), 'chargebee'));
        if (typeof (getObjectProperty(StudentInfo, 'studentMSEmail')) === 'string') {
          StudentInfo['1disabled'] = true;
          StudentInfo['1.5disabled'] = true;
          StudentInfo['1.6disabled'] = true;
          StudentInfo['2disabled'] = true;
          StudentInfo['3disabled'] = true;
          StudentInfo['4disabled'] = true;
          StudentInfo['5disabled'] = true;
          StudentInfo['6disabled'] = true;
          StudentInfo['6.1disabled'] = true;
          StudentInfo['7disabled'] = true;
          StudentInfo['8disabled'] = true;
          StudentInfo['8.1disabled'] = true;
          StudentInfo['8.2disabled'] = true;
          StudentInfo['9disabled'] = true;
        }
        StudentInfo['requiredList'] = ['Ethnicity', 'student_name', 'student_last_name', 'student_birth_date', 'most_interested_in', 'behavior', 'parent_address', 'email', 'parent_phone', 'parent_name', 'parent_last_name', 'science_grade_level', 'ela_grade_level', 'math_grade_level', 'learning_environment_past_12_months', 'learning_experiece_past_12_months', 'upload_copy_EIP_504_plan', 'CreditTransfer', 'home_state', 'honorCodeSigned'];
        NotCompletedFields = (await asyncListFilter((getObjectProperty(StudentInfo, 'requiredList')), async (item) => {


         return ((item.indexOf('behavior') !== -1) && (getObjectProperty(StudentInfo, 'learning_or_behavioral_challenges')) != false && !(getObjectProperty(StudentInfo, item)).length || (item.indexOf('CreditTransfer') !== -1) && (getObjectProperty(StudentInfo, 'transferCredit')) && !((getObjectProperty(StudentInfo, 'grade')).indexOf('Kindergarten') !== -1) && (((getObjectProperty(StudentInfo, item)) === null) || !(getObjectProperty(StudentInfo, item)).length) || (item.indexOf('upload_copy_EIP_504_plan') !== -1) && (getObjectProperty(StudentInfo, 'IEP_or_504_plan')) != false && ((getObjectProperty(StudentInfo, item)) === null) || (item.indexOf('Ethnicity') !== -1) && ((getObjectProperty(StudentInfo, 'ethnicityValue')) === null) || (item.indexOf('honorCodeSigned') !== -1) && !(getObjectProperty(StudentInfo, item)) || !(item.indexOf('upload_copy_EIP_504_plan') !== -1) && ((getObjectProperty(StudentInfo, item)) === null));
        }));
        lengthCompetedFields = (getObjectProperty(StudentInfo, 'requiredList')).length - NotCompletedFields.length;
        percentCompleted = (lengthCompetedFields / (getObjectProperty(StudentInfo, 'requiredList')).length) * 100;
        StudentInfo['NotCompletedFields'] = NotCompletedFields;
        StudentInfo['PercentCompleted'] = percentCompleted;
        ___arguments.context.pageData['StudentInfo'] = StudentInfo;
        ___arguments.context.pageData['ShareParentContact'] = (getObjectProperty(StudentInfo, 'share_contact'));
      }
    }
    ___arguments.context.pageData['StudentDIRParent'] = StudentDIRData;
  } else if (!(await Backendless.UserService.isValidLogin()) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'string') || (typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'undefined')) && ((typeof (getObjectProperty(___arguments.context.pageData, 'fromTutorSSO')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) === 'undefined'))) {
    console.log('back to main page');
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(((typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string') ? ['https://portal.brilliantgrades.com/Clever/index.html?#lead_id=',(getObjectProperty(___arguments.context.pageData, 'lead_id')),(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'string') ? ['&student_name=',(getObjectProperty(___arguments.context.pageData, 'student_name')),''].join('') : null].join('') : (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send())), false, undefined);
  } else {
    console.log('admin tutor view');
    console.log(getObjectProperty(___arguments.context.pageData, 'tutorEmail'));
    TeacherDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) || (getObjectProperty(___arguments.context.pageData, 'fromTutorSSO')) ? ['email = \'',(getObjectProperty(___arguments.context.pageData, 'tutorEmail')),'\''].join('') : ['MS_teacher_email = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\''].join(''))).setPageSize(100)))[0];
    if ((TeacherDB !== null && !Array.isArray(TeacherDB) && (typeof TeacherDB === 'object')) && (getObjectProperty(TeacherDB, 'userType')) == 'Teacher') {
      try {
        await Backendless.UserService.login( (getObjectProperty(TeacherDB, 'email')), (getObjectProperty(TeacherDB, 'zoomid')), true  );

      } catch (error) {
        await Backendless.UserService.login( (getObjectProperty(TeacherDB, 'email')), (getObjectProperty(TeacherDB, 'MS_teacher_password')), true  );

      }
      console.log(await Backendless.UserService.getCurrentUser(false));
      pageTitle = String((getObjectProperty(TeacherDB, 'name')).split(' ')[0]) + String('\'s Students Information');
      TeacherID = (await BackendlessUI.Functions.Custom['fn_0df128e4d9c37ba41e7beec18fa5414e']((getObjectProperty(TeacherDB, 'lead_id'))));
      ___arguments.context.pageData['isTeacher'] = ((getObjectProperty(TeacherDB, 'name')) != 'Rachel Gentillon' && (getObjectProperty(TeacherDB, 'name')) != 'Jordan Knoetgen' && (getObjectProperty(TeacherDB, 'name')) != 'Kelly Radigan' && (getObjectProperty(TeacherDB, 'name')) != 'River Lotus' && (getObjectProperty(TeacherDB, 'name')) != 'Deborah Buttridge' && (getObjectProperty(TeacherDB, 'name')) != 'Lori Anderson' && (getObjectProperty(TeacherDB, 'name')) != 'Katie Campos');
    } else {
      ___arguments.context.pageData['isTeacher'] = false;
    }
    ObjectList = [];
    offset = 0;
    var repeat_end = Math.ceil((await Backendless.Data.of('ms_classes').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'isTeacher')) ? ['(teacher = \'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', '')), '\'\'')),'\' or assistant_teacher = \'',TeacherID,'\') and ((Class like \'%MICROSCHOOL%\' OR Class like \'%ELECTIVE%\' OR Class like \'%MS_GROUP%\')) and Class not like \'%MS_BREAK%\''].join('') : 'teacher not like \'TestNicolasTutor Live\' and teacher not like \'JomarTutor live\' and students.lead_id not like \'lead_LxXPvI8zzYVdVWGBqWgtZzHqF40H956TFOd0Rn9cWNr\' and ((Class like \'%MICROSCHOOL%\' OR Class like \'%ELECTIVE%\' OR Class like \'%MS_GROUP%\')) and Class not like \'%MS_BREAK%\'')))) / 100);
    for (var count = 0; count < repeat_end; count++) {
      _unused = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty(___arguments.context.pageData, 'isTeacher')) ? ['(teacher = \'',((getObjectProperty(TeacherDB, 'name')).replace((new RegExp('\'', '')), '\'\'')),'\' or assistant_teacher = \'',TeacherID,'\') and ((Class like \'%MICROSCHOOL%\' OR Class like \'%ELECTIVE%\' OR Class like \'%MS_GROUP%\')) and Class not like \'%MS_BREAK%\''].join('') : 'teacher not like \'TestNicolasTutor Live\' and teacher not like \'JomarTutor live\' and students.lead_id not like \'lead_LxXPvI8zzYVdVWGBqWgtZzHqF40H956TFOd0Rn9cWNr\' and ((Class like \'%MICROSCHOOL%\' OR Class like \'%ELECTIVE%\' OR Class like \'%MS_GROUP%\')) and Class not like \'%MS_BREAK%\'')).setRelated('students').setRelationsPageSize(100).setPageSize(100).setOffset(offset).setDistinct(true)));
      addItemToList(ObjectList, _unused);
      offset = (typeof offset == 'number' ? offset : 0) + 100;
    }
    ___arguments.context.pageData['ClassList'] = (await asyncListFilter(ObjectList, async (item) => {


     return (!((getObjectProperty(item, 'Class')) === null) && !((getObjectProperty(item, 'students')) === null) && !!(await asyncListFilter((getObjectProperty(item, 'students')), async (item) => {


     return ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1);
    })).length && !((getObjectProperty(item, 'Class')).indexOf('MS_BREAK') !== -1));
    }));
    console.log(ObjectList);
    console.log(getObjectProperty(___arguments.context.pageData, 'ClassList'));
    if (true) {
      ___arguments.context.pageData['searchBar'] = ({ [`blank_property`]: undefined });
      (getObjectProperty(___arguments.context.pageData, 'searchBar'))['ClassOptions'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'ClassList')).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join(''),[`value`]: (getObjectProperty(item, 'Class')) });})));
      if (getObjectProperty(___arguments.context.pageData, 'isTeacher')) {
        (getObjectProperty(___arguments.context.pageData, 'searchBar'))['searchInput'] = (getObjectProperty(TeacherDB, 'name'));
        (getObjectProperty(___arguments.context.pageData, 'searchBar'))['searchDisabled'] = true;
      }
      (getObjectProperty(___arguments.context.pageData, 'searchBar'))['ClassLabel'] = 'Choose a classroom';
      (getObjectProperty(___arguments.context.pageData, 'searchBar'))['StudentLabel'] = 'Choose a student';
    }
    ___arguments.context.pageData['TeacherNotes'] = [];
    ___arguments.context.pageData['PSNotes'] = [];
  }
  ___arguments.context.pageData['ListForNote'] = [];
  ___arguments.context.pageData['ListForInterests'] = [];
  ___arguments.context.pageData['interestDropdown'] = [];
  ___arguments.context.pageData['ListForNote'] = [];
  ___arguments.context.pageData['pageTitle'] = pageTitle;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('257cdf3168d77145439adb339c2e01b4', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
  ___arguments.context.pageData['mobile-menu-action'] = 'open';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var leadData, tutorData, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(await Backendless.UserService.getCurrentUser(false));
  if ((await Backendless.UserService.getCurrentUser(false)) === null) {
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'fromTutorSSO')) || (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel'))) {
    tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email=\'',(getObjectProperty(___arguments.context.pageData, 'tutorEmail')),'\' and accountType=\'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
    console.log(tutorData);
    if (!((getObjectProperty(tutorData, 'userType')) === null) && (getObjectProperty(tutorData, 'userType')) != 'Teacher') {
      return null;
    }
    try {
      await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'zoomid')), true  );

    } catch (error) {
      console.log(error);
      await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'ms_teacher_password')), true  );

    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'accountType')) == 'OAUTH' && !((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1)) {
    leadData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and name=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setPageSize(1)))[0];
    if ((getObjectProperty(leadData, 'userType')) == 'Teacher' && (getObjectProperty(leadData, 'name')) == 'TestNicolasTutor Live') {
      if (!(getObjectProperty(___arguments.context.pageData, 'fromTutorSSO'))) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('tutor_sso', undefined);
      }
    }
  }
  await new Promise(r => setTimeout(r, 2000 || 0));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/SIS_v2/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    await Backendless.UserService.logout();
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS').error((String('Error in Navigating back to Dashboard | Error:\n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/851767025f0eaaabf65cb5931f5dfe8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, parent_map, masked_location, geocode, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    console.log(getObjectProperty(___arguments.context.pageData, 'isTeacher'));
    console.log('Check if First Name is present');
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b4974c1ef74876e133355b63bc60e74', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd04334b6225acf734c996bf54a1c467')));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fe6031dbcc353dd3ecc3287da81478c'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fe6031dbcc353dd3ecc3287da81478c'))['border-color'] = 'red';
      return null;
    }
    console.log('Check if Last Name is present');
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b4974c1ef74876e133355b63bc60e74', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd04334b6225acf734c996bf54a1c467')));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e9ae931b3597e12257f3345788f8b45'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e9ae931b3597e12257f3345788f8b45'))['border-color'] = 'red';
      return null;
    }
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      await new Promise(r => setTimeout(r, 50 || 0));
      console.log(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd04334b6225acf734c996bf54a1c467')), 'display'));
      console.log(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e5f314a35c9f002d111bdc870863e4e')), 'display'));
      Object2 = ({ [`Student Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')).trim(),[`Student Last Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')).trim(),[`Student Nick Name`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) === null) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')).trim(),[`Student Birth Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`Gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'genderValue')),[`Ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ethnicityValue')),[`Student Birth Certificate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`Student Picture`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',j == 'Student Birth Date' ? ((new Date((getObjectProperty(Object2, j)))).toDateString()) : (getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',j == 'Student Birth Date' ? ((new Date((getObjectProperty(Object2, j)))).toDateString()) : (getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContact'] = (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) === null) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) : true);
    if ((await Backendless.Data.of('parent_maps').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join(''))))) == 0) {
      geocode = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeChargebeeAddressConversion`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')))));
      masked_location = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeMaskLocation`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat': (Number((getObjectProperty(geocode, 'lat')))),'lon': (Number((getObjectProperty(geocode, 'lon')))) }));
      parent_map = (await Backendless.Data.of('parent_maps').save( ({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`share_contact`]: 'Yes',[`location`]: (new Backendless.Data.Point().setX((getObjectProperty(geocode, 'lon'))).setY((getObjectProperty(geocode, 'lat')))),[`masked_location`]: (new Backendless.Data.Point().setX((getObjectProperty(masked_location, 'lon'))).setY((getObjectProperty(masked_location, 'lat')))) }) ));
      await Backendless.Data.of('parent_maps').setRelation(({ [`objectId`]: (getObjectProperty(parent_map, 'objectId')) }), 'student_dir', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId'))]);
      await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`share_contact`]: 'Yes' }) );
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: undefined,[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 1st Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/2ab378fd07e4e08fcca5a14404b8ebe6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/62dae2236ff36b2e05a7ff0f029626f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Student Interest`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 4th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/8ac84fa8a27730e9807452d8affd7f15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/6c04c8c420e6bad4c54637e71b0aae55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', true);
      if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')))) {
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyslexia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyslexia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dysgraphia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dysgraphia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyscalculia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyscalculia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ADHD'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('ADHD')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['auditory_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Auditory processing disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['language_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Language processing disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['nonverbal_learning_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Nonverbal learning disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['visual_perceptual_or_visual_motor_defecit'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Visual perceptual/visual motor deficit')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['austism_spectrum_discorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Autism spectrum disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['asperger'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Asperger’s')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['anxiety'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Anxiety')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['depression'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Depression')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavioral_issues'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Behavioral issues')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_behavioral_challenges'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')) : '');
      }
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Behavioral Challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')),[`Additional information on behavioral challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',j == 'Behavioral Challenges' ? [(getObjectProperty(Object2, j)),':',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges'))].join('') : (getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',j == 'Behavioral Challenges' ? [(getObjectProperty(Object2, j)),':',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges'))].join('') : (getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',j == 'Behavioral Challenges' ? [(getObjectProperty(Object2, j)),':',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges'))].join('') : (getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 5th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/b8118538e1b944f2c286d2b83b189713/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/c2e758d4431aaf625f07c78312e1fcdb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`ELA Grade Level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`MATH Grade Level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`SCIENCE Grade Level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 6th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/19ee626322062e87a2bb85b541ad9119/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/30eac0e74114c9540b65f04abf5e760c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
      console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade'));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Kindergarten') !== -1) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', true);
      }
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Learning Environment for the past 12 months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`Student's Last School Address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`Learnong experience for the past 12 Months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`EIP 504 Plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`Current Learning Example`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`Student's Last School`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`What the parent would like to see in our school`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`Student Last School Contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`Student Last School Contact Person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 8th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/4aad223fe72f516eb96af88e2b93c3da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Kindergarten') !== -1) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', true);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/f38a88531d421da4f86ea2e515b5fd79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07dc116efb3653f910fb001dc4228ded', true);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-style'] = 'solid';
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-color'] = 'red';
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218')));
        await new Promise(r => setTimeout(r, 2000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07dc116efb3653f910fb001dc4228ded', false);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-style'] = 'none';
        return null;
      }
    }
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Home State`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`Step Up ID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`Student Award ID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`Vaccine Situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 10th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/24aed774d441fcef440e2d0957bf3608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/f61f81f65217443abff5959d6e9a6be5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d409fdfd091677ebd7eefd8664b75f26'))['border-style'] = 'solid';
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d409fdfd091677ebd7eefd8664b75f26'))['border-color'] = 'red';
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d409fdfd091677ebd7eefd8664b75f26')));
        await new Promise(r => setTimeout(r, 2000 || 0));
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d409fdfd091677ebd7eefd8664b75f26'))['border-style'] = 'none';
        return null;
      }
    }
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Starting Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`Email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`Computer System`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`Length of Staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`Electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',j == 'Starting Date' ? ((new Date((getObjectProperty(Object2, j)))).toDateString()) : (getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 11th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/883c65fd263cbd39e9b7b86a49cc5a5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/a4fc94ab7b2b559aece5136e2bcf526c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Confidence in collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`Confidence in engaging independent work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`Confidence in writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`Confidence in using technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`Confidence in reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`Connecting in engaging with adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 7th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/dd04334b6225acf734c996bf54a1c467/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/41b657385909ff1c98ae26c177aee544/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/dc9437ec826dd44d2ba2d40d2729992a/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/ba0f86727c8f81bb002460a80b7dabb8/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/343ac0d3bd63aac25a73972fa1ae9b41/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/4ba661be6b2c122691289404915f8d68/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/62f4c62fcd4eb26d864109c9e4591c22/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/506d3ac2bf8d8126d934a7c89c3a54df/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/57b998ec90b97f7b2955ccc23b2130b3/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#F5713C';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/5fb5631c318616d6b3c4bd8d4f2c79ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['learning_or_behavioral_challenges'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowLearningBehavioral')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowLearningBehavioral')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowLearningBehavioral')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowLearningBehavioral'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowLearningBehavioral'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/3a3f0cc940ab89bd784f5739245ec5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['learning_or_behavioral_challenges'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavior'] = [];

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowLearningBehavioral')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowLearningBehavioral')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowLearningBehavioral')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowLearningBehavioral'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowLearningBehavioral'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/edbc76978df8ee28a3b944323814a072/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('37b6d8866f3769068be8e65e52e64c3e')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/2c664168765d30c68ddf816f65f19afa/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Dyslexia', 'Dysgraphia', 'Dyscalculia', 'ADHD', 'Auditory processing disorder', 'Language processing disorder', 'Nonverbal learning disorder', 'Visual perceptual/visual motor deficit', 'Autism spectrum disorder', 'Asperger’s', 'Anxiety', 'Depression', 'Behavioral issues', 'Other']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/37b6d8866f3769068be8e65e52e64c3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37b6d8866f3769068be8e65e52e64c3e')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavior'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredBehavior'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredBehavior'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/1cdcc6a82167c5529a64ff17c8dd2a13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/5a9fa86b193d69ff182715a2c31dc008/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/8e8ba9b86bacee9ca79a2376e581cf4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c9ebe788865e9acaa016c3ff5811b386/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/6e0220912801faf75a264e9971b8c0e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_reading'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/e3ae8edbfa56a69e5d07961c55af363b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/bff2880367d4652b13ce26c3cfff9572/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/54f4bfceae53a73545970dda60a16aa5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a25f1c0c7f9391e87e9749b939ab98cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/bf4a0f82f4646bf514f6688f7883179d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_writing'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/29e4338480cf1ecf90fbfbe48f46bc92/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/1bebd2e4e4d7db77c4c106f1b259a184/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/11d1532aeb8143df74db0e03a8b4e17b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/4ff899d45123de99b8175d45fae112d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/d9cb6618a02f889b939148aaa045081f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_collaborating'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/ce6762e9ce0dd3ffa08dd24ffe0175b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/9595340684216613735be35867b6b0be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/495a2d43c571e6896ce54c9e97cab451/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a6381c54209c7c02bd7876f9190a5f5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/391e7105c955e2f67a3b7c2c2537af1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_in_engaging_independent_work'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/ef1b6a7d5c16761620fac9bf5bbcab09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/64384a9734b93b43e6d5c1aff7858af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/fdf48309004f8d6cb16b7bd803768732/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/133586cecb2b45ccdf6c514ebe97316c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/85d81ac22581f8796b8783944a639595/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['confidence_using_technology'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/8c5f484b7805c917f64585f4ce4f9659/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['IEP_or_504_plan'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowIEPHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowIEPHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowIEPHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowIEPHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowIEPHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/9f5d7ea81e195527e3c8594c2e457469/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['IEP_or_504_plan'] = false;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowIEPHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowIEPHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowIEPHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowIEPHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowIEPHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/8c993f6a22358c58b2cae42a6ba55757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['submit_step_up'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowSubmitStepupHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowSubmitStepupHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowSubmitStepupHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowSubmitStepupHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowSubmitStepupHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/a2d5274e753c8d26b024978323d30b26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['submit_step_up'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['step_up_id'] = null;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['student_award_id'] = null;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowSubmitStepupHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowSubmitStepupHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowSubmitStepupHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowSubmitStepupHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowSubmitStepupHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/5675b91b3047a151234624423b94fa5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['determining_required_paperwork_home_state'] = 'I need support with local paperwork';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')) == 'I need support with local paperwork' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesPaperworkHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesPaperworkHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesPaperworkHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['YesPaperworkHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['YesPaperworkHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/c47bd83295659ac262472e8dd22e9974/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['determining_required_paperwork_home_state'] = 'I don\'t need support with local paperwork';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')) == 'I don\'t need support with local paperwork' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoPaperworkHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoPaperworkHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoPaperworkHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['NoPaperworkHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['NoPaperworkHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/6e28c656b1535b2d67099fcb3c4c8043/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['learningCenterBool'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesLearningCenterHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesLearningCenterHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'YesLearningCenterHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['YesLearningCenterHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['YesLearningCenterHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/8117ff97f96151ef0af67881d3dfdc25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['learningCenterBool'] = false;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoLearningCenterHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoLearningCenterHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NoLearningCenterHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['NoLearningCenterHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['NoLearningCenterHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/3a4ecf94f7c4e233e5d846fe2eb78c0c/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Beginner Spanish (full program)', 'Beginner Art (full program)', 'Beginner Coding (full program)', 'Beginner Health & PE (full program)', 'I prefer not to have any electives', 'I could not find what I was looking for', 'Please keep me in the loop about new/upcoming After School Clubs!']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/39da0cced587c8499cc2c92633e3efb1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('39da0cced587c8499cc2c92633e3efb1')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['electives'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')), ___arguments.context.dataModel, '');
  }
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives'));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) === null)) ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredElectives')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredElectives'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredElectives'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/235898fcb77bc15429618b98d82c9b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('39da0cced587c8499cc2c92633e3efb1')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/511a701d1a63335a92a7490a09f77d17/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('511a701d1a63335a92a7490a09f77d17');
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['upload_copy_EIP_504_plan'] = (['https://drive.google.com/file/d/',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f2923cbac91ee3c38c4349b78f3f5f04'))[0]), 'id')),'/view'].join(''));
  await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')) }) );

  },
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['IEP_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    console.log(Metadata);
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2923cbac91ee3c38c4349b78f3f5f04', [Metadata]);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['IEP_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/14d528460d2c273f50c44341aff5abe4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c873f39fc6b0d99380bc7d408c8db6e'), 'id')).indexOf('typeform') !== -1)) {
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c873f39fc6b0d99380bc7d408c8db6e'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['upload_copy_EIP_504_plan '] = null;
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f2923cbac91ee3c38c4349b78f3f5f04')), ___arguments.context.getComponentDataStoreByUid('4c873f39fc6b0d99380bc7d408c8db6e'), '');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/f6dca288407dbde32e2cac217299f548/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['learningFiles_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    console.log(Metadata);
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('516b0a2c8c02e8c16262283908e75071', [Metadata]);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6dca288407dbde32e2cac217299f548');
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['upload_student_curreny_learning'] = (['https://drive.google.com/file/d/',(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('516b0a2c8c02e8c16262283908e75071'))[0]), 'id')),'/view'].join(''));
  await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')) }) );

  },
  /* handler:onUploadSuccess */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['learningFiles_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/445e58961b448a72be8981b5431d8a4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('144a68dadf12889f23ce5d2285eecc7a'), 'id')).indexOf('typeform') !== -1)) {
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('144a68dadf12889f23ce5d2285eecc7a'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['upload_student_curreny_learning'] = null;
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('516b0a2c8c02e8c16262283908e75071')), ___arguments.context.getComponentDataStoreByUid('144a68dadf12889f23ce5d2285eecc7a'), '');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/6c15b822abd79b583a6c90d6559b4a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89e976bbc472d90d055fb9697b0cdcda', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/11f4392dee67c2c17642cb7c552ebef9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, DateNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['teacherNotes'] = [];
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')), ({ [`title`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNoteTitle')),[`type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNoteType')),[`description`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNoteDescription')),[`date`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()),' ',getValueLength(String(new Date((new Date())).getHours())) == 1 ? String('0') + String(new Date((new Date())).getHours()) : (new Date((new Date())).getHours()),':',getValueLength(String(new Date((new Date())).getMinutes())) == 1 ? String('0') + String(new Date((new Date())).getMinutes()) : (new Date((new Date())).getMinutes()),':',getValueLength(String(new Date((new Date())).getSeconds())) == 1 ? String('0') + String(new Date((new Date())).getSeconds()) : (new Date((new Date())).getSeconds())].join(''),[`teacher`]: (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'boolean') && (getObjectProperty(___arguments.context.pageData, 'isTeacher')) ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) : 'TestNicolasTutor Live' }));
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) }) );
    DateNow = (new Date());
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': (String('New student note added by ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name'))),'date': DateNow,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89e976bbc472d90d055fb9697b0cdcda', false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['teacherNoteTitle'] = null;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['teacherNoteType'] = null;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['teacherNoteDescription'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/11c398ee4e1ef6db80a3b325bd9bedf4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f591ed3d0afaad88133d09bc6bba8101/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89e976bbc472d90d055fb9697b0cdcda', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/46546a4e28488c3398fc2bbfd2e2b325/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')).length))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f38de707d68c9eab309ce5ce39c7c59b/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/566ed33c0d7aec63a5f417a5ff97408e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/3eb63b3c000eff275494fe07007cb4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a910f3ecd066ae6adc1a8d8b381a0c3', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/966b8775b508377b7cff6882aa0d42a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a910f3ecd066ae6adc1a8d8b381a0c3', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/d8abb7d7e5b44fbbb5529468762e705e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/bdd55efe404e282133797d9e10147e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, TutorObject, dateScheduled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PSNotes'] = [];
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')), ({ [`title`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNoteTitle')),[`type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNoteType')),[`description`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNoteDescription')),[`date`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()),' ',(new Date((new Date())).getHours()),':',(new Date((new Date())).getMinutes()) == 0 ? '00' : (new Date((new Date())).getMinutes()),':',(new Date((new Date())).getSeconds()) == 0 ? '00' : (new Date((new Date())).getSeconds())].join(''),[`PS`]: '' }));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a910f3ecd066ae6adc1a8d8b381a0c3', false);
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) }) );
    dateScheduled = (new Date((new Date()).getTime() + (600 * 1000)));
    TutorObject = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'slots'))[0]), 'tutor')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': dateScheduled,'lead_id': (getObjectProperty(TutorObject, 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(TutorObject, 'MS_teacher_email')),'body_html': (['Dear ',(getObjectProperty(TutorObject, 'name')),', <br><br>','This is to inform you that a PS Team Member has added a note regarding your student, ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'. <br><br>You can see the note in the <a href = "https://portal.brilliantgrades.com/Clever/index.html?page=Main_Page">Student Information System</a> on the Extra Notes -> PS Notes Section<br>','<br><br>Parent Support Team<br><img src= \'https://lh6.googleusercontent.com/hnkDEFumM6CbPs3YxDAwWOcvchVNNwOawvbe-zzLebpvQ1HaJSrBBhJrpn-PeVYUHesnL6zm_31TBdeCqMVBlaTkq-NVaJFrk5zrl0f4EZn0rvc6-ftZkvxJ71oN0HQxIw-KqrPwB8Jj2bgYoO84rng\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': 'New Note Added by PS Team' });
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PSNoteTitle'] = null;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PSNoteType'] = null;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PSNoteDescription'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/e8e93c6e8a355251d61bb336361d9aaa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')).length))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/ab35210785a3b846ffc89bfc3aa1731a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/fface34474bdfff5f5367151549cfb4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/e63c38c628be877b4ea9c7f800f9c5bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/664528e2ea7e8422836919767aafc28f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01259b7992242d645472a27bd1abb789', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4219cad74346f3461e5e7d8c557d8b97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/0c5dc3ade5e9d08a85791781f28f6a3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/38d73e1a849c8d0a69d47c8e63174ff1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/550374cdba6f5ad446537e4c899b3afd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item, NotesList, teacherNotes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6da239cf645da1552382003941da429f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66572449a018615fba98bc7ed3380217', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('550374cdba6f5ad446537e4c899b3afd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fd9369f7a7eeb0c9154bdc95ba5d02f', true);
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/7fd9369f7a7eeb0c9154bdc95ba5d02f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6da239cf645da1552382003941da429f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66572449a018615fba98bc7ed3380217', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('550374cdba6f5ad446537e4c899b3afd', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fd9369f7a7eeb0c9154bdc95ba5d02f', false);
  ___arguments.context.getComponentDataStoreByUid('6f7bc14d5a17091862218bd7e78f92a1')['date'] = ([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()),' ',String(new Date((new Date())).getHours()).length == 1 ? String('0') + String(new Date((new Date())).getHours()) : (new Date((new Date())).getHours()),':',String(new Date((new Date())).getMinutes()).length == 1 ? String('0') + String(new Date((new Date())).getMinutes()) : (new Date((new Date())).getMinutes()),':',String(new Date((new Date())).getSeconds()).length == 1 ? String('0') + String(new Date((new Date())).getSeconds()) : (new Date((new Date())).getSeconds())].join(''));
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) ? (JSON.stringify((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) : (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`teacherNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'teacherNotes')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/f6248bf1caaa40e94ecef8a51d429837/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e23a48f346b9bf74d0a4e469a39f164', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bea90e936197bf1145a69373abce858d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6248bf1caaa40e94ecef8a51d429837', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f09c9176bc21bdf5cd06b1add8636a68', true);
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/f09c9176bc21bdf5cd06b1add8636a68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e23a48f346b9bf74d0a4e469a39f164', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bea90e936197bf1145a69373abce858d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6248bf1caaa40e94ecef8a51d429837', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f09c9176bc21bdf5cd06b1add8636a68', false);
  ___arguments.context.getComponentDataStoreByUid('1bf5d267ecb65cf1265874c889a7226b')['date'] = ([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()),' ',String(new Date((new Date())).getHours()).length == 1 ? String('0') + String(new Date((new Date())).getHours()) : (new Date((new Date())).getMinutes()),':',String(new Date((new Date())).getMinutes()).length == 1 ? String('0') + String(new Date((new Date())).getMinutes()) : (new Date((new Date())).getMinutes()),':',String(new Date((new Date())).getSeconds()).length == 1 ? String('0') + String(new Date((new Date())).getSeconds()) : (new Date((new Date())).getSeconds())].join(''));
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) ? (JSON.stringify((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) : (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`PSNotes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PSNotes')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/40470eac1bdc42484f6e84aae0f39b01/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Found, item, Classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd'), 'searchInput'))) == 0) {
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['TimeTable'] = [];
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['ClassValue'] = '';
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['StudentValue'] = '';
    ___arguments.context.pageData['infoTitle'] = '';
  } else {
    Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


     return ((([(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join('').toUpperCase()).indexOf(((___arguments.value.replace((new RegExp('\'', 'g')), '\'\'')).toUpperCase())) !== -1) && !((getObjectProperty(item, 'students')) === null) && !!(await asyncListFilter((getObjectProperty(item, 'students')), async (item) => {


     return ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1);
    })).length && !((getObjectProperty(item, 'Class')).indexOf('MS_BREAK') !== -1));
    }));
    console.log(Classes);
    if (!Classes.length) {
      return null;
    }
    Found = (await Promise.all(Classes.map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'teacher')),' - ',((getObjectProperty(item, 'Class')).indexOf('ELECTIVE') !== -1) ? ((((getObjectProperty(item, 'Class')).split('-')[2]).indexOf('DIGITAL') !== -1) ? 'DIGITAL ART' : (getObjectProperty(item, 'Class')).split('-')[2].split('_')[0]) : (getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'starting_time'))].join(''),[`value`]: (getObjectProperty(item, 'Class')) });})));
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['ClassOptions'] = Found;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/8e5b6b1d967569d32467154477991b34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, FinalStudents, j, FinalStudentChecker, Students, Classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


   return ((getObjectProperty(item, 'Class')).startsWith(___arguments.value));
  }));
  Students = (await asyncListFilter((getObjectProperty((Classes[0]), 'students')), async (item) => {


   return ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1);
  }));
  console.log(Students);
  FinalStudents = [];
  FinalStudentChecker = [];
  for (var j_index in Students) {
    j = Students[j_index];
    if (!(FinalStudentChecker.includes((getObjectProperty(j, 'contact_id'))))) {
      addItemToList(FinalStudents, j);
      addItemToList(FinalStudentChecker, (getObjectProperty(j, 'contact_id')));
    }
  }
  ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['StudentOptions'] = (await Promise.all(FinalStudents.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'student_name')),[`value`]: (getObjectProperty(item, 'contact_id')) });})));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/8459700acc028dc5e7a31e213a2c0d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, StudentInfo, percentCompleted, NotCompletedFields, lengthCompetedFields, item, Students, StateRegObject, Classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  try {
    Classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ClassList')), async (item) => {


     return ((getObjectProperty(item, 'Class')).startsWith((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd'), 'ClassValue'))));
    }));
    Students = (await asyncListFilter((getObjectProperty((Classes[0]), 'students')), async (item) => {


     return ((getObjectProperty(item, 'contact_id')).indexOf(___arguments.value) !== -1);
    }));
    console.log(JSON.stringify(Students));
    StudentInfo = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['student_name = \'',(getObjectProperty((Students[0]), 'student_name')),'\' and lead_id = \'',(getObjectProperty((Students[0]), 'lead_id')),'\''].join(''))).setRelated('slots').setRelationsPageSize(100).setPageSize(100)))[0];
    if (!(typeof StudentInfo === 'undefined')) {
      if (true) {
        StudentInfo['behavior'] = [];
        if (getObjectProperty(StudentInfo, 'Dyslexia')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyslexia');
        }
        if (getObjectProperty(StudentInfo, 'Dysgraphia')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dysgraphia');
        }
        if (getObjectProperty(StudentInfo, 'Dyscalculia')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyscalculia');
        }
        if (getObjectProperty(StudentInfo, 'ADHD')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'ADHD');
        }
        if (getObjectProperty(StudentInfo, 'auditory_processing_disorder')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Auditory processing disorder');
        }
        if (getObjectProperty(StudentInfo, 'language_processing_disorder')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Language processing disorder');
        }
        if (getObjectProperty(StudentInfo, 'nonverbal_learning_disorder')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Nonverbal learning disorder');
        }
        if (getObjectProperty(StudentInfo, 'visual_perceptual_or_visual_motor_defecit')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Visual perceptual/visual motor deficit');
        }
        if (getObjectProperty(StudentInfo, 'austism_spectrum_discorder')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Autism spectrum disorder');
        }
        if (getObjectProperty(StudentInfo, 'asperger')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Asperger’s');
        }
        if (getObjectProperty(StudentInfo, 'anxiety')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Anxiety');
        }
        if (getObjectProperty(StudentInfo, 'depression')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Depression');
        }
        if (getObjectProperty(StudentInfo, 'behavioral_issues')) {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Behavioral issues');
        }
        if ((typeof (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) === 'string') && (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) != '') {
          addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Other');
        }
      }
      if (!((getObjectProperty(StudentInfo, 'home_state')) === null)) {
        StateRegObject = (await Backendless.Data.of('state_regs').find(Backendless.DataQueryBuilder.create().setWhereClause((['State_Name = \'',(getObjectProperty(StudentInfo, 'home_state')),'\''].join(''))).setPageSize(10)))[0];
        ___arguments.context.pageData['StateRegObject'] = StateRegObject;
      }
      console.log(Students);
      console.log('first day');
      console.log(getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'firstDay'));
      ___arguments.context.pageData['ShareParentContact'] = (getObjectProperty(StudentInfo, 'share_contact'));
      StudentInfo['firstDay'] = (((getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'firstDay')) === null) || ((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })) === null) ? null : (new Date((getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'firstDay')))));
      StudentInfo['ethnicityValue'] = ((getObjectProperty(StudentInfo, 'African_American')) ? 'African-American' : ((getObjectProperty(StudentInfo, 'Asian')) ? 'Asian' : ((getObjectProperty(StudentInfo, 'Caucasian')) ? 'Caucasian' : ((getObjectProperty(StudentInfo, 'Latino_Hispanic')) ? 'Latino or Hispanic' : ((getObjectProperty(StudentInfo, 'Native_American')) ? 'Native American' : ((getObjectProperty(StudentInfo, 'Native_Hawaiian')) ? 'Native Hawaiian' : ((getObjectProperty(StudentInfo, 'other_unknown_ethnicity')) ? 'Other/Unknown' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_ethnicity')) ? 'Prefer not to say' : null))))))));
      StudentInfo['genderValue'] = ((getObjectProperty(StudentInfo, 'female')) ? 'Female' : ((getObjectProperty(StudentInfo, 'male')) ? 'Male' : ((getObjectProperty(StudentInfo, 'transgender')) ? 'Transgender' : ((getObjectProperty(StudentInfo, 'gender_variant_non_conforming')) ? 'Gender Variant/Non-Conforming' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_gender')) ? 'Prefer not to say' : (!((getObjectProperty(StudentInfo, 'other_gender')) === null) ? (getObjectProperty(StudentInfo, 'other_gender')) : null))))));
      StudentInfo['learningList'] = ((typeof (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')) === 'string') && ((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')), (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
      StudentInfo['IEPDocs'] = ((typeof (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')) === 'string') && ((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')), (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
      StudentInfo['secondary_guardian_show'] = (!((getObjectProperty(StudentInfo, 'secondary_guardian')) === null));
      StudentInfo['ShowPTOQuestions'] = (!((getObjectProperty(StudentInfo, 'PTO')) === null));
      StudentInfo['ShowPTOQuestions'] = (!((getObjectProperty(StudentInfo, 'PTO')) === null));
      StudentInfo['honorCodeStudentName'] = (getObjectProperty(StudentInfo, 'student_name'));
      StudentInfo['honorCodeParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
      StudentInfo['ToSParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
      if ((getObjectProperty(StudentInfo, 'CallNotes')) === null) {
        StudentInfo['CallNotes'] = [];
      }
      if ((getObjectProperty(StudentInfo, 'teacherNotes')) === null) {
        StudentInfo['teacherNotes'] = [];
      }
      if ((getObjectProperty(StudentInfo, 'PTO')) === null) {
        StudentInfo['PTO'] = ({ [`PTOOptions`]: [] });
      }
      if ((getObjectProperty(StudentInfo, 'PSNotes')) === null) {
        StudentInfo['PSNotes'] = [];
      }
      if (!(getObjectProperty(StudentInfo, 'transferCredit'))) {
        StudentInfo['CreditTransfer'] = [];
      }
      StudentInfo['grade'] = (getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'grade'));
      StudentInfo['chargebeeID'] = (getObjectProperty((await asyncListFind(Students, async (item) => {


       return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      })), 'chargebee'));
      StudentInfo['English'] = ['English 1', 'English 2', 'English 3', 'English 4'];
      StudentInfo['Math'] = ['Pre-Algebra', 'Algebra 1', 'Algebra 2', 'Geometry', 'Pre-Calculus', 'Calculus', 'Statistics', 'Integrated Math 1', 'Integrated Math 2', 'Integrated Math 3'];
      StudentInfo['SocialStudies'] = ['World History', 'Global Studies', 'U.S. History', 'U.S. Government', 'Economics', 'Geography', 'Psychology', 'Sociology'];
      StudentInfo['Science'] = ['Biology', 'Chemistry', 'Physics', 'Environmental Science', 'Anatomy and Physiology'];
      StudentInfo['PE&Health'] = ['Physical Education', 'Health Education'];
      StudentInfo['WorldLanguage'] = ['Spanish', 'French', 'German', 'Chinese'];
      StudentInfo['FineArts'] = ['Band', 'Orchestra', 'Choir', 'Theatre Arts/Drama', 'Visual Arts', 'Digital Design', 'Photography'];
      StudentInfo['CTE'] = ['Computer Science', 'Business and Marketing', 'Health Sciences', 'Culinary Arts', 'Automotive Technology', 'Agriculture Sciences', 'Audio/Video Production', 'Creative Writing', 'Journalism', 'Debate'];
      if (typeof (getObjectProperty(StudentInfo, 'studentMSEmail')) === 'string') {
        StudentInfo['1disabled'] = true;
        StudentInfo['1.5disabled'] = true;
        StudentInfo['1.6disabled'] = true;
        StudentInfo['2disabled'] = true;
        StudentInfo['3disabled'] = true;
        StudentInfo['4disabled'] = true;
        StudentInfo['5disabled'] = true;
        StudentInfo['6disabled'] = true;
        StudentInfo['6.1disabled'] = true;
        StudentInfo['7disabled'] = true;
        StudentInfo['8disabled'] = true;
        StudentInfo['8.1disabled'] = true;
        StudentInfo['8.2disabled'] = true;
        StudentInfo['9disabled'] = true;
        console.log(StudentInfo);
      }
      StudentInfo['requiredList'] = ['Ethnicity', 'student_name', 'student_last_name', 'student_birth_date', 'most_interested_in', 'behavior', 'parent_address', 'email', 'parent_phone', 'parent_name', 'parent_last_name', 'science_grade_level', 'ela_grade_level', 'math_grade_level', 'learning_environment_past_12_months', 'learning_experiece_past_12_months', 'upload_copy_EIP_504_plan', 'CreditTransfer', 'home_state', 'honorCodeSigned'];
      NotCompletedFields = (await asyncListFilter((getObjectProperty(StudentInfo, 'requiredList')), async (item) => {


       return ((item.indexOf('behavior') !== -1) && (getObjectProperty(StudentInfo, 'learning_or_behavioral_challenges')) != false && !(getObjectProperty(StudentInfo, item)).length || (item.indexOf('CreditTransfer') !== -1) && (getObjectProperty(StudentInfo, 'transferCredit')) && !((getObjectProperty(StudentInfo, 'grade')).indexOf('Kindergarten') !== -1) && (((getObjectProperty(StudentInfo, item)) === null) || !(getObjectProperty(StudentInfo, item)).length) || (item.indexOf('upload_copy_EIP_504_plan') !== -1) && (getObjectProperty(StudentInfo, 'IEP_or_504_plan')) != false && ((getObjectProperty(StudentInfo, item)) === null) || (item.indexOf('Ethnicity') !== -1) && ((getObjectProperty(StudentInfo, 'ethnicityValue')) === null) || (item.indexOf('honorCodeSigned') !== -1) && !(getObjectProperty(StudentInfo, item)) || !(item.indexOf('upload_copy_EIP_504_plan') !== -1) && ((getObjectProperty(StudentInfo, item)) === null));
      }));
      console.log(NotCompletedFields);
      lengthCompetedFields = (getObjectProperty(StudentInfo, 'requiredList')).length - NotCompletedFields.length;
      console.log(lengthCompetedFields);
      percentCompleted = (lengthCompetedFields / (getObjectProperty(StudentInfo, 'requiredList')).length) * 100;
      console.log(String(percentCompleted) + String('%'));
      StudentInfo['NotCompletedFields'] = NotCompletedFields;
      StudentInfo['PercentCompleted'] = percentCompleted;
      ___arguments.context.pageData['StudentInfo'] = StudentInfo;
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/2a591b197cad317c0cbb162e16a36616/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/ace552a827a5700e870e4e050e770166/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j, StudentInfo;


  var j_list = ['female', 'male', 'transgender', 'gender_variant_non_conforming', 'prefer_not_to_say_gender', 'other_gender'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')[j] = (j == 'other_gender' ? null : false);
  }
  if (___arguments.value == 'Female') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['female'] = true;
  } else if (___arguments.value == 'Male') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['male'] = true;
  } else if (___arguments.value == 'Transgender') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transgender'] = true;
  } else if (___arguments.value == 'Gender Variant/Non-Conforming') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['gender_variant_non_conforming'] = true;
  } else if (___arguments.value == 'Prefer not to say') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['prefer_not_to_say_gender'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_gender'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/ba1c4efc1547f2bbcd2fe6cb9cab4efc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j;


  var j_list = ['African_American', 'Asian', 'Caucasian', 'Latino_Hispanic', 'Native_American', 'Native_Hawaiian', 'other_unknown_ethnicity', 'prefer_not_to_say_ethnicity'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')[j] = false;
  }
  if (___arguments.value == 'African-American') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['African_American'] = true;
  } else if (___arguments.value == 'Asian') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Asian'] = true;
  } else if (___arguments.value == 'Caucasian') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Caucasian'] = true;
  } else if (___arguments.value == 'Latino or Hispanic') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Latino_Hispanic'] = true;
  } else if (___arguments.value == 'Native American') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Native_American'] = true;
  } else if (___arguments.value == 'Native Hawaiian') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Native_Hawaiian'] = true;
  } else if (___arguments.value == 'Other/Unknown') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_unknown_ethnicity'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['prefer_not_to_say_ethnicity'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/ebec95de013e9df4be5250e7e989fcb5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/4b4f9ad7e5c23f2fbb58c7d211314edf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')) === 'undefined')) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Physical private school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Virtual private school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Physical public/charter school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Virtual public/charter school') !== -1)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f2923cbac91ee3c38c4349b78f3f5f04/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/516b0a2c8c02e8c16262283908e75071/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/4c873f39fc6b0d99380bc7d408c8db6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'id')).indexOf('typeform') !== -1) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.dataModel, 'id')), true, undefined);
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/144a68dadf12889f23ce5d2285eecc7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'id')).indexOf('typeform') !== -1) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.dataModel, 'id')), true, undefined);
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/b98d141bbc783d419dcfe3b71e0ad4a5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;



  return (await Promise.all(('Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, District of Columbia, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina, North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina, South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia, Wisconsin, Wyoming, International Territories, Cayman Islands'.split(', ')).map(async item => {; return ({ [`value`]: item,[`label`]: item,[`disabled`]: item == 'International Territories' });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var StateRegObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  StateRegObject = (await Backendless.Data.of('state_regs').find(Backendless.DataQueryBuilder.create().setWhereClause((['State_Name = \'',___arguments.value,'\''].join(''))).setPageSize(10)))[0];
  ___arguments.context.pageData['StateRegObject'] = StateRegObject;
  console.log(getObjectProperty(___arguments.context.pageData, 'StateRegObject'));
  await new Promise(r => setTimeout(r, 1000 || 0));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/e487d36e0f3af45e701572ebb508bcd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/127636bd353265f27b4d9f52ebd3450e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  }

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/SIS_v2/components/60acfec20618643567364af31db57952/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/90c20b9ae3abe035ae9587b194ef30b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/da44d7d4a1c69648f32e6c21bf27f328/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/b8af85447dd9709542c94d6dd7c4c0e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/b8815e1a5434df4f94a6443a33f9c3a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/b8146bf5afa16f197d4d48e16225bf71/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/1d1919c5953e41522d5490bd85460f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')) === 'undefined')) && !(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Physical private school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Virtual private school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Physical public/charter school') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')).indexOf('Virtual public/charter school') !== -1))) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['student_last_school_address'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/3d4a32731c5b9604374efd4fba14771f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/01212aeb955c082f1715cb0723cd349b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/4ed9b5593c9159be43bd53ca8c21ae45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/e89c1559e767215845ed4954ff16779f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/53e23462f0713562d535ae2774cefdd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/77f4602e44a7ebe91928ca074bded7b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a15f6d84c3fd06cef36ae28d4a36494b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value != 'More than one academic year') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['electives'] = [];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/801eb33e551fe7670239913725169cb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1disabled'] = true;
  if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
    return null;
  }
  changed_fields = [];
  oldData = ({  });
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
  }
  var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) })));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
      addItemToList(changed_fields, j);
      oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
    }
  }
  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
  console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
  await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/e06f7907c4cc9e098ad178a1c46540da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/682eb4824fde031e6da964d3e9a7ac88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['2disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/ae933ee6d245a606c1e223fc23538a96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['2disabled'] = true;
  if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
    return null;
  }
  changed_fields = [];
  oldData = ({  });
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
  }
  var j_list = (Object.keys(({ [`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) })));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
      addItemToList(changed_fields, j);
      oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
    }
  }
  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
  console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
  await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/853f542a8f1c8ec53d3a14388c23057c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['3disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/dc4f24c68d36264dd7fa8f03e3069f32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['3disabled'] = true;
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')))) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyslexia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyslexia')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dysgraphia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dysgraphia')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyscalculia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyscalculia')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ADHD'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('ADHD')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['auditory_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Auditory processing disorder')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['language_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Language processing disorder')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['nonverbal_learning_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Nonverbal learning disorder')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['visual_perceptual_or_visual_motor_defecit'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Visual perceptual/visual motor deficit')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['austism_spectrum_discorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Autism spectrum disorder')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['asperger'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Asperger’s')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['anxiety'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Anxiety')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['depression'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Depression')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavioral_issues'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Behavioral issues')) ? true : false);
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_behavioral_challenges'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')) : '');
  }
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/5872977e2d21337c47ae934ff19734dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['4disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/fc0e0a93d003671df71ef2e7157459bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['4disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/22ea9548ec5e3e066015d58e4045e5b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['5disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/1a25eb7189843615d481e8616a298fdc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['5disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/5872f9751de7523823b9fb5ac5dfd2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/b599431e9fb1121bc232dd01cc0ea053/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/536e104b6144372c0ea7139c2704104b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['7disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/ab5d5e382a6229b6a33be84e00efde85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['7disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/de24e51c84d3405e917a526eee2cd67e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var electives, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['8disabled'] = false;
  electives = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')).map(async item => {; return item;})));
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: electives });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/e7bccfdba5c2d572f6f2339821c92d21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['8disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (j == 'electives') {
        console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j));
        console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) ? (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/ffb1b8afa99e30adb4e2deb6c0bcb8cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (getObjectProperty(___arguments.context.pageData, 'isTeacher'))) && !(typeof (getObjectProperty(___arguments.context.pageData, 'ClassList')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a5ede64a7781ca7eba7d501604a85d09/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var StudentInfo, ChargebeeCustomer, LeadHolder, percentCompleted, NotCompletedFields, lengthCompetedFields, item, StateRegObject, RegFormCompleteTask;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  StudentInfo = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')), async (item) => {


   return ((getObjectProperty(___arguments.context.pageData, 'StudentSelectionValue')) == (getObjectProperty(item, 'objectId')));
  }))[0];
  if (!(typeof StudentInfo === 'undefined')) {
    RegFormCompleteTask = !((getObjectProperty(StudentInfo, 'studentMSEmail')) === null);
    ___arguments.context.pageData['isSubmitted'] = RegFormCompleteTask;
    console.log(StudentInfo);
    StudentInfo['ethnicityValue'] = ((getObjectProperty(StudentInfo, 'African_American')) ? 'African-American' : ((getObjectProperty(StudentInfo, 'Asian')) ? 'Asian' : ((getObjectProperty(StudentInfo, 'Caucasian')) ? 'Caucasian' : ((getObjectProperty(StudentInfo, 'Latino_Hispanic')) ? 'Latino or Hispanic' : ((getObjectProperty(StudentInfo, 'Native_American')) ? 'Native American' : ((getObjectProperty(StudentInfo, 'Native_Hawaiian')) ? 'Native Hawaiian' : ((getObjectProperty(StudentInfo, 'other_unknown_ethnicity')) ? 'Other/Unknown' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_ethnicity')) ? 'Prefer not to say' : null))))))));
    StudentInfo['genderValue'] = ((getObjectProperty(StudentInfo, 'female')) ? 'Female' : ((getObjectProperty(StudentInfo, 'male')) ? 'Male' : ((getObjectProperty(StudentInfo, 'transgender')) ? 'Transgender' : ((getObjectProperty(StudentInfo, 'gender_variant_non_conforming')) ? 'Gender Variant/Non-Conforming' : ((getObjectProperty(StudentInfo, 'prefer_not_to_say_gender')) ? 'Prefer not to say' : (!((getObjectProperty(StudentInfo, 'other_gender')) === null) ? (getObjectProperty(StudentInfo, 'other_gender')) : null))))));
    console.log((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
    }))[0]);
    StudentInfo['firstDay'] = (((getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
    }))[0]), 'firstDay')) === null) || (((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
    }))[0]) === null) ? null : (new Date((getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
    }))[0]), 'firstDay')))));
    if (true) {
      StudentInfo['behavior'] = [];
      if (getObjectProperty(StudentInfo, 'Dyslexia')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyslexia');
      }
      if (getObjectProperty(StudentInfo, 'Dysgraphia')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dysgraphia');
      }
      if (getObjectProperty(StudentInfo, 'Dyscalculia')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Dyscalculia');
      }
      if (getObjectProperty(StudentInfo, 'ADHD')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'ADHD');
      }
      if (getObjectProperty(StudentInfo, 'auditory_processing_disorder')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Auditory processing disorder');
      }
      if (getObjectProperty(StudentInfo, 'language_processing_disorder')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Language processing disorder');
      }
      if (getObjectProperty(StudentInfo, 'nonverbal_learning_disorder')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Nonverbal learning disorder');
      }
      if (getObjectProperty(StudentInfo, 'visual_perceptual_or_visual_motor_defecit')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Visual perceptual/visual motor deficit');
      }
      if (getObjectProperty(StudentInfo, 'austism_spectrum_discorder')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Autism spectrum disorder');
      }
      if (getObjectProperty(StudentInfo, 'asperger')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Asperger’s');
      }
      if (getObjectProperty(StudentInfo, 'anxiety')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Anxiety');
      }
      if (getObjectProperty(StudentInfo, 'depression')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Depression');
      }
      if (getObjectProperty(StudentInfo, 'behavioral_issues')) {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Behavioral issues');
      }
      if ((typeof (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) === 'string') && (getObjectProperty(StudentInfo, 'other_behavioral_challenges')) != '') {
        addItemToList((getObjectProperty(StudentInfo, 'behavior')), 'Other');
      }
    }
    if (!((getObjectProperty(StudentInfo, 'home_state')) === null)) {
      StateRegObject = (await Backendless.Data.of('state_regs').find(Backendless.DataQueryBuilder.create().setWhereClause((['State_Name = \'',(getObjectProperty(StudentInfo, 'home_state')),'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['StateRegObject'] = StateRegObject;
    }
    if (!((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')) === null)) {
      StudentInfo['learningList'] = (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_student_curreny_learning')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')), (((getObjectProperty(StudentInfo, 'upload_student_curreny_learning')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
    }
    if (!((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')) === null)) {
      StudentInfo['IEPDocs'] = (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).indexOf('typeform') !== -1) ? [({ [`id`]: (getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')),[`name`]: subsequenceFromStartLast((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')), (((getObjectProperty(StudentInfo, 'upload_copy_EIP_504_plan')).lastIndexOf('/') + 1 + 1) - 1)) })] : null);
    }
    if ((getObjectProperty(StudentInfo, 'transcriptFiles')) === null) {
      StudentInfo['transcriptFiles'] = [];
    }
    StudentInfo['secondary_guardian_show'] = (!((getObjectProperty(StudentInfo, 'secondary_guardian')) === null));
    StudentInfo['ShowPTOQuestions'] = (!((getObjectProperty(StudentInfo, 'PTO')) === null));
    StudentInfo['honorCodeStudentName'] = (getObjectProperty(StudentInfo, 'student_name'));
    StudentInfo['honorCodeParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
    StudentInfo['ToSParentName'] = (getObjectProperty(StudentInfo, 'parent_name'));
    if ((getObjectProperty(StudentInfo, 'CallNotes')) === null) {
      StudentInfo['CallNotes'] = [];
    }
    if ((getObjectProperty(StudentInfo, 'teacherNotes')) === null) {
      StudentInfo['teacherNotes'] = [];
    }
    if ((getObjectProperty(StudentInfo, 'PSNotes')) === null) {
      StudentInfo['PSNotes'] = [];
    }
    if (!(getObjectProperty(StudentInfo, 'transferCredit'))) {
      StudentInfo['CreditTransfer'] = [];
    }
    StudentInfo['English'] = ['English 1', 'English 2', 'English 3', 'English 4'];
    StudentInfo['Math'] = ['Pre-Algebra', 'Algebra 1', 'Algebra 2', 'Geometry', 'Pre-Calculus', 'Calculus', 'Statistics', 'Integrated Math 1', 'Integrated Math 2', 'Integrated Math 3'];
    StudentInfo['SocialStudies'] = ['World History', 'Global Studies', 'U.S. History', 'U.S. Government', 'Economics', 'Geography', 'Psychology', 'Sociology'];
    StudentInfo['Science'] = ['Biology', 'Chemistry', 'Physics', 'Environmental Science', 'Anatomy and Physiology'];
    StudentInfo['PE&Health'] = ['Physical Education', 'Health Education'];
    StudentInfo['WorldLanguage'] = ['Spanish', 'French', 'German', 'Chinese'];
    StudentInfo['FineArts'] = ['Band', 'Orchestra', 'Choir', 'Theatre Arts/Drama', 'Visual Arts', 'Digital Design', 'Photography'];
    StudentInfo['CTE'] = ['Computer Science', 'Business and Marketing', 'Health Sciences', 'Culinary Arts', 'Automotive Technology', 'Agriculture Sciences', 'Audio/Video Production', 'Creative Writing', 'Journalism', 'Debate'];
    StudentInfo['grade'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1) || ((getObjectProperty(item, 'status')).indexOf('churn') !== -1));
    }))[0]), 'grade'));
    StudentInfo['chargebeeID'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(StudentInfo, 'slots')), async (item) => {


     return (((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1) || ((getObjectProperty(item, 'status')).indexOf('churn') !== -1));
    }))[0]), 'chargebee'));
    if (typeof (getObjectProperty(StudentInfo, 'studentMSEmail')) === 'string') {
      StudentInfo['1disabled'] = true;
      StudentInfo['1.5disabled'] = true;
      StudentInfo['1.6disabled'] = true;
      StudentInfo['2disabled'] = true;
      StudentInfo['3disabled'] = true;
      StudentInfo['4disabled'] = true;
      StudentInfo['5disabled'] = true;
      StudentInfo['6disabled'] = true;
      StudentInfo['6.1disabled'] = true;
      StudentInfo['7disabled'] = true;
      StudentInfo['8disabled'] = true;
      StudentInfo['8.1disabled'] = true;
      StudentInfo['8.2disabled'] = true;
      StudentInfo['9disabled'] = true;
      console.log(StudentInfo);
    }
    StudentInfo['requiredList'] = ['Ethnicity', 'student_name', 'student_last_name', 'student_birth_date', 'most_interested_in', 'behavior', 'parent_address', 'email', 'parent_phone', 'parent_name', 'parent_last_name', 'science_grade_level', 'ela_grade_level', 'math_grade_level', 'learning_environment_past_12_months', 'learning_experiece_past_12_months', 'upload_copy_EIP_504_plan', 'CreditTransfer', 'home_state', 'honorCodeSigned', 'transcriptFiles'];
    NotCompletedFields = (await asyncListFilter((getObjectProperty(StudentInfo, 'requiredList')), async (item) => {


     return ((item.indexOf('behavior') !== -1) && (getObjectProperty(StudentInfo, 'learning_or_behavioral_challenges')) != false && !(getObjectProperty(StudentInfo, item)).length || (item.indexOf('CreditTransfer') !== -1) && (getObjectProperty(StudentInfo, 'transferCredit')) && !((getObjectProperty(StudentInfo, 'grade')).indexOf('Kindergarten') !== -1) && (((getObjectProperty(StudentInfo, item)) === null) || !(getObjectProperty(StudentInfo, item)).length) || (item.indexOf('transcriptFiles') !== -1) && (getObjectProperty(StudentInfo, 'uploadTranscript')) == 'I can upload them' && !(getObjectProperty(StudentInfo, item)).length || (item.indexOf('upload_copy_EIP_504_plan') !== -1) && (getObjectProperty(StudentInfo, 'IEP_or_504_plan')) != false && ((getObjectProperty(StudentInfo, item)) === null) || (item.indexOf('Ethnicity') !== -1) && ((getObjectProperty(StudentInfo, 'ethnicityValue')) === null) || (item.indexOf('honorCodeSigned') !== -1) && !(getObjectProperty(StudentInfo, item)) || !(item.indexOf('upload_copy_EIP_504_plan') !== -1) && ((getObjectProperty(StudentInfo, item)) === null));
    }));
    console.log(NotCompletedFields);
    lengthCompetedFields = (getObjectProperty(StudentInfo, 'requiredList')).length - NotCompletedFields.length;
    console.log(lengthCompetedFields);
    percentCompleted = (lengthCompetedFields / (getObjectProperty(StudentInfo, 'requiredList')).length) * 100;
    console.log(String(percentCompleted) + String('%'));
    StudentInfo['NotCompletedFields'] = NotCompletedFields;
    StudentInfo['PercentCompleted'] = percentCompleted;
  }
  ___arguments.context.pageData['StudentInfo'] = StudentInfo;
  ___arguments.context.pageData['ShareParentContact'] = (getObjectProperty(StudentInfo, 'share_contact'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/2917e6f79362c86ddf23ece5b6eb9362/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/1bbfc25fdf15be1929c420f79dd750f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['To edit ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s information, click the edit button above. Don\'t forget to save your progress once you are done editing. '].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f4b96b552685c1aa56dfeaee7ef90a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/938f0503dde3755c4498266a1947235a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c2e45eefeec557dbf91fed44aa9b7ad9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What is  ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' most interested in?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/3deed936f9210b98d6765dbfce5c04db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Does ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' have any learning or behavioral challenges '].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/cee8a2e1f038cde8921cb7237efd9d53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Please choose any challenges ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' is experiencing that may '].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/15844f36803830d5469497af2ac3220e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s learning or behavioral challenges?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/98811e425949e082adb5db012521a2e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['To the best of your knowledge,  what is ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s grade level in these subjects?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/7e9f8eca23ef603d7c3c461ae6c3dcd4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Rate ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s confidence in these subjects'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/316acce9798dff1ed2c9cfcb3306b31f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What best describes ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s learning environment '].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/b9bc5298be5e370c40d414c8dc17ad37/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What was the name of ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s last school?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/6a31d8e57048ff2815f1dce2763337f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Can you briefly describe ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s past learning experience'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/6e9475b589daee24f3011c4ee6351a6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['what ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' liked/disliked, where ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' thrived/struggled..'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/68c8b098120d6aaada9588b8f5011215/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Does ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' have an IEP or 504 plan?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/77aaa9523151c9880a49d396a1573b2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Feel free to upload a copy so that we can better understand how to serve ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/744e3e5f79ba1bd52d325bc9a56efb94/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['exemplifies ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s current learning?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/100bee2eff531bea314537b59178335c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What computer system will ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' be using?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/9f99f8e74f82aa6a17cf8909f46673de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['If our microschool is a good fit for  ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s learning environment '].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/4d2b1f121dbf67c3762b60f388a8ae8f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Would you like to enroll ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' in one or more electives?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/98bdf9e5868da7a97902860594c44253/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') ? ({ [`margin-left`]: '100px' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/3263884eef02089294d1c70166c50a43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.5disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/7e5f314a35c9f002d111bdc870863e4e/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/0c3817c3d698ca05fb143d5d1c615436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (false) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.5disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/8a794065b704ad73f532701467d7598f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, checkMap, parent_map, masked_location, geocode, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d647136d1b60fd6ecdb4f796a5b53e', true);
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e5f314a35c9f002d111bdc870863e4e')));
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c6d81b44bdfba1a61526b2973e401f1'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c6d81b44bdfba1a61526b2973e401f1'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfb57096f662ccbaf9313afcd7032ac4'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfb57096f662ccbaf9313afcd7032ac4'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1569180130fc8c47fa595b6d62aecb1e'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1569180130fc8c47fa595b6d62aecb1e'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('97a522e1ea357b72b6219366dd06fb01'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('97a522e1ea357b72b6219366dd06fb01'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5d4edf1880f675f42dfeaf2481c37b2'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5d4edf1880f675f42dfeaf2481c37b2'))['border-color'] = 'red';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c9bebdf97d7b2932919d151169f2efbf'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c9bebdf97d7b2932919d151169f2efbf'))['border-color'] = 'red';
        }
        await new Promise(r => setTimeout(r, 3000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d647136d1b60fd6ecdb4f796a5b53e', false);
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c6d81b44bdfba1a61526b2973e401f1'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfb57096f662ccbaf9313afcd7032ac4'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1569180130fc8c47fa595b6d62aecb1e'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('97a522e1ea357b72b6219366dd06fb01'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5d4edf1880f675f42dfeaf2481c37b2'))['border-style'] = 'none';
        }
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) === null)) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c9bebdf97d7b2932919d151169f2efbf'))['border-style'] = 'none';
        }
        return null;
      }
    }
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Parent Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`Parent Last Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`Parent Email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`Parent Phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`Parent Address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`Parent Relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContact'] = (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) === null) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) : true);
    checkMap = (await Backendless.Data.of('parent_maps').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join(''))).setPageSize(10)));
    if (!checkMap.length) {
      geocode = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeChargebeeAddressConversion`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')))));
      masked_location = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeMaskLocation`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat': (Number((getObjectProperty(geocode, 'lat')))),'lon': (Number((getObjectProperty(geocode, 'lon')))) }));
      parent_map = (await Backendless.Data.of('parent_maps').save( ({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`share_contact`]: 'Yes',[`location`]: (new Backendless.Data.Point().setX((getObjectProperty(geocode, 'lon'))).setY((getObjectProperty(geocode, 'lat')))),[`masked_location`]: (new Backendless.Data.Point().setX((getObjectProperty(masked_location, 'lon'))).setY((getObjectProperty(masked_location, 'lat')))) }) ));
      await Backendless.Data.of('parent_maps').setRelation(({ [`objectId`]: (getObjectProperty(parent_map, 'objectId')) }), 'student_dir', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId'))]);
      await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`share_contact`]: 'Yes' }) );
    } else {
      await Backendless.Data.of('parent_maps').save( ({ [`objectId`]: (getObjectProperty((checkMap[0]), 'objectId')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) }) );
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 2nd Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/b0533e09442c07b1fa1bc4340543bccc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/3e748f3b3e9ab433bb12640eff6650cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c51f833774ac25c2e7877565349624fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/6d738d39260f4e583da4ab0cd6d838be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    console.log((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) && ((JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')))) == '{}' || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === 'undefined')) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === null) || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')) === 'undefined') || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) && ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_last_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_email')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_phone')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_address')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_relation')) === null) || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')) === 'undefined')));
    console.log((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) && ((JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')))) == '{}' || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === 'undefined')));
    console.log((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === null) || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')) === 'undefined'));
    console.log((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) && ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_last_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_email')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_phone')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_address')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_relation')) === null) || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')) === 'undefined')));
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) && ((JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')))) == '{}' || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === 'undefined')) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === null) || (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === null) || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')) === 'undefined') || false) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        console.log('test test ');
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('035a1adcaaa694f1c38e5bf639eebadc', true);
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('30084e4e0553f76a546808bff8cb5def')));
        if (true) {
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b6e9476cb1ee67733fd4c8a37bb2810d'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b6e9476cb1ee67733fd4c8a37bb2810d'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45645d7ad44962ce40c9e9844653fd7a'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45645d7ad44962ce40c9e9844653fd7a'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9bc1f443f224af1351ee8d7cce568764'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9bc1f443f224af1351ee8d7cce568764'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d77ff2b8d41a53f9024e9696331a8f94'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d77ff2b8d41a53f9024e9696331a8f94'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('061acbf520484e6a21d5c30ca545842e'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('061acbf520484e6a21d5c30ca545842e'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cb748ba1c4a8bb58110af6ea8867edc2'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cb748ba1c4a8bb58110af6ea8867edc2'))['border-color'] = 'red';
          }
        }
        if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) {
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_name')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ff620176ef35bb39fc6555d8cd1ba2bb'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ff620176ef35bb39fc6555d8cd1ba2bb'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_last_name')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('66a4c3047451cc8c34fa129193aa24c8'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('66a4c3047451cc8c34fa129193aa24c8'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_email')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96891818db69f49560988cb6165f2439'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96891818db69f49560988cb6165f2439'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_phone')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cd8916e2ed6ee62e979b42fb554117f8'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cd8916e2ed6ee62e979b42fb554117f8'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_address')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a54e827760398688242d6bbc62def0f'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a54e827760398688242d6bbc62def0f'))['border-color'] = 'red';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_relation')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d01efc12630fba6dff4c17bccd9de6f9'))['border-style'] = 'solid';
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d01efc12630fba6dff4c17bccd9de6f9'))['border-color'] = 'red';
          }
        }
        console.log(JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3'))));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) && ((JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')))) == '{}' || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === 'undefined'))) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d241451218b36ae53f8419d048151f1'))['border-style'] = 'solid';
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d241451218b36ae53f8419d048151f1'))['border-color'] = 'red';
        }
        await new Promise(r => setTimeout(r, 3000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('035a1adcaaa694f1c38e5bf639eebadc', false);
        if (true) {
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_name')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b6e9476cb1ee67733fd4c8a37bb2810d'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_last_name')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45645d7ad44962ce40c9e9844653fd7a'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_email')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9bc1f443f224af1351ee8d7cce568764'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_phone')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d77ff2b8d41a53f9024e9696331a8f94'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_address')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('061acbf520484e6a21d5c30ca545842e'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')), 'parent_relation')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cb748ba1c4a8bb58110af6ea8867edc2'))['border-style'] = 'none';
          }
        }
        if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) {
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_name')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ff620176ef35bb39fc6555d8cd1ba2bb'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_last_name')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_last_name')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('66a4c3047451cc8c34fa129193aa24c8'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_email')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_email')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96891818db69f49560988cb6165f2439'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_phone')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_phone')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cd8916e2ed6ee62e979b42fb554117f8'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_address')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_address')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a54e827760398688242d6bbc62def0f'))['border-style'] = 'none';
          }
          if ((typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_relation')) === 'undefined') || ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')), 'parent_relation')) === null)) {
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d01efc12630fba6dff4c17bccd9de6f9'))['border-style'] = 'none';
          }
        }
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) && ((JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')))) == '{}' || (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) === 'undefined'))) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d241451218b36ae53f8419d048151f1'))['border-style'] = 'none';
        }
        return null;
      }
    }
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['interests'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentInfo')), 'interests'));
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['secondary_guardian'] = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716'));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['tertiary_guardian'] = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8'));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PTO'] = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3'));
      Object2 = ({ [`Secondary Guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`Tertiary Guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO Interests`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',j == 'Secondary Guardian' || j == 'Tertiary Guardian' ? ['\nFirst Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_name')),'\nLast Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_last_name')),'\nEmail:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_email')),'\nPhone:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_phone')),'\nAddress:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_address')),'\nRelation:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_relation'))].join('') : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? String(getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')) + String(((getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')).includes('Other ideas')) ? String(':') + String(getObjectProperty((getObjectProperty(Object2, j)), 'Other')) : '') : '')].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',j == 'Secondary Guardian' || j == 'Tertiary Guardian' ? ['\nFirst Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_name')),'\nLast Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_last_name')),'\nEmail:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_email')),'\nPhone:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_phone')),'\nAddress:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_address')),'\nRelation:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_relation'))].join('') : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? String(getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')) + String(((getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')).includes('Other ideas')) ? String(':') + String(getObjectProperty((getObjectProperty(Object2, j)), 'Other')) : '') : '')].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',j == 'Secondary Guardian' || j == 'Tertiary Guardian' ? ['\nFirst Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_name')),'\nLast Name:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_last_name')),'\nEmail:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_email')),'\nPhone:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_phone')),'\nAddress:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_address')),'\nRelation:',(getObjectProperty((getObjectProperty(Object2, j)), 'parent_relation'))].join('') : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? String(getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')) + String(((getObjectProperty((getObjectProperty(Object2, j)), 'PTOOptions')).includes('Other ideas')) ? String(':') + String(getObjectProperty((getObjectProperty(Object2, j)), 'Other')) : '') : '')].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`tertiary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 3rd Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/cf45d6e16c3d9a34d9a3bb7fa68f6555/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/30084e4e0553f76a546808bff8cb5def/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/2ae80c656e01f3886fc152384b498e7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.6disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/e54cbd01874556f909cbb7c47b453643/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.6disabled'] = true;
  if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
    return null;
  }
  changed_fields = [];
  oldData = ({  });
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
  }
  var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) })));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) !== null && !Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) === 'object')) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != (((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)) !== null && !Array.isArray((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j))) && (typeof (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)) === 'object')) ? (JSON.stringify((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) : (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) {
      addItemToList(changed_fields, j);
      oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
    }
  }
  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
  console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
  await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/94e617e2071c15dbbbd4b14b6bbbe6af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['secondary_guardian_show'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowGuardianHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowGuardianHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowGuardianHovered')) ? '#F89C77' : '#F5713C' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowGuardianHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowGuardianHovered'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/6446fa6c54abaf8bac66358eb2ed02fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['secondary_guardian_show'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['secondary_guardian'] = null;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowGuardianHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowGuardianHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowGuardianHovered')) ? '#F89C77' : '#9998A3' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowGuardianHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowGuardianHovered'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/2c6824b1c9fc9b04fc2424c31ecd9716/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show')) === 'boolean')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0b02e254208d1541598583546c4480e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/ff5deb6bc77dbb81ce1bdd4caa4cce15/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/4a0f4741af8ec4eaba74d4e71da7b496/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/9e5eeba8104634048e39dc62d87cc961/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/7c3fab816a4dd4f939279ec20d7f3a51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0bfc45e1d55d5ecb72552d0aa43696e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Organize parent meetups in your area', 'Participate in parent meetups in your area', 'Host afternoon clubs on zoom, eg. chess club', 'Host midday recess in a zoom room', 'Help organize one-off themed events', 'Other ideas']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/2b8b4e22d5ecf839c1c5a7fbcc16be2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2b8b4e22d5ecf839c1c5a7fbcc16be2b')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')).length) {
      ___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3')['PTOOptions'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')), ___arguments.context.dataModel, '');
    if (___arguments.context.dataModel == 'Other ideas') {
      ___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3')['Other'] = null;
    }
  }
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions'));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPTO')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPTO'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPTO'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/1852c2a7cd6180f659a3a6f7550ad602/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('2b8b4e22d5ecf839c1c5a7fbcc16be2b')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/2757bcb836de8c3855e11a14e8e43942/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) == 'Florida' && true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/54cce2629fed97f38322198de364fcdb/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return [({ [`choice`]: 'Confirming',[`description`]: 'We have already completed the necessary vaccinations and have sent relevant form for to the state’s' }), ({ [`choice`]: 'Pending',[`description`]: 'We don\'t currently have the form, but we will be submitting it shortly.' }), ({ [`choice`]: 'Exemption',[`description`]: 'We are seeking an exemption and will be submitting it soon' })]

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c76ec7713d240401ad3bf0fd775e304c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c76ec7713d240401ad3bf0fd775e304c')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ExemptionShow'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = 'Confirming';
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = null;
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) === null)) ? ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) == 'Confirming' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) == 'Confirming' ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredConfirming')) == 'Confirming' ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredConfirming'] = 'Confirming';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredConfirming'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/42f4d6b8dd0b3278dab5daae62499456/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ExemptionShow')) === 'boolean') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ExemptionShow')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/2209e0c9e42b3db55407737f3c9d0f3c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2209e0c9e42b3db55407737f3c9d0f3c')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ExemptionShow'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = 'Pending';
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = null;
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) === null)) ? ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) == 'Pending' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) == 'Pending' ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPending')) == 'Pending' ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPending'] = 'Pending';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPending'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/fb1ae4f43012bcffcee6bc2d2cbb40c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb1ae4f43012bcffcee6bc2d2cbb40c2')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ExemptionShow'] = true;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['vaccine_situation'] = null;
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ExemptionShow'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ExemptionShow')) === 'boolean') ? ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ExemptionShow')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredExemption')) ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredExemption'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredExemption'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/9e69fea177555565b8c91a2f52d7e354/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/8886358f6346b03b1dd2dce24cb9db7e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['What was the address of ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s last school?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c7c344ab35c1346f3ea97687a6b3697f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('663db5f617bd76ac60880ea579194c34')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/663db5f617bd76ac60880ea579194c34/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (___arguments.context.dataModel == 'English 1' ? '9th Grade English or Freshman English' : (___arguments.context.dataModel == 'English 2' ? '10th Grade English or Sophomore English' : (___arguments.context.dataModel == 'English 3' ? '11th Grade English or Junior English' : '12th Grade English or Senior English')))

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('663db5f617bd76ac60880ea579194c34')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredEnglish')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredEnglish'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredEnglish'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/53eb2d3228423c2d6a645824c463f6d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c66a2e5f84ce5e5545fa0f3c89889def/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66a2e5f84ce5e5545fa0f3c89889def')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredMath'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredMath'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/310f12a2da325905d658d54a8467c5ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('c66a2e5f84ce5e5545fa0f3c89889def')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/683d024c0d0e744e5b915c7742e4cfd4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/85bbb92a9cafcd619eee1da95cfa3ac4/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (___arguments.context.dataModel == 'Psychology' ? 'or AP Psychology' : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85bbb92a9cafcd619eee1da95cfa3ac4')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredSocStud')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredMath')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredSocStud'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredSocStud'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/009cc2d488836768456af091bcb261bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('85bbb92a9cafcd619eee1da95cfa3ac4')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/5829ab0a7598a5cd423a649564991d27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5829ab0a7598a5cd423a649564991d27')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredScience')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredScience'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredScience'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/f0bcb7eef2bede3f7a6585f768c4f0d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('5829ab0a7598a5cd423a649564991d27')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/43358406225d115bdb1210032e983052/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/9f6ba791c8ea28c66162a3d8cdd75d97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('0b276207d3bf2a94b1bc6763e862a974')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0b276207d3bf2a94b1bc6763e862a974/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredPEH')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0b276207d3bf2a94b1bc6763e862a974')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPEH'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredPEH'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/66c512d9a5f9391dcefa8a916fd66d4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/cf0975d97a29bf3529188505ba927209/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf0975d97a29bf3529188505ba927209')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (___arguments.context.dataModel == 'Spanish' ? 'Levels 1-5, including AP Spanish Language or AP Spanish Literature' : (___arguments.context.dataModel == 'French' ? 'Levels 1-5, or AP French Language' : (___arguments.context.dataModel == 'German' ? 'Levels 1-4 or 5' : 'Levels 1-4 or 5, or AP Chinese Language')))

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredWorldLang')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredWorldLang'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredWorldLang'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/0e8518f2583e1e266d951353e716b2b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('cf0975d97a29bf3529188505ba927209')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/500b35e231c83ca521d328bacdc886bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/dc937c0b4fe157bc97c4a7241f8e92be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('929f144ea0ef31f4b6a4a486079bef7f')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/929f144ea0ef31f4b6a4a486079bef7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('929f144ea0ef31f4b6a4a486079bef7f')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredFineArts')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredFineArts'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredFineArts'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/e84d3971a5ead984d9a3c18ddd3133dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/dfe4da3438bf20c5a6838c04954b6785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('452ff1ec3a5ed5615b3416ad537e1697')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/452ff1ec3a5ed5615b3416ad537e1697/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).includes(___arguments.context.dataModel)) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredCTE')) == ___arguments.context.dataModel ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('452ff1ec3a5ed5615b3416ad537e1697')), 'box-shadow')) != '0px 0px 0px 2px #F5713C inset') {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [___arguments.context.dataModel];
    } else {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel);
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), ___arguments.context.dataModel, '');
  }

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (___arguments.context.dataModel == 'Computer Science' ? 'Including AP Computer Science A and Principles' : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredCTE'] = ___arguments.context.dataModel;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ItemHoveredCTE'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/f0a5904fce4fe3f5de5765a7a516676a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6.1disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/29acfd66c685c296d2884ef672d148bf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, date, j, oldData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6.1disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I prefer you source them from the school ($5 processing fee)') {
      date = (new Date());
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': (['Collect ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s Records ($5 fee)'].join('')),'date': date,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/89cc536a06a6fe8c67bc3951356544a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/5a4b671dc6542eb8a3f4293d053b8271/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) === 'undefined') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
      Object2 = ({ [`Credit Transfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`Transcript Files`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) });
      var j_list = (Object.keys(Object2));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
        } else {
          replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
        }
      }
      console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 9th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/eccc9e69245e0babd422c7e9a9728261/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/30feead2b9e174a496f94fa73dfb042b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowPTOQuestions'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOHovered')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowPTOHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowPTOHovered'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/b4fc77a3e9148b6db6aeb983f97c34b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/6d7e20ec1235f4a8a0bd2946429b1fd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShowPTOQuestions'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PTO'] = null;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShowPTOQuestions')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowPTOHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowPTOHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShowPTOHovered')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowPTOHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShowPTOHovered'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/e19ca2d70fc323a873099c596c61c3b4/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'English')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['EnglishShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['EnglishShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/b41283063c912739b4c1f73c13249301/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Math')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['MathShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['MathShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'MathShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/a7c38fdf85a98fe2dcd9ba422a25d245/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocialStudies')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['SocStudShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['SocStudShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'SocStudShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/3cd12f8dbbdbfd6c2104e0bbe68fc659/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Science')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ScienceShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ScienceShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ScienceShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/c50e3ef60efb74bd09840c3b5699d797/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PE&Health')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PEHShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['PEHShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/7817ff9e102ae21ccaef5543e47f570f/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLanguage')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['WorldLangShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['WorldLangShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'WorldLangShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/d88540a6a8749eca66e8cf3390189843/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArts')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['FineArtsShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['FineArtsShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'FineArtsShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/034af72122456c5d4d1327b868dd9b4e/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')).length ? String(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')), async (item) => {


 return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTE')).includes(item));
})) : null)

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')) === 'undefined') {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CTEShow'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CTEShow'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CTEShow')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/02bc09052fc5492afb0454e2dece4e8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/7c15baf6c5f42a8e23e2da93ee510f82/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CallNotes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/bee16249008955367aa87137091c7aff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CallNotes')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/df6e488df9c72379ed84298168fdfb69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['noteTextVisible'] = (!(getObjectProperty(___arguments.context.dataModel, 'noteTextVisible')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/853cf34f946fc484c3dbb39847b68ca2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Note;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.dataModel, 'noteTextVisible')) === 'undefined') && (getObjectProperty(___arguments.context.dataModel, 'noteTextVisible')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/b0446715cd37d435b47390d6f6864245/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://app.close.com/lead/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'lead_id')),'/'].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/4db5af31c231a0a1c17d7e2a12ffbc1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var StudentList, item, StudentLeadIDs;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['StudentsWithMissingValues'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', true);
  ___arguments.context.pageData['QCclicked'] = 'QC1';
  StudentLeadIDs = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIfindLeadObjectByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`entityName`]: 'lead',[`entityID`]: undefined,[`queryParam`]: '"custom.*bg service":(Microschool) "custom.*lifetime amount" > 500 lead_status in ("Families (Tutoring)") ',[`outputField`]: 'id',[`outputCount`]: 1000 })))).map(async item => {; return (getObjectProperty(item, 'id'));})));
  StudentList = (await asyncListFilter((await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause('most_interested_in is null and subjects not like \'%_ESE_%\' and subjects like \'%MS%\'').setRelated('slots').setPageSize(100))), async (item) => {


   return (StudentLeadIDs.includes((getObjectProperty(item, 'lead_id'))));
  }));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', false);
  ___arguments.context.pageData['StudentsWithMissingValues'] = StudentList;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'QCclicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'QCclicked')) == 'QC1' ? ({ [`box-shadow`]: '0px 0px 0px 2px #F5713C inset' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0fac23642a4a1a5229c3bcd2c14a7018/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var StudentList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['StudentsWithMissingValues'] = null;
  ___arguments.context.pageData['QCclicked'] = 'QC2';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', true);
  StudentList = (await asyncListFilter((await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause('submit_step_up = true').setRelated('slots').setPageSize(100))), async (item) => {


   return (((getObjectProperty(item, 'step_up_id')) === null) || !((getObjectProperty(item, 'step_up_id')) === null) && !(typeof (Number((getObjectProperty(item, 'step_up_id')))) === 'number' && !isNaN((Number((getObjectProperty(item, 'step_up_id')))))));
  }));
  console.log(StudentList);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', false);
  ___arguments.context.pageData['StudentsWithMissingValues'] = StudentList;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'QCclicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'QCclicked')) == 'QC2' ? ({ [`box-shadow`]: '0px 0px 0px 2px #F5713C inset' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0f62689ee309f3e3ae8d3b923438963e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === null)) && !!(getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/9bad409a3fb5d3896513cf8187f71f39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var StudentList;


  ___arguments.context.pageData['StudentsWithMissingValues'] = null;
  ___arguments.context.pageData['QCclicked'] = 'QC3';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', true);
  StudentList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause('learning_environment_past_12_months not like \'%Homeschool%\' and transcriptFiles is null and status = \'enrolled\'').setRelated('slots').setPageSize(100)));
  console.log(StudentList);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', false);
  ___arguments.context.pageData['StudentsWithMissingValues'] = StudentList;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'QCclicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'QCclicked')) == 'QC3' ? ({ [`box-shadow`]: '0px 0px 0px 2px #F5713C inset' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/87be630d169dbcabfc39d26d2f1cf1ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var StudentList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['StudentsWithMissingValues'] = null;
  ___arguments.context.pageData['QCclicked'] = 'QC4';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', true);
  StudentList = (await asyncListFilter((await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause('vaccine_situation is null').setRelated('slots').setPageSize(100))), async (item) => {


   return ((getObjectProperty(((getObjectProperty(item, 'slots'))[0]), 'grade')) == 'Kindergarten' || (getObjectProperty(((getObjectProperty(item, 'slots'))[0]), 'grade')) == 'Grade 7');
  }));
  console.log(StudentList);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d26e98e4849519b46092e75dd0c2d1d3', false);
  ___arguments.context.pageData['StudentsWithMissingValues'] = StudentList;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'QCclicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'QCclicked')) == 'QC4' ? ({ [`box-shadow`]: '0px 0px 0px 2px #F5713C inset' }) : null)

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c978e87c0d5bef09d1361e8b8b417ca9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === null)) && !(getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/6c9fdd7df2aa7c357437b51174882da4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['sectionClicked'] = 'studentQC';
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b32531b25d7b13d73b9cf3e1b28fe138')), 'display')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b32531b25d7b13d73b9cf3e1b28fe138', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02e89d912cb30fafe9428e752623b0d8', true);
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'sectionClicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'sectionClicked')) == 'studentQC' ? ({ [`box-shadow`]: '0px 4px 0px 0px #32325D' }) : ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') && (await Backendless.UserService.isValidLogin()) ? true : (!(getObjectProperty(___arguments.context.pageData, 'isTeacher')) && (await Backendless.UserService.isValidLogin()) ? true : (!(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/926bf66956dc230fbbfdb2377d68a85a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('02e89d912cb30fafe9428e752623b0d8')), 'display')) {
    ___arguments.context.pageData['sectionClicked'] = 'studentInfo';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b32531b25d7b13d73b9cf3e1b28fe138', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02e89d912cb30fafe9428e752623b0d8', false);
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'sectionClicked')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'sectionClicked')) == 'studentInfo' ? ({ [`box-shadow`]: '0px 4px 0px 0px #32325D' }) : ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') && (await Backendless.UserService.isValidLogin()) ? true : (!(getObjectProperty(___arguments.context.pageData, 'isTeacher')) && (await Backendless.UserService.isValidLogin()) ? true : (!(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/b8d363c75b75ed3397fc3e8f05c7cbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var date, j, reminderLastSent, scheduled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  reminderLastSent = (new Date());
  var j_list = (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`reminderLastSent`]: reminderLastSent }) );
    j['loadingReminder'] = true;
    scheduled = (new Date((new Date()).getTime() + (300 * 1000)));
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': scheduled,'lead_id': (getObjectProperty(j, 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(((getObjectProperty(j, 'slots'))[0]), 'email')),'body_html': (['Dear ',(getObjectProperty(j, 'parent_name')),',<br><br>There are a few important fields in your Student Information that require an update.','<br><br>Please log on <a href="https://portal.brilliantgrades.com/Clever/?page=student_form&lead_id=',(getObjectProperty(j, 'lead_id')),'">here</a> to quickly add the required information.<br>Kindly note that all students\' information are kept secure and in compliance with FERPA.','<br><br>Best regards,','<br>The Parent Support Team'].join('')),'subject': 'Reminder to update your Student Information' });
    j['loadingReminder'] = false;
    j['reminderSent'] = true;
    await new Promise(r => setTimeout(r, 1000 || 0));
    j['reminderSent'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/8e1fda824169117ff95a4c93c2dd55e7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'reminderSent')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'reminderSent')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f9b538bd90e1abe14c1207a9950eb364/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'loadingReminder')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9c7b052f43e6f6585e9fcbeede840d2'), 'loadingReminder')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/d801ea279c99052fdb5d3f548a41e233/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === null)) && !!(getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/665bfd758f4ce9eb55d256518f5ecb6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues')) === 'undefined') ? (!((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues'))[0]), 'reminderLastSent')) === null) ? ((String(String(new Date((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'StudentsWithMissingValues'))[0]), 'reminderLastSent')))).split(' ').slice(0, 5))).replace((new RegExp(',', 'g')), ' ')) : '') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/b8b42495e142c6bfcc122ba3d73b53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dateScheduled, updateFile, accessTokenString, copyInvoiceTemplate, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
    console.log('new Google Drive API auth code needed');
    accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
    await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
    accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
  } else {
    accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae9cf60c2bee1ec2b71324460329614e', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b8b42495e142c6bfcc122ba3d73b53d4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('509d3857dcd39544596591dcdaa79601', true);
    if (!(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeParentName')) === null) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeStudentName')) === null))) {
      copyInvoiceTemplate = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveCopyFileIDtoFolderIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'sourceFileID': '1leXqbMKzIwI2EXnavTZX-XKMajr0m2TMqpkmV-5-hj8','fileName': (['BMS Honor Code - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),' and ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join('')),'destinationFolderID': '1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K' }));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveAllowFileAccessByFileIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(copyInvoiceTemplate, 'id'))));
      updateFile = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://docs.googleapis.com/v1/documents/',(getObjectProperty(copyInvoiceTemplate, 'id')),':batchUpdate'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`requests`]: [({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{parentSignature}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeParentName')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{studentSignature}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeParentName')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{dateSigned}}',[`matchCase`]: true }),[`replaceText`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('') }) })] })));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['honorCodeURL'] = (['https://docs.google.com/feeds/download/documents/export/Export?id=',(getObjectProperty(updateFile, 'documentId')),'&exportFormat=pdf'].join(''));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['honorCodeSigned'] = 'Completed';
      await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`honorCodeSigned`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')),[`honorCodeURL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) }) );
      dateScheduled = (new Date((new Date()).getTime() + (300 * 1000)));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': dateScheduled,'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),'body_html': (['Dear ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),',','<br><br>I trust this email finds you well. Thank you for taking the time to review and sign the honor code. Your commitment to our shared values is greatly appreciated.','<br><br>Attached to this email, you will find a copy of the signed honor code for your records. Please feel free to reach out if you have any questions',['<br><br><a href=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')),'\'>Brilliant Microschool Honor Code</a>'].join(''),'<br><br>Best Regards,','<br><br>Parent Support Team<br><img src= \'https://lh6.googleusercontent.com/hnkDEFumM6CbPs3YxDAwWOcvchVNNwOawvbe-zzLebpvQ1HaJSrBBhJrpn-PeVYUHesnL6zm_31TBdeCqMVBlaTkq-NVaJFrk5zrl0f4EZn0rvc6-ftZkvxJ71oN0HQxIw-KqrPwB8Jj2bgYoO84rng\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': 'Signed Honor Code' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('509d3857dcd39544596591dcdaa79601', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b8b42495e142c6bfcc122ba3d73b53d4', true);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/1df16677f5435328fce7de6789249efc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' ? 'View Signed Code' : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed through PandaDoc' ? 'Signed' : 'Sign'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/3716c848f5613d129cd50d5390755802/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/015eb939bb2741f8e13fc0288bb5e079/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/661c2ccb0be5a8dede7bac6e57eed2ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Not Completed' && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) === 'undefined')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('883bcde55757843909fcb379d4a7b5a2', true);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-style'] = 'solid';
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-color'] = 'red';
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a')));
        await new Promise(r => setTimeout(r, 2000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('883bcde55757843909fcb379d4a7b5a2', false);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-style'] = 'none';
        return null;
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
    Object2 = ({ [`Honor Code URL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) });
    var j_list = (Object.keys(Object2));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
      } else {
        replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
      }
    }
    console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`honorCodeURL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 12th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/d2afb5bd7ab7c3d3ae19739310193834/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae9cf60c2bee1ec2b71324460329614e', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/2e66bc8fd371831c28e612adb699ae52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae9cf60c2bee1ec2b71324460329614e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/338b0e0d31d9d6cf2d4f878108b5ac71/bundle.js', [], () => ({
  /* content */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) : 'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/honor+codes/honorCodeDefault.pdf')

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/SIS_v2/components/71d47d08a45594c2bbf431a1900df34a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('BMS_time_table', (((getObjectProperty(___arguments.context.pageData, 'StudentInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'StudentInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'object')) ? ({ [`studentMSEmail`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentInfo')), 'studentMSEmail')),[`student_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentInfo')), 'student_name')) }) : ___arguments.context.pageData));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/bf79eafbca1136ca142c21f810d24283/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['BirthCert_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    console.log(Metadata);
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['birthCertMetaData'] = Metadata;

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_184994440a04f7b16266320a3805a58f']('Birth Certificate Upload', 'An issue has occured while the upload was running', error);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('bf79eafbca1136ca142c21f810d24283');
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentBirthCert'] = (['https://drive.google.com/file/d/',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'birthCertMetaData')), 'id')),'/view'].join(''));
  await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')) }) );

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['BirthCert_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/5bc79764702eed53488c4e2f6d3cd5e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'birthCertMetaData')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'birthCertMetaData')) === null)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0108c5c8e32c13b6c4923262daee2691/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5bc79764702eed53488c4e2f6d3cd5e2'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['birthCertMetaData'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/2d043a6fee89e7e95fb18aa5797faa0d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['StudentPic_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    console.log(Metadata);
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentPicMetaData'] = Metadata;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('2d043a6fee89e7e95fb18aa5797faa0d');
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentPic'] = (['https://drive.google.com/file/d/',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPicMetaData')), 'id')),'/view'].join(''));
  await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) }) );

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['StudentPic_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/3ecbd2d7774be4f7e44f93ae2c918526/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPicMetaData')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPicMetaData')) === null)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/79ccef7ab42631a33c4e80d41e45b0ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3ecbd2d7774be4f7e44f93ae2c918526'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentPicMetaData'] = null;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/12d48721fb0900cb04b60141830126f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'EnglishShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/65bbab8c95cfc0539bb13be7d3f67201/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')) === 'undefined') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PEHShow')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/e42fe89912f7a5de822f4994c7cf9e16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'requiredList')) === 'undefined') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'requiredList')).includes('student_name')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/5c186baacc043fa9f5ae44ed09859505/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'requiredList')) === 'undefined') && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'requiredList')).includes('student_last_name')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/9f43f04b940ae486bbaf4c070c242d46/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHovered')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHovered')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHovered')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransferHovered'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransferHovered'] = false;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transferCredit'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/3ee4bbcbd5552c7262650d561e1839be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transferCredit'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransfer'] = [];

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var StudentInfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHoveredNo')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHoveredNo')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransferHoveredNo')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransferHoveredNo'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['CreditTransferHoveredNo'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/6bef1c7b36d86cf67aee127af0e7e389/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/27a3a738e1735a671e9ffeae72c3cc78/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b4fc77a3e9148b6db6aeb983f97c34b3'), 'PTOOptions')).includes('Other ideas')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c87d8e8560d3d46367fcba43a73972e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Please share any records or transcripts from ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s prior school(s)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a94a02f75ea530fb5a1ed2ec441f2f95/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I can upload them' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscriptHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscriptHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscriptHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['uploadTranscript'] = 'I can upload them';

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['uploadTranscriptHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['uploadTranscriptHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/2571eb09175cf6fd1bfe925dd035c673/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I prefer you source them from the school ($50 processing fee)' ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'dontUploadTranscriptHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'dontUploadTranscriptHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'dontUploadTranscriptHover')) ? '#F89C77' : '#FAE2D9' })

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['uploadTranscript'] = 'I prefer you source them from the school ($50 processing fee)';

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['dontUploadTranscriptHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['dontUploadTranscriptHover'] = false;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/SIS_v2/components/e6530f5a1c1dac85e0c27c7c181328c2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I can upload them')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/71dbbd1be5758d3352a21af8b3155406/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var error, Metadata, accessTokenString, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
      console.log('new Google Drive API auth code needed');
      accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
      accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
    } else {
      accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`name`]: ['Transcript_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''),[`parents`]: ['1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K'],[`mimeType`]: (getObjectProperty((___arguments.files[0]), 'type')) })));
    console.log(Metadata);
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: (getObjectProperty((___arguments.files[0]), 'type')) })).setEncoding('utf8').send((___arguments.files[0]));
    if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')).length) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2bee94e2c48eb648a19a0a395af70b4f', [Metadata]);
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')), Metadata);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var item;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('71dbbd1be5758d3352a21af8b3155406');
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transcriptFiles'] = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')).map(async item => {; return (['https://drive.google.com/file/d/',(getObjectProperty(item, 'id')),'/view'].join(''));})));
  await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) }) );

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Transcript_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/bf3436869c7d27eb9064d231cc2c40a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var accessTokenObject, accessTokenString, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce310896e2297c946d1544c84cc5613d'), 'id')).indexOf('typeform') !== -1)) {
      if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
        console.log('new Google Drive API auth code needed');
        accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
        await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
        accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
      } else {
        accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
      }
      await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://www.googleapis.com/drive/v2/files/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce310896e2297c946d1544c84cc5613d'), 'id'))))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send();
    }
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')), ___arguments.context.getComponentDataStoreByUid('ce310896e2297c946d1544c84cc5613d'), '');
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['transcriptFiles'] = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('2bee94e2c48eb648a19a0a395af70b4f')).map(async item => {; return (['https://drive.google.com/file/d/',(getObjectProperty(item, 'id')),'/view'].join(''));})));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/ab564af2dd0ec3ced2313df90da9ceed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0fbc747969a1dc23f07db92d7e41a33a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/7b62f89607da6ff34c42ba04b0568f7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/9fbe3e64a914ea2ff1be143b8ed53de5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/34b6661a385f8066585fbfee59f162a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a2dbbcb5b30a5fafdd9844971deb422c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/11c8c349cf3323eb82661afe4cec7b55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/37ae315e43343c8cce161c2c92f55b31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/890bdfe8a7a30a5650b70f0c6b873b3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/2b2a6248968194c91bfcca06944a5a7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/ffe54f9c4b134d01dd21542c6e6b2ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'bold';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['color'] = '#32325D';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9'))['font-weight'] = 'normal';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bbfc25fdf15be1929c420f79dd750f9')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`z-index`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? '1' : '-1' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/89ac2a4a23f9cc5e164f465276d5e872/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['9disabled'] = false;
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/51299101a47bc22ffdcd427d00d450cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['9disabled'] = true;
  if (true) {
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) ? (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`lastQuestionBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lastQuestionBool')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`lastQuestionBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lastQuestionBool')),[`learningCenterBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '9disabled')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/2c0f370547bac0f138f874ef942920dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['The form\'s required fields are ',Math.round(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PercentCompleted')),'% completed.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f4faf2094324352ed5bef53a47dc1899/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NotCompletedFields')) === 'undefined') ? null : String(' - ') + String((String(await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NotCompletedFields')).map(async item => {; return (item == 'Ethnicity' ? 'Ethnicity' : (item == 'student_name' ? 'Student Name' : (item == 'student_last_name' ? 'Student Last Name' : (item == 'student_birth_date' ? 'Student Birth Date ' : (item == 'most_interested_in' ? 'Student Most Interested in' : (item == 'behavior' ? 'Behaviorial Challenges' : (item == 'parent_address' ? 'Parent Address' : (item == 'email' ? 'Parent Email' : (item == 'parent_phone' ? 'Parent Phone' : (item == 'parent_name' ? 'Parent Name' : (item == 'parent_last_name' ? 'Parent Last Name' : (item == 'science_grade_level' ? 'Science Grade Level' : (item == 'ela_grade_level' ? 'ELA Grade Level' : (item == 'math_grade_level' ? 'Math Grade Level' : (item == 'learning_environment_past_12_months' ? 'Learning ENVIRONMENT for the past 12 months' : (item == 'learning_experiece_past_12_months' ? 'Learning EXPERIENCE for the past 12 months' : (item == 'upload_copy_EIP_504_plan' ? 'Upload a copy of the EIP Plan' : (item == 'CreditTransfer' ? 'Credit Transfer Subjects' : (item == 'home_state' ? 'Home State' : (item == 'honorCodeSigned' ? 'Sign the Honor Code' : 'Transcript for Credit Transfer'))))))))))))))))))));})))).replace((new RegExp(',', 'g')), '\n - ')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/6758c6352b86b81d7bf7081596f8d29e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') ? false : ((typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') && (await Backendless.UserService.isValidLogin()) ? true : (!(getObjectProperty(___arguments.context.pageData, 'isTeacher')) && (await Backendless.UserService.isValidLogin()) ? true : (!(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') ? true : false)))) && (await Backendless.UserService.isValidLogin()) && Math.round(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'PercentCompleted')) != 100)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/fc278ebd9082c595526f3f26a80a91c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fbfbe341023d509b126c6aea08e7172', true);
  date = (new Date((new Date()).getTime() + (600 * 1000)));
  await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': date,'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'sender_name': 'Brilliant Microschool','sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'slots'))[0]), 'email')),'body_html': (['<p>Dear ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),'</p><p>I hope this message finds you well. We noticed that some fields in ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s registration form are incomplete. Please complete the following fields:</p>','<ol>',((String(await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'NotCompletedFields')).map(async item => {; return (item == 'Ethnicity' ? '<li>Ethnicity</li>' : (item == 'student_name' ? '<li>Student Name</li>' : (item == 'student_last_name' ? '<li>Student Last Name</li>' : (item == 'student_birth_date' ? '<li>Student Birth Date</li>' : (item == 'most_interested_in' ? '<li>Student Most Interested in</li>' : (item == 'behavior' ? '<li>Behaviorial Challenges</li>' : (item == 'parent_address' ? '<li>Parent Address</li>' : (item == 'parent_email' ? '<li>Parent Email</li>' : (item == 'parent_phone' ? '<li>Parent Phone</li>' : (item == 'parent_name' ? '<li>Parent Name</li>' : (item == 'parent_last_name' ? '<li>Parent Last Name</li>' : (item == 'science_grade_level' ? '<li>Science Grade Level</li>' : (item == 'ela_grade_level' ? '<li>ELA Grade Level</li>' : (item == 'math_grade_level' ? '<li>Math Grade Level</li>' : (item == 'learning_environment_past_12_months' ? '<li>Learning ENVIRONMENT for the past 12 months</li>' : (item == 'learning_experiece_past_12_months' ? '<li>Learning EXPERIENCE for the past 12 months</li>' : (item == 'upload_copy_EIP_504_plan' ? '<li>Upload a copy of the EIP Plan</li>' : (item == 'CreditTransfer' ? '<li>Credit Transfer Subjects</li>' : (item == 'home_state' ? '<li>Home State</li>' : (item == 'honorCodeSigned' ? '<li>Sign the Honor Code</li>' : '<li>Transcript for Credit Transfer</li>'))))))))))))))))))));})))).replace((new RegExp(',', 'g')), '\n')),'</ol><p>Your prompt attention to this matter is appreciated. If you need assistance, please don\'t hesitate to contact us.<p>Best regards,<br>','<br><br>Parent Support Team<br><img src= \'https://lh6.googleusercontent.com/hnkDEFumM6CbPs3YxDAwWOcvchVNNwOawvbe-zzLebpvQ1HaJSrBBhJrpn-PeVYUHesnL6zm_31TBdeCqMVBlaTkq-NVaJFrk5zrl0f4EZn0rvc6-ftZkvxJ71oN0HQxIw-KqrPwB8Jj2bgYoO84rng\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': (String('Registration form completion required') + String('')) });
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fbfbe341023d509b126c6aea08e7172', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/9a12d1dc3b06970e1ad83f39097975d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Kindergarten') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0827f4d123ca93c9aab18336538f24df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 9') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 10') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 11') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 12') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 13') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/8674d858447b8ca18ee899d4634b0023/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 9') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 10') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 11') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 12') !== -1) || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Grade 13') !== -1)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0a72d4f4e0734d3ecdbc5974e7e2c505/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Object2, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
      if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) === 'undefined')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99e5d6d74b42a38337c84ceab5a3b8df', true);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-style'] = 'solid';
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-color'] = 'red';
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e')));
        await new Promise(r => setTimeout(r, 2000 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99e5d6d74b42a38337c84ceab5a3b8df', false);
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-style'] = 'none';
        return null;
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));
    Object2 = ({ [`Terms of Service URL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) });
    var j_list = (Object.keys(Object2));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (!((getObjectProperty(___arguments.context.pageData, 'ListForNote')).includes(([j,',',(getObjectProperty(Object2, j))].join(''))))) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), ([j,',',(getObjectProperty(Object2, j))].join('')));
      } else {
        replaceItemInList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), j, ([j,',',(getObjectProperty(Object2, j))].join('')));
      }
    }
    console.log(getObjectProperty(___arguments.context.pageData, 'ListForNote'));
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`ToSURL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Form Method - 13th Form').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/bf9e90475c8300db7daaa3c653798b44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/7c64b48c3b0c3bfebd4bdd989495d4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed through PandaDoc')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/81c9d80c1223c3b871b2a62c9ea5489f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Completed through PandaDoc')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/29274685236b31a3754f97dd69bcb9ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dateScheduled, updateFile, price, units, plan, last_name, first_name, address, IP, accessTokenString, copyInvoiceTemplate, chargebee, accessTokenObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
    console.log('new Google Drive API auth code needed');
    accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
    await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
    accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
  } else {
    accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a3742e89d91c31cbaf3df3a5fccd8a4', true);
  } else {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSParentName')) === null)) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29274685236b31a3754f97dd69bcb9ef', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0359ab94813e96756fab3303ab8edb56', true);
      chargebee = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIChargebeeGetObjectListByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'returnCount': 1,'isLiveCB': (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')).indexOf('TestPeterLive') !== -1)),'entityName': 'subscriptions','utmParan': (String('?customer_id[is]=') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'chargebeeID'))) }))[0];
      console.log(chargebee);
      plan = (getObjectProperty((getObjectProperty(chargebee, 'subscription')), 'plan_id'));
      units = (getObjectProperty((getObjectProperty(chargebee, 'subscription')), 'plan_quantity'));
      price = (getObjectProperty((getObjectProperty(chargebee, 'subscription')), 'plan_unit_price')) / 100;
      last_name = (getObjectProperty((getObjectProperty(chargebee, 'card')), 'last_name'));
      first_name = (getObjectProperty((getObjectProperty(chargebee, 'card')), 'first_name'));
      address = [(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_addr1')),' ',(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_city')),' ',(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_zip')),' ',(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_state_code')),' ',(getObjectProperty((getObjectProperty(chargebee, 'card')), 'billing_country'))].join('');
      IP = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GetIPFrontEnd`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), 'X-Real-IP'));
      copyInvoiceTemplate = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveCopyFileIDtoFolderIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'sourceFileID': '1WKFdWXqTCNfdpy9WfpzXyLwM_rrsSEV1aiRHIg_4Ztg','fileName': (String('BMS ToS - ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name'))),'destinationFolderID': '1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K' }));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveAllowFileAccessByFileIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(copyInvoiceTemplate, 'id'))));
      updateFile = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://docs.googleapis.com/v1/documents/',(getObjectProperty(copyInvoiceTemplate, 'id')),':batchUpdate'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`requests`]: [({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{parentSignature}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSParentName')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{userIP}}',[`matchCase`]: true }),[`replaceText`]: IP }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{dateSigned}}',[`matchCase`]: true }),[`replaceText`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('') }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{address}}',[`matchCase`]: true }),[`replaceText`]: address }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{contactName}}',[`matchCase`]: true }),[`replaceText`]: [first_name,' ',last_name].join('') }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{contactEmail}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{chargebeePlan}}',[`matchCase`]: true }),[`replaceText`]: plan }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{quantity}}',[`matchCase`]: true }),[`replaceText`]: String(units) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{price}}',[`matchCase`]: true }),[`replaceText`]: String(price) }) })] })));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ToSURL'] = (['https://docs.google.com/feeds/download/documents/export/Export?id=',(getObjectProperty(updateFile, 'documentId')),'&exportFormat=pdf'].join(''));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ToSBool'] = true;
      await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ToSBool`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')),[`ToSURL`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) }) );
      dateScheduled = (new Date((new Date()).getTime() + (300 * 1000)));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': dateScheduled,'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),'body_html': (['Dear ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),',','<br><br>I trust this email finds you well. Thank you for taking the time to review and sign the Terms of Service. ','<br><br>Attached to this email, you will find a copy of the signed Terms of Service for your records. Please feel free to reach out if you have any questions',['<br><br><a href=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')),'\'>Brilliant Microschool Terms of Service</a>'].join(''),'<br><br>Best Regards,','<br><br>Parent Support Team<br><img src= \'https://lh6.googleusercontent.com/hnkDEFumM6CbPs3YxDAwWOcvchVNNwOawvbe-zzLebpvQ1HaJSrBBhJrpn-PeVYUHesnL6zm_31TBdeCqMVBlaTkq-NVaJFrk5zrl0f4EZn0rvc6-ftZkvxJ71oN0HQxIw-KqrPwB8Jj2bgYoO84rng\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': 'Signed Terms of Service' });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0359ab94813e96756fab3303ab8edb56', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29274685236b31a3754f97dd69bcb9ef', true);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/85ba7c657ebdd2b9e0ce0f22abbf2d16/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) ? 'View Signed ToS' : 'Sign')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/48a3e4da787c432cf6a3571ffa132342/bundle.js', [], () => ({
  /* content */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) : null)

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/SIS_v2/components/f78564ffd6a98113224af9a7b0465a52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a3742e89d91c31cbaf3df3a5fccd8a4', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/3905c14ac74d5be6395392ce78a6a1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 1 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 1;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/41dab42f464563920f4ecd591eaca32a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 2 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 2;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/47ae4948596eca6b7d127837741cd482/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 3 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 3;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/d68b0bef223bcc3f0a46965b8f83d5bb/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 4 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 4;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/e4ce46f7c4f49b75b382e3769c583d01/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) >= 5 ? ({ [`color`]: '#F5713C' }) : ({ [`color`]: '#B4BAC8' }))

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['connecting_with_adults'] = 5;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/3f3fba9680ef4df7f49326d38e3fb423/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/8bc7beb9f8de96bc7dc5c7195b1d35b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f3fba9680ef4df7f49326d38e3fb423')), 'content')).indexOf('Edit') !== -1) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1disabled'] = false;
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) });
    } else {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1disabled'] = true;
      if (true) {
        if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
          return null;
        }
        changed_fields = [];
        oldData = ({  });
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
          ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
        }
        var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')) })));
        for (var j_index in j_list) {
          j = j_list[j_index];
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
            addItemToList(changed_fields, j);
            oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
          }
        }
        addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
        console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/CheckFNameSimilar_SIS`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`contact_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'contact_id')),[`new_fname`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) })));
        await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`student_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),[`student_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`student_nick_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')),[`student_birth_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date')),[`female`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'female')),[`male`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'male')),[`transgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transgender')),[`gender_variant_non_conforming`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'gender_variant_non_conforming')),[`prefer_not_to_say_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_gender')),[`other_gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_gender')),[`African_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'African_American')),[`Asian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Asian')),[`Caucasian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Caucasian')),[`Latino_Hispanic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Latino_Hispanic')),[`Native_American`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_American')),[`Native_Hawaiian`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Native_Hawaiian')),[`other_unknown_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_unknown_ethnicity')),[`prefer_not_to_say_ethnicity`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'prefer_not_to_say_ethnicity')),[`studentBirthCert`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentBirthCert')),[`studentPic`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentPic')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
        if ((!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) === null) || !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) === 'undefined')) && (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) || !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === 'undefined'))) {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGoogleUpdateUserDisplayNameByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')),'displayName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) });
        }
      }
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/c68687d5e0591343372d5b612ccbd2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f95ddaf208faae38b9f24d62197812e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, existingParentMap, parent_map, student_dir_data, masked_location, geocode, changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('SIS Save Location');
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c68687d5e0591343372d5b612ccbd2b6')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.5disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.5disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    try {
      var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')) })));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
          addItemToList(changed_fields, j);
          oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
        }
      }
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
      console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'share_contact')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
      student_dir_data = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`parent_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),[`parent_last_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')),[`parent_email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_email')),[`parent_phone`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_phone')),[`parent_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_address')),[`parent_relation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_relation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No' })));
      existingParentMap = (await Backendless.Data.of('parent_maps').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join(''))).setPageSize(1)))[0];
      console.log('check existing');
      console.log(existingParentMap);
      console.log(await Backendless.Data.of('parent_maps').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join('')))));
      if ((await Backendless.Data.of('parent_maps').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'\''].join(''))))) == 0) {
        geocode = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeChargebeeAddressConversion`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')))));
        masked_location = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIGeocodeMaskLocation`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lat': (Number((getObjectProperty(geocode, 'lat')))),'lon': (Number((getObjectProperty(geocode, 'lon')))) }));
        parent_map = (await Backendless.Data.of('parent_maps').save( ({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`share_contact`]: !(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === 'undefined') || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === null) || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) !== null && !Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact'))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === 'object')) ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No') : 'No',[`location`]: (new Backendless.Data.Point().setX((getObjectProperty(geocode, 'lon'))).setY((getObjectProperty(geocode, 'lat')))),[`masked_location`]: (new Backendless.Data.Point().setX((getObjectProperty(masked_location, 'lon'))).setY((getObjectProperty(masked_location, 'lat')))) }) ));
        await Backendless.Data.of('parent_maps').setRelation(({ [`objectId`]: (getObjectProperty(parent_map, 'objectId')) }), 'student_dir', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId'))]);
      } else {
        student_dir_data = (await Backendless.Data.of('ms_student_dir').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No' }) ));
        parent_map = (await Backendless.Data.of('parent_maps').save( ({ [`objectId`]: (getObjectProperty(existingParentMap, 'objectId')),[`share_contact`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) ? 'Yes' : 'No',[`location`]: (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(existingParentMap, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(existingParentMap, 'location')), 'lat')))),[`masked_location`]: (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(existingParentMap, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(existingParentMap, 'location')), 'lat')))) }) ));
      }

    } catch (error) {
      console.log(error);
      console.log(getObjectProperty(error, 'message'));

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a8cfb81b3802ee832d42cfa7d4a239cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/53e6c42ed0d31951b1a11752fa4f1ef1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a8cfb81b3802ee832d42cfa7d4a239cd')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.6disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`tertiary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) })));
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['1.6disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`tertiary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`tertiary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) !== null && !Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) === 'object')) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != (((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)) !== null && !Array.isArray((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j))) && (typeof (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)) === 'object')) ? (JSON.stringify((getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) : (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`tertiary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`secondary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2c6824b1c9fc9b04fc2424c31ecd9716')),[`tertiary_guardian`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4856ecf6577a64ed87cf934e153ab4b8')),[`PTO`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4fc77a3e9148b6db6aeb983f97c34b3')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.6disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/03def3a850adab2bef692134646ad1de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/39dca496a4b68dbdc81ad9b6078c2ac3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, changed_fields, oldData, j, arrayOptions, _unused, item, reply, prompt2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03def3a850adab2bef692134646ad1de')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['2disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`intersts`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['2disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`interests`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    try {
      var j_list = (Object.keys(({ [`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) })));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
          addItemToList(changed_fields, j);
          oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
        }
      }
      if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')) === null) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) === null)) {
        prompt2 = ['From the options below, choose whatever is closely related to this text - "',(getObjectProperty(j, 'most_interested_in')),'" do not include that is not in the option but you can choose multiple options below:','Sports: Soccer, Basketball, Swimming, Tennis, Gymnastics, etc.','Music: Playing an instrument, Singing, Listening to music, Music composition, etc.','Arts and Crafts: Drawing, Painting, Sculpting, Pottery, Knitting, DIY projects, etc.','Science and Nature: Astronomy, Biology, Chemistry, Environmental conservation, Gardening, etc.','Reading and Writing: Fiction, Non-fiction, Poetry, Creative writing, Comics, etc.','Technology and Computing: Video games, Coding, Robotics, Web design, etc.','Performing Arts: Theater, Dance, Magic, Circus arts, etc.','History and Geography: World history, Archaeology, Cultural studies, Map reading, etc.','Languages and Linguistics: Learning foreign languages, Sign language, Linguistics, etc.','Mathematics: Solving puzzles, Math competitions, etc.','Cooking and Baking: Trying new recipes, Cake decorating, etc.','Board Games and Puzzles: Chess, Card games, Jigsaw puzzles, etc.','Movies and Television: Watching films, Animation, Documentary, etc.','Outdoor Activities: Hiking, Camping, Birdwatching, Fishing, etc.','Animals and Pets: Learning about animals, Pet care, Horseback riding, etc.','Volunteering and Community Service: Charity work, Community clean-up, Helping at animal shelters, etc.','Photography and Videography: Taking photos, Making videos, Editing, etc.','Fashion and Design: Clothing design, Fashion blogging, Interior design, etc.','Collecting: Stamps, Coins, Figurines, etc.','Health and Fitness: Yoga, Meditation, Running, Weightlifting, etc.','Astronomy and Space Exploration: Stargazing, Learning about space missions, etc.','Mind and Brain Games: Sudoku, Crossword puzzles, Brain teasers, etc.','Vehicles and Mechanics: Cars, Bikes, Model building, etc.'].join('');
        reply = (getObjectProperty((getObjectProperty(((getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.openai.com/v1/chat/completions')).set(({ [`Content-Type`]: 'application/json',[`Authorization`]: String('Bearer ') + String('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') })).setEncoding('utf8').send(({ [`model`]: 'gpt-4',[`temperature`]: 0.7,[`max_tokens`]: undefined,[`messages`]: [({ [`role`]: 'user',[`content`]: prompt2 })] }))), 'choices'))[0]), 'message')), 'content'));
        arrayOptions = (removeItemInList((await Promise.all((reply.split('.')).map(async item => {; return (item.replace((new RegExp('\\n', 'g')), ''));}))), '', ''));
        _unused = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(j, 'objectId')),[`interests`]: arrayOptions })));
      }
      var j_list2 = (Object.keys(({ [`interests`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) })));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
          addItemToList(changed_fields, j);
          oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
        }
      }
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`most_interested_in`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'most_interested_in')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')),[`interests`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) }));

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/349358fdd8544d67f448b7135dca2e2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/ae6eae519fa3629b3b5ba57129aa632e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('349358fdd8544d67f448b7135dca2e2d')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['3disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['3disabled'] = true;
    if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')))) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyslexia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyslexia')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dysgraphia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dysgraphia')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyscalculia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyscalculia')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ADHD'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('ADHD')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['auditory_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Auditory processing disorder')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['language_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Language processing disorder')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['nonverbal_learning_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Nonverbal learning disorder')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['visual_perceptual_or_visual_motor_defecit'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Visual perceptual/visual motor deficit')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['austism_spectrum_discorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Autism spectrum disorder')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['asperger'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Asperger’s')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['anxiety'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Anxiety')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['depression'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Depression')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavioral_issues'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Behavioral issues')) ? true : false);
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_behavioral_challenges'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')) : '');
    }
    if (true) {
      if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
        return null;
      }
      changed_fields = [];
      oldData = ({  });
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
      }
      var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')) })));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
          addItemToList(changed_fields, j);
          oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
        }
      }
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
      console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
      await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_or_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_or_behavioral_challenges')),[`Dyslexia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyslexia')),[`Dysgraphia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dysgraphia')),[`Dyscalculia`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'Dyscalculia')),[`ADHD`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ADHD')),[`auditory_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'auditory_processing_disorder')),[`language_processing_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'language_processing_disorder')),[`nonverbal_learning_disorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'nonverbal_learning_disorder')),[`visual_perceptual_or_visual_motor_defecit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'visual_perceptual_or_visual_motor_defecit')),[`austism_spectrum_discorder`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'austism_spectrum_discorder')),[`asperger`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'asperger')),[`anxiety`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'anxiety')),[`depression`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'depression')),[`behavioral_issues`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavioral_issues')),[`other_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')),[`additional_info_behavioral_challenges`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'additional_info_behavioral_challenges')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '3disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/7ca67a2aab794a4df4134b7892dd307d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28cd95ff0fe5379ac056c13862813daf')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['4disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['4disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`ela_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ela_grade_level')),[`math_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'math_grade_level')),[`science_grade_level`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'science_grade_level')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/aa41dd2b1fa4d8f6413de5c291349c49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/085b63df4426142c0852477e809ea76c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aa41dd2b1fa4d8f6413de5c291349c49')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['5disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['5disabled'] = true;
    if ((JSON.stringify(({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`confidence_in_collaborating`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_collaborating')),[`confidence_in_engaging_independent_work`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_engaging_independent_work')),[`confidence_in_writing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_writing')),[`confidence_using_technology`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_using_technology')),[`confidence_in_reading`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'confidence_in_reading')),[`connecting_with_adults`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'connecting_with_adults')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '5disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/28cd95ff0fe5379ac056c13862813daf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '4disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/0ef745812d5ddb3807e98c26748f975c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/e72d7c2d9d4946842ee6186a9707cb98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0ef745812d5ddb3807e98c26748f975c')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')) === 'undefined') || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')) === null)) {
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`note`]: String('IEP has been uploaded via SIS - \n') + String((String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan'))).replace((new RegExp(',', 'g')), '\n')) })));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`learning_environment_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_environment_past_12_months')),[`student_last_school_address`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_address')),[`learning_experiece_past_12_months`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learning_experiece_past_12_months')),[`IEP_or_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'IEP_or_504_plan')),[`upload_copy_EIP_504_plan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_copy_EIP_504_plan')),[`upload_student_curreny_learning`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'upload_student_curreny_learning')),[`student_last_school_name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_name')),[`school_like_to_see`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'school_like_to_see')),[`student_last_school_contact_num`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_num')),[`student_last_school_contact_person`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_school_contact_person')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/19074a1e47d181d74e9bcd4b19cc0eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/1385f2be8c499e64f47169e293dc85b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var date, changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19074a1e47d181d74e9bcd4b19cc0eb9')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6.1disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = (JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })));
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['6.1disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) }))) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((JSON.parse((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')))), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    if (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) === 'undefined') || !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')) === null)) {
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),[`note`]: String('Transcript has been uploaded via SIS - \n') + String((String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles'))).replace((new RegExp(',', 'g')), '\n')) })));
    }
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`CreditTransfer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'CreditTransfer')),[`transferCredit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transferCredit')),[`uploadTranscript`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')),[`transcriptFiles`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'transcriptFiles')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6.1disabled')) === 'undefined') || !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a9675fc8f10ee0972f84812b5b7bd405/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/95dd651de3e1baeabb47253fc4828208/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var datescheduled, changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a9675fc8f10ee0972f84812b5b7bd405')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['7disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['7disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) == 'Alabama') {
      datescheduled = (new Date((new Date()).getTime() + (600 * 1000)));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': 'Alabama family: difficult homeschool paperwork, review with Andreas','date': datescheduled,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
    }
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')),[`submit_step_up`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'submit_step_up')),[`step_up_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'step_up_id')),[`student_award_id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_award_id')),[`determining_required_paperwork_home_state`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'determining_required_paperwork_home_state')),[`vaccine_situation`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'vaccine_situation')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '7disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/bedf93384f546d666f11663294bc659d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? 'Edit' : 'Save')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/24ef50bb87882e15d66aefc874fc2952/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var changed_fields, oldData, j, electives;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bedf93384f546d666f11663294bc659d')), 'content')).indexOf('Edit') !== -1) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['8disabled'] = false;
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) });
  } else {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['8disabled'] = true;
    if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
      return null;
    }
    changed_fields = [];
    oldData = ({  });
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
    }
    var j_list = (Object.keys(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (j == 'electives') {
        console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j));
        console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
      if (((Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) ? (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)))) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j))) != ((Array.isArray((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) ? (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j)))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    console.log({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) });
    await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`starting_date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date')),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`computer_system`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'computer_system')),[`length_of_staying`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'length_of_staying')),[`electives`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'electives')),[`UpdateHistory`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/14f2142d3231a2427b5c82f5be27991e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/2bbbdcb9ae368d072f63e3034f55bd6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/365d57b8da71441443a206ddc815af6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Please complete the typeform above to complete ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s information.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/b1e49d1b23097583c92bcee4996c0484/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#F5713C';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#32325D';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#B4BAC8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/82bc13eb1d93916c8bcf279b53ae299b/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#FEFEFE';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/c43ed6ac19b48f0510d9037a50732667/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a95e53312cfc76817cb61728dcd9e898'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ec6f66ba3cfc4aa4a1fcec13a11d0552'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e63c38c628be877b4ea9c7f800f9c5bc'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bdb5acd5df6bfbfe6024be62dd7b975'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1e8149cc1c1f8f13ca3b10fe6cbc9861'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('664528e2ea7e8422836919767aafc28f'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('805b2e5412124d42839611fffd9a11ee'))['background'] = '#FEFEFE';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b93cbbcbbe833d4f327983da1c41c566'))['color'] = '#B4BAC8';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0c5dc3ade5e9d08a85791781f28f6a3f'))['color'] = '#B4BAC8';
    if (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('938f0503dde3755c4498266a1947235a'))['background'] = '#F5713C';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d9bd52c7198642bfe74ba90bdc089402'))['color'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38d73e1a849c8d0a69d47c8e63174ff1'))['color'] = '#32325D';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fb06b192422aab4b24d54adcfb36617d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('313d60652323f37f3f85470573714ede'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba0a7dbc8b4811bff70d129c68ae02b5'))['background'] = '#F5713C';
    }
    if (true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('074164d44f217beb682dd8b49ef5762d'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2eee747b3912ebf6f4cc5d41ce1a2b'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d1afa3426ef476ee0e03501f706ed294'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cc89ffc12f6d8c8ee86134609092907'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('524bd0a88f3177de0163c2885c297c88'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c873c113361b2a67cbf1cd6d2e81d8d4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('735cd4b1edc58d7e111ed494d5f1bd9a'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f35c19d92266442ec508982de406d5f4'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38e4f32b984ea4b6e6f934534e0335db'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2bead3d62d1b596ff062bc05484aeff5'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a83e92e755ebf894f917c3bc71245f7'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('01259b7992242d645472a27bd1abb789'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4219cad74346f3461e5e7d8c557d8b97'))['background'] = '#FEFEFE';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83fca12852c4326f1c554ba602be934d'))['background'] = '#FEFEFE';
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/SIS_v2/components/074164d44f217beb682dd8b49ef5762d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/8f2eee747b3912ebf6f4cc5d41ce1a2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/d1afa3426ef476ee0e03501f706ed294/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/1cc89ffc12f6d8c8ee86134609092907/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/524bd0a88f3177de0163c2885c297c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/c873c113361b2a67cbf1cd6d2e81d8d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/735cd4b1edc58d7e111ed494d5f1bd9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/f35c19d92266442ec508982de406d5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/38e4f32b984ea4b6e6f934534e0335db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'grade')).indexOf('Kindergarten') !== -1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/2bead3d62d1b596ff062bc05484aeff5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/9a83e92e755ebf894f917c3bc71245f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
    if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) === null)) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null)) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07dc116efb3653f910fb001dc4228ded', true);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-color'] = 'red';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07dc116efb3653f910fb001dc4228ded', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('37e8e5be267e4c7af957cda40d9b4218'))['border-style'] = 'none';
      return null;
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/01259b7992242d645472a27bd1abb789/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/4219cad74346f3461e5e7d8c557d8b97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeSigned')) == 'Not Completed' && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'honorCodeURL')) === 'undefined'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('883bcde55757843909fcb379d4a7b5a2', true);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-color'] = 'red';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('883bcde55757843909fcb379d4a7b5a2', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2cfe5a2c4fd23a2e61b983b8e693187a'))['border-style'] = 'none';
      return null;
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/83fca12852c4326f1c554ba602be934d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') {
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSBool')) && (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ToSURL')) === 'undefined'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99e5d6d74b42a38337c84ceab5a3b8df', true);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-style'] = 'solid';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-color'] = 'red';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99e5d6d74b42a38337c84ceab5a3b8df', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19aee1b27baab683d99d847bf47d813e'))['border-style'] = 'none';
      return null;
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/fb06b192422aab4b24d54adcfb36617d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/313d60652323f37f3f85470573714ede/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/ba0a7dbc8b4811bff70d129c68ae02b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentDIRParent')) === 'undefined')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2917e6f79362c86ddf23ece5b6eb9362'))['border-width'] = '1px';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = 'red';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '2px';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd')));
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-color'] = '#EAF1F8';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffb1b8afa99e30adb4e2deb6c0bcb8cd'))['border-width'] = '1px';
    }
    return null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'studentMSEmail')) === null) {
    return null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dd04334b6225acf734c996bf54a1c467', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e5f314a35c9f002d111bdc870863e4e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30084e4e0553f76a546808bff8cb5def', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41b657385909ff1c98ae26c177aee544', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dc9437ec826dd44d2ba2d40d2729992a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba0f86727c8f81bb002460a80b7dabb8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('343ac0d3bd63aac25a73972fa1ae9b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ba661be6b2c122691289404915f8d68', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eccc9e69245e0babd422c7e9a9728261', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62f4c62fcd4eb26d864109c9e4591c22', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('506d3ac2bf8d8126d934a7c89c3a54df', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3716c848f5613d129cd50d5390755802', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82bc13eb1d93916c8bcf279b53ae299b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c43ed6ac19b48f0510d9037a50732667', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/82341e8fa12d3ee27a0c1c19cc8efd21/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['If applicable, what would you have liked to see more/less of in ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s previous educational establishment?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/72029cb6c53674f3b904f29bb95fd602/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')) + String(' classifies families as homeschoolers when attending out-of-state private schools (we are a Florida private school). That is nothing to worry about; it just means that you should submit some simple paperwork. '))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StateRegObject')) === 'undefined') && !((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'enrollment_type')) == 'private' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'difficulty')) == 'easy' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')) == 'Alabama'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/590d953e7512130e69837b652406d828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StateRegObject')) === 'undefined') && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'enrollment_type')) != 'private' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Difficulty')) != 'easy' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')) != 'Alabama')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/d8fe95fcc02bc76c4c028bcfd6fbfbe9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['While we are not legal professionals, here is what our families from ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')),' usually do:'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StateRegObject')) === 'undefined') && !((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'enrollment_type')) == 'private' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'difficulty')) == 'easy' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')) == 'Alabama'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/3a83d42893ad44f39727225503cccffd/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/6b7ecb4e441c5ca3c0ac1e3a76bb809e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Affidavit'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/3fd3abd926e93bea042a516c80fb2f6c/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/42d2229b371a85a3d3188f02b5c5da46/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Register_with_the_DoE'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/865eaddffe7c50f961edd284ce4fe0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Individualized_Home_Instruction_Plan'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/6cfb0efee86217bd3e86af71496467c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Quarterly_Reports'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/df6895d5aa085bb5af73f6b1d3f8f3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Annual_Evaluation'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/d75e3294065ec2b535e4f3fd8bbedc93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StateRegObject')) === 'undefined') ? ['- ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')),' asks families to do one nationally-normed diagnostic per year. We provide this for you, but make sure ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' participates in our diagnostic when the time comes!'].join('') : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/d26f9bbff30d01253d4a2b72068de39f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Minimum_number_of_hours')).indexOf('no minimum hours') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/4d63cad25013db7b464ae214cbc9da78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['- When planning your annual calendar, we recommend staying with us until the end of June and starting in early August, since ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')),' requires  ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Minimum_number_of_hours')),' of school. This way you will be covered 100%.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/94261251b48f98716b6d2c76117ae3d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Comments')) === null))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/fe7e879de2fd0b9498129e067bfc3bd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'Comments'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/91b54073a95235612b8e9105d4ff49e7/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://hslda.org/legal/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StateRegObject')), 'State_Name'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/4856ecf6577a64ed87cf934e153ab4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'secondary_guardian_show'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/7c770a6260d82999ace75cf864ad3f17/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' })

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('GMeet_Recordings', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/e9d3320c3503424908686531be944bad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Grade_Switcher', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/8384fe5ec8058a217d6c70929782516f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['How can we contact ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s last school?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/501c8d6bc01f9114ee18c0de76688119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Person to speak with from ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'’s last school?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/921225ead5d65b2fe1efb32e32e568f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/2a5910718f4adafc67e81e18f2e25b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '6disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f7ee64acdde690d5fc4ee02373645656/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MobyMax_CSV', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var user;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/543d0da5751b37d60b68c966f0c83b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === null) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContactHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContactHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContactHover')) ? '#F89C77' : '#F5713C' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContactHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContactHover'] = false;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContact'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/e78396ca7f12dba96732c898a376836c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`box-shadow`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) && !((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ShareParentContact')) === null) ? '0px 0px 0px 0.5px #F78E64 inset' : '0px 0px 0px 2px #F5713C inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShareParentContactHover')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShareParentContactHover')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'DontShareParentContactHover')) ? '#F89C77' : '#9998A3' })

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.pageData['DontShareParentContactHover'] = true;

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['DontShareParentContactHover'] = false;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '1.5disabled')) {
    return null;
  }
  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ShareParentContact'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/ff97bf7224e7ef222b5bf781cffce1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'mobile-menu-action')) == 'close') {
    ___arguments.context.pageData['mobile-menu-action'] = 'open';
  } else {
    ___arguments.context.pageData['mobile-menu-action'] = 'close';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/d88814b596863fe889d5be0accfea2e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'mobile-menu-action')) == 'open' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/9447ac2a6434312fa91405ec03d930c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') ? false : ((typeof (getObjectProperty(___arguments.context.pageData, 'isTeacher')) === 'undefined') && (await Backendless.UserService.isValidLogin()) ? true : (!(getObjectProperty(___arguments.context.pageData, 'isTeacher')) && (await Backendless.UserService.isValidLogin()) ? true : (!(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f313f7adfa11d43ddc8171f51b3e2bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, selectedList, InterestsList, interestAdded, j, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89d43d6d9fed15843bd8c44d4f7954ac', false);
    interestAdded = false;
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) === null)) {
      InterestsList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests'));
      selectedList = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')).map(async item => {; return ({ [`interest`]: item });})));
      for (var j_index in selectedList) {
        j = selectedList[j_index];
        if ((getObjectProperty(j, 'interest')) == ___arguments.value) {
          interestAdded = true;
          break;
        }
      }
    } else {
      InterestsList = [];
      selectedList = [];
    }
    if (interestAdded) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89d43d6d9fed15843bd8c44d4f7954ac', true);
    } else {
      addItemToList(InterestsList, ___arguments.value);
      addItemToList(selectedList, ({ [`interest`]: ___arguments.value }));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['interests'] = InterestsList;
      ___arguments.context.pageData['ListForInterests'] = selectedList;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89d43d6d9fed15843bd8c44d4f7954ac', false);
    }

  } catch (error) {
    console.log(error);
    console.log(getObjectProperty(error, 'message'));

  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/257cdf3168d77145439adb339c2e01b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var StudentInfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/57c6c1c4dcb252b2856929345a4bb118/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, list, selectedList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    list = (getObjectProperty(___arguments.context.pageData, 'ListForInterests'));
    selectedList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2abd08dd5b943bfad744cbd9fc7e6423'), 'interest'));
    ___arguments.context.pageData['ListForInterests'] = (removeItemInList(list, ({ [`interest`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2abd08dd5b943bfad744cbd9fc7e6423'), 'interest')) }), 'interest'));

  } catch (error) {
    console.log(error);
    console.log(getObjectProperty(error, 'message'));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/2abd08dd5b943bfad744cbd9fc7e6423/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, newList, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '2disabled'))) {
      list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests'));
      newList = [];
      for (var j_index in list) {
        j = list[j_index];
        if (j != (getObjectProperty(___arguments.context.dataModel, 'interest'))) {
          addItemToList(newList, j);
        }
      }
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['interests'] = newList;
    }

  } catch (error) {
    console.log(error);
    console.log(getObjectProperty(error, 'message'));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/23b5c10d1c55c494a8784877d5f8e9be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) === null) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')).length || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')).length == 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/54f35a855e3ea1762ad5c26b393d1016/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam, url;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    urlParam = ({  });
    url = '';
    if ((getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin' || !(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
      url = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Student' }) }));
      urlParam['lead_id'] = (getObjectProperty(___arguments.context.pageData, 'lead_id'));
      urlParam['student_name'] = (getObjectProperty(___arguments.context.pageData, 'student_name'));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
        urlParam['fromParentOTP'] = true;
      }
    } else {
      url = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Teacher' }) }));
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
        urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
        urlParam['fromAP'] = true;
        urlParam['fromDashboard'] = true;
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
        urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
        urlParam['fromSA'] = true;
        urlParam['fromDashboard'] = true;
      }
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(url, false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS').debug((String('Problem occurs in breadcrumbs | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/b9f59319cecac1483756e8c466a43749/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'jomar.balanag@brilliantmicroschool.org' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/68f73f9a356258d315a67a1e5366d803/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')) === null) ? (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'interests')).map(async item => {; return ({ [`interest`]: item });}))) : null)

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/f435063776a9a3282ed4e31be579d54d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/MS_Pages/index.html?page=Parent_Mapping', true, ({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`fromSIS`]: true }));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`box-shadow`]: '0px 2px 0px 0px #32325D' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/7131f6ea11feab8c2071c4584c3ba106/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, StudentDIR, j, Checker, TempList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (___arguments.value != '') {
    TempList = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['student_name = \'',___arguments.value,'','','\' and slots.status = \'enrolled\''].join(''))).setRelated('slots').setRelationsPageSize(100).setPageSize(100)));
    StudentDIR = [];
    Checker = [];
    for (var j_index in TempList) {
      j = TempList[j_index];
      if (!(Checker.includes((getObjectProperty(j, 'objectId'))))) {
        addItemToList(Checker, (getObjectProperty(j, 'objectId')));
        addItemToList(StudentDIR, j);
      }
    }
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['SearchByStudentResults'] = StudentDIR;
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['SearchByStudentOptions'] = (await Promise.all((await asyncListSort(StudentDIR, -1, async (item) => {


     return ___arguments.value;
    })).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'parent_name')),' | ',(getObjectProperty(item, 'student_name'))].join(''),[`value`]: (getObjectProperty(item, 'objectId')) });})));
    ___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd')['SearchByStudentLabel'] = 'Choose a parent/student';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/761cbf4754ffc963b15a5945f84ff335/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var FiltereResults, item, StudentInfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  console.log(___arguments.value);
  FiltereResults = (await asyncListFind((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ffb1b8afa99e30adb4e2deb6c0bcb8cd'), 'SearchByStudentResults')), async (item) => {


   return (___arguments.value == (getObjectProperty(item, 'objectId')));
  }));
  FiltereResults['firstDay'] = (((getObjectProperty((await asyncListFind((getObjectProperty(FiltereResults, 'slots')), async (item) => {


   return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
  })), 'firstDay')) === null) || ((await asyncListFind((getObjectProperty(FiltereResults, 'slots')), async (item) => {


   return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
  })) === null) ? null : (new Date((getObjectProperty((await asyncListFind((getObjectProperty(FiltereResults, 'slots')), async (item) => {


   return (((getObjectProperty(item, 'slot_slug')).indexOf('MS_') !== -1) && !((getObjectProperty(item, 'slot_slug')).indexOf('ELECTIVE') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
  })), 'firstDay')))));
  ___arguments.context.pageData['StudentInfo'] = FiltereResults;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SIS_v2/components/2d46b26422e34d17d26a9d36f3928611/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, studentContact, result, changed_fields, oldData, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['oldData'] = ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`onBreak`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) });
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) && ___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['onBreak'] = true;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) && !___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['onBreak'] = false;
  }
  if ((JSON.stringify(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`onBreak`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) }))) == (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData'))))) {
    return null;
  }
  changed_fields = [];
  oldData = ({  });
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')) === null) {
    ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['UpdateHistory'] = [];
  }
  try {
    var j_list = (Object.keys(({ [`onBreak`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) })));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), j)) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j))) {
        addItemToList(changed_fields, j);
        oldData[j] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'oldData')), j));
      }
    }
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'UpdateHistory')), ({ [`previous_data`]: oldData,[`changed_fields`]: changed_fields,[`date_updated`]: (new Date()) }));
    result = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/A7809FF8-76D2-4DC1-81CE-6138FA452608/data/ms_student_dir')).setEncoding('utf8').send(({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'objectId')),[`onBreak`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) })));
    studentContact = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(result, 'lead_id')),'\' and student_name=\'',(getObjectProperty(result, 'student_name')),'\' and status = \'enrolled\' and slot_slug like \'%MS_%\''].join(''))).setPageSize(10)))[0];
    await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseContactUpdateByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`contact_id`]: (getObjectProperty(studentContact, 'contact_id')),[`subject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak')) ? 'MS_Break_Not_Attending' : (getObjectProperty(studentContact, 'subject')) })));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['onBreak'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentInfo')), 'onBreak'));

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'onBreak'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/fc7c521bea53065c0b821b7e1813bc85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.UserService.isValidLogin()) && !(typeof (getObjectProperty(___arguments.context.pageData, 'StudentInfo')) === 'undefined') && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') && !(typeof (getObjectProperty(___arguments.context.pageData, 'student_name')) === 'undefined') || (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) && true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/1029879d048337ffa6c13b4c72112e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) === 'undefined') || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), '8disabled')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'firstDay')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'firstDay')) === null) ? '' : (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'firstDay')).getTime() + (14400 * 1000))))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/fd634705c423823d4219cbc2b107a3b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin' && (getObjectProperty(___arguments.context.pageData, 'SSO')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/e77c626f2c1566618d951dc52d82f96c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    urlParam = ({  });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParam['fromAP'] = true;
      urlParam['fromDashboard'] = true;
      urlParam['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParam['fromSA'] = true;
      urlParam['fromDashboard'] = true;
      urlParam['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/8908bd23ca3ef3f9f9995e4977ea8daf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS').debug((String('Problem with Back To Admin button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/134243c585479f580c316e73dc34e2b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Parent' }) })), false, ({ [`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').debug((String('Problem encountered in clicking Back to Student List | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/ae65ab9a5d8e8dc50914270aadc3483a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  display = true;
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'SSO')) === 'undefined')) {
    display = false;
  }
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined')) {
    display = false;
  }
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'undefined') || (getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin') {
    display = false;
  }
  if (await Backendless.UserService.isValidLogin()) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'access_level')) != 'Core Administrator') {
      display = false;
    } else {
      display = true;
    }
  } else {
    display = false;
  }

  return display

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/af9a3f33d7f8238f1368cc3b55228c3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b1e49d1b23097583c92bcee4996c0484', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SIS_v2/components/836f64b7118bcd3ea80cea8a250488f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, UpdateDIR, TaskCreated, ContactUpdated, updateFile, date_scheduled, LeadfromDB, accessTokenString, copyFile, accessTokenObject, date, UpdateStudentDIR, GoogleAccount, Note, j, TeacherLead, AssistantTeacherLead, HouseLeaderDB, datescheduled, item, slot;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  try {
    if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('acf20b0c97535768641d432c511e3e99')), 'display')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'ListForNote')), (['Prefer online only approach',',',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'learningCenterBool'))].join('')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', true);
      LeadfromDB = (await asyncListFilter((await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'slots')), 1, async (item) => {


       return (getObjectProperty(item, 'created'));
      })), async (item) => {


       return (((getObjectProperty(item, 'subject')).indexOf('MS_') !== -1) && ((getObjectProperty(item, 'status')).indexOf('enrolled') !== -1));
      }))[0];
      TeacherLead = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',((getObjectProperty(LeadfromDB, 'tutor')).replace((new RegExp('\'', '')), '\'\'')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
      if (!((getObjectProperty(LeadfromDB, 'assistant_teacher')) === null)) {
        AssistantTeacherLead = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name = \'',(getObjectProperty(LeadfromDB, 'assistant_teacher')),'\' and accountType = \'BACKENDLESS\''].join(''))).setPageSize(10)))[0];
      }
      slot = (getObjectProperty(LeadfromDB, 'slots_sort'));
      if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')))) {
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyslexia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyslexia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dysgraphia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dysgraphia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['Dyscalculia'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Dyscalculia')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['ADHD'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('ADHD')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['auditory_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Auditory processing disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['language_processing_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Language processing disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['nonverbal_learning_disorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Nonverbal learning disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['visual_perceptual_or_visual_motor_defecit'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Visual perceptual/visual motor deficit')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['austism_spectrum_discorder'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Autism spectrum disorder')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['asperger'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Asperger’s')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['anxiety'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Anxiety')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['depression'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Depression')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['behavioral_issues'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Behavioral issues')) ? true : false);
        ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['other_behavioral_challenges'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes('Other')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'other_behavioral_challenges')) : '');
      }
      var j_list = ['ShowGuardianHovered', 'ShowLearningBehavioral', 'ShowPTOHovered', 'ShowSubmitStepupHover', 'uploadTranscriptHover', 'DontShowLearningBehavioral', 'DontShowPTOHovered', 'DontShowSubmitStepupHover', 'dontUploadTranscriptHover', 'requiredList', 'chargebeeID', 'DontShowIEPHover', 'grade', 'ethnicityValue', 'genderValue', 'secondary_guardian_show', 'ShowIEPHover', 'ToSParentName', 'PercentCompleted', 'NotCompletedFields', '1disabled', '2disabled', '1.5disabled', '1.6disabled', '3disabled', '4disabled', '5disabled', '6disabled', '6.1disabled', '7disabled', '8disabled', '8.1disabled', '8.2disabled', '9disabled', 'ExemptionShow', 'ItemHoveredPTO', 'behavior', 'IEPDocs', 'learningList', 'CTE', 'English', 'FineArts', 'ItemHoveredBehavior', 'ItemHoveredCTE', 'ItemHoveredConfirming', 'ItemHoveredElectives', 'ItemHoveredEnglish', 'ItemHoveredExemption', 'ItemHoveredFineArts', 'ItemHoveredMath', 'ItemHoveredNoCourses', 'ItemHoveredPEH', 'ItemHoveredPending', 'ItemHoveredScience', 'ItemHoveredSocStud', 'ItemHoveredWorldLang', 'Math', 'PE&Health', 'Science', 'ShowPTOQuestions', 'SocialStudies', 'WorldLanguage', 'birthCertMetaData', 'honorCodeParentName', 'honorCodeStudentName', 'pdfURL', 'studentPicMetaData'];
      for (var j_index in j_list) {
        j = j_list[j_index];
        delete ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')[j];
      }
      datescheduled = (new Date((new Date()).getTime() + (600 * 1000)));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'home_state')) == 'Alabama') {
        ;(async () => {
            await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': 'Alabama family: difficult homeschool paperwork, review with Andreas','date': datescheduled,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });

        })();
        await new Promise(r => setTimeout(r, 100 || 0));
      }
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/sendSlackMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`channelId`]: 'C02C1CS1HC0',[`message`]: ['New Microschool Onboarding Form New Microschool Onboarding Form Submitted\n','--\n','Student name:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\nSubject:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'subjects')),'\n\n','Lead:','https://app.close.com/lead/',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'/'].join(''),[`userName`]: 'BMS Registration Form ',[`bot_icon`]: ':school_satchel:' })));

      })();
      await new Promise(r => setTimeout(r, 100 || 0));
      GoogleAccount = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/CreateGoogleAccountStudents`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`fullname`]: (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendReplaceDiacriticsWithRegularLetters`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`text`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')).split(' ')[0],' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')).split(' ')[0]].join('').trim() })))),[`email`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),[`display_name`]: (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendReplaceDiacriticsWithRegularLetters`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`text`]: (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name')) === null) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_nick_name'))).trim() })))),[`contact_id`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'contact_id')) === null) ? (generateUUID().short()) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'contact_id')),[`type`]: 'student',[`password`]: [(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendReplaceDiacriticsWithRegularLetters`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`text`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) })))),'BMS',(getObjectProperty(LeadfromDB, 'contact_id')).slice(4, 11)].join('') }))));
      await new Promise(r => setTimeout(r, 500 || 0));
      console.log(JSON.stringify(GoogleAccount));
      await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseCreateNotebyLeadID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`raw_note`]: ['BMS Google Account Created','\n\n','Email: ',(getObjectProperty(GoogleAccount, 'primaryEmail')),'\n','Password: ',[(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UIBackendReplaceDiacriticsWithRegularLetters`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`text`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) })))),'BMS',(getObjectProperty(LeadfromDB, 'contact_id')).slice(4, 11)].join('')].join('') })));
      ContactUpdated = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseContactUpdateByParam`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`contact_id`]: (getObjectProperty(LeadfromDB, 'contact_id')),[`StudentLastName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')),[`MsEmail`]: (getObjectProperty(GoogleAccount, 'primaryEmail')),[`MsPass`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'BMS',(getObjectProperty(LeadfromDB, 'contact_id')).slice(4, 11)].join('') }))));
      date_scheduled = (new Date((new Date()).getTime() + (600 * 1000)));
      await new Promise(r => setTimeout(r, 100 || 0));
      HouseLeaderDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and opp_status=\'enrolled\' and name=\'',(getObjectProperty(TeacherLead, 'house_leader')),'\''].join(''))).setPageSize(10)))[0];
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontent_v2`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`status`]: 'scheduled',[`date_scheduled`]: date_scheduled,[`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`sender_name`]: undefined,[`sender_email`]: 'notifications@brilliantgrades.com',[`to`]: ((getObjectProperty(TeacherLead, 'MS_teacher_email')) === null) ? ((AssistantTeacherLead !== null && !Array.isArray(AssistantTeacherLead) && (typeof AssistantTeacherLead === 'object')) ? [(getObjectProperty(TeacherLead, 'email')), (getObjectProperty(AssistantTeacherLead, 'email'))] : (getObjectProperty(TeacherLead, 'email'))) : ((AssistantTeacherLead !== null && !Array.isArray(AssistantTeacherLead) && (typeof AssistantTeacherLead === 'object')) ? [(getObjectProperty(TeacherLead, 'MS_teacher_email')), (getObjectProperty(AssistantTeacherLead, 'MS_teacher_email'))] : (getObjectProperty(TeacherLead, 'MS_teacher_email'))),[`cc`]: (typeof (getObjectProperty(HouseLeaderDB, 'MS_teacher_email')) === 'undefined') ? null : (getObjectProperty(HouseLeaderDB, 'MS_teacher_email')),[`body`]: ['Dear ',(getObjectProperty(LeadfromDB, 'tutor')).split(' ')[0],',<br><br>','Your student, ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),', has completed the Microschool Registration Form.','<br>You can login <a href = \'https://portal.brilliantgrades.com/Clever/?page=Main_Page\'>here</a>',' with your Brilliant Microschool email to access the Student Information System page.','<br>Select the class where the student is enrolled in the Classroom dropdown and select the student\'s name in the Student dropdown to access the student\'s information. '].join(''),[`subject`]: 'Your student has completed the Microschool Registration Form' })));

      })();
      await new Promise(r => setTimeout(r, 100 || 0));
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`note`]: String('Microschool Registration Form forwarded to ') + String(getObjectProperty(LeadfromDB, 'tutor')) })));

      })();
      await new Promise(r => setTimeout(r, 100 || 0));
      Note = ['Registration form for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' has been completed!'].join('');
      var j_list2 = (getObjectProperty(___arguments.context.pageData, 'ListForNote'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        Note = String(Note) + String(String('\n\n') + String(j.replace((new RegExp(',', '')), '\n')));
      }
      ;(async () => {
          await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilderCS/createNote`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`note`]: Note })));

      })();
      await new Promise(r => setTimeout(r, 100 || 0));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['student_name'] = (getObjectProperty(ContactUpdated, 'display_name'));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentMSEmail'] = (getObjectProperty(GoogleAccount, 'primaryEmail'));
      ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')['studentMSPassword'] = ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'BMS',(getObjectProperty(LeadfromDB, 'contact_id')).slice(4, 11)].join(''));
      UpdateStudentDIR = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/ms_student_dir')).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd584a8d8951d4dba87dfb275f5d7e09', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c048b5d25c10865a63206ccb82f056b', true);
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'uploadTranscript')) == 'I prefer you source them from the school ($50 processing fee)') {
        date = (new Date());
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/taskCreateFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'lead_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'lead_id')),'text': (['Collect ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),'\'s Records ($50 fee)'].join('')),'date': date,'is_complete': false,'assigned_to': 'user_XrJwNc9AvYWxJXivqd5BkpXYJa53CGmK7vMfHKGyxwC' });
      }
      if (true) {
        if (((new Date()).valueOf()) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'expiring'))) {
          accessTokenObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=840561961074-bmsnps98jfa0s5lubaqljdhetsvh8n56.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
          await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'objectId')),[`access_token`]: (getObjectProperty(accessTokenObject, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + (3000 * 1000))) }) );
          accessTokenString = (getObjectProperty(accessTokenObject, 'access_token'));
        } else {
          accessTokenString = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'DriveTokenObject')), 'access_token'));
        }
        copyFile = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveCopyFileIDtoFolderIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'sourceFileID': '1np-yov3B95u8jeJijJMmE3dfdvwm22IODessStrGbSQ','fileName': (['BMS Enrollment Letter - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),' and ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name'))].join('')),'destinationFolderID': '1_xwT_J7TVSiBbUtQ_Mn6cl6dbDuLqx4K' }));
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/GDriveAllowFileAccessByFileIDFrontEnd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(copyFile, 'id'))));
        updateFile = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://docs.googleapis.com/v1/documents/',(getObjectProperty(copyFile, 'id')),':batchUpdate'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(accessTokenString),[`Content-Type`]: undefined })).setEncoding('utf8').send(({ [`requests`]: [({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{studentName}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{studentDOB}}',[`matchCase`]: true }),[`replaceText`]: [(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date'))))).getDate()),'/',(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_birth_date'))))).getFullYear())].join('') }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{startDate}}',[`matchCase`]: true }),[`replaceText`]: [(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date'))))).getDate()),'/',(new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'starting_date'))))).getFullYear())].join('') }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{parentName}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{parentLastName}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_last_name')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{studentLastName}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_last_name')) }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{schoolYear}}',[`matchCase`]: true }),[`replaceText`]: '2024 - 2025' }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{dateNow}}',[`matchCase`]: true }),[`replaceText`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('') }) }), ({ [`replaceAllText`]: ({ [`containsText`]: ({ [`text`]: '{{contactID}}',[`matchCase`]: true }),[`replaceText`]: (getObjectProperty(LeadfromDB, 'contact_id')) }) })] })));
        await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/emailFrontend`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'status': 'scheduled','date_scheduled': date_scheduled,'lead_id': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'sender_email': 'help@brilliantmicroschool.org','to': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'email')),'body_html': (['Hi ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'parent_name')),',<br><br>','Attached below is your copy of the official enrollment letter for ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'student_name')),' with the Brilliant Microschool!<br><br>',['<a href="',['https://docs.google.com/feeds/download/documents/export/Export?id=',(getObjectProperty(updateFile, 'documentId')),'&exportFormat=pdf'].join(''),'">Official Enrollment Letter','</a><br><br>'].join(''),'Let us know if you have questions!<br><br>','Warm regards,<br>','Parent Support Team<br><img src= \'https://lh6.googleusercontent.com/hnkDEFumM6CbPs3YxDAwWOcvchVNNwOawvbe-zzLebpvQ1HaJSrBBhJrpn-PeVYUHesnL6zm_31TBdeCqMVBlaTkq-NVaJFrk5zrl0f4EZn0rvc6-ftZkvxJ71oN0HQxIw-KqrPwB8Jj2bgYoO84rng\' width=110px height=50px><br><br>help@brilliantmicroschool.org<br>+1 917-563-2694'].join('')),'subject': 'Microschool Enrollment Letter 2024 - 2025' });
      }
      await new Promise(r => setTimeout(r, 5000 || 0));
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57b998ec90b97f7b2955ccc23b2130b3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f38de707d68c9eab309ce5ce39c7c59b', true);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e44d89383b3cf2deb0c67ea8eac78d4')));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('SIS Submit Button').warn(((typeof error === 'string') ? error : (JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((!(await Backendless.UserService.isValidLogin()) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && true || !(typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin') && !(getObjectProperty(___arguments.context.pageData, 'isSubmitted'))) {
    display = true;
  } else if ((!(await Backendless.UserService.isValidLogin()) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && true || !(typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin') && (getObjectProperty(___arguments.context.pageData, 'isSubmitted'))) {
    display = false;
  } else if ((await Backendless.UserService.isValidLogin()) && !((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && (((function () { return window.location.href })()).indexOf('student_name') !== -1)) {
    display = true;
  }

  return display

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/acf20b0c97535768641d432c511e3e99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((!(await Backendless.UserService.isValidLogin()) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && true || !(typeof (getObjectProperty(___arguments.context.pageData, 'from')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'from')) == 'ParentOTPLogin') && !(getObjectProperty(___arguments.context.pageData, 'isSubmitted')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/a13548b8d18e8ea91396a05fe99564a4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.UserService.isValidLogin()) && !((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).indexOf('bms.family') !== -1) && (!(typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'lead_id')) === 'string')) && (((function () { return window.location.href })()).indexOf('student_name') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/43b133ede87a01bf151f06dada89e315/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ['Inattention/Poor Focus', 'Impulsivity/Hyperactivity', 'Disorganization', 'Frustration/Overwhelm', 'Anxiety/Fear', 'Social Withdrawal/Shyness', 'Emotional Outbursts', 'Difficulty Transitioning', 'Defiance', 'Low Perseverance', 'Sensory sensitivity', 'Forgetfulness', 'Perfectionism']

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/1fde238557839b93bed728df73ceeec6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('8b2591f2819c82c355d8fd5146a7c9ec')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SIS_v2/components/8b2591f2819c82c355d8fd5146a7c9ec/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')) === 'undefined') ? ({ [`box-shadow`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'behavior')).includes(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'))) ? '0px 0px 0px 2px #F5713C inset' : '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) == ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4') ? '#F89C77' : '#FAE2D9' }) : ({ [`box-shadow`]: '0px 0px 0px 0.5px #F78E64 inset',[`background`]: !((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) === null)) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4'), 'ItemHoveredBehavior')) == ___arguments.context.getComponentDataStoreByUid('257cdf3168d77145439adb339c2e01b4') ? '#F89C77' : '#FAE2D9' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/School_Administrator_Page/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item, AssistantPrincipalList, AdminData, tutorData, LoginData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (getObjectProperty(___arguments.context.pageData, 'fromSA')) {
      AdminData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',(getObjectProperty(___arguments.context.pageData, 'sa_name')),'\' and MS_teacher_email is not null and accountType=\'BACKENDLESS\''].join(''))).setProperties('email,zoomid,MS_teacher_password,name').setPageSize(10)))[0];
      try {
        await Backendless.UserService.login( (getObjectProperty(AdminData, 'email')), (getObjectProperty(AdminData, 'MS_teacher_password')), true  );

      } catch (error) {
        await Backendless.UserService.login( (getObjectProperty(AdminData, 'email')), (getObjectProperty(AdminData, 'zoomid')), true  );

      }
    }
    AdminData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['(email=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\' or MS_teacher_email=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\') and MS_teacher_email is not null and accountType=\'BACKENDLESS\''].join(''))).setProperties('email,zoomid,MS_teacher_password,name,lead_id').setPageSize(10)))[0];
    console.log(AdminData);
    ___arguments.context.pageData['adminData'] = AdminData;
    ___arguments.context.pageData['title'] = (['Hi ',(getObjectProperty(AdminData, 'name')).split(' ')[0],', welcome back!'].join(''));
    AssistantPrincipalList = [];
    AssistantPrincipalList = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['opp_status=\'enrolled\'  and house_leader != null and house_leader != \'JomarTutor Live\' and house_leader != \'',((getObjectProperty(AdminData, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setProperties('house_leader').setSortBy('name').setGroupBy('house_leader').setPageSize(100).setDistinct(true)));
    ___arguments.context.pageData['AssistantPrincipalList'] = (await Promise.all(AssistantPrincipalList.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'house_leader')),[`label`]: (getObjectProperty(item, 'house_leader')) });})));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Assistant Teacher').debug((['Assistant Teacher Error | Error in Page Enter AP:',(decodeURIComponent((getObjectProperty(___arguments.context.pageData, 'name')))),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/School_Administrator_Page/components/bb6f19d743c180fa88dc51396f12e482/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/4a15948c501e1c8ff62650f541644056/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var tutorSelection, item, TutorList, error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  try {
    if (!(___arguments.value === null) && ___arguments.value != '') {
      stopSetTimeout('searchTutorMenu');

      ;(function() {
        const callback = async () => {
            TutorList = [];
        TutorList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/B1F5670D-DA3D-40EB-B93B-51378E3C9571/data/Users')).query(({ [`where`]: ['name LIKE \'',___arguments.value,'%\' and opp_status = \'enrolled\' and userType = \'Teacher\' and accountType=\'BACKENDLESS\''].join(''),[`properties`]: 'name',[`sortBy`]: 'name',[`pageSize`]: 100 })).setEncoding('utf8').send());
        if (!!TutorList.length) {
          ___arguments.context.pageData['tutorListMenu'] = TutorList;
          tutorSelection = (await Promise.all(TutorList.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'name')),[`value`]: (getObjectProperty(item, 'name')) });})));
          ___arguments.context.pageData['tutorSelectorMenu'] = tutorSelection;
          ___arguments.context.pageData['selectedTutorMenu'] = (getObjectProperty((tutorSelection[0]), 'value'));
        } else {
          ___arguments.context.pageData['tutorSelectorMenu'] = [];
          ___arguments.context.pageData['selectedTutorMenu'] = '';
        }

        };

        const timerId = 'searchTutorMenu';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/School_Administrator_Page/components/a34715550a77c4e5e142387a3f085a26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, LoginData, GetTutorData, adminData, isTeacher, redirectLink, selectedTutor, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    adminData = (getObjectProperty(___arguments.context.pageData, 'adminData'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'selectedTutorMenu')) === 'undefined')) {
      await Backendless.UserService.logout();
      redirectLink = '';
      selectedTutor = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'tutorListMenu')), async (item) => {


       return ((getObjectProperty(item, 'name')) == (getObjectProperty(___arguments.context.pageData, 'selectedTutorMenu')));
      }))[0];
      GetTutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',((getObjectProperty(selectedTutor, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'Backendless\''].join(''))).setProperties('tutorType,name,email,subjects,access_level,MS_teacher_password,zoomid,phone').setPageSize(10)))[0];
      isTeacher = false;
      if ((getObjectProperty(GetTutorData, 'tutorType')) == 'Flex' || (getObjectProperty(GetTutorData, 'tutorType')) == 'Flex/Certified') {
        redirectLink = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Tutor' }) }));
      } else {
        redirectLink = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Teacher' }) }));
        isTeacher = true;
      }
      console.log(isTeacher);
      console.log(getObjectProperty(___arguments.context.pageData, 'selectedTutorMenu'));
      console.log(GetTutorData);
      if ((getObjectProperty(GetTutorData, 'access_level')) == 'Admin Tutor') {
        redirectLink = (await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Admin Tutor' }) }));
        isTeacher = true;
      }
      if (isTeacher) {
        try {
          LoginData = (await Backendless.UserService.login( (getObjectProperty(GetTutorData, 'email')), (getObjectProperty(GetTutorData, 'MS_teacher_password')), false  ));

        } catch (error) {
          LoginData = (await Backendless.UserService.login( (getObjectProperty(GetTutorData, 'email')), (getObjectProperty(GetTutorData, 'zoomid')), false  ));

        }
      } else {
        if ((getObjectProperty(GetTutorData, 'MS_teacher_password')) === null) {
          try {
            LoginData = (await Backendless.UserService.login( (getObjectProperty(GetTutorData, 'email')), (getObjectProperty(GetTutorData, 'phone')), true  ));

          } catch (error) {
            LoginData = (await Backendless.UserService.login( (getObjectProperty(GetTutorData, 'email')), (getObjectProperty(GetTutorData, 'zoomid')), true  ));

          }
        } else {
          try {
            LoginData = (await Backendless.UserService.login( (getObjectProperty(GetTutorData, 'email')), (getObjectProperty(GetTutorData, 'MS_teacher_password')), true  ));

          } catch (error) {
            LoginData = (await Backendless.UserService.login( (getObjectProperty(GetTutorData, 'email')), (getObjectProperty(GetTutorData, 'zoomid')), true  ));

          }
        }
      }
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(redirectLink, false, (isTeacher ? ({ [`sa_name`]: (getObjectProperty(adminData, 'name')),[`fromSA`]: true,[`name`]: (getObjectProperty(___arguments.context.pageData, 'selectedTutorMenu')),[`email`]: (getObjectProperty(LoginData, 'email')) }) : ({ [`sa_name`]: (getObjectProperty(adminData, 'name')),[`fromSA`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`userEmail`]: (getObjectProperty(LoginData, 'email')) })));
    } else {
      (function (message) { alert(message) })('Please select a Tutor to proceed!');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/8f5f26f395dfe9bce08637a2ebcadd92/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, parentSelection, item, ParentList;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  try {
    if (!(___arguments.value === null) && ___arguments.value != '') {
      stopSetTimeout('searchParentMenu');

      ;(function() {
        const callback = async () => {
            ParentList = [];
        ParentList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/ms_student_dir')).query(({ [`where`]: ['parent_name like \'%',___arguments.value,'%\' and status=\'enrolled\''].join(''),[`sortBy`]: 'parent_name',[`groupBy`]: 'lead_id',[`pageSize`]: 100 })).setEncoding('utf8').send());
        if (!!ParentList.length) {
          ___arguments.context.pageData['parentListMenuMap'] = ParentList;
          parentSelection = (await Promise.all(ParentList.map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'parent_name')),' ',(getObjectProperty(item, 'parent_last_name'))].join(''),[`value`]: [(getObjectProperty(item, 'parent_name')),' ',(getObjectProperty(item, 'parent_last_name'))].join('') });})));
          console.log(parentSelection);
          ___arguments.context.pageData['parentSelectorMenuMap'] = parentSelection;
          ___arguments.context.pageData['selectedParentMenuMap'] = (getObjectProperty((parentSelection[0]), 'value'));
        } else {
          ___arguments.context.pageData['parentSelectorMenuMap'] = [];
          ___arguments.context.pageData['selectedParentMenuMap'] = '';
        }

        };

        const timerId = 'searchParentMenu';
        const timerDelay = 600;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/School_Administrator_Page/components/0628bade6aba532e427f5b3265d988ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'selectedAssistantPrincipal')) === 'undefined')) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, ({ [`fromDashboard`]: true,[`fromSA`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'selectedAssistantPrincipal')),[`sa_name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) }));
    } else {
      (function (message) { alert(message) })('Please select an Assistant Principal to proceed!');
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Assistant_Principal_Page').error((String('Error when Navigating to Teacher Dashboard | \nError:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/187658aa39dbc46259ad5f629b5580d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, GetParentData, leadData, parent_map, j, studentDir, item, masked_location, geocode;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'selectedParentMenuMap')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'selectedParentMenuMap')) != '') {
      GetParentData = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'parentListMenuMap')), async (item) => {


       return ([(getObjectProperty(item, 'parent_name')),' ',(getObjectProperty(item, 'parent_last_name'))].join('') == (getObjectProperty(___arguments.context.pageData, 'selectedParentMenuMap')));
      }))[0];
      leadData = (await Backendless.Data.of('parent_maps').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(GetParentData, 'lead_id')),'\''].join(''))).setPageSize(1)));
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Parent Mapping' })), false, ({ [`fromAdmin`]: true,[`fromSA`]: true,[`sa_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'adminData')), 'name')),[`lead_id`]: (getObjectProperty(GetParentData, 'lead_id')) }));
    } else {
      (function (message) { alert(message) })('Please select a parent to proceed!');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/4f33ecd68ce9e36aa66229e1cdc97d6b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Student Metrics' })), true, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('School_Administrator_Page').error((String('Problem encounter with accessing the Student Metric') + String(JSON.stringify(error))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/4885f71c3d8b838e5eb34a29652acd94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'CS MS Calendar' })), true, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('School_Administrator_Page').debug((String('There was a problem accessing the CS MS Calendar | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/5cc6cdc5aa7eec4898178153bc0d79c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) != 'Jordan Knoetgen' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) != 'Emily OConnell')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParam, UserData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    UserData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'BACKENDLESS\''].join(''))).setProperties('name, email').setPageSize(10)))[0];
    urlParam = ({ [`fromSA`]: true,[`email`]: (getObjectProperty(UserData, 'email')),[`sa_name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) });
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Teacher' }) })), false, urlParam);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('googleRedirectClever_refactored').debug((['Login Error: Teacher:\n',(await Backendless.UserService.getCurrentUser(false)),'\nError:\n',error,(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/d1b54b74a1e86b2d033fea5d3aba0fd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    
  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/School_Administrator_Page/components/af5704ce27fb6992b0159be59874f9bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Admin/index.html?page=EmployeeHandbook', true, ({ [`email`]: (getObjectProperty(___arguments.context.pageData, 'email')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/892a6e6b1c661307825338be73cf4f07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var userDB;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  userDB = (getObjectProperty(___arguments.context.pageData, 'adminData'));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=StudentInfo_Summary&lead_id=',(getObjectProperty(userDB, 'lead_id')),'&userType=Assistant_Principal'].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/6cda96d9bff2e40401746a58b25810d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Admin/index.html?page=teachers_directory', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/2b04567fbaf40a3f8e2ab046cc5e4c2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var userObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  userObject = (await Backendless.UserService.getCurrentUser(false));

  return ((getObjectProperty(userObject, 'email')) == 'gina.y@brilliantmicroschool.org' || (getObjectProperty(userObject, 'email')) == 'jordan.k@brilliantmicroschool.org')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/School_Administrator_Page/components/337ab0d8c3780e53206820c835d1ee56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/index.html?page=Grade_Switcher', true, ({ [`tutorEmail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/School_Administrator_Page/components/fa8817f80ed51688d5e89a14b1e8d107/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) == 'Jordan Knoetgen')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, ms_classes, _catcher, j, Teachers_Roster, SelectClassOpt, item, UserDB, access_level, ms_student_dir, lead_id, urlParam, _value, _label, CurrentURL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', true);
    CurrentURL = ((function () { return window.location.href })());
    urlParam = (await Promise.all((CurrentURL.split('?').slice(-1)[0].split('&')).map(async item => {  _label = item.split('=')[0];
      _value = item.split('=').slice(-1)[0];
    ; return ({ [`label`]: _label,[`value`]: _value });})));
    console.log(urlParam);
    lead_id = false ? 'lead_jfP8iVUBphtaVLLyd4MEH9kZAECDvmqU1uV1VQhKV5Z' : (getObjectProperty((await asyncListFind(urlParam, async (item) => {


     return ((getObjectProperty(item, 'label')) == 'lead_id');
    })), 'value'));
    access_level = (getObjectProperty((await asyncListFind(urlParam, async (item) => {


     return ((getObjectProperty(item, 'label')) == 'access_level');
    })), 'value')) == 'assistant_principal' ? 'Assistant_Principal' : 'Teacher';
    ___arguments.context.pageData['access_level'] = access_level;
    ___arguments.context.pageData['lead_id'] = lead_id;
    if (!!lead_id.length && !!access_level.length) {
      console.log(['accountType=\'BACKENDLESS\' and access_level=\'',true ? 'Teacher' : 'Assistant Principal','\' and lead_id=\'',lead_id,'\''].join(''));
      UserDB = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and (access_level=\'',access_level,'\' or access_level=\'School Administrator\')',' and lead_id=\'',lead_id,'\''].join(''))).setPageSize(10)))[0];
      if (UserDB !== null && !Array.isArray(UserDB) && (typeof UserDB === 'object')) {
        ___arguments.context.pageData['UserDB'] = UserDB;
        if (access_level == 'Teacher') {
          console.log(['Class like \'%24_25%\' and teacher=\'',(getObjectProperty(UserDB, 'name')),'\''].join(''));
          ms_classes = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause((['Class like \'%24_25%\' and teacher=\'',(getObjectProperty(UserDB, 'name')),'\''].join(''))).setRelationsDepth(3).setRelationsPageSize(50).setPageSize(100)));
          ms_student_dir = [];
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('196e3a6d3e29fbdfa479c2d64a7b8697', true);
          await new Promise(r => setTimeout(r, 300 || 0));
          SelectClassOpt = [({ [`label`]: 'All Classes',[`value`]: 'All' })];
          addItemToList(SelectClassOpt, (await Promise.all(ms_classes.map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'teacher')),' - ',(getObjectProperty(item, 'Class')).split('-')[2],' - ',(getObjectProperty(item, 'Class')).split('-')[3],' EST'].join(''),[`value`]: (getObjectProperty(item, 'Class')) });}))));
          (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('b9bbd18830ec3467866da0a88cbdb7d1', SelectClassOpt);
          (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('b9bbd18830ec3467866da0a88cbdb7d1', 'All');
          for (var j_index in ms_classes) {
            j = ms_classes[j_index];
            addItemToList(ms_student_dir, (await asyncListSort((getObjectProperty(j, 'students')), 1, async (item) => {
               item['Class'] = (getObjectProperty(j, 'Class'));


             return (getObjectProperty(item, 'parent_name'));
            })));
          }
          ___arguments.context.pageData['students_dir'] = ms_student_dir;
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a344eaf1122e3a292b9295651bfc6936', ms_student_dir);
        } else if (access_level == 'Assistant_Principal') {
          console.log(['accountType=\'BACKENDLESS\' and access_level=\'Teacher\' and opp_status=\'enrolled\' and house_leader=\'',(getObjectProperty(UserDB, 'name')),'\''].join(''));
          Teachers_Roster = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['accountType=\'BACKENDLESS\' and access_level=\'Teacher\' and opp_status=\'enrolled\' and house_leader=\'',((getObjectProperty(UserDB, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setSortBy('name').setPageSize(50)));
          SelectClassOpt = [({ [`label`]: 'All Teachers',[`value`]: 'All' })];
          addItemToList(SelectClassOpt, (await Promise.all(Teachers_Roster.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'name')),[`value`]: (getObjectProperty(item, 'name')) });}))));
          (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('b9bbd18830ec3467866da0a88cbdb7d1', SelectClassOpt);
          (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('b9bbd18830ec3467866da0a88cbdb7d1', 'All');
          (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e6ae8f01e2ef9174873d71a127ae9045', 'All');
          ms_classes = [];
          for (var j_index2 in Teachers_Roster) {
            j = Teachers_Roster[j_index2];
            _catcher = (await Backendless.Data.of('ms_classes').find(Backendless.DataQueryBuilder.create().setWhereClause((['Class like \'%24_25%\' and teacher=\'',((getObjectProperty(j, 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\''].join(''))).setRelationsDepth(3).setRelationsPageSize(100).setPageSize(100)));
            addItemToList(ms_classes, _catcher);
          }
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcda44acdeb68d5fd28c4f4df7415c85', true);
          await new Promise(r => setTimeout(r, 300 || 0));
          ___arguments.context.pageData['ms_classes'] = ms_classes;
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('319718383edab184f786fe143bae625c', ms_classes);
        }
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', false);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);
    }

  } catch (error) {
    console.log(error);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/8e578ba976dcd23d67879fbc50a82124/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'slot_slug')).split('-')[3]) + String(' EST'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/b9bbd18830ec3467866da0a88cbdb7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, ms_classes, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', true);
    if ((getObjectProperty(___arguments.context.pageData, 'access_level')) == 'Teacher') {
      if (___arguments.value != 'All') {
        ms_classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'students_dir')), async (item) => {


         return ((getObjectProperty(item, 'Class')) == ___arguments.value);
        }));
      } else {
        ms_classes = (getObjectProperty(___arguments.context.pageData, 'students_dir'));
      }
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a344eaf1122e3a292b9295651bfc6936', ms_classes);
    } else if ((getObjectProperty(___arguments.context.pageData, 'access_level')) == 'Assistant_Principal') {
      if (___arguments.value != 'All') {
        ms_classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ms_classes')), async (item) => {


         return ((getObjectProperty(item, 'teacher')) == ___arguments.value);
        }));
      } else {
        ms_classes = (getObjectProperty(___arguments.context.pageData, 'ms_classes'));
      }
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('319718383edab184f786fe143bae625c', ms_classes);
      if (!ms_classes.length) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd5afbf9b4a5738804fd7902269ce2de', true);
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd5afbf9b4a5738804fd7902269ce2de', false);
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'access_level')) == 'Teacher' ? 'Select Class' : 'Select Teacher')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/cf95fadc20f3035d816bf958c1fba8fa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, ms_classes, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', true);
    if ((getObjectProperty(___arguments.context.pageData, 'access_level')) == 'Teacher') {
      if (getValueLength(___arguments.value) != 0) {
        ms_classes = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'students_dir')), async (item) => {


         return (((getObjectProperty(item, 'student_name')).indexOf(___arguments.value) !== -1) || ((getObjectProperty(item, 'parent_name')).indexOf(___arguments.value) !== -1));
        }));
      } else {
        ms_classes = (getObjectProperty(___arguments.context.pageData, 'students_dir'));
      }
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a344eaf1122e3a292b9295651bfc6936', ms_classes);
    } else if ((getObjectProperty(___arguments.context.pageData, 'access_level')) == 'Assistant_Principal') {
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'access_level')) == 'Teacher' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/4e5cdbe64149ed4d2ac90f18c13f8d4c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'Class')).split('-')[2];

  return ((value.indexOf('Metaverse') !== -1) ? 'Metaverse and Society Elective' : value)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/ffbe8811721acec535667b91b4d7060b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'Class')).split('-')[3]) + String(' EST'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/b30727427d51e7eca8c853c7e2bb0249/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'seats_taken')),' / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'class_size'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/c33f286e066d4ac7c6afac1403f84522/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53ac166d27a5deab7fb332c5ce3ad965', true);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2b6ea6dfbae3ca5c28cadc9f2af26538', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'students')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/8d613357004575ca06e1026f92dae2c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53ac166d27a5deab7fb332c5ce3ad965', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/1cfd553e19b1f92cd1ddd154e89bd983/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://hi.btgs.co/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'teacher')).split(' ')[0].toLowerCase(),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'teacher')).split(' ').slice(-1)[0].toLowerCase()].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://hi.btgs.co/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'teacher')).split(' ')[0].toLowerCase(),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('23ca2b2abd0ce01ed0a6801b1356181d'), 'teacher')).split(' ').slice(-1)[0].toLowerCase()].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/e6ae8f01e2ef9174873d71a127ae9045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'access_level')) == 'Teacher' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
      return [({ [`label`]: 'All Classes',[`value`]: 'All' }), ({ [`label`]: 'Kindergarten',[`value`]: 'MS_KINDERGARTEN' }), ({ [`label`]: 'Lower Elementary',[`value`]: 'MS_LOWER_ELEM' }), ({ [`label`]: 'Upper Elementary',[`value`]: 'MS_UPPER_ELEM' }), ({ [`label`]: 'Middle School',[`value`]: 'MS_MIDDLE' }), ({ [`label`]: 'Lower High School',[`value`]: 'MS_LOWER_HIGHSCHOOL' }), ({ [`label`]: 'Upper High School',[`value`]: 'MS_UPPER_HIGHSCHOOL' }), ({ [`label`]: 'Elective Class',[`value`]: 'MS_ELECTIVE' }), ({ [`label`]: 'Remedial Class',[`value`]: 'REMEDIAL' })]

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, item, ms_classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    console.log(___arguments.value);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', true);
    ms_classes = ___arguments.value == 'All' ? (getObjectProperty(___arguments.context.pageData, 'ms_classes')) : (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ms_classes')), async (item) => {


     return ((getObjectProperty(item, 'Class')).indexOf(___arguments.value) !== -1);
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('319718383edab184f786fe143bae625c', ms_classes);
    if (!ms_classes.length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd5afbf9b4a5738804fd7902269ce2de', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd5afbf9b4a5738804fd7902269ce2de', false);
    }
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ccc87db50a90a38c425856f3e2ea07', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/7884c8636c1dfd0e2569ceba27867121/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/?page=SIS&from=ParentOTPLogin&lead_id=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4a970e7e6cbcbed1d1719cc8fba89984'), 'lead_id')),'&student_name=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4a970e7e6cbcbed1d1719cc8fba89984'), 'student_name'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/c79912028293a28e7488021dbf240e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/?page=SIS&from=ParentOTPLogin&lead_id=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'lead_id')),'&student_name=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a053507b548bb3ee85b73c39568e2b4'), 'student_name'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/a345bc8c5ee974a3c03d5969acd63722/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://hi.btgs.co/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'UserDB')), 'name')).split(' ')[0].toLowerCase(),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'UserDB')), 'name')).split(' ').slice(-1)[0].toLowerCase()].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StudentInfo_Summary/components/bac1fdcfdcf28578478a730738af6612/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://hi.btgs.co/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('53ac166d27a5deab7fb332c5ce3ad965'), 'teacher')).split(' ')[0].toLowerCase(),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('53ac166d27a5deab7fb332c5ce3ad965'), 'teacher')).split(' ').slice(-1)[0].toLowerCase()].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Student_Identification/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, student_dir, weeklySlot, student_name, lead_id, urlParam, CurrentURL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522b022b0eb96c410f7e35c324357621', true);
    CurrentURL = ((function () { return window.location.href })());
    console.log(CurrentURL);
    if (CurrentURL.indexOf('lead_id=') !== -1) {
      urlParam = CurrentURL.split('?').slice(-1)[0].split('&');
      lead_id = urlParam[1].split('=').slice(-1)[0];
      student_name = urlParam[2].split('=').slice(-1)[0];
    } else {
      lead_id = 'lead_rM3I5bguDqDJ1Cl8g3pE6Qct2PwyHZcdOW9c5i4bYf8';
      student_name = 'Danielle';
    }
    console.log(student_name);
    console.log(['lead_id=\'',lead_id,'\' and student_name=\'',student_name,'\'',' and status=\'enrolled\'',''].join(''));
    student_dir = (lead_id.startsWith('lead_rM3I5bguDqDJ1Cl8g3pE6Qct2PwyHZcdOW9c5i4bYf8')) ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': lead_id,'studentDirObject': ((await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',lead_id,'\' and student_name=\'',student_name,'\'','',''].join(''))).setPageSize(10)))[0]),'process': 'decrypt' })) : (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',lead_id,'\' and student_name=\'',student_name,'\'','',''].join(''))).setPageSize(10)))[0];
    weeklySlot = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',lead_id,'\' and student_name=\'',student_name,'\'',' and status=\'enrolled\''].join(''))).setPageSize(10)))[0];
    if ((student_dir !== null && !Array.isArray(student_dir) && (typeof student_dir === 'object')) && (weeklySlot !== null && !Array.isArray(weeklySlot) && (typeof weeklySlot === 'object'))) {
      ___arguments.context.pageData['student_dir'] = student_dir;
      ___arguments.context.pageData['weeklySlot'] = weeklySlot;
      ___arguments.context.pageData['student_name'] = ([(getObjectProperty(student_dir, 'student_name')),' ',(getObjectProperty(student_dir, 'student_last_name'))].join(''));
      ___arguments.context.pageData['grade_level'] = (getObjectProperty(weeklySlot, 'grade'));
      ___arguments.context.pageData['birthday'] = (getObjectProperty(student_dir, 'student_birth_date'));
      ___arguments.context.pageData['student_id_number'] = (getObjectProperty(student_dir, 'student_id_number'));
      ___arguments.context.pageData['student_dir_objectId'] = (getObjectProperty(student_dir, 'objectId'));
      ___arguments.context.pageData['student_photo'] = (((getObjectProperty(student_dir, 'studentPic')) === null) || !((getObjectProperty(student_dir, 'studentPic')).indexOf('thumbnail?') !== -1) ? 'https://backendlessappcontent.com/4A47197B-AE30-FA84-FF56-0071F4010900/A39AC69D-C148-48A3-BDCE-0821C4698217/files/images/user-orange.png' : (getObjectProperty(student_dir, 'studentPic')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522b022b0eb96c410f7e35c324357621', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c1df186faad2d24a53590696d842947', true);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);
    }

  } catch (error) {
    console.log(error);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Student_Identification/components/3c97eb8ec1f655c682636fe162274f5e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var birthdate, month;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  birthdate = (getObjectProperty(___arguments.context.pageData, 'birthday'));
  month = '';
  if ((new Date(birthdate).getMonth() + 1) == 1) {
    month = 'January';
  }
  if ((new Date(birthdate).getMonth() + 1) == 2) {
    month = 'February';
  }
  if ((new Date(birthdate).getMonth() + 1) == 3) {
    month = 'March';
  }
  if ((new Date(birthdate).getMonth() + 1) == 4) {
    month = 'April';
  }
  if ((new Date(birthdate).getMonth() + 1) == 5) {
    month = 'May';
  }
  if ((new Date(birthdate).getMonth() + 1) == 6) {
    month = 'June';
  }
  if ((new Date(birthdate).getMonth() + 1) == 7) {
    month = 'July';
  }
  if ((new Date(birthdate).getMonth() + 1) == 8) {
    month = 'August';
  }
  if ((new Date(birthdate).getMonth() + 1) == 9) {
    month = 'September';
  }
  if ((new Date(birthdate).getMonth() + 1) == 10) {
    month = 'October';
  }
  if ((new Date(birthdate).getMonth() + 1) == 11) {
    month = 'November';
  }
  if ((new Date(birthdate).getMonth() + 1) == 12) {
    month = 'December';
  }

  return ([month,' ',(new Date(birthdate).getDate()),', ',(new Date(birthdate).getFullYear())].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Student_Identification/components/6f487114d3a4e77bbda522e2e6c64718/bundle.js', [], () => ({
  /* content */
  /* handler:onUpload */
  async ['onUpload'](___arguments) {
    var error, ImageFetch, access_token, Metadata, GDriveAuthCode, RefreshAuthCode, student_dir;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  console.log(___arguments['selectedFile']);
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ec5f04a5835bc136b880bee4ffdc0b7', true);
    GDriveAuthCode = (await Backendless.Data.of('authcodes').find(Backendless.DataQueryBuilder.create().setWhereClause((['api=\'','GoogleImageAPI','\''].join(''))).setPageSize(10)))[0];
    if (((new Date()).valueOf()) > ((getObjectProperty(GDriveAuthCode, 'expiring')).valueOf())) {
      RefreshAuthCode = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accounts.google.com/o/oauth2/token?','client_id=1096446449962-1ni3r08aeqnm6rrdao6nofrvcl1j9nif.apps.googleusercontent.com','&client_secret=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','&refresh_token=',(getObjectProperty(GDriveAuthCode, 'refresh_token')),'&grant_type=refresh_token'].join('')))).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded' })).setEncoding('utf8').send());
      await Backendless.Data.of('authcodes').save( ({ [`objectId`]: (getObjectProperty(GDriveAuthCode, 'objectId')),[`access_token`]: (getObjectProperty(RefreshAuthCode, 'access_token')),[`expiring`]: (new Date((new Date()).getTime() + ((getObjectProperty(RefreshAuthCode, 'expires_in')) * 1000))) }) );
      access_token = (getObjectProperty(RefreshAuthCode, 'access_token'));
    } else {
      access_token = (getObjectProperty(GDriveAuthCode, 'access_token'));
    }
    Metadata = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://www.googleapis.com/drive/v3/files')).set(({ [`Authorization`]: String('Bearer ') + String(access_token),[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(({ [`name`]: ['Student_ID_',((getObjectProperty(___arguments.context.pageData, 'student_name')).replace((new RegExp(' ', 'g')), '_')),'_',(generateUUID().short())].join(''),[`parents`]: ['1w3I9OTPmJbeb4Ca-wkeDGAc07cESseiz'],[`mimeType`]: (getObjectProperty(___arguments['selectedFile'], 'type')) })));
    console.log(Metadata);
    ImageFetch = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://www.googleapis.com/upload/drive/v2/files/',(getObjectProperty(Metadata, 'id')),'?uploadType=media'].join('')))).set(({ [`Authorization`]: String('Bearer ') + String(access_token),[`Content-Type`]: (getObjectProperty(___arguments['selectedFile'], 'type')) })).setEncoding('utf8').send(___arguments['selectedFile']));
    console.log(ImageFetch);
    await Backendless.Data.of('ms_student_dir').save( (((getObjectProperty(___arguments.context.pageData, 'lead_id')).indexOf('lead_rM3I5bguDqDJ1Cl8g3pE6Qct2PwyHZcdOW9c5i4bYf8') !== -1) ? (await Backendless.Request.post(`${Backendless.appPath}/services/BG_13_HR/EncryptDecryptMSStudentDir`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'key': (getObjectProperty(___arguments.context.pageData, 'lead_id')),'studentDirObject': ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'student_dir_objectId')),[`studentPic`]: String('https://drive.google.com/thumbnail?id=') + String((getObjectProperty(ImageFetch, 'selfLink')).split('/').slice(-1)[0]) }),'process': 'encrypt' })) : ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'student_dir_objectId')),[`studentPic`]: String('https://drive.google.com/thumbnail?id=') + String((getObjectProperty(ImageFetch, 'selfLink')).split('/').slice(-1)[0]) })) );
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ec5f04a5835bc136b880bee4ffdc0b7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d86d594d803ff1fa64a2d5083fd8c8b5', true);
    await new Promise(r => setTimeout(r, 4000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d86d594d803ff1fa64a2d5083fd8c8b5', false);

  } catch (error) {
    console.log(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9b40282447857977f1d55f2637fd42b', true);

  }

  },
  /* handler:onUpload */
  /* handler:imageUrlLogic */
  ['imageUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'student_photo'));

  return (((getObjectProperty(___arguments.context.pageData, 'student_photo')).indexOf('thumbnail') !== -1) || !((getObjectProperty(___arguments.context.pageData, 'student_photo')) === null) ? (getObjectProperty(___arguments.context.pageData, 'student_photo')) : String('https://drive.google.com/thumbnail?id=') + String((getObjectProperty(___arguments.context.pageData, 'student_photo')).split('/')[5]))

  },
  /* handler:imageUrlLogic */
  /* content */
}))

define('./pages/logout/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await Backendless.UserService.logout();
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/', false, undefined);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/parent_student_sso/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var StudentData, MeetAndGreetDone, CheckClass, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  StudentData = ({  });
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
    try {
      StudentData = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\' and student_name=\'',((getObjectProperty(___arguments.context.pageData, 'student_name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and status = \'enrolled\''].join(''))).setPageSize(10)))[0];

    } catch (error) {
      console.log(error);
      Backendless.Logging.getLogger('Parent Student SSO').debug((['Error in load Student Data from parent otp \n Lead ID:\n',(getObjectProperty(___arguments.context.pageData, 'lead_id')),'\n Error:\n',error,'\n',(getObjectProperty(error, 'message'))].join('')));

    }
  } else {
    if (!(await Backendless.UserService.isValidLogin())) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'exit')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'exit'))) {
      await Backendless.UserService.logout();
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);
    }
    StudentData = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['studentMSEmail =\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and status=\'enrolled\''].join(''))).setProperties('studentMSEmail,student_name,student_last_name,parent_name,status,lead_id').setPageSize(10)))[0];
  }
  if ((StudentData !== null && !Array.isArray(StudentData) && (typeof StudentData === 'object')) && !(typeof StudentData === 'undefined')) {
    ___arguments.context.pageData['buttonTitle'] = (!(typeof (getObjectProperty(StudentData, 'student_name')) === 'undefined') ? (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) ? String(getObjectProperty(StudentData, 'student_name')) + String('\'s') : '') : '');
    ___arguments.context.pageData['title'] = (!(typeof (getObjectProperty(StudentData, 'student_name')) === 'undefined') ? (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) ? ['Hi ',(getObjectProperty(StudentData, 'parent_name')),', welcome back!'].join('') : ['Hi ',(getObjectProperty(StudentData, 'student_name')),', welcome back!'].join('')) : 'Dashboard');
    ___arguments.context.pageData['StudentData'] = StudentData;
    if (false) {
      ___arguments.context.pageData['showElective'] = false;
    } else {
      CheckClass = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['status=\'enrolled\' and lead_id=\'',(getObjectProperty(StudentData, 'lead_id')),'\' and student_name=\'',(getObjectProperty(StudentData, 'student_name')),'\' and (slot_slug like \'%\\_ESE\\_%\')'].join(''))).setPageSize(10)));
      MeetAndGreetDone = ((await asyncListFind((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseGetAllTasksByLeadID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(StudentData, 'lead_id')) })))), async (item) => {


       return ((getObjectProperty(item, 'text')).indexOf('#meet&greet#') !== -1);
      })) !== null && !Array.isArray((await asyncListFind((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseGetAllTasksByLeadID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(StudentData, 'lead_id')) })))), async (item) => {


       return ((getObjectProperty(item, 'text')).indexOf('#meet&greet#') !== -1);
      }))) && (typeof (await asyncListFind((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/UICloseGetAllTasksByLeadID`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`lead_id`]: (getObjectProperty(StudentData, 'lead_id')) })))), async (item) => {


       return ((getObjectProperty(item, 'text')).indexOf('#meet&greet#') !== -1);
      })) === 'object'));
      if (!CheckClass.length && MeetAndGreetDone) {
        ___arguments.context.pageData['showElective'] = true;
      } else {
        ___arguments.context.pageData['showElective'] = false;
      }
      if (MeetAndGreetDone || ((getObjectProperty(StudentData, 'parent_name')).indexOf('TestPeter') !== -1)) {
        ___arguments.context.pageData['ShowClubs'] = true;
      } else {
        ___arguments.context.pageData['ShowClubs'] = false;
      }
    }
    ___arguments.context.pageData['showSISForm'] = true;
    if ((getObjectProperty(StudentData, 'lead_id')) == 'lead_tMton5az4AmlurmhVTzDNORlW0R8xBkZ7XuuyEMnTXf') {
      ___arguments.context.pageData['showSISForm'] = false;
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/parent_student_sso/components/4756d4ddb332497515dc236f06169a05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Parent Student SSO').debug((['Parent Student SSO Logout Error:\n',error,'\n',(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/8873cf183028a95d7e9fd1e9236f2685/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Timetable' })), false, ({ [`SSO`]: true,[`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty(GetTutorData, 'lead_id')),[`student_name`]: (getObjectProperty(GetTutorData, 'student_name')) }));
    } else {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Timetable' })), false, ({ [`SSO`]: true }));
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/96a144d2476aedbb3e0712594242360f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, StudentData, ShareContact;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    StudentData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
    ShareContact = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(StudentData, 'lead_id')),'\' and student_name=\'',(getObjectProperty(StudentData, 'student_name')),'\' and studentMSEmail is not null'].join(''))).setProperties('share_contact').setPageSize(10)))[0];
    if (!(typeof ShareContact === 'undefined') && (getObjectProperty(ShareContact, 'share_contact')) == 'Yes') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Parent Mapping' })), false, (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) ? ({ [`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty(StudentData, 'lead_id')),[`student_name`]: (getObjectProperty(StudentData, 'student_name')) }) : ({ [`SSO`]: true,[`lead_id`]: (getObjectProperty(StudentData, 'lead_id')),[`student_name`]: (getObjectProperty(StudentData, 'student_name')) })));
    } else {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3f2f227b989ed763470f15864829e8af');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/378373abcbb644db2bfcece153fdb0be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, StudentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    StudentData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=SIS#lead_id=',(getObjectProperty(StudentData, 'lead_id')),'&SSO=true'].join('')), false, ({ [`fromParentOTP`]: true,[`student_name`]: (getObjectProperty(StudentData, 'student_name')) }));
    } else {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=SIS#lead_id=',(getObjectProperty(StudentData, 'lead_id')),'&SSO=true'].join('')), false, ({ [`from`]: 'ParentOTPLogin',[`student_name`]: (getObjectProperty(StudentData, 'student_name')) }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').error((String('Error in accessing SIS Error\n:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/88d686b50d41310326fb4392c38bb8f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3f2f227b989ed763470f15864829e8af');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/062580ea95348db382277659785d4db7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['To access this feature, enable the ','<strong>Share contact information to other parents within a 30-mile radius</strong> ','in ',(typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name')) === 'undefined') ? 'the' : String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name')) + String('\'s'),' Student Information.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/11e5a8840cd782764d4d9ec7495e2c42/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['1. Go to <strong>',(typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name')) === 'undefined') ? null : String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name')) + String('\'s'),' Student Information.</strong>'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/b5bca2e9d1832c5b8c3e62770d2980a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (['3. Under ','<strong>General Information</strong>',', click the 2nd bullet to proceed to ','<strong>Parent/Guardian General Information</strong>'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/d034689b472663eb71138f72d33cbf0b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (['4. Find the option','<strong>Share contact information to other parents within a 30-mile radius? </strong>',' and change it to ','<strong>Yes</strong>'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/66043abbafdf956dead154df90e7013d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, WeeklySlotData, StudentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log('Elective Redirect');
    StudentData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
    console.log(getObjectProperty(StudentData, 'lead_id'));
    if (!(typeof (getObjectProperty(StudentData, 'lead_id')) === 'undefined')) {
      WeeklySlotData = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['subject like \'%MS%\' and lead_id=\'',(getObjectProperty(StudentData, 'lead_id')),'\' and student_name=\'',(getObjectProperty(StudentData, 'student_name')),'\' and status=\'enrolled\''].join(''))).setPageSize(10)))[0];
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Electives' })),'&lead_id=',(getObjectProperty(StudentData, 'lead_id')),'&student_name=',(getObjectProperty(StudentData, 'student_name')),'&ms_type=',(getObjectProperty(WeeklySlotData, 'subject')),'&parent_name=',(getObjectProperty(StudentData, 'parent_name')),'&timezone=',(getObjectProperty(WeeklySlotData, 'timezone')),'&SSO=true',!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') ? '&fromParentOTP=true' : null].join('')), false, undefined);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').debug((['Electives Option Error:\n',error,'\n',(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/e6c5d0f8e843c9eec59e2594ed8aef2b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'buttonTitle')) === 'undefined') ? 'Timetable' : String(getObjectProperty(___arguments.context.pageData, 'buttonTitle')) + String(' Timetable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/f18985b66d9141d426a2df6fb40bf38a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'buttonTitle')) === 'undefined') ? 'Student Information' : String(getObjectProperty(___arguments.context.pageData, 'buttonTitle')) + String(' Information'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/3f2ac12bdebac78f9feaa083ea2587ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'buttonTitle')) === 'undefined') ? 'Electives' : String(getObjectProperty(___arguments.context.pageData, 'buttonTitle')) + String(' Electives'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/f4c3c2ba0e0981c60a5cfb0a70d88e78/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (true ? false : (getObjectProperty(___arguments.context.pageData, 'showElective')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/7f88f7f7e94e3ce2cc6e8b258eb38437/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Clubs' })), false, (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') ? ({ [`lead_id`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'lead_id')),[`student_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name')),[`SSO`]: true,[`fromParentOTP`]: true }) : ({ [`lead_id`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'lead_id')),[`student_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name')),[`SSO`]: true })));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').debug((String('Problem with accessing the clubs | Error: \n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/8778094b75955d5665e2e523b549160c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowClubs'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/9b1c25c5427d87756f3a097a4c1978bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/8e877f719bc43bdabf2e47014847ba84/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Parent' }) })), false, ({ [`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty(___arguments.context.pageData, 'lead_id')),[`student_name`]: (getObjectProperty(___arguments.context.pageData, 'student_name')) }));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').debug((String('Problem encountered in clicking Back to Student List | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/e404b0956f7c98241af4ac3bd2c60367/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Timetable' })), false, ({ [`SSO`]: true,[`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty(GetTutorData, 'lead_id')),[`student_name`]: (getObjectProperty(GetTutorData, 'student_name')) }));
    } else {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Timetable' })), false, ({ [`SSO`]: true }));
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/457ab583c7b4347be26f2681f649af94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, StudentData, ShareContact;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    StudentData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
    ShareContact = (await Backendless.Data.of('ms_student_dir').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(StudentData, 'lead_id')),'\' and student_name=\'',(getObjectProperty(StudentData, 'student_name')),'\' and studentMSEmail is not null'].join(''))).setProperties('share_contact').setPageSize(10)))[0];
    if (!(typeof ShareContact === 'undefined') && (getObjectProperty(ShareContact, 'share_contact')) == 'Yes') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Parent Mapping' })), false, (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) ? ({ [`fromParentOTP`]: true,[`lead_id`]: (getObjectProperty(StudentData, 'lead_id')),[`student_name`]: (getObjectProperty(StudentData, 'student_name')) }) : ({ [`SSO`]: true,[`lead_id`]: (getObjectProperty(StudentData, 'lead_id')),[`student_name`]: (getObjectProperty(StudentData, 'student_name')) })));
    } else {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3f2f227b989ed763470f15864829e8af');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/6b57d21913d7f0bd92be00aaeb47515b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, StudentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    StudentData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromParentOTP'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=SIS#lead_id=',(getObjectProperty(StudentData, 'lead_id')),'&SSO=true'].join('')), false, ({ [`fromParentOTP`]: true,[`student_name`]: (getObjectProperty(StudentData, 'student_name')) }));
    } else {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=SIS#lead_id=',(getObjectProperty(StudentData, 'lead_id')),'&SSO=true'].join('')), false, ({ [`from`]: 'ParentOTPLogin',[`student_name`]: (getObjectProperty(StudentData, 'student_name')) }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').error((String('Error in accessing SIS Error\n:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/fc0a7c68f16944bbb33677bf1073c726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, WeeklySlotData, StudentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log('Elective Redirect');
    StudentData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
    console.log(getObjectProperty(StudentData, 'lead_id'));
    if (!(typeof (getObjectProperty(StudentData, 'lead_id')) === 'undefined')) {
      WeeklySlotData = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['subject like \'%MS%\' and lead_id=\'',(getObjectProperty(StudentData, 'lead_id')),'\' and student_name=\'',(getObjectProperty(StudentData, 'student_name')),'\' and status=\'enrolled\''].join(''))).setPageSize(10)))[0];
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Electives' })),'&lead_id=',(getObjectProperty(StudentData, 'lead_id')),'&student_name=',(getObjectProperty(StudentData, 'student_name')),'&ms_type=',(getObjectProperty(WeeklySlotData, 'subject')),'&parent_name=',(getObjectProperty(StudentData, 'parent_name')),'&timezone=',(getObjectProperty(WeeklySlotData, 'timezone')),'&SSO=true',!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') ? '&fromParentOTP=true' : null].join('')), false, undefined);
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').debug((['Electives Option Error:\n',error,'\n',(getObjectProperty(error, 'message'))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/eb0282198e8120df2877962463abf72e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Clubs' })), false, (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromParentOTP')) === 'undefined') ? ({ [`lead_id`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'lead_id')),[`student_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name')),[`SSO`]: true,[`fromParentOTP`]: true }) : ({ [`lead_id`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'lead_id')),[`student_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name')),[`SSO`]: true })));

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('parent_student_sso').debug((String('Problem with accessing the clubs | Error: \n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/e03a9076172beaf94d735566f1e85a47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var StudentData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSISForm'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/5a44aab65512f9766c385b236c536515/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty(___arguments.context.pageData, 'StudentData')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'StudentData'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'StudentData')) === 'object')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'honorCodeSigned')) != 'Not Completed' && ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'parent_name')).indexOf('Test') !== -1) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/86c2e5efe9e2bfdaeab9a6c59696e758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=Student_Identification','&lead_id=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'lead_id')),'&student_name=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StudentData')), 'student_name'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/parent_student_sso/components/4c78f5d80a7f3365ad18e685aa469257/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var StudentData, leads;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  StudentData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));

  return (!(typeof StudentData === 'undefined') ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/parent_student_sso/components/198c1374583829a8ba08918d5c880068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var gradeband, lead_id, student_name, StudentData, weeklySlots, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  StudentData = (getObjectProperty(___arguments.context.pageData, 'StudentData'));
  if (!(typeof StudentData === 'undefined')) {
    weeklySlots = (await Backendless.Data.of('weekly_slots').find(Backendless.DataQueryBuilder.create().setWhereClause((['slot_slug like \'%MS_%\' and status=\'enrolled\'',' and lead_id=\'',(getObjectProperty(StudentData, 'lead_id')),'\' and student_name=\'',(getObjectProperty(StudentData, 'student_name')),'\''].join(''))).setPageSize(10)))[0];
    if (weeklySlots !== null && !Array.isArray(weeklySlots) && (typeof weeklySlots === 'object')) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/MS_Pages/index.html?page=SummerSchool_Enrollment&','lead_id=',(getObjectProperty(StudentData, 'lead_id')),'&student_name=',(getObjectProperty(StudentData, 'student_name')),'&gradeband=',(getObjectProperty(weeklySlots, 'subject'))].join('')), true, undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var tutorDataLoggedIn, tutorData, LoginData, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'fromPortal')) || (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) || (getObjectProperty(___arguments.context.pageData, 'fromAP')) || (getObjectProperty(___arguments.context.pageData, 'fromSA'))) && !(typeof (getObjectProperty(___arguments.context.pageData, 'email')) === 'undefined')) {
    await Backendless.UserService.logout();
    tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((((getObjectProperty(___arguments.context.pageData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? ['MS_teacher_email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join('') : ['email=\'',(getObjectProperty(___arguments.context.pageData, 'email')),'\' and accountType=\'BACKENDLESS\' and userType=\'Teacher\''].join(''))).setProperties('email,zoomid,MS_teacher_password').setPageSize(10)))[0];
    try {
      LoginData = (await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'zoomid')), true  ));

    } catch (error) {
      console.log(getObjectProperty(error, 'message'));
      console.log(error);
      LoginData = (await Backendless.UserService.login( (getObjectProperty(tutorData, 'email')), (getObjectProperty(tutorData, 'MS_teacher_password')), true  ));

    }
    Backendless.Logging.getLogger('tutor_sso').info((['Teacher Info.\nEmail used:',(getObjectProperty(___arguments.context.pageData, 'email')),'\nLogged in User Name:',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),'\nEmail:',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')),'\nData:',(JSON.stringify((await Backendless.UserService.getCurrentUser(true))))].join('')));
    console.log(await Backendless.UserService.getCurrentUser(false));
  } else if ((await Backendless.UserService.isValidLogin()) && (typeof (getObjectProperty(___arguments.context.pageData, 'email')) === 'undefined')) {
    console.log('no email page data');
    tutorData = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'BACKENDLESS\''].join(''))).setProperties('email,name').setPageSize(10)))[0];
    Backendless.Logging.getLogger('tutor_sso').info((['Teacher Info.','\nLogged in User Name:',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')),'\nEmail:',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'email')),'\nData:',(JSON.stringify((await Backendless.UserService.getCurrentUser(true))))].join('')));
    if ((getObjectProperty(tutorData, 'name')).indexOf('TestNicolas') !== -1) {
      ___arguments.context.pageData['showPTC'] = true;
      ___arguments.context.pageData['showStudInfoHub'] = true;
    } else {
      ___arguments.context.pageData['showPTC'] = false;
      ___arguments.context.pageData['showStudInfoHub'] = false;
    }
    console.log(getObjectProperty(___arguments.context.pageData, 'showPTC'));
    ___arguments.context.pageData['email'] = (getObjectProperty(tutorData, 'email'));
    ___arguments.context.pageData['access_level'] = (getObjectProperty(tutorData, 'access_level'));
    ___arguments.context.pageData['lead_id'] = (getObjectProperty(tutorData, 'lead_id'));
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);
  } else {
    tutorDataLoggedIn = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['name=\'',((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')).replace((new RegExp('\'', 'g')), '\'\'')),'\' and accountType=\'BACKENDLESS\''].join(''))).setProperties('access_level,name,email,MS_teacher_email,subjects,lead_id').setPageSize(10)))[0];
    ___arguments.context.pageData['teacher'] = tutorDataLoggedIn;
    if ((getObjectProperty(tutorDataLoggedIn, 'access_level')) == 'School Administrator') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('67bee2a27f26c44a263e2acd70aa8bdd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91dbd95e2de9795337f28418b9dd2d5a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('760f1b560cd6c183cfcd8409827bd065', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83caec513695d65baa43f27798d63831', true);
    }
    if ((getObjectProperty(tutorDataLoggedIn, 'name')) == 'Lori Anderson') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('67bee2a27f26c44a263e2acd70aa8bdd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91dbd95e2de9795337f28418b9dd2d5a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('760f1b560cd6c183cfcd8409827bd065', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83caec513695d65baa43f27798d63831', true);
    }
    ___arguments.context.pageData['lead_id'] = (getObjectProperty(tutorDataLoggedIn, 'lead_id'));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/tutor_sso/components/4756d4ddb332497515dc236f06169a05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    await Backendless.UserService.logout();
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/SignInPageRedirectionLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), false, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_sso').debug((String('Problem occurs in logging out | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/00b276c2b0c5baaa9282670dd683dc65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var name2, teacherData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  teacherData = (await Backendless.UserService.getCurrentUser(false));
  name2 = 'Dashboard';
  if (!(teacherData === null)) {
    name2 = ['Hi ',(getObjectProperty(teacherData, 'name')).split(' ')[0],', welcome back!'].join('');
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tutor_sso/components/8873cf183028a95d7e9fd1e9236f2685/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParameter, access_level, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromAdminPanel`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`fromMainPortal`]: (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')),[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')),[`fromAP`]: true,[`userEmail`]: (getObjectProperty(GetTutorData, 'email')) }) : ({ [`fromAdminPanel`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`fromMainPortal`]: (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')),[`userEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) || !(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')) || !(typeof (getObjectProperty(___arguments.context.pageData, 'test')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'test'))) {
      access_level = ({ [`access_level`]: 'Tutor Test' });
    } else {
      access_level = ({ [`access_level`]: 'Tutor' });
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': access_level })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').error((String('Error Navigating Tutor Porta | Error:\n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/2a13182faf0cd7a31c8f3542758c4995/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var GetTutorData, error, urlParameter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')),[`fromAP`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/index.html?page=Grade_Switcher', false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((['Error in Navigating Time table | Error:\n',error,'\nData:\n',(JSON.stringify(___arguments.context.pageData))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/67dc04c3a407cc8e177fc863ffa66fc3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var GetTutorData, error, urlParameter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')),[`fromAP`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/index.html?page=GMeet_Recordings', false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((['Error in Navigating Time table | Error:\n',error,'\nData:\n',(JSON.stringify(___arguments.context.pageData))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/96a144d2476aedbb3e0712594242360f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, GetTutorData, urlParameter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) ? ({ [`fromAdminPanel`]: true,[`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParameter['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParameter['fromAP'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'SIS' })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').error((String('Error in Navigating SIS | Error:\n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/378373abcbb644db2bfcece153fdb0be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParameter, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')),[`fromAP`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Timetable' })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((['Error in Navigating Time table | Error:\n',error,'\nData:\n',(JSON.stringify(___arguments.context.pageData))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/0c2169e72e24f1033cde0ed65b9f9959/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParameter, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')),[`fromAP`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Student Credentials' })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((['Error in Navigating Time table | Error:\n',error,'\nData:\n',(JSON.stringify(___arguments.context.pageData))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/61b9d8663bd34a254b94f6ce27b849ed/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var parentSelection, item, ParentList, error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  try {
    if (!(___arguments.value === null) && ___arguments.value != '') {
      stopSetTimeout('searchParentMenu');

      ;(function() {
        const callback = async () => {
            ParentList = [];
        ParentList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.backendless.com/4A47197B-AE30-FA84-FF56-0071F4010900/DBF60C1F-FE33-47BD-9D93-877058456A9F/data/ms_student_dir')).query(({ [`where`]: ['parent_name like \'%',___arguments.value,'%\' and status=\'enrolled\''].join(''),[`sortBy`]: 'parent_name',[`groupBy`]: 'lead_id',[`pageSize`]: 100 })).setEncoding('utf8').send());
        if (!!ParentList.length) {
          ___arguments.context.pageData['parentListMenuMap'] = ParentList;
          parentSelection = (await Promise.all(ParentList.map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'parent_name')),' ',(getObjectProperty(item, 'parent_last_name'))].join(''),[`value`]: [(getObjectProperty(item, 'parent_name')),' ',(getObjectProperty(item, 'parent_last_name'))].join('') });})));
          console.log(parentSelection);
          ___arguments.context.pageData['parentSelectorMenuMap'] = parentSelection;
          ___arguments.context.pageData['selectedParentMenuMap'] = (getObjectProperty((parentSelection[0]), 'value'));
        }

        };

        const timerId = 'searchParentMenu';
        const timerDelay = 600;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/tutor_sso/components/8a93a7ffc69fa29c5cdca74ea13bdee9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, GetParentData, parent_map, leadData, j, studentDir, item, masked_location, geocode;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    GetParentData = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'parentListMenuMap')), async (item) => {


     return ([(getObjectProperty(item, 'parent_name')),' ',(getObjectProperty(item, 'parent_last_name'))].join('') == (getObjectProperty(___arguments.context.pageData, 'selectedParentMenuMap')));
    }))[0];
    leadData = (await Backendless.Data.of('parent_maps').find(Backendless.DataQueryBuilder.create().setWhereClause((['lead_id=\'',(getObjectProperty(GetParentData, 'lead_id')),'\''].join(''))).setPageSize(1)));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Parent Mapping' })), true, ({ [`fromAdmin`]: true,[`lead_id`]: (getObjectProperty(GetParentData, 'lead_id')) }));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/0394b0af97edf2c180666df2983df823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParameter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    urlParameter = ({ [`fromDashboard`]: true });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParameter['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParameter['fromAP'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'Assistant Principal' }) })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_sso').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_sso/components/31365f12cd4be76b2611352b10d155d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.logout();
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': ({ [`access_level`]: 'School Administrator' }) })), false, ({ [`sa_name`]: (getObjectProperty(___arguments.context.pageData, 'sa_name')),[`fromSA`]: true }));
    }

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('Tutor_dash_ms').debug((String('Problem with Back To List button | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/44d663ebfa0c755ab56d25912036d967/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var tutor, error, GetTutorData, urlParameter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) ? ({ [`fromAdminPanel`]: true,[`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParameter['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParameter['fromAP'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://portal.brilliantgrades.com/CS/index.html?page=PTC_Time_Table&email=') + String(((getObjectProperty(GetTutorData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? (getObjectProperty(GetTutorData, 'email')) : (getObjectProperty(GetTutorData, 'MS_teacher_email')))), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').error((String('Error in Navigating SIS | Error:\n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/e404b0956f7c98241af4ac3bd2c60367/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParameter, access_level, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromAdminPanel`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`fromMainPortal`]: (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')),[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')),[`fromAP`]: true,[`userEmail`]: (getObjectProperty(GetTutorData, 'email')) }) : ({ [`fromAdminPanel`]: true,[`tutorName`]: ((getObjectProperty(GetTutorData, 'name')).replace((new RegExp('\\s', '')), '_')),[`fromMainPortal`]: (getObjectProperty(___arguments.context.pageData, 'fromMainPortal')),[`userEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    access_level = ({ [`access_level`]: 'Tutor' });
    Backendless.Logging.getLogger('tutor_sso').info((String('Redirect to Tutor Dash.\nURL Parameter:') + String(urlParameter)));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userObject': access_level })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').error((String('Error Navigating Tutor Porta | Error:\n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/457ab583c7b4347be26f2681f649af94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, GetTutorData, urlParameter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) ? ({ [`fromAdminPanel`]: true,[`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParameter['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParameter['fromAP'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'SIS' })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').error((String('Error in Navigating SIS | Error:\n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/6b57d21913d7f0bd92be00aaeb47515b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParameter, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')),[`fromAP`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Timetable' })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((['Error in Navigating Time table | Error:\n',error,'\nData:\n',(JSON.stringify(___arguments.context.pageData))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/0406baefbbeb469325c5256ce2cf9cfb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, urlParameter, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')),[`fromAP`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/index.html?page=Grade_Switcher', false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((['Error in Navigating Time table | Error:\n',error,'\nData:\n',(JSON.stringify(___arguments.context.pageData))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/2e0d833c62faa3451748d4318cf243f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, urlParameter, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')),[`fromAP`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Clever/index.html?page=GMeet_Recordings', false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((['Error in Navigating Time table | Error:\n',error,'\nData:\n',(JSON.stringify(___arguments.context.pageData))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/a244d9662798440e56f559fc7a65e8f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, urlParameter, GetTutorData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = !(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP')) ? ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')),[`fromAP`]: true,[`ap_name`]: (getObjectProperty(___arguments.context.pageData, 'ap_name')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'Student Credentials' })), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((['Error in Navigating Time table | Error:\n',error,'\nData:\n',(JSON.stringify(___arguments.context.pageData))].join('')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/965305b5a355cfc1fc06573d1f3627b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, GetTutorData, urlParameter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    GetTutorData = (getObjectProperty(___arguments.context.pageData, 'teacher'));
    urlParameter = (getObjectProperty(___arguments.context.pageData, 'fromAdminPanel')) ? ({ [`fromAdminPanel`]: true,[`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) }) : ({ [`fromTutorSSO`]: true,[`tutorEmail`]: (getObjectProperty(GetTutorData, 'email')) });
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromAP')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromAP'))) {
      urlParameter['ap_name'] = (getObjectProperty(___arguments.context.pageData, 'ap_name'));
      urlParameter['fromAP'] = true;
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'fromSA')) === 'undefined') && (getObjectProperty(___arguments.context.pageData, 'fromSA'))) {
      urlParameter['sa_name'] = (getObjectProperty(___arguments.context.pageData, 'sa_name'));
      urlParameter['fromSA'] = true;
    }
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://portal.brilliantgrades.com/CS/index.html?page=PTC_Time_Table&email=') + String(((getObjectProperty(GetTutorData, 'email')).indexOf('brilliantmicroschool.org') !== -1) ? (getObjectProperty(GetTutorData, 'email')) : (getObjectProperty(GetTutorData, 'MS_teacher_email')))), false, urlParameter);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').error((String('Error in Navigating SIS | Error:\n') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/56d19222867c1fa4609334b40b69a8ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/uiBuilder/IndexPageRedirectionLinkByUserRole`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'redirectPage': 'CS MS Calendar' })), true, undefined);

  } catch (error) {
    console.log(error);
    Backendless.Logging.getLogger('tutor_sso').debug((String('There was a problem accessing the CS MS Calendar | Error:') + String(error)));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/5cab800e2467b26ed1feae5ca7a24e3c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var teacherData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) == 'TestNicolasTutor Live')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_sso/components/9da3ae337aa6b9786435c0715b874bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/CS/index.html?page=ms_sub_tool_v2', true, ({ [`name`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')) }));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/512564c156338d1c8fece18920cd7d42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://portal.brilliantgrades.com/Admin/index.html?page=EmployeeHandbook', true, ({ [`email`]: (getObjectProperty(___arguments.context.pageData, 'email')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/5ab6c7e289aa028c3b1abfbe0107bd89/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    
  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_sso/components/b2a96b2ab368f4bf338ca00b842c3243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'teacher')), 'subjects'));
  console.log((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'teacher')), 'subjects')).indexOf('MS_') !== -1);

  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')) == 'TestNicolasTutor Live' || (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'name')) == 'DummyTeacher2' || (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'access_level')) == 'Assistant Principal' || (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'access_level')) == 'School Administrator' || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'teacher')), 'subjects')).indexOf('MS_') !== -1))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_sso/components/59f66019599cc0a885edc70b51081608/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Student Hub Visibility');
  console.log(getObjectProperty(___arguments.context.pageData, 'showStudInfoHub'));
  console.log(!(typeof (getObjectProperty(___arguments.context.pageData, 'teacher')) === 'undefined') && ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'teacher')), 'name')).indexOf('Test') !== -1) || (getObjectProperty(___arguments.context.pageData, 'showStudInfoHub')));

  return (!(typeof (getObjectProperty(___arguments.context.pageData, 'teacher')) === 'undefined') && (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'teacher')), 'name')).indexOf('Test') !== -1) || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'teacher')), 'name')).indexOf('Jordan Knoetgen') !== -1)) || (getObjectProperty(___arguments.context.pageData, 'showStudInfoHub')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_sso/components/30b8941802f1602a42e7ba98eb0d6348/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var teacher;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  teacher = (getObjectProperty(___arguments.context.pageData, 'teacher'));
  if (!(typeof teacher === 'undefined') && !(getObjectProperty(___arguments.context.pageData, 'showStudInfoHub'))) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=StudentInfo_Summary&lead_id=',(getObjectProperty(teacher, 'lead_id')),'&access_level=',(getObjectProperty(teacher, 'access_level')) == 'Teacher' ? 'teacher' : 'assistant_principal'].join('')), true, undefined);
  } else if (getObjectProperty(___arguments.context.pageData, 'showStudInfoHub')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=StudentInfo_Summary&lead_id=','lead_EZGM0iV4WNRGKaHK10iYVoEjU6oIos4jCLyOXW1avrI','&access_level=teacher'].join('')), true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/tutor_sso/components/6b9845d8a65895db36d2a828aa5b4388/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'lead_id')) == 'lead_UJ4WydwHrW4YEIOcf4gc5GBcxXiAZxkA9Xqjvh1EPK8')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tutor_sso/components/9f680648669da238e6f25dc801241a3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((['https://portal.brilliantgrades.com/Clever/index.html?page=1on1_Class&lead_id=',(getObjectProperty(___arguments.context.pageData, 'lead_id')),''].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

